import React, { useRef, useEffect, useState, useCallback, Component, useContext, createContext, forwardRef, createElement } from 'react';
import classnames from 'classnames';
import { withRouter, Link, Switch, Route, Redirect, useParams, NavLink, useLocation } from 'react-router-dom';
import useMeasure from 'react-use/lib/useMeasure';
import { Howl } from 'howler';
import dialTone from './assets/dial-tone.mp3';
import { observer } from 'mobx-react-lite';
import browser from './assets/browser.png';
import photos from './assets/photos.png';
import messages from './assets/messages.png';
import phone from './assets/phone.png';
import contacts from './assets/contacts.png';
import notes from './assets/notes.png';
import email from './assets/email.png';
import streaming from './assets/streaming.png';
import calculator from './assets/calculator.png';
import authenticator from './assets/authenticator.png';
import chat from './assets/chat.png';
import findFriends from './assets/findFriends.png';
import news from './assets/news.png';
import dating from './assets/dating.png';
import vault from './assets/vault.png';
import vaultWebp from './assets/vault.webp';
import home from './assets/home.png';
import calendar from './assets/calendar.png';
import social from './assets/social.png';
import socialWebp from './assets/social.webp';
import iconDocument from './assets/file-document.png';
import iconPhoto from './assets/file-photo.png';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import iconCamera from './assets/icon-camera.svg';
import iconLight from './assets/icon-light.svg';
import iconSocket from './assets/icon-socket.svg';
import iconDoorlock from './assets/icon-door-lock.svg';
import VideoPlayer$1 from '@faintlines/video-player';
import 'react-toggle/style.css';
import brokenScreen2 from './assets/broken-screen-2.png';
import brokenScreen3 from './assets/broken-screen-3.png';
import videoCallRingtone from './assets/video-call-ringtone.mp3';
import newsIn from './assets/news-in.mp3';
import { toJS, makeAutoObservable, set, autorun } from 'mobx';
import store from 'store';
import { MemoryRouter } from 'react-router';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var styles$e = {"PhoneSimulator":"PhoneSimulator-module_PhoneSimulator__3WqlO","text-select":"PhoneSimulator-module_text-select__2psdS","PhoneSimulator-content":"PhoneSimulator-module_PhoneSimulator-content__3i3d6","menuOpen":"PhoneSimulator-module_menuOpen__22wJb"};

var AppStoreContext = /*#__PURE__*/React.createContext(null);
var AppStoreProvider = function AppStoreProvider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(AppStoreContext.Provider, {
    value: store
  }, children);
};
var useAppStore = function useAppStore() {
  return React.useContext(AppStoreContext);
};

var styles$d = {"browser":"AppBrowser-module_browser__2qosC","search":"AppBrowser-module_search__IlQR8","search__input":"AppBrowser-module_search__input__3mPAM","history__item":"AppBrowser-module_history__item__QtFpW","history__item__text":"AppBrowser-module_history__item__text__1CYk_","history__item__icon":"AppBrowser-module_history__item__icon__1NK9L","history__item__cached":"AppBrowser-module_history__item__cached__2xdy-","history__more":"AppBrowser-module_history__more__2Pgrg","offline":"AppBrowser-module_offline__1IsxW","offline__title":"AppBrowser-module_offline__title__mG38u","offline__text":"AppBrowser-module_offline__text__1V76P","cached":"AppBrowser-module_cached__1vjR1","cached__note":"AppBrowser-module_cached__note__2SHA0","cached__image":"AppBrowser-module_cached__image__kXXgl"};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var RGI_Emoji = function RGI_Emoji() {
  // https://mths.be/emoji
  return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]/g;
};

function rsplit(string, sep, maxsplit) {
  var split = string.split(sep);
  return maxsplit ? [split.slice(0, -maxsplit).join(sep)].concat(split.slice(-maxsplit)) : split;
}
function limitString(string, limit) {
  if (!string) {
    return string;
  }

  if (string.length <= limit) {
    return string;
  }

  return string.substring(0, limit) + "...";
}
function replaceCaseInsensitive(str, strReplace, strWith) {
  var esc = strReplace.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  var reg = new RegExp(esc, "ig");
  return str.replace(reg, strWith);
}
function pluralize(num, pluralForm, singularForm) {
  return num === 1 ? singularForm || "" : pluralForm || "s";
}
function isEmoji(string) {
  var regex = RGI_Emoji();

  if (!string) {
    return false;
  }

  var match = string.match(regex);
  return match !== null && match.length > 0 && match[0] === string;
}
function escapeLunrQueryString(queryString) {
  if (typeof queryString !== "string") {
    return queryString;
  }

  return queryString.replace(/[-~^:+]/g, "\\$&");
}

var showdown$1 = {exports: {}};

(function (module) {
  /*! showdown v 1.9.1 - 02-11-2019 */

  (function () {
    /**
     * Created by Tivie on 13-07-2015.
     */
    function getDefaultOpts(simple) {

      var defaultOptions = {
        omitExtraWLInCodeBlocks: {
          defaultValue: false,
          describe: 'Omit the default extra whiteline added to code blocks',
          type: 'boolean'
        },
        noHeaderId: {
          defaultValue: false,
          describe: 'Turn on/off generated header id',
          type: 'boolean'
        },
        prefixHeaderId: {
          defaultValue: false,
          describe: 'Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic \'section-\' prefix',
          type: 'string'
        },
        rawPrefixHeaderId: {
          defaultValue: false,
          describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
          type: 'boolean'
        },
        ghCompatibleHeaderId: {
          defaultValue: false,
          describe: 'Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)',
          type: 'boolean'
        },
        rawHeaderId: {
          defaultValue: false,
          describe: 'Remove only spaces, \' and " from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids',
          type: 'boolean'
        },
        headerLevelStart: {
          defaultValue: false,
          describe: 'The header blocks level start',
          type: 'integer'
        },
        parseImgDimensions: {
          defaultValue: false,
          describe: 'Turn on/off image dimension parsing',
          type: 'boolean'
        },
        simplifiedAutoLink: {
          defaultValue: false,
          describe: 'Turn on/off GFM autolink style',
          type: 'boolean'
        },
        excludeTrailingPunctuationFromURLs: {
          defaultValue: false,
          describe: 'Excludes trailing punctuation from links generated with autoLinking',
          type: 'boolean'
        },
        literalMidWordUnderscores: {
          defaultValue: false,
          describe: 'Parse midword underscores as literal underscores',
          type: 'boolean'
        },
        literalMidWordAsterisks: {
          defaultValue: false,
          describe: 'Parse midword asterisks as literal asterisks',
          type: 'boolean'
        },
        strikethrough: {
          defaultValue: false,
          describe: 'Turn on/off strikethrough support',
          type: 'boolean'
        },
        tables: {
          defaultValue: false,
          describe: 'Turn on/off tables support',
          type: 'boolean'
        },
        tablesHeaderId: {
          defaultValue: false,
          describe: 'Add an id to table headers',
          type: 'boolean'
        },
        ghCodeBlocks: {
          defaultValue: true,
          describe: 'Turn on/off GFM fenced code blocks support',
          type: 'boolean'
        },
        tasklists: {
          defaultValue: false,
          describe: 'Turn on/off GFM tasklist support',
          type: 'boolean'
        },
        smoothLivePreview: {
          defaultValue: false,
          describe: 'Prevents weird effects in live previews due to incomplete input',
          type: 'boolean'
        },
        smartIndentationFix: {
          defaultValue: false,
          description: 'Tries to smartly fix indentation in es6 strings',
          type: 'boolean'
        },
        disableForced4SpacesIndentedSublists: {
          defaultValue: false,
          description: 'Disables the requirement of indenting nested sublists by 4 spaces',
          type: 'boolean'
        },
        simpleLineBreaks: {
          defaultValue: false,
          description: 'Parses simple line breaks as <br> (GFM Style)',
          type: 'boolean'
        },
        requireSpaceBeforeHeadingText: {
          defaultValue: false,
          description: 'Makes adding a space between `#` and the header text mandatory (GFM Style)',
          type: 'boolean'
        },
        ghMentions: {
          defaultValue: false,
          description: 'Enables github @mentions',
          type: 'boolean'
        },
        ghMentionsLink: {
          defaultValue: 'https://github.com/{u}',
          description: 'Changes the link generated by @mentions. Only applies if ghMentions option is enabled.',
          type: 'string'
        },
        encodeEmails: {
          defaultValue: true,
          description: 'Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities',
          type: 'boolean'
        },
        openLinksInNewWindow: {
          defaultValue: false,
          description: 'Open all links in new windows',
          type: 'boolean'
        },
        backslashEscapesHTMLTags: {
          defaultValue: false,
          description: 'Support for HTML Tag escaping. ex: \<div>foo\</div>',
          type: 'boolean'
        },
        emoji: {
          defaultValue: false,
          description: 'Enable emoji support. Ex: `this is a :smile: emoji`',
          type: 'boolean'
        },
        underline: {
          defaultValue: false,
          description: 'Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`',
          type: 'boolean'
        },
        completeHTMLDocument: {
          defaultValue: false,
          description: 'Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags',
          type: 'boolean'
        },
        metadata: {
          defaultValue: false,
          description: 'Enable support for document metadata (defined at the top of the document between `«««` and `»»»` or between `---` and `---`).',
          type: 'boolean'
        },
        splitAdjacentBlockquotes: {
          defaultValue: false,
          description: 'Split adjacent blockquote blocks',
          type: 'boolean'
        }
      };

      if (simple === false) {
        return JSON.parse(JSON.stringify(defaultOptions));
      }

      var ret = {};

      for (var opt in defaultOptions) {
        if (defaultOptions.hasOwnProperty(opt)) {
          ret[opt] = defaultOptions[opt].defaultValue;
        }
      }

      return ret;
    }

    function allOptionsOn() {

      var options = getDefaultOpts(true),
          ret = {};

      for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
          ret[opt] = true;
        }
      }

      return ret;
    }
    /**
     * Created by Tivie on 06-01-2015.
     */
    // Private properties


    var showdown = {},
        parsers = {},
        extensions = {},
        globalOptions = getDefaultOpts(true),
        setFlavor = 'vanilla',
        flavor = {
      github: {
        omitExtraWLInCodeBlocks: true,
        simplifiedAutoLink: true,
        excludeTrailingPunctuationFromURLs: true,
        literalMidWordUnderscores: true,
        strikethrough: true,
        tables: true,
        tablesHeaderId: true,
        ghCodeBlocks: true,
        tasklists: true,
        disableForced4SpacesIndentedSublists: true,
        simpleLineBreaks: true,
        requireSpaceBeforeHeadingText: true,
        ghCompatibleHeaderId: true,
        ghMentions: true,
        backslashEscapesHTMLTags: true,
        emoji: true,
        splitAdjacentBlockquotes: true
      },
      original: {
        noHeaderId: true,
        ghCodeBlocks: false
      },
      ghost: {
        omitExtraWLInCodeBlocks: true,
        parseImgDimensions: true,
        simplifiedAutoLink: true,
        excludeTrailingPunctuationFromURLs: true,
        literalMidWordUnderscores: true,
        strikethrough: true,
        tables: true,
        tablesHeaderId: true,
        ghCodeBlocks: true,
        tasklists: true,
        smoothLivePreview: true,
        simpleLineBreaks: true,
        requireSpaceBeforeHeadingText: true,
        ghMentions: false,
        encodeEmails: true
      },
      vanilla: getDefaultOpts(true),
      allOn: allOptionsOn()
    };
    /**
     * helper namespace
     * @type {{}}
     */

    showdown.helper = {};
    /**
     * TODO LEGACY SUPPORT CODE
     * @type {{}}
     */

    showdown.extensions = {};
    /**
     * Set a global option
     * @static
     * @param {string} key
     * @param {*} value
     * @returns {showdown}
     */

    showdown.setOption = function (key, value) {

      globalOptions[key] = value;
      return this;
    };
    /**
     * Get a global option
     * @static
     * @param {string} key
     * @returns {*}
     */


    showdown.getOption = function (key) {

      return globalOptions[key];
    };
    /**
     * Get the global options
     * @static
     * @returns {{}}
     */


    showdown.getOptions = function () {

      return globalOptions;
    };
    /**
     * Reset global options to the default values
     * @static
     */


    showdown.resetOptions = function () {

      globalOptions = getDefaultOpts(true);
    };
    /**
     * Set the flavor showdown should use as default
     * @param {string} name
     */


    showdown.setFlavor = function (name) {

      if (!flavor.hasOwnProperty(name)) {
        throw Error(name + ' flavor was not found');
      }

      showdown.resetOptions();
      var preset = flavor[name];
      setFlavor = name;

      for (var option in preset) {
        if (preset.hasOwnProperty(option)) {
          globalOptions[option] = preset[option];
        }
      }
    };
    /**
     * Get the currently set flavor
     * @returns {string}
     */


    showdown.getFlavor = function () {

      return setFlavor;
    };
    /**
     * Get the options of a specified flavor. Returns undefined if the flavor was not found
     * @param {string} name Name of the flavor
     * @returns {{}|undefined}
     */


    showdown.getFlavorOptions = function (name) {

      if (flavor.hasOwnProperty(name)) {
        return flavor[name];
      }
    };
    /**
     * Get the default options
     * @static
     * @param {boolean} [simple=true]
     * @returns {{}}
     */


    showdown.getDefaultOptions = function (simple) {

      return getDefaultOpts(simple);
    };
    /**
     * Get or set a subParser
     *
     * subParser(name)       - Get a registered subParser
     * subParser(name, func) - Register a subParser
     * @static
     * @param {string} name
     * @param {function} [func]
     * @returns {*}
     */


    showdown.subParser = function (name, func) {

      if (showdown.helper.isString(name)) {
        if (typeof func !== 'undefined') {
          parsers[name] = func;
        } else {
          if (parsers.hasOwnProperty(name)) {
            return parsers[name];
          } else {
            throw Error('SubParser named ' + name + ' not registered!');
          }
        }
      }
    };
    /**
     * Gets or registers an extension
     * @static
     * @param {string} name
     * @param {object|function=} ext
     * @returns {*}
     */


    showdown.extension = function (name, ext) {

      if (!showdown.helper.isString(name)) {
        throw Error('Extension \'name\' must be a string');
      }

      name = showdown.helper.stdExtName(name); // Getter

      if (showdown.helper.isUndefined(ext)) {
        if (!extensions.hasOwnProperty(name)) {
          throw Error('Extension named ' + name + ' is not registered!');
        }

        return extensions[name]; // Setter
      } else {
        // Expand extension if it's wrapped in a function
        if (typeof ext === 'function') {
          ext = ext();
        } // Ensure extension is an array


        if (!showdown.helper.isArray(ext)) {
          ext = [ext];
        }

        var validExtension = validate(ext, name);

        if (validExtension.valid) {
          extensions[name] = ext;
        } else {
          throw Error(validExtension.error);
        }
      }
    };
    /**
     * Gets all extensions registered
     * @returns {{}}
     */


    showdown.getAllExtensions = function () {

      return extensions;
    };
    /**
     * Remove an extension
     * @param {string} name
     */


    showdown.removeExtension = function (name) {

      delete extensions[name];
    };
    /**
     * Removes all extensions
     */


    showdown.resetExtensions = function () {

      extensions = {};
    };
    /**
     * Validate extension
     * @param {array} extension
     * @param {string} name
     * @returns {{valid: boolean, error: string}}
     */


    function validate(extension, name) {

      var errMsg = name ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension',
          ret = {
        valid: true,
        error: ''
      };

      if (!showdown.helper.isArray(extension)) {
        extension = [extension];
      }

      for (var i = 0; i < extension.length; ++i) {
        var baseMsg = errMsg + ' sub-extension ' + i + ': ',
            ext = extension[i];

        if (_typeof(ext) !== 'object') {
          ret.valid = false;
          ret.error = baseMsg + 'must be an object, but ' + _typeof(ext) + ' given';
          return ret;
        }

        if (!showdown.helper.isString(ext.type)) {
          ret.valid = false;
          ret.error = baseMsg + 'property "type" must be a string, but ' + _typeof(ext.type) + ' given';
          return ret;
        }

        var type = ext.type = ext.type.toLowerCase(); // normalize extension type

        if (type === 'language') {
          type = ext.type = 'lang';
        }

        if (type === 'html') {
          type = ext.type = 'output';
        }

        if (type !== 'lang' && type !== 'output' && type !== 'listener') {
          ret.valid = false;
          ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
          return ret;
        }

        if (type === 'listener') {
          if (showdown.helper.isUndefined(ext.listeners)) {
            ret.valid = false;
            ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
            return ret;
          }
        } else {
          if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
            ret.valid = false;
            ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
            return ret;
          }
        }

        if (ext.listeners) {
          if (_typeof(ext.listeners) !== 'object') {
            ret.valid = false;
            ret.error = baseMsg + '"listeners" property must be an object but ' + _typeof(ext.listeners) + ' given';
            return ret;
          }

          for (var ln in ext.listeners) {
            if (ext.listeners.hasOwnProperty(ln)) {
              if (typeof ext.listeners[ln] !== 'function') {
                ret.valid = false;
                ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln + ' must be a function but ' + _typeof(ext.listeners[ln]) + ' given';
                return ret;
              }
            }
          }
        }

        if (ext.filter) {
          if (typeof ext.filter !== 'function') {
            ret.valid = false;
            ret.error = baseMsg + '"filter" must be a function, but ' + _typeof(ext.filter) + ' given';
            return ret;
          }
        } else if (ext.regex) {
          if (showdown.helper.isString(ext.regex)) {
            ext.regex = new RegExp(ext.regex, 'g');
          }

          if (!(ext.regex instanceof RegExp)) {
            ret.valid = false;
            ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + _typeof(ext.regex) + ' given';
            return ret;
          }

          if (showdown.helper.isUndefined(ext.replace)) {
            ret.valid = false;
            ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
            return ret;
          }
        }
      }

      return ret;
    }
    /**
     * Validate extension
     * @param {object} ext
     * @returns {boolean}
     */


    showdown.validateExtension = function (ext) {

      var validateExtension = validate(ext, null);

      if (!validateExtension.valid) {
        console.warn(validateExtension.error);
        return false;
      }

      return true;
    };
    /**
     * showdownjs helper functions
     */


    if (!showdown.hasOwnProperty('helper')) {
      showdown.helper = {};
    }
    /**
     * Check if var is string
     * @static
     * @param {string} a
     * @returns {boolean}
     */


    showdown.helper.isString = function (a) {

      return typeof a === 'string' || a instanceof String;
    };
    /**
     * Check if var is a function
     * @static
     * @param {*} a
     * @returns {boolean}
     */


    showdown.helper.isFunction = function (a) {

      var getType = {};
      return a && getType.toString.call(a) === '[object Function]';
    };
    /**
     * isArray helper function
     * @static
     * @param {*} a
     * @returns {boolean}
     */


    showdown.helper.isArray = function (a) {

      return Array.isArray(a);
    };
    /**
     * Check if value is undefined
     * @static
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     */


    showdown.helper.isUndefined = function (value) {

      return typeof value === 'undefined';
    };
    /**
     * ForEach helper function
     * Iterates over Arrays and Objects (own properties only)
     * @static
     * @param {*} obj
     * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
     */


    showdown.helper.forEach = function (obj, callback) {

      if (showdown.helper.isUndefined(obj)) {
        throw new Error('obj param is required');
      }

      if (showdown.helper.isUndefined(callback)) {
        throw new Error('callback param is required');
      }

      if (!showdown.helper.isFunction(callback)) {
        throw new Error('callback param must be a function/closure');
      }

      if (typeof obj.forEach === 'function') {
        obj.forEach(callback);
      } else if (showdown.helper.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          callback(obj[i], i, obj);
        }
      } else if (_typeof(obj) === 'object') {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            callback(obj[prop], prop, obj);
          }
        }
      } else {
        throw new Error('obj does not seem to be an array or an iterable object');
      }
    };
    /**
     * Standardidize extension name
     * @static
     * @param {string} s extension name
     * @returns {string}
     */


    showdown.helper.stdExtName = function (s) {

      return s.replace(/[_?*+\/\\.^-]/g, '').replace(/\s/g, '').toLowerCase();
    };

    function escapeCharactersCallback(wholeMatch, m1) {

      var charCodeToEscape = m1.charCodeAt(0);
      return '¨E' + charCodeToEscape + 'E';
    }
    /**
     * Callback used to escape characters when passing through String.replace
     * @static
     * @param {string} wholeMatch
     * @param {string} m1
     * @returns {string}
     */


    showdown.helper.escapeCharactersCallback = escapeCharactersCallback;
    /**
     * Escape characters in a string
     * @static
     * @param {string} text
     * @param {string} charsToEscape
     * @param {boolean} afterBackslash
     * @returns {XML|string|void|*}
     */

    showdown.helper.escapeCharacters = function (text, charsToEscape, afterBackslash) {
      // we can build a character class out of them

      var regexString = '([' + charsToEscape.replace(/([\[\]\\])/g, '\\$1') + '])';

      if (afterBackslash) {
        regexString = '\\\\' + regexString;
      }

      var regex = new RegExp(regexString, 'g');
      text = text.replace(regex, escapeCharactersCallback);
      return text;
    };
    /**
     * Unescape HTML entities
     * @param txt
     * @returns {string}
     */


    showdown.helper.unescapeHTMLEntities = function (txt) {

      return txt.replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    };

    var rgxFindMatchPos = function rgxFindMatchPos(str, left, right, flags) {

      var f = flags || '',
          g = f.indexOf('g') > -1,
          x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')),
          l = new RegExp(left, f.replace(/g/g, '')),
          pos = [],
          t,
          s,
          m,
          start,
          end;

      do {
        t = 0;

        while (m = x.exec(str)) {
          if (l.test(m[0])) {
            if (!t++) {
              s = x.lastIndex;
              start = s - m[0].length;
            }
          } else if (t) {
            if (! --t) {
              end = m.index + m[0].length;
              var obj = {
                left: {
                  start: start,
                  end: s
                },
                match: {
                  start: s,
                  end: m.index
                },
                right: {
                  start: m.index,
                  end: end
                },
                wholeMatch: {
                  start: start,
                  end: end
                }
              };
              pos.push(obj);

              if (!g) {
                return pos;
              }
            }
          }
        }
      } while (t && (x.lastIndex = s));

      return pos;
    };
    /**
     * matchRecursiveRegExp
     *
     * (c) 2007 Steven Levithan <stevenlevithan.com>
     * MIT License
     *
     * Accepts a string to search, a left and right format delimiter
     * as regex patterns, and optional regex flags. Returns an array
     * of matches, allowing nested instances of left/right delimiters.
     * Use the "g" flag to return all matches, otherwise only the
     * first is returned. Be careful to ensure that the left and
     * right format delimiters produce mutually exclusive matches.
     * Backreferences are not supported within the right delimiter
     * due to how it is internally combined with the left delimiter.
     * When matching strings whose format delimiters are unbalanced
     * to the left or right, the output is intentionally as a
     * conventional regex library with recursion support would
     * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
     * "<" and ">" as the delimiters (both strings contain a single,
     * balanced instance of "<x>").
     *
     * examples:
     * matchRecursiveRegExp("test", "\\(", "\\)")
     * returns: []
     * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
     * returns: ["t<<e>><s>", ""]
     * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
     * returns: ["test"]
     */


    showdown.helper.matchRecursiveRegExp = function (str, left, right, flags) {

      var matchPos = rgxFindMatchPos(str, left, right, flags),
          results = [];

      for (var i = 0; i < matchPos.length; ++i) {
        results.push([str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end), str.slice(matchPos[i].match.start, matchPos[i].match.end), str.slice(matchPos[i].left.start, matchPos[i].left.end), str.slice(matchPos[i].right.start, matchPos[i].right.end)]);
      }

      return results;
    };
    /**
     *
     * @param {string} str
     * @param {string|function} replacement
     * @param {string} left
     * @param {string} right
     * @param {string} flags
     * @returns {string}
     */


    showdown.helper.replaceRecursiveRegExp = function (str, replacement, left, right, flags) {

      if (!showdown.helper.isFunction(replacement)) {
        var repStr = replacement;

        replacement = function replacement() {
          return repStr;
        };
      }

      var matchPos = rgxFindMatchPos(str, left, right, flags),
          finalStr = str,
          lng = matchPos.length;

      if (lng > 0) {
        var bits = [];

        if (matchPos[0].wholeMatch.start !== 0) {
          bits.push(str.slice(0, matchPos[0].wholeMatch.start));
        }

        for (var i = 0; i < lng; ++i) {
          bits.push(replacement(str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end), str.slice(matchPos[i].match.start, matchPos[i].match.end), str.slice(matchPos[i].left.start, matchPos[i].left.end), str.slice(matchPos[i].right.start, matchPos[i].right.end)));

          if (i < lng - 1) {
            bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
          }
        }

        if (matchPos[lng - 1].wholeMatch.end < str.length) {
          bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
        }

        finalStr = bits.join('');
      }

      return finalStr;
    };
    /**
     * Returns the index within the passed String object of the first occurrence of the specified regex,
     * starting the search at fromIndex. Returns -1 if the value is not found.
     *
     * @param {string} str string to search
     * @param {RegExp} regex Regular expression to search
     * @param {int} [fromIndex = 0] Index to start the search
     * @returns {Number}
     * @throws InvalidArgumentError
     */


    showdown.helper.regexIndexOf = function (str, regex, fromIndex) {

      if (!showdown.helper.isString(str)) {
        throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
      }

      if (regex instanceof RegExp === false) {
        throw 'InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp';
      }

      var indexOf = str.substring(fromIndex || 0).search(regex);
      return indexOf >= 0 ? indexOf + (fromIndex || 0) : indexOf;
    };
    /**
     * Splits the passed string object at the defined index, and returns an array composed of the two substrings
     * @param {string} str string to split
     * @param {int} index index to split string at
     * @returns {[string,string]}
     * @throws InvalidArgumentError
     */


    showdown.helper.splitAtIndex = function (str, index) {

      if (!showdown.helper.isString(str)) {
        throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
      }

      return [str.substring(0, index), str.substring(index)];
    };
    /**
     * Obfuscate an e-mail address through the use of Character Entities,
     * transforming ASCII characters into their equivalent decimal or hex entities.
     *
     * Since it has a random component, subsequent calls to this function produce different results
     *
     * @param {string} mail
     * @returns {string}
     */


    showdown.helper.encodeEmailAddress = function (mail) {

      var encode = [function (ch) {
        return '&#' + ch.charCodeAt(0) + ';';
      }, function (ch) {
        return '&#x' + ch.charCodeAt(0).toString(16) + ';';
      }, function (ch) {
        return ch;
      }];
      mail = mail.replace(/./g, function (ch) {
        if (ch === '@') {
          // this *must* be encoded. I insist.
          ch = encode[Math.floor(Math.random() * 2)](ch);
        } else {
          var r = Math.random(); // roughly 10% raw, 45% hex, 45% dec

          ch = r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch);
        }

        return ch;
      });
      return mail;
    };
    /**
     *
     * @param str
     * @param targetLength
     * @param padString
     * @returns {string}
     */


    showdown.helper.padEnd = function padEnd(str, targetLength, padString) {
      /*jshint bitwise: false*/
      // eslint-disable-next-line space-infix-ops

      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;

      /*jshint bitwise: true*/

      padString = String(padString || ' ');

      if (str.length > targetLength) {
        return String(str);
      } else {
        targetLength = targetLength - str.length;

        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }

        return String(str) + padString.slice(0, targetLength);
      }
    };
    /**
     * POLYFILLS
     */
    // use this instead of builtin is undefined for IE8 compatibility


    if (typeof console === 'undefined') {
      console = {
        warn: function warn(msg) {

          alert(msg);
        },
        log: function log(msg) {

          alert(msg);
        },
        error: function error(msg) {

          throw msg;
        }
      };
    }
    /**
     * Common regexes.
     * We declare some common regexes to improve performance
     */


    showdown.helper.regexes = {
      asteriskDashAndColon: /([*_:~])/g
    };
    /**
     * EMOJIS LIST
     */

    showdown.helper.emojis = {
      '+1': "\uD83D\uDC4D",
      '-1': "\uD83D\uDC4E",
      '100': "\uD83D\uDCAF",
      '1234': "\uD83D\uDD22",
      '1st_place_medal': "\uD83E\uDD47",
      '2nd_place_medal': "\uD83E\uDD48",
      '3rd_place_medal': "\uD83E\uDD49",
      '8ball': "\uD83C\uDFB1",
      'a': "\uD83C\uDD70\uFE0F",
      'ab': "\uD83C\uDD8E",
      'abc': "\uD83D\uDD24",
      'abcd': "\uD83D\uDD21",
      'accept': "\uD83C\uDE51",
      'aerial_tramway': "\uD83D\uDEA1",
      'airplane': "\u2708\uFE0F",
      'alarm_clock': "\u23F0",
      'alembic': "\u2697\uFE0F",
      'alien': "\uD83D\uDC7D",
      'ambulance': "\uD83D\uDE91",
      'amphora': "\uD83C\uDFFA",
      'anchor': "\u2693\uFE0F",
      'angel': "\uD83D\uDC7C",
      'anger': "\uD83D\uDCA2",
      'angry': "\uD83D\uDE20",
      'anguished': "\uD83D\uDE27",
      'ant': "\uD83D\uDC1C",
      'apple': "\uD83C\uDF4E",
      'aquarius': "\u2652\uFE0F",
      'aries': "\u2648\uFE0F",
      'arrow_backward': "\u25C0\uFE0F",
      'arrow_double_down': "\u23EC",
      'arrow_double_up': "\u23EB",
      'arrow_down': "\u2B07\uFE0F",
      'arrow_down_small': "\uD83D\uDD3D",
      'arrow_forward': "\u25B6\uFE0F",
      'arrow_heading_down': "\u2935\uFE0F",
      'arrow_heading_up': "\u2934\uFE0F",
      'arrow_left': "\u2B05\uFE0F",
      'arrow_lower_left': "\u2199\uFE0F",
      'arrow_lower_right': "\u2198\uFE0F",
      'arrow_right': "\u27A1\uFE0F",
      'arrow_right_hook': "\u21AA\uFE0F",
      'arrow_up': "\u2B06\uFE0F",
      'arrow_up_down': "\u2195\uFE0F",
      'arrow_up_small': "\uD83D\uDD3C",
      'arrow_upper_left': "\u2196\uFE0F",
      'arrow_upper_right': "\u2197\uFE0F",
      'arrows_clockwise': "\uD83D\uDD03",
      'arrows_counterclockwise': "\uD83D\uDD04",
      'art': "\uD83C\uDFA8",
      'articulated_lorry': "\uD83D\uDE9B",
      'artificial_satellite': "\uD83D\uDEF0",
      'astonished': "\uD83D\uDE32",
      'athletic_shoe': "\uD83D\uDC5F",
      'atm': "\uD83C\uDFE7",
      'atom_symbol': "\u269B\uFE0F",
      'avocado': "\uD83E\uDD51",
      'b': "\uD83C\uDD71\uFE0F",
      'baby': "\uD83D\uDC76",
      'baby_bottle': "\uD83C\uDF7C",
      'baby_chick': "\uD83D\uDC24",
      'baby_symbol': "\uD83D\uDEBC",
      'back': "\uD83D\uDD19",
      'bacon': "\uD83E\uDD53",
      'badminton': "\uD83C\uDFF8",
      'baggage_claim': "\uD83D\uDEC4",
      'baguette_bread': "\uD83E\uDD56",
      'balance_scale': "\u2696\uFE0F",
      'balloon': "\uD83C\uDF88",
      'ballot_box': "\uD83D\uDDF3",
      'ballot_box_with_check': "\u2611\uFE0F",
      'bamboo': "\uD83C\uDF8D",
      'banana': "\uD83C\uDF4C",
      'bangbang': "\u203C\uFE0F",
      'bank': "\uD83C\uDFE6",
      'bar_chart': "\uD83D\uDCCA",
      'barber': "\uD83D\uDC88",
      'baseball': "\u26BE\uFE0F",
      'basketball': "\uD83C\uDFC0",
      'basketball_man': "\u26F9\uFE0F",
      'basketball_woman': "\u26F9\uFE0F&zwj;\u2640\uFE0F",
      'bat': "\uD83E\uDD87",
      'bath': "\uD83D\uDEC0",
      'bathtub': "\uD83D\uDEC1",
      'battery': "\uD83D\uDD0B",
      'beach_umbrella': "\uD83C\uDFD6",
      'bear': "\uD83D\uDC3B",
      'bed': "\uD83D\uDECF",
      'bee': "\uD83D\uDC1D",
      'beer': "\uD83C\uDF7A",
      'beers': "\uD83C\uDF7B",
      'beetle': "\uD83D\uDC1E",
      'beginner': "\uD83D\uDD30",
      'bell': "\uD83D\uDD14",
      'bellhop_bell': "\uD83D\uDECE",
      'bento': "\uD83C\uDF71",
      'biking_man': "\uD83D\uDEB4",
      'bike': "\uD83D\uDEB2",
      'biking_woman': "\uD83D\uDEB4&zwj;\u2640\uFE0F",
      'bikini': "\uD83D\uDC59",
      'biohazard': "\u2623\uFE0F",
      'bird': "\uD83D\uDC26",
      'birthday': "\uD83C\uDF82",
      'black_circle': "\u26AB\uFE0F",
      'black_flag': "\uD83C\uDFF4",
      'black_heart': "\uD83D\uDDA4",
      'black_joker': "\uD83C\uDCCF",
      'black_large_square': "\u2B1B\uFE0F",
      'black_medium_small_square': "\u25FE\uFE0F",
      'black_medium_square': "\u25FC\uFE0F",
      'black_nib': "\u2712\uFE0F",
      'black_small_square': "\u25AA\uFE0F",
      'black_square_button': "\uD83D\uDD32",
      'blonde_man': "\uD83D\uDC71",
      'blonde_woman': "\uD83D\uDC71&zwj;\u2640\uFE0F",
      'blossom': "\uD83C\uDF3C",
      'blowfish': "\uD83D\uDC21",
      'blue_book': "\uD83D\uDCD8",
      'blue_car': "\uD83D\uDE99",
      'blue_heart': "\uD83D\uDC99",
      'blush': "\uD83D\uDE0A",
      'boar': "\uD83D\uDC17",
      'boat': "\u26F5\uFE0F",
      'bomb': "\uD83D\uDCA3",
      'book': "\uD83D\uDCD6",
      'bookmark': "\uD83D\uDD16",
      'bookmark_tabs': "\uD83D\uDCD1",
      'books': "\uD83D\uDCDA",
      'boom': "\uD83D\uDCA5",
      'boot': "\uD83D\uDC62",
      'bouquet': "\uD83D\uDC90",
      'bowing_man': "\uD83D\uDE47",
      'bow_and_arrow': "\uD83C\uDFF9",
      'bowing_woman': "\uD83D\uDE47&zwj;\u2640\uFE0F",
      'bowling': "\uD83C\uDFB3",
      'boxing_glove': "\uD83E\uDD4A",
      'boy': "\uD83D\uDC66",
      'bread': "\uD83C\uDF5E",
      'bride_with_veil': "\uD83D\uDC70",
      'bridge_at_night': "\uD83C\uDF09",
      'briefcase': "\uD83D\uDCBC",
      'broken_heart': "\uD83D\uDC94",
      'bug': "\uD83D\uDC1B",
      'building_construction': "\uD83C\uDFD7",
      'bulb': "\uD83D\uDCA1",
      'bullettrain_front': "\uD83D\uDE85",
      'bullettrain_side': "\uD83D\uDE84",
      'burrito': "\uD83C\uDF2F",
      'bus': "\uD83D\uDE8C",
      'business_suit_levitating': "\uD83D\uDD74",
      'busstop': "\uD83D\uDE8F",
      'bust_in_silhouette': "\uD83D\uDC64",
      'busts_in_silhouette': "\uD83D\uDC65",
      'butterfly': "\uD83E\uDD8B",
      'cactus': "\uD83C\uDF35",
      'cake': "\uD83C\uDF70",
      'calendar': "\uD83D\uDCC6",
      'call_me_hand': "\uD83E\uDD19",
      'calling': "\uD83D\uDCF2",
      'camel': "\uD83D\uDC2B",
      'camera': "\uD83D\uDCF7",
      'camera_flash': "\uD83D\uDCF8",
      'camping': "\uD83C\uDFD5",
      'cancer': "\u264B\uFE0F",
      'candle': "\uD83D\uDD6F",
      'candy': "\uD83C\uDF6C",
      'canoe': "\uD83D\uDEF6",
      'capital_abcd': "\uD83D\uDD20",
      'capricorn': "\u2651\uFE0F",
      'car': "\uD83D\uDE97",
      'card_file_box': "\uD83D\uDDC3",
      'card_index': "\uD83D\uDCC7",
      'card_index_dividers': "\uD83D\uDDC2",
      'carousel_horse': "\uD83C\uDFA0",
      'carrot': "\uD83E\uDD55",
      'cat': "\uD83D\uDC31",
      'cat2': "\uD83D\uDC08",
      'cd': "\uD83D\uDCBF",
      'chains': "\u26D3",
      'champagne': "\uD83C\uDF7E",
      'chart': "\uD83D\uDCB9",
      'chart_with_downwards_trend': "\uD83D\uDCC9",
      'chart_with_upwards_trend': "\uD83D\uDCC8",
      'checkered_flag': "\uD83C\uDFC1",
      'cheese': "\uD83E\uDDC0",
      'cherries': "\uD83C\uDF52",
      'cherry_blossom': "\uD83C\uDF38",
      'chestnut': "\uD83C\uDF30",
      'chicken': "\uD83D\uDC14",
      'children_crossing': "\uD83D\uDEB8",
      'chipmunk': "\uD83D\uDC3F",
      'chocolate_bar': "\uD83C\uDF6B",
      'christmas_tree': "\uD83C\uDF84",
      'church': "\u26EA\uFE0F",
      'cinema': "\uD83C\uDFA6",
      'circus_tent': "\uD83C\uDFAA",
      'city_sunrise': "\uD83C\uDF07",
      'city_sunset': "\uD83C\uDF06",
      'cityscape': "\uD83C\uDFD9",
      'cl': "\uD83C\uDD91",
      'clamp': "\uD83D\uDDDC",
      'clap': "\uD83D\uDC4F",
      'clapper': "\uD83C\uDFAC",
      'classical_building': "\uD83C\uDFDB",
      'clinking_glasses': "\uD83E\uDD42",
      'clipboard': "\uD83D\uDCCB",
      'clock1': "\uD83D\uDD50",
      'clock10': "\uD83D\uDD59",
      'clock1030': "\uD83D\uDD65",
      'clock11': "\uD83D\uDD5A",
      'clock1130': "\uD83D\uDD66",
      'clock12': "\uD83D\uDD5B",
      'clock1230': "\uD83D\uDD67",
      'clock130': "\uD83D\uDD5C",
      'clock2': "\uD83D\uDD51",
      'clock230': "\uD83D\uDD5D",
      'clock3': "\uD83D\uDD52",
      'clock330': "\uD83D\uDD5E",
      'clock4': "\uD83D\uDD53",
      'clock430': "\uD83D\uDD5F",
      'clock5': "\uD83D\uDD54",
      'clock530': "\uD83D\uDD60",
      'clock6': "\uD83D\uDD55",
      'clock630': "\uD83D\uDD61",
      'clock7': "\uD83D\uDD56",
      'clock730': "\uD83D\uDD62",
      'clock8': "\uD83D\uDD57",
      'clock830': "\uD83D\uDD63",
      'clock9': "\uD83D\uDD58",
      'clock930': "\uD83D\uDD64",
      'closed_book': "\uD83D\uDCD5",
      'closed_lock_with_key': "\uD83D\uDD10",
      'closed_umbrella': "\uD83C\uDF02",
      'cloud': "\u2601\uFE0F",
      'cloud_with_lightning': "\uD83C\uDF29",
      'cloud_with_lightning_and_rain': "\u26C8",
      'cloud_with_rain': "\uD83C\uDF27",
      'cloud_with_snow': "\uD83C\uDF28",
      'clown_face': "\uD83E\uDD21",
      'clubs': "\u2663\uFE0F",
      'cocktail': "\uD83C\uDF78",
      'coffee': "\u2615\uFE0F",
      'coffin': "\u26B0\uFE0F",
      'cold_sweat': "\uD83D\uDE30",
      'comet': "\u2604\uFE0F",
      'computer': "\uD83D\uDCBB",
      'computer_mouse': "\uD83D\uDDB1",
      'confetti_ball': "\uD83C\uDF8A",
      'confounded': "\uD83D\uDE16",
      'confused': "\uD83D\uDE15",
      'congratulations': "\u3297\uFE0F",
      'construction': "\uD83D\uDEA7",
      'construction_worker_man': "\uD83D\uDC77",
      'construction_worker_woman': "\uD83D\uDC77&zwj;\u2640\uFE0F",
      'control_knobs': "\uD83C\uDF9B",
      'convenience_store': "\uD83C\uDFEA",
      'cookie': "\uD83C\uDF6A",
      'cool': "\uD83C\uDD92",
      'policeman': "\uD83D\uDC6E",
      'copyright': "\xA9\uFE0F",
      'corn': "\uD83C\uDF3D",
      'couch_and_lamp': "\uD83D\uDECB",
      'couple': "\uD83D\uDC6B",
      'couple_with_heart_woman_man': "\uD83D\uDC91",
      'couple_with_heart_man_man': "\uD83D\uDC68&zwj;\u2764\uFE0F&zwj;\uD83D\uDC68",
      'couple_with_heart_woman_woman': "\uD83D\uDC69&zwj;\u2764\uFE0F&zwj;\uD83D\uDC69",
      'couplekiss_man_man': "\uD83D\uDC68&zwj;\u2764\uFE0F&zwj;\uD83D\uDC8B&zwj;\uD83D\uDC68",
      'couplekiss_man_woman': "\uD83D\uDC8F",
      'couplekiss_woman_woman': "\uD83D\uDC69&zwj;\u2764\uFE0F&zwj;\uD83D\uDC8B&zwj;\uD83D\uDC69",
      'cow': "\uD83D\uDC2E",
      'cow2': "\uD83D\uDC04",
      'cowboy_hat_face': "\uD83E\uDD20",
      'crab': "\uD83E\uDD80",
      'crayon': "\uD83D\uDD8D",
      'credit_card': "\uD83D\uDCB3",
      'crescent_moon': "\uD83C\uDF19",
      'cricket': "\uD83C\uDFCF",
      'crocodile': "\uD83D\uDC0A",
      'croissant': "\uD83E\uDD50",
      'crossed_fingers': "\uD83E\uDD1E",
      'crossed_flags': "\uD83C\uDF8C",
      'crossed_swords': "\u2694\uFE0F",
      'crown': "\uD83D\uDC51",
      'cry': "\uD83D\uDE22",
      'crying_cat_face': "\uD83D\uDE3F",
      'crystal_ball': "\uD83D\uDD2E",
      'cucumber': "\uD83E\uDD52",
      'cupid': "\uD83D\uDC98",
      'curly_loop': "\u27B0",
      'currency_exchange': "\uD83D\uDCB1",
      'curry': "\uD83C\uDF5B",
      'custard': "\uD83C\uDF6E",
      'customs': "\uD83D\uDEC3",
      'cyclone': "\uD83C\uDF00",
      'dagger': "\uD83D\uDDE1",
      'dancer': "\uD83D\uDC83",
      'dancing_women': "\uD83D\uDC6F",
      'dancing_men': "\uD83D\uDC6F&zwj;\u2642\uFE0F",
      'dango': "\uD83C\uDF61",
      'dark_sunglasses': "\uD83D\uDD76",
      'dart': "\uD83C\uDFAF",
      'dash': "\uD83D\uDCA8",
      'date': "\uD83D\uDCC5",
      'deciduous_tree': "\uD83C\uDF33",
      'deer': "\uD83E\uDD8C",
      'department_store': "\uD83C\uDFEC",
      'derelict_house': "\uD83C\uDFDA",
      'desert': "\uD83C\uDFDC",
      'desert_island': "\uD83C\uDFDD",
      'desktop_computer': "\uD83D\uDDA5",
      'male_detective': "\uD83D\uDD75\uFE0F",
      'diamond_shape_with_a_dot_inside': "\uD83D\uDCA0",
      'diamonds': "\u2666\uFE0F",
      'disappointed': "\uD83D\uDE1E",
      'disappointed_relieved': "\uD83D\uDE25",
      'dizzy': "\uD83D\uDCAB",
      'dizzy_face': "\uD83D\uDE35",
      'do_not_litter': "\uD83D\uDEAF",
      'dog': "\uD83D\uDC36",
      'dog2': "\uD83D\uDC15",
      'dollar': "\uD83D\uDCB5",
      'dolls': "\uD83C\uDF8E",
      'dolphin': "\uD83D\uDC2C",
      'door': "\uD83D\uDEAA",
      'doughnut': "\uD83C\uDF69",
      'dove': "\uD83D\uDD4A",
      'dragon': "\uD83D\uDC09",
      'dragon_face': "\uD83D\uDC32",
      'dress': "\uD83D\uDC57",
      'dromedary_camel': "\uD83D\uDC2A",
      'drooling_face': "\uD83E\uDD24",
      'droplet': "\uD83D\uDCA7",
      'drum': "\uD83E\uDD41",
      'duck': "\uD83E\uDD86",
      'dvd': "\uD83D\uDCC0",
      'e-mail': "\uD83D\uDCE7",
      'eagle': "\uD83E\uDD85",
      'ear': "\uD83D\uDC42",
      'ear_of_rice': "\uD83C\uDF3E",
      'earth_africa': "\uD83C\uDF0D",
      'earth_americas': "\uD83C\uDF0E",
      'earth_asia': "\uD83C\uDF0F",
      'egg': "\uD83E\uDD5A",
      'eggplant': "\uD83C\uDF46",
      'eight_pointed_black_star': "\u2734\uFE0F",
      'eight_spoked_asterisk': "\u2733\uFE0F",
      'electric_plug': "\uD83D\uDD0C",
      'elephant': "\uD83D\uDC18",
      'email': "\u2709\uFE0F",
      'end': "\uD83D\uDD1A",
      'envelope_with_arrow': "\uD83D\uDCE9",
      'euro': "\uD83D\uDCB6",
      'european_castle': "\uD83C\uDFF0",
      'european_post_office': "\uD83C\uDFE4",
      'evergreen_tree': "\uD83C\uDF32",
      'exclamation': "\u2757\uFE0F",
      'expressionless': "\uD83D\uDE11",
      'eye': "\uD83D\uDC41",
      'eye_speech_bubble': "\uD83D\uDC41&zwj;\uD83D\uDDE8",
      'eyeglasses': "\uD83D\uDC53",
      'eyes': "\uD83D\uDC40",
      'face_with_head_bandage': "\uD83E\uDD15",
      'face_with_thermometer': "\uD83E\uDD12",
      'fist_oncoming': "\uD83D\uDC4A",
      'factory': "\uD83C\uDFED",
      'fallen_leaf': "\uD83C\uDF42",
      'family_man_woman_boy': "\uD83D\uDC6A",
      'family_man_boy': "\uD83D\uDC68&zwj;\uD83D\uDC66",
      'family_man_boy_boy': "\uD83D\uDC68&zwj;\uD83D\uDC66&zwj;\uD83D\uDC66",
      'family_man_girl': "\uD83D\uDC68&zwj;\uD83D\uDC67",
      'family_man_girl_boy': "\uD83D\uDC68&zwj;\uD83D\uDC67&zwj;\uD83D\uDC66",
      'family_man_girl_girl': "\uD83D\uDC68&zwj;\uD83D\uDC67&zwj;\uD83D\uDC67",
      'family_man_man_boy': "\uD83D\uDC68&zwj;\uD83D\uDC68&zwj;\uD83D\uDC66",
      'family_man_man_boy_boy': "\uD83D\uDC68&zwj;\uD83D\uDC68&zwj;\uD83D\uDC66&zwj;\uD83D\uDC66",
      'family_man_man_girl': "\uD83D\uDC68&zwj;\uD83D\uDC68&zwj;\uD83D\uDC67",
      'family_man_man_girl_boy': "\uD83D\uDC68&zwj;\uD83D\uDC68&zwj;\uD83D\uDC67&zwj;\uD83D\uDC66",
      'family_man_man_girl_girl': "\uD83D\uDC68&zwj;\uD83D\uDC68&zwj;\uD83D\uDC67&zwj;\uD83D\uDC67",
      'family_man_woman_boy_boy': "\uD83D\uDC68&zwj;\uD83D\uDC69&zwj;\uD83D\uDC66&zwj;\uD83D\uDC66",
      'family_man_woman_girl': "\uD83D\uDC68&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67",
      'family_man_woman_girl_boy': "\uD83D\uDC68&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC66",
      'family_man_woman_girl_girl': "\uD83D\uDC68&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC67",
      'family_woman_boy': "\uD83D\uDC69&zwj;\uD83D\uDC66",
      'family_woman_boy_boy': "\uD83D\uDC69&zwj;\uD83D\uDC66&zwj;\uD83D\uDC66",
      'family_woman_girl': "\uD83D\uDC69&zwj;\uD83D\uDC67",
      'family_woman_girl_boy': "\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC66",
      'family_woman_girl_girl': "\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC67",
      'family_woman_woman_boy': "\uD83D\uDC69&zwj;\uD83D\uDC69&zwj;\uD83D\uDC66",
      'family_woman_woman_boy_boy': "\uD83D\uDC69&zwj;\uD83D\uDC69&zwj;\uD83D\uDC66&zwj;\uD83D\uDC66",
      'family_woman_woman_girl': "\uD83D\uDC69&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67",
      'family_woman_woman_girl_boy': "\uD83D\uDC69&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC66",
      'family_woman_woman_girl_girl': "\uD83D\uDC69&zwj;\uD83D\uDC69&zwj;\uD83D\uDC67&zwj;\uD83D\uDC67",
      'fast_forward': "\u23E9",
      'fax': "\uD83D\uDCE0",
      'fearful': "\uD83D\uDE28",
      'feet': "\uD83D\uDC3E",
      'female_detective': "\uD83D\uDD75\uFE0F&zwj;\u2640\uFE0F",
      'ferris_wheel': "\uD83C\uDFA1",
      'ferry': "\u26F4",
      'field_hockey': "\uD83C\uDFD1",
      'file_cabinet': "\uD83D\uDDC4",
      'file_folder': "\uD83D\uDCC1",
      'film_projector': "\uD83D\uDCFD",
      'film_strip': "\uD83C\uDF9E",
      'fire': "\uD83D\uDD25",
      'fire_engine': "\uD83D\uDE92",
      'fireworks': "\uD83C\uDF86",
      'first_quarter_moon': "\uD83C\uDF13",
      'first_quarter_moon_with_face': "\uD83C\uDF1B",
      'fish': "\uD83D\uDC1F",
      'fish_cake': "\uD83C\uDF65",
      'fishing_pole_and_fish': "\uD83C\uDFA3",
      'fist_raised': "\u270A",
      'fist_left': "\uD83E\uDD1B",
      'fist_right': "\uD83E\uDD1C",
      'flags': "\uD83C\uDF8F",
      'flashlight': "\uD83D\uDD26",
      'fleur_de_lis': "\u269C\uFE0F",
      'flight_arrival': "\uD83D\uDEEC",
      'flight_departure': "\uD83D\uDEEB",
      'floppy_disk': "\uD83D\uDCBE",
      'flower_playing_cards': "\uD83C\uDFB4",
      'flushed': "\uD83D\uDE33",
      'fog': "\uD83C\uDF2B",
      'foggy': "\uD83C\uDF01",
      'football': "\uD83C\uDFC8",
      'footprints': "\uD83D\uDC63",
      'fork_and_knife': "\uD83C\uDF74",
      'fountain': "\u26F2\uFE0F",
      'fountain_pen': "\uD83D\uDD8B",
      'four_leaf_clover': "\uD83C\uDF40",
      'fox_face': "\uD83E\uDD8A",
      'framed_picture': "\uD83D\uDDBC",
      'free': "\uD83C\uDD93",
      'fried_egg': "\uD83C\uDF73",
      'fried_shrimp': "\uD83C\uDF64",
      'fries': "\uD83C\uDF5F",
      'frog': "\uD83D\uDC38",
      'frowning': "\uD83D\uDE26",
      'frowning_face': "\u2639\uFE0F",
      'frowning_man': "\uD83D\uDE4D&zwj;\u2642\uFE0F",
      'frowning_woman': "\uD83D\uDE4D",
      'middle_finger': "\uD83D\uDD95",
      'fuelpump': "\u26FD\uFE0F",
      'full_moon': "\uD83C\uDF15",
      'full_moon_with_face': "\uD83C\uDF1D",
      'funeral_urn': "\u26B1\uFE0F",
      'game_die': "\uD83C\uDFB2",
      'gear': "\u2699\uFE0F",
      'gem': "\uD83D\uDC8E",
      'gemini': "\u264A\uFE0F",
      'ghost': "\uD83D\uDC7B",
      'gift': "\uD83C\uDF81",
      'gift_heart': "\uD83D\uDC9D",
      'girl': "\uD83D\uDC67",
      'globe_with_meridians': "\uD83C\uDF10",
      'goal_net': "\uD83E\uDD45",
      'goat': "\uD83D\uDC10",
      'golf': "\u26F3\uFE0F",
      'golfing_man': "\uD83C\uDFCC\uFE0F",
      'golfing_woman': "\uD83C\uDFCC\uFE0F&zwj;\u2640\uFE0F",
      'gorilla': "\uD83E\uDD8D",
      'grapes': "\uD83C\uDF47",
      'green_apple': "\uD83C\uDF4F",
      'green_book': "\uD83D\uDCD7",
      'green_heart': "\uD83D\uDC9A",
      'green_salad': "\uD83E\uDD57",
      'grey_exclamation': "\u2755",
      'grey_question': "\u2754",
      'grimacing': "\uD83D\uDE2C",
      'grin': "\uD83D\uDE01",
      'grinning': "\uD83D\uDE00",
      'guardsman': "\uD83D\uDC82",
      'guardswoman': "\uD83D\uDC82&zwj;\u2640\uFE0F",
      'guitar': "\uD83C\uDFB8",
      'gun': "\uD83D\uDD2B",
      'haircut_woman': "\uD83D\uDC87",
      'haircut_man': "\uD83D\uDC87&zwj;\u2642\uFE0F",
      'hamburger': "\uD83C\uDF54",
      'hammer': "\uD83D\uDD28",
      'hammer_and_pick': "\u2692",
      'hammer_and_wrench': "\uD83D\uDEE0",
      'hamster': "\uD83D\uDC39",
      'hand': "\u270B",
      'handbag': "\uD83D\uDC5C",
      'handshake': "\uD83E\uDD1D",
      'hankey': "\uD83D\uDCA9",
      'hatched_chick': "\uD83D\uDC25",
      'hatching_chick': "\uD83D\uDC23",
      'headphones': "\uD83C\uDFA7",
      'hear_no_evil': "\uD83D\uDE49",
      'heart': "\u2764\uFE0F",
      'heart_decoration': "\uD83D\uDC9F",
      'heart_eyes': "\uD83D\uDE0D",
      'heart_eyes_cat': "\uD83D\uDE3B",
      'heartbeat': "\uD83D\uDC93",
      'heartpulse': "\uD83D\uDC97",
      'hearts': "\u2665\uFE0F",
      'heavy_check_mark': "\u2714\uFE0F",
      'heavy_division_sign': "\u2797",
      'heavy_dollar_sign': "\uD83D\uDCB2",
      'heavy_heart_exclamation': "\u2763\uFE0F",
      'heavy_minus_sign': "\u2796",
      'heavy_multiplication_x': "\u2716\uFE0F",
      'heavy_plus_sign': "\u2795",
      'helicopter': "\uD83D\uDE81",
      'herb': "\uD83C\uDF3F",
      'hibiscus': "\uD83C\uDF3A",
      'high_brightness': "\uD83D\uDD06",
      'high_heel': "\uD83D\uDC60",
      'hocho': "\uD83D\uDD2A",
      'hole': "\uD83D\uDD73",
      'honey_pot': "\uD83C\uDF6F",
      'horse': "\uD83D\uDC34",
      'horse_racing': "\uD83C\uDFC7",
      'hospital': "\uD83C\uDFE5",
      'hot_pepper': "\uD83C\uDF36",
      'hotdog': "\uD83C\uDF2D",
      'hotel': "\uD83C\uDFE8",
      'hotsprings': "\u2668\uFE0F",
      'hourglass': "\u231B\uFE0F",
      'hourglass_flowing_sand': "\u23F3",
      'house': "\uD83C\uDFE0",
      'house_with_garden': "\uD83C\uDFE1",
      'houses': "\uD83C\uDFD8",
      'hugs': "\uD83E\uDD17",
      'hushed': "\uD83D\uDE2F",
      'ice_cream': "\uD83C\uDF68",
      'ice_hockey': "\uD83C\uDFD2",
      'ice_skate': "\u26F8",
      'icecream': "\uD83C\uDF66",
      'id': "\uD83C\uDD94",
      'ideograph_advantage': "\uD83C\uDE50",
      'imp': "\uD83D\uDC7F",
      'inbox_tray': "\uD83D\uDCE5",
      'incoming_envelope': "\uD83D\uDCE8",
      'tipping_hand_woman': "\uD83D\uDC81",
      'information_source': "\u2139\uFE0F",
      'innocent': "\uD83D\uDE07",
      'interrobang': "\u2049\uFE0F",
      'iphone': "\uD83D\uDCF1",
      'izakaya_lantern': "\uD83C\uDFEE",
      'jack_o_lantern': "\uD83C\uDF83",
      'japan': "\uD83D\uDDFE",
      'japanese_castle': "\uD83C\uDFEF",
      'japanese_goblin': "\uD83D\uDC7A",
      'japanese_ogre': "\uD83D\uDC79",
      'jeans': "\uD83D\uDC56",
      'joy': "\uD83D\uDE02",
      'joy_cat': "\uD83D\uDE39",
      'joystick': "\uD83D\uDD79",
      'kaaba': "\uD83D\uDD4B",
      'key': "\uD83D\uDD11",
      'keyboard': "\u2328\uFE0F",
      'keycap_ten': "\uD83D\uDD1F",
      'kick_scooter': "\uD83D\uDEF4",
      'kimono': "\uD83D\uDC58",
      'kiss': "\uD83D\uDC8B",
      'kissing': "\uD83D\uDE17",
      'kissing_cat': "\uD83D\uDE3D",
      'kissing_closed_eyes': "\uD83D\uDE1A",
      'kissing_heart': "\uD83D\uDE18",
      'kissing_smiling_eyes': "\uD83D\uDE19",
      'kiwi_fruit': "\uD83E\uDD5D",
      'koala': "\uD83D\uDC28",
      'koko': "\uD83C\uDE01",
      'label': "\uD83C\uDFF7",
      'large_blue_circle': "\uD83D\uDD35",
      'large_blue_diamond': "\uD83D\uDD37",
      'large_orange_diamond': "\uD83D\uDD36",
      'last_quarter_moon': "\uD83C\uDF17",
      'last_quarter_moon_with_face': "\uD83C\uDF1C",
      'latin_cross': "\u271D\uFE0F",
      'laughing': "\uD83D\uDE06",
      'leaves': "\uD83C\uDF43",
      'ledger': "\uD83D\uDCD2",
      'left_luggage': "\uD83D\uDEC5",
      'left_right_arrow': "\u2194\uFE0F",
      'leftwards_arrow_with_hook': "\u21A9\uFE0F",
      'lemon': "\uD83C\uDF4B",
      'leo': "\u264C\uFE0F",
      'leopard': "\uD83D\uDC06",
      'level_slider': "\uD83C\uDF9A",
      'libra': "\u264E\uFE0F",
      'light_rail': "\uD83D\uDE88",
      'link': "\uD83D\uDD17",
      'lion': "\uD83E\uDD81",
      'lips': "\uD83D\uDC44",
      'lipstick': "\uD83D\uDC84",
      'lizard': "\uD83E\uDD8E",
      'lock': "\uD83D\uDD12",
      'lock_with_ink_pen': "\uD83D\uDD0F",
      'lollipop': "\uD83C\uDF6D",
      'loop': "\u27BF",
      'loud_sound': "\uD83D\uDD0A",
      'loudspeaker': "\uD83D\uDCE2",
      'love_hotel': "\uD83C\uDFE9",
      'love_letter': "\uD83D\uDC8C",
      'low_brightness': "\uD83D\uDD05",
      'lying_face': "\uD83E\uDD25",
      'm': "\u24C2\uFE0F",
      'mag': "\uD83D\uDD0D",
      'mag_right': "\uD83D\uDD0E",
      'mahjong': "\uD83C\uDC04\uFE0F",
      'mailbox': "\uD83D\uDCEB",
      'mailbox_closed': "\uD83D\uDCEA",
      'mailbox_with_mail': "\uD83D\uDCEC",
      'mailbox_with_no_mail': "\uD83D\uDCED",
      'man': "\uD83D\uDC68",
      'man_artist': "\uD83D\uDC68&zwj;\uD83C\uDFA8",
      'man_astronaut': "\uD83D\uDC68&zwj;\uD83D\uDE80",
      'man_cartwheeling': "\uD83E\uDD38&zwj;\u2642\uFE0F",
      'man_cook': "\uD83D\uDC68&zwj;\uD83C\uDF73",
      'man_dancing': "\uD83D\uDD7A",
      'man_facepalming': "\uD83E\uDD26&zwj;\u2642\uFE0F",
      'man_factory_worker': "\uD83D\uDC68&zwj;\uD83C\uDFED",
      'man_farmer': "\uD83D\uDC68&zwj;\uD83C\uDF3E",
      'man_firefighter': "\uD83D\uDC68&zwj;\uD83D\uDE92",
      'man_health_worker': "\uD83D\uDC68&zwj;\u2695\uFE0F",
      'man_in_tuxedo': "\uD83E\uDD35",
      'man_judge': "\uD83D\uDC68&zwj;\u2696\uFE0F",
      'man_juggling': "\uD83E\uDD39&zwj;\u2642\uFE0F",
      'man_mechanic': "\uD83D\uDC68&zwj;\uD83D\uDD27",
      'man_office_worker': "\uD83D\uDC68&zwj;\uD83D\uDCBC",
      'man_pilot': "\uD83D\uDC68&zwj;\u2708\uFE0F",
      'man_playing_handball': "\uD83E\uDD3E&zwj;\u2642\uFE0F",
      'man_playing_water_polo': "\uD83E\uDD3D&zwj;\u2642\uFE0F",
      'man_scientist': "\uD83D\uDC68&zwj;\uD83D\uDD2C",
      'man_shrugging': "\uD83E\uDD37&zwj;\u2642\uFE0F",
      'man_singer': "\uD83D\uDC68&zwj;\uD83C\uDFA4",
      'man_student': "\uD83D\uDC68&zwj;\uD83C\uDF93",
      'man_teacher': "\uD83D\uDC68&zwj;\uD83C\uDFEB",
      'man_technologist': "\uD83D\uDC68&zwj;\uD83D\uDCBB",
      'man_with_gua_pi_mao': "\uD83D\uDC72",
      'man_with_turban': "\uD83D\uDC73",
      'tangerine': "\uD83C\uDF4A",
      'mans_shoe': "\uD83D\uDC5E",
      'mantelpiece_clock': "\uD83D\uDD70",
      'maple_leaf': "\uD83C\uDF41",
      'martial_arts_uniform': "\uD83E\uDD4B",
      'mask': "\uD83D\uDE37",
      'massage_woman': "\uD83D\uDC86",
      'massage_man': "\uD83D\uDC86&zwj;\u2642\uFE0F",
      'meat_on_bone': "\uD83C\uDF56",
      'medal_military': "\uD83C\uDF96",
      'medal_sports': "\uD83C\uDFC5",
      'mega': "\uD83D\uDCE3",
      'melon': "\uD83C\uDF48",
      'memo': "\uD83D\uDCDD",
      'men_wrestling': "\uD83E\uDD3C&zwj;\u2642\uFE0F",
      'menorah': "\uD83D\uDD4E",
      'mens': "\uD83D\uDEB9",
      'metal': "\uD83E\uDD18",
      'metro': "\uD83D\uDE87",
      'microphone': "\uD83C\uDFA4",
      'microscope': "\uD83D\uDD2C",
      'milk_glass': "\uD83E\uDD5B",
      'milky_way': "\uD83C\uDF0C",
      'minibus': "\uD83D\uDE90",
      'minidisc': "\uD83D\uDCBD",
      'mobile_phone_off': "\uD83D\uDCF4",
      'money_mouth_face': "\uD83E\uDD11",
      'money_with_wings': "\uD83D\uDCB8",
      'moneybag': "\uD83D\uDCB0",
      'monkey': "\uD83D\uDC12",
      'monkey_face': "\uD83D\uDC35",
      'monorail': "\uD83D\uDE9D",
      'moon': "\uD83C\uDF14",
      'mortar_board': "\uD83C\uDF93",
      'mosque': "\uD83D\uDD4C",
      'motor_boat': "\uD83D\uDEE5",
      'motor_scooter': "\uD83D\uDEF5",
      'motorcycle': "\uD83C\uDFCD",
      'motorway': "\uD83D\uDEE3",
      'mount_fuji': "\uD83D\uDDFB",
      'mountain': "\u26F0",
      'mountain_biking_man': "\uD83D\uDEB5",
      'mountain_biking_woman': "\uD83D\uDEB5&zwj;\u2640\uFE0F",
      'mountain_cableway': "\uD83D\uDEA0",
      'mountain_railway': "\uD83D\uDE9E",
      'mountain_snow': "\uD83C\uDFD4",
      'mouse': "\uD83D\uDC2D",
      'mouse2': "\uD83D\uDC01",
      'movie_camera': "\uD83C\uDFA5",
      'moyai': "\uD83D\uDDFF",
      'mrs_claus': "\uD83E\uDD36",
      'muscle': "\uD83D\uDCAA",
      'mushroom': "\uD83C\uDF44",
      'musical_keyboard': "\uD83C\uDFB9",
      'musical_note': "\uD83C\uDFB5",
      'musical_score': "\uD83C\uDFBC",
      'mute': "\uD83D\uDD07",
      'nail_care': "\uD83D\uDC85",
      'name_badge': "\uD83D\uDCDB",
      'national_park': "\uD83C\uDFDE",
      'nauseated_face': "\uD83E\uDD22",
      'necktie': "\uD83D\uDC54",
      'negative_squared_cross_mark': "\u274E",
      'nerd_face': "\uD83E\uDD13",
      'neutral_face': "\uD83D\uDE10",
      'new': "\uD83C\uDD95",
      'new_moon': "\uD83C\uDF11",
      'new_moon_with_face': "\uD83C\uDF1A",
      'newspaper': "\uD83D\uDCF0",
      'newspaper_roll': "\uD83D\uDDDE",
      'next_track_button': "\u23ED",
      'ng': "\uD83C\uDD96",
      'no_good_man': "\uD83D\uDE45&zwj;\u2642\uFE0F",
      'no_good_woman': "\uD83D\uDE45",
      'night_with_stars': "\uD83C\uDF03",
      'no_bell': "\uD83D\uDD15",
      'no_bicycles': "\uD83D\uDEB3",
      'no_entry': "\u26D4\uFE0F",
      'no_entry_sign': "\uD83D\uDEAB",
      'no_mobile_phones': "\uD83D\uDCF5",
      'no_mouth': "\uD83D\uDE36",
      'no_pedestrians': "\uD83D\uDEB7",
      'no_smoking': "\uD83D\uDEAD",
      'non-potable_water': "\uD83D\uDEB1",
      'nose': "\uD83D\uDC43",
      'notebook': "\uD83D\uDCD3",
      'notebook_with_decorative_cover': "\uD83D\uDCD4",
      'notes': "\uD83C\uDFB6",
      'nut_and_bolt': "\uD83D\uDD29",
      'o': "\u2B55\uFE0F",
      'o2': "\uD83C\uDD7E\uFE0F",
      'ocean': "\uD83C\uDF0A",
      'octopus': "\uD83D\uDC19",
      'oden': "\uD83C\uDF62",
      'office': "\uD83C\uDFE2",
      'oil_drum': "\uD83D\uDEE2",
      'ok': "\uD83C\uDD97",
      'ok_hand': "\uD83D\uDC4C",
      'ok_man': "\uD83D\uDE46&zwj;\u2642\uFE0F",
      'ok_woman': "\uD83D\uDE46",
      'old_key': "\uD83D\uDDDD",
      'older_man': "\uD83D\uDC74",
      'older_woman': "\uD83D\uDC75",
      'om': "\uD83D\uDD49",
      'on': "\uD83D\uDD1B",
      'oncoming_automobile': "\uD83D\uDE98",
      'oncoming_bus': "\uD83D\uDE8D",
      'oncoming_police_car': "\uD83D\uDE94",
      'oncoming_taxi': "\uD83D\uDE96",
      'open_file_folder': "\uD83D\uDCC2",
      'open_hands': "\uD83D\uDC50",
      'open_mouth': "\uD83D\uDE2E",
      'open_umbrella': "\u2602\uFE0F",
      'ophiuchus': "\u26CE",
      'orange_book': "\uD83D\uDCD9",
      'orthodox_cross': "\u2626\uFE0F",
      'outbox_tray': "\uD83D\uDCE4",
      'owl': "\uD83E\uDD89",
      'ox': "\uD83D\uDC02",
      'package': "\uD83D\uDCE6",
      'page_facing_up': "\uD83D\uDCC4",
      'page_with_curl': "\uD83D\uDCC3",
      'pager': "\uD83D\uDCDF",
      'paintbrush': "\uD83D\uDD8C",
      'palm_tree': "\uD83C\uDF34",
      'pancakes': "\uD83E\uDD5E",
      'panda_face': "\uD83D\uDC3C",
      'paperclip': "\uD83D\uDCCE",
      'paperclips': "\uD83D\uDD87",
      'parasol_on_ground': "\u26F1",
      'parking': "\uD83C\uDD7F\uFE0F",
      'part_alternation_mark': "\u303D\uFE0F",
      'partly_sunny': "\u26C5\uFE0F",
      'passenger_ship': "\uD83D\uDEF3",
      'passport_control': "\uD83D\uDEC2",
      'pause_button': "\u23F8",
      'peace_symbol': "\u262E\uFE0F",
      'peach': "\uD83C\uDF51",
      'peanuts': "\uD83E\uDD5C",
      'pear': "\uD83C\uDF50",
      'pen': "\uD83D\uDD8A",
      'pencil2': "\u270F\uFE0F",
      'penguin': "\uD83D\uDC27",
      'pensive': "\uD83D\uDE14",
      'performing_arts': "\uD83C\uDFAD",
      'persevere': "\uD83D\uDE23",
      'person_fencing': "\uD83E\uDD3A",
      'pouting_woman': "\uD83D\uDE4E",
      'phone': "\u260E\uFE0F",
      'pick': "\u26CF",
      'pig': "\uD83D\uDC37",
      'pig2': "\uD83D\uDC16",
      'pig_nose': "\uD83D\uDC3D",
      'pill': "\uD83D\uDC8A",
      'pineapple': "\uD83C\uDF4D",
      'ping_pong': "\uD83C\uDFD3",
      'pisces': "\u2653\uFE0F",
      'pizza': "\uD83C\uDF55",
      'place_of_worship': "\uD83D\uDED0",
      'plate_with_cutlery': "\uD83C\uDF7D",
      'play_or_pause_button': "\u23EF",
      'point_down': "\uD83D\uDC47",
      'point_left': "\uD83D\uDC48",
      'point_right': "\uD83D\uDC49",
      'point_up': "\u261D\uFE0F",
      'point_up_2': "\uD83D\uDC46",
      'police_car': "\uD83D\uDE93",
      'policewoman': "\uD83D\uDC6E&zwj;\u2640\uFE0F",
      'poodle': "\uD83D\uDC29",
      'popcorn': "\uD83C\uDF7F",
      'post_office': "\uD83C\uDFE3",
      'postal_horn': "\uD83D\uDCEF",
      'postbox': "\uD83D\uDCEE",
      'potable_water': "\uD83D\uDEB0",
      'potato': "\uD83E\uDD54",
      'pouch': "\uD83D\uDC5D",
      'poultry_leg': "\uD83C\uDF57",
      'pound': "\uD83D\uDCB7",
      'rage': "\uD83D\uDE21",
      'pouting_cat': "\uD83D\uDE3E",
      'pouting_man': "\uD83D\uDE4E&zwj;\u2642\uFE0F",
      'pray': "\uD83D\uDE4F",
      'prayer_beads': "\uD83D\uDCFF",
      'pregnant_woman': "\uD83E\uDD30",
      'previous_track_button': "\u23EE",
      'prince': "\uD83E\uDD34",
      'princess': "\uD83D\uDC78",
      'printer': "\uD83D\uDDA8",
      'purple_heart': "\uD83D\uDC9C",
      'purse': "\uD83D\uDC5B",
      'pushpin': "\uD83D\uDCCC",
      'put_litter_in_its_place': "\uD83D\uDEAE",
      'question': "\u2753",
      'rabbit': "\uD83D\uDC30",
      'rabbit2': "\uD83D\uDC07",
      'racehorse': "\uD83D\uDC0E",
      'racing_car': "\uD83C\uDFCE",
      'radio': "\uD83D\uDCFB",
      'radio_button': "\uD83D\uDD18",
      'radioactive': "\u2622\uFE0F",
      'railway_car': "\uD83D\uDE83",
      'railway_track': "\uD83D\uDEE4",
      'rainbow': "\uD83C\uDF08",
      'rainbow_flag': "\uD83C\uDFF3\uFE0F&zwj;\uD83C\uDF08",
      'raised_back_of_hand': "\uD83E\uDD1A",
      'raised_hand_with_fingers_splayed': "\uD83D\uDD90",
      'raised_hands': "\uD83D\uDE4C",
      'raising_hand_woman': "\uD83D\uDE4B",
      'raising_hand_man': "\uD83D\uDE4B&zwj;\u2642\uFE0F",
      'ram': "\uD83D\uDC0F",
      'ramen': "\uD83C\uDF5C",
      'rat': "\uD83D\uDC00",
      'record_button': "\u23FA",
      'recycle': "\u267B\uFE0F",
      'red_circle': "\uD83D\uDD34",
      'registered': "\xAE\uFE0F",
      'relaxed': "\u263A\uFE0F",
      'relieved': "\uD83D\uDE0C",
      'reminder_ribbon': "\uD83C\uDF97",
      'repeat': "\uD83D\uDD01",
      'repeat_one': "\uD83D\uDD02",
      'rescue_worker_helmet': "\u26D1",
      'restroom': "\uD83D\uDEBB",
      'revolving_hearts': "\uD83D\uDC9E",
      'rewind': "\u23EA",
      'rhinoceros': "\uD83E\uDD8F",
      'ribbon': "\uD83C\uDF80",
      'rice': "\uD83C\uDF5A",
      'rice_ball': "\uD83C\uDF59",
      'rice_cracker': "\uD83C\uDF58",
      'rice_scene': "\uD83C\uDF91",
      'right_anger_bubble': "\uD83D\uDDEF",
      'ring': "\uD83D\uDC8D",
      'robot': "\uD83E\uDD16",
      'rocket': "\uD83D\uDE80",
      'rofl': "\uD83E\uDD23",
      'roll_eyes': "\uD83D\uDE44",
      'roller_coaster': "\uD83C\uDFA2",
      'rooster': "\uD83D\uDC13",
      'rose': "\uD83C\uDF39",
      'rosette': "\uD83C\uDFF5",
      'rotating_light': "\uD83D\uDEA8",
      'round_pushpin': "\uD83D\uDCCD",
      'rowing_man': "\uD83D\uDEA3",
      'rowing_woman': "\uD83D\uDEA3&zwj;\u2640\uFE0F",
      'rugby_football': "\uD83C\uDFC9",
      'running_man': "\uD83C\uDFC3",
      'running_shirt_with_sash': "\uD83C\uDFBD",
      'running_woman': "\uD83C\uDFC3&zwj;\u2640\uFE0F",
      'sa': "\uD83C\uDE02\uFE0F",
      'sagittarius': "\u2650\uFE0F",
      'sake': "\uD83C\uDF76",
      'sandal': "\uD83D\uDC61",
      'santa': "\uD83C\uDF85",
      'satellite': "\uD83D\uDCE1",
      'saxophone': "\uD83C\uDFB7",
      'school': "\uD83C\uDFEB",
      'school_satchel': "\uD83C\uDF92",
      'scissors': "\u2702\uFE0F",
      'scorpion': "\uD83E\uDD82",
      'scorpius': "\u264F\uFE0F",
      'scream': "\uD83D\uDE31",
      'scream_cat': "\uD83D\uDE40",
      'scroll': "\uD83D\uDCDC",
      'seat': "\uD83D\uDCBA",
      'secret': "\u3299\uFE0F",
      'see_no_evil': "\uD83D\uDE48",
      'seedling': "\uD83C\uDF31",
      'selfie': "\uD83E\uDD33",
      'shallow_pan_of_food': "\uD83E\uDD58",
      'shamrock': "\u2618\uFE0F",
      'shark': "\uD83E\uDD88",
      'shaved_ice': "\uD83C\uDF67",
      'sheep': "\uD83D\uDC11",
      'shell': "\uD83D\uDC1A",
      'shield': "\uD83D\uDEE1",
      'shinto_shrine': "\u26E9",
      'ship': "\uD83D\uDEA2",
      'shirt': "\uD83D\uDC55",
      'shopping': "\uD83D\uDECD",
      'shopping_cart': "\uD83D\uDED2",
      'shower': "\uD83D\uDEBF",
      'shrimp': "\uD83E\uDD90",
      'signal_strength': "\uD83D\uDCF6",
      'six_pointed_star': "\uD83D\uDD2F",
      'ski': "\uD83C\uDFBF",
      'skier': "\u26F7",
      'skull': "\uD83D\uDC80",
      'skull_and_crossbones': "\u2620\uFE0F",
      'sleeping': "\uD83D\uDE34",
      'sleeping_bed': "\uD83D\uDECC",
      'sleepy': "\uD83D\uDE2A",
      'slightly_frowning_face': "\uD83D\uDE41",
      'slightly_smiling_face': "\uD83D\uDE42",
      'slot_machine': "\uD83C\uDFB0",
      'small_airplane': "\uD83D\uDEE9",
      'small_blue_diamond': "\uD83D\uDD39",
      'small_orange_diamond': "\uD83D\uDD38",
      'small_red_triangle': "\uD83D\uDD3A",
      'small_red_triangle_down': "\uD83D\uDD3B",
      'smile': "\uD83D\uDE04",
      'smile_cat': "\uD83D\uDE38",
      'smiley': "\uD83D\uDE03",
      'smiley_cat': "\uD83D\uDE3A",
      'smiling_imp': "\uD83D\uDE08",
      'smirk': "\uD83D\uDE0F",
      'smirk_cat': "\uD83D\uDE3C",
      'smoking': "\uD83D\uDEAC",
      'snail': "\uD83D\uDC0C",
      'snake': "\uD83D\uDC0D",
      'sneezing_face': "\uD83E\uDD27",
      'snowboarder': "\uD83C\uDFC2",
      'snowflake': "\u2744\uFE0F",
      'snowman': "\u26C4\uFE0F",
      'snowman_with_snow': "\u2603\uFE0F",
      'sob': "\uD83D\uDE2D",
      'soccer': "\u26BD\uFE0F",
      'soon': "\uD83D\uDD1C",
      'sos': "\uD83C\uDD98",
      'sound': "\uD83D\uDD09",
      'space_invader': "\uD83D\uDC7E",
      'spades': "\u2660\uFE0F",
      'spaghetti': "\uD83C\uDF5D",
      'sparkle': "\u2747\uFE0F",
      'sparkler': "\uD83C\uDF87",
      'sparkles': "\u2728",
      'sparkling_heart': "\uD83D\uDC96",
      'speak_no_evil': "\uD83D\uDE4A",
      'speaker': "\uD83D\uDD08",
      'speaking_head': "\uD83D\uDDE3",
      'speech_balloon': "\uD83D\uDCAC",
      'speedboat': "\uD83D\uDEA4",
      'spider': "\uD83D\uDD77",
      'spider_web': "\uD83D\uDD78",
      'spiral_calendar': "\uD83D\uDDD3",
      'spiral_notepad': "\uD83D\uDDD2",
      'spoon': "\uD83E\uDD44",
      'squid': "\uD83E\uDD91",
      'stadium': "\uD83C\uDFDF",
      'star': "\u2B50\uFE0F",
      'star2': "\uD83C\uDF1F",
      'star_and_crescent': "\u262A\uFE0F",
      'star_of_david': "\u2721\uFE0F",
      'stars': "\uD83C\uDF20",
      'station': "\uD83D\uDE89",
      'statue_of_liberty': "\uD83D\uDDFD",
      'steam_locomotive': "\uD83D\uDE82",
      'stew': "\uD83C\uDF72",
      'stop_button': "\u23F9",
      'stop_sign': "\uD83D\uDED1",
      'stopwatch': "\u23F1",
      'straight_ruler': "\uD83D\uDCCF",
      'strawberry': "\uD83C\uDF53",
      'stuck_out_tongue': "\uD83D\uDE1B",
      'stuck_out_tongue_closed_eyes': "\uD83D\uDE1D",
      'stuck_out_tongue_winking_eye': "\uD83D\uDE1C",
      'studio_microphone': "\uD83C\uDF99",
      'stuffed_flatbread': "\uD83E\uDD59",
      'sun_behind_large_cloud': "\uD83C\uDF25",
      'sun_behind_rain_cloud': "\uD83C\uDF26",
      'sun_behind_small_cloud': "\uD83C\uDF24",
      'sun_with_face': "\uD83C\uDF1E",
      'sunflower': "\uD83C\uDF3B",
      'sunglasses': "\uD83D\uDE0E",
      'sunny': "\u2600\uFE0F",
      'sunrise': "\uD83C\uDF05",
      'sunrise_over_mountains': "\uD83C\uDF04",
      'surfing_man': "\uD83C\uDFC4",
      'surfing_woman': "\uD83C\uDFC4&zwj;\u2640\uFE0F",
      'sushi': "\uD83C\uDF63",
      'suspension_railway': "\uD83D\uDE9F",
      'sweat': "\uD83D\uDE13",
      'sweat_drops': "\uD83D\uDCA6",
      'sweat_smile': "\uD83D\uDE05",
      'sweet_potato': "\uD83C\uDF60",
      'swimming_man': "\uD83C\uDFCA",
      'swimming_woman': "\uD83C\uDFCA&zwj;\u2640\uFE0F",
      'symbols': "\uD83D\uDD23",
      'synagogue': "\uD83D\uDD4D",
      'syringe': "\uD83D\uDC89",
      'taco': "\uD83C\uDF2E",
      'tada': "\uD83C\uDF89",
      'tanabata_tree': "\uD83C\uDF8B",
      'taurus': "\u2649\uFE0F",
      'taxi': "\uD83D\uDE95",
      'tea': "\uD83C\uDF75",
      'telephone_receiver': "\uD83D\uDCDE",
      'telescope': "\uD83D\uDD2D",
      'tennis': "\uD83C\uDFBE",
      'tent': "\u26FA\uFE0F",
      'thermometer': "\uD83C\uDF21",
      'thinking': "\uD83E\uDD14",
      'thought_balloon': "\uD83D\uDCAD",
      'ticket': "\uD83C\uDFAB",
      'tickets': "\uD83C\uDF9F",
      'tiger': "\uD83D\uDC2F",
      'tiger2': "\uD83D\uDC05",
      'timer_clock': "\u23F2",
      'tipping_hand_man': "\uD83D\uDC81&zwj;\u2642\uFE0F",
      'tired_face': "\uD83D\uDE2B",
      'tm': "\u2122\uFE0F",
      'toilet': "\uD83D\uDEBD",
      'tokyo_tower': "\uD83D\uDDFC",
      'tomato': "\uD83C\uDF45",
      'tongue': "\uD83D\uDC45",
      'top': "\uD83D\uDD1D",
      'tophat': "\uD83C\uDFA9",
      'tornado': "\uD83C\uDF2A",
      'trackball': "\uD83D\uDDB2",
      'tractor': "\uD83D\uDE9C",
      'traffic_light': "\uD83D\uDEA5",
      'train': "\uD83D\uDE8B",
      'train2': "\uD83D\uDE86",
      'tram': "\uD83D\uDE8A",
      'triangular_flag_on_post': "\uD83D\uDEA9",
      'triangular_ruler': "\uD83D\uDCD0",
      'trident': "\uD83D\uDD31",
      'triumph': "\uD83D\uDE24",
      'trolleybus': "\uD83D\uDE8E",
      'trophy': "\uD83C\uDFC6",
      'tropical_drink': "\uD83C\uDF79",
      'tropical_fish': "\uD83D\uDC20",
      'truck': "\uD83D\uDE9A",
      'trumpet': "\uD83C\uDFBA",
      'tulip': "\uD83C\uDF37",
      'tumbler_glass': "\uD83E\uDD43",
      'turkey': "\uD83E\uDD83",
      'turtle': "\uD83D\uDC22",
      'tv': "\uD83D\uDCFA",
      'twisted_rightwards_arrows': "\uD83D\uDD00",
      'two_hearts': "\uD83D\uDC95",
      'two_men_holding_hands': "\uD83D\uDC6C",
      'two_women_holding_hands': "\uD83D\uDC6D",
      'u5272': "\uD83C\uDE39",
      'u5408': "\uD83C\uDE34",
      'u55b6': "\uD83C\uDE3A",
      'u6307': "\uD83C\uDE2F\uFE0F",
      'u6708': "\uD83C\uDE37\uFE0F",
      'u6709': "\uD83C\uDE36",
      'u6e80': "\uD83C\uDE35",
      'u7121': "\uD83C\uDE1A\uFE0F",
      'u7533': "\uD83C\uDE38",
      'u7981': "\uD83C\uDE32",
      'u7a7a': "\uD83C\uDE33",
      'umbrella': "\u2614\uFE0F",
      'unamused': "\uD83D\uDE12",
      'underage': "\uD83D\uDD1E",
      'unicorn': "\uD83E\uDD84",
      'unlock': "\uD83D\uDD13",
      'up': "\uD83C\uDD99",
      'upside_down_face': "\uD83D\uDE43",
      'v': "\u270C\uFE0F",
      'vertical_traffic_light': "\uD83D\uDEA6",
      'vhs': "\uD83D\uDCFC",
      'vibration_mode': "\uD83D\uDCF3",
      'video_camera': "\uD83D\uDCF9",
      'video_game': "\uD83C\uDFAE",
      'violin': "\uD83C\uDFBB",
      'virgo': "\u264D\uFE0F",
      'volcano': "\uD83C\uDF0B",
      'volleyball': "\uD83C\uDFD0",
      'vs': "\uD83C\uDD9A",
      'vulcan_salute': "\uD83D\uDD96",
      'walking_man': "\uD83D\uDEB6",
      'walking_woman': "\uD83D\uDEB6&zwj;\u2640\uFE0F",
      'waning_crescent_moon': "\uD83C\uDF18",
      'waning_gibbous_moon': "\uD83C\uDF16",
      'warning': "\u26A0\uFE0F",
      'wastebasket': "\uD83D\uDDD1",
      'watch': "\u231A\uFE0F",
      'water_buffalo': "\uD83D\uDC03",
      'watermelon': "\uD83C\uDF49",
      'wave': "\uD83D\uDC4B",
      'wavy_dash': "\u3030\uFE0F",
      'waxing_crescent_moon': "\uD83C\uDF12",
      'wc': "\uD83D\uDEBE",
      'weary': "\uD83D\uDE29",
      'wedding': "\uD83D\uDC92",
      'weight_lifting_man': "\uD83C\uDFCB\uFE0F",
      'weight_lifting_woman': "\uD83C\uDFCB\uFE0F&zwj;\u2640\uFE0F",
      'whale': "\uD83D\uDC33",
      'whale2': "\uD83D\uDC0B",
      'wheel_of_dharma': "\u2638\uFE0F",
      'wheelchair': "\u267F\uFE0F",
      'white_check_mark': "\u2705",
      'white_circle': "\u26AA\uFE0F",
      'white_flag': "\uD83C\uDFF3\uFE0F",
      'white_flower': "\uD83D\uDCAE",
      'white_large_square': "\u2B1C\uFE0F",
      'white_medium_small_square': "\u25FD\uFE0F",
      'white_medium_square': "\u25FB\uFE0F",
      'white_small_square': "\u25AB\uFE0F",
      'white_square_button': "\uD83D\uDD33",
      'wilted_flower': "\uD83E\uDD40",
      'wind_chime': "\uD83C\uDF90",
      'wind_face': "\uD83C\uDF2C",
      'wine_glass': "\uD83C\uDF77",
      'wink': "\uD83D\uDE09",
      'wolf': "\uD83D\uDC3A",
      'woman': "\uD83D\uDC69",
      'woman_artist': "\uD83D\uDC69&zwj;\uD83C\uDFA8",
      'woman_astronaut': "\uD83D\uDC69&zwj;\uD83D\uDE80",
      'woman_cartwheeling': "\uD83E\uDD38&zwj;\u2640\uFE0F",
      'woman_cook': "\uD83D\uDC69&zwj;\uD83C\uDF73",
      'woman_facepalming': "\uD83E\uDD26&zwj;\u2640\uFE0F",
      'woman_factory_worker': "\uD83D\uDC69&zwj;\uD83C\uDFED",
      'woman_farmer': "\uD83D\uDC69&zwj;\uD83C\uDF3E",
      'woman_firefighter': "\uD83D\uDC69&zwj;\uD83D\uDE92",
      'woman_health_worker': "\uD83D\uDC69&zwj;\u2695\uFE0F",
      'woman_judge': "\uD83D\uDC69&zwj;\u2696\uFE0F",
      'woman_juggling': "\uD83E\uDD39&zwj;\u2640\uFE0F",
      'woman_mechanic': "\uD83D\uDC69&zwj;\uD83D\uDD27",
      'woman_office_worker': "\uD83D\uDC69&zwj;\uD83D\uDCBC",
      'woman_pilot': "\uD83D\uDC69&zwj;\u2708\uFE0F",
      'woman_playing_handball': "\uD83E\uDD3E&zwj;\u2640\uFE0F",
      'woman_playing_water_polo': "\uD83E\uDD3D&zwj;\u2640\uFE0F",
      'woman_scientist': "\uD83D\uDC69&zwj;\uD83D\uDD2C",
      'woman_shrugging': "\uD83E\uDD37&zwj;\u2640\uFE0F",
      'woman_singer': "\uD83D\uDC69&zwj;\uD83C\uDFA4",
      'woman_student': "\uD83D\uDC69&zwj;\uD83C\uDF93",
      'woman_teacher': "\uD83D\uDC69&zwj;\uD83C\uDFEB",
      'woman_technologist': "\uD83D\uDC69&zwj;\uD83D\uDCBB",
      'woman_with_turban': "\uD83D\uDC73&zwj;\u2640\uFE0F",
      'womans_clothes': "\uD83D\uDC5A",
      'womans_hat': "\uD83D\uDC52",
      'women_wrestling': "\uD83E\uDD3C&zwj;\u2640\uFE0F",
      'womens': "\uD83D\uDEBA",
      'world_map': "\uD83D\uDDFA",
      'worried': "\uD83D\uDE1F",
      'wrench': "\uD83D\uDD27",
      'writing_hand': "\u270D\uFE0F",
      'x': "\u274C",
      'yellow_heart': "\uD83D\uDC9B",
      'yen': "\uD83D\uDCB4",
      'yin_yang': "\u262F\uFE0F",
      'yum': "\uD83D\uDE0B",
      'zap': "\u26A1\uFE0F",
      'zipper_mouth_face': "\uD83E\uDD10",
      'zzz': "\uD83D\uDCA4",

      /* special emojis :P */
      'octocat': '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
      'showdown': '<span style="font-family: \'Anonymous Pro\', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;">S</span>'
    };
    /**
     * Created by Estevao on 31-05-2015.
     */

    /**
     * Showdown Converter class
     * @class
     * @param {object} [converterOptions]
     * @returns {Converter}
     */

    showdown.Converter = function (converterOptions) {

      var
      /**
       * Options used by this converter
       * @private
       * @type {{}}
       */
      options = {},

      /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */
      langExtensions = [],

      /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */
      outputModifiers = [],

      /**
       * Event listeners
       * @private
       * @type {{}}
       */
      listeners = {},

      /**
       * The flavor set in this converter
       */
      setConvFlavor = setFlavor,

      /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */
      metadata = {
        parsed: {},
        raw: '',
        format: ''
      };

      _constructor();
      /**
       * Converter constructor
       * @private
       */


      function _constructor() {
        converterOptions = converterOptions || {};

        for (var gOpt in globalOptions) {
          if (globalOptions.hasOwnProperty(gOpt)) {
            options[gOpt] = globalOptions[gOpt];
          }
        } // Merge options


        if (_typeof(converterOptions) === 'object') {
          for (var opt in converterOptions) {
            if (converterOptions.hasOwnProperty(opt)) {
              options[opt] = converterOptions[opt];
            }
          }
        } else {
          throw Error('Converter expects the passed parameter to be an object, but ' + _typeof(converterOptions) + ' was passed instead.');
        }

        if (options.extensions) {
          showdown.helper.forEach(options.extensions, _parseExtension);
        }
      }
      /**
       * Parse extension
       * @param {*} ext
       * @param {string} [name='']
       * @private
       */


      function _parseExtension(ext, name) {
        name = name || null; // If it's a string, the extension was previously loaded

        if (showdown.helper.isString(ext)) {
          ext = showdown.helper.stdExtName(ext);
          name = ext; // LEGACY_SUPPORT CODE

          if (showdown.extensions[ext]) {
            console.warn('DEPRECATION WARNING: ' + ext + ' is an old extension that uses a deprecated loading method.' + 'Please inform the developer that the extension should be updated!');
            legacyExtensionLoading(showdown.extensions[ext], ext);
            return; // END LEGACY SUPPORT CODE
          } else if (!showdown.helper.isUndefined(extensions[ext])) {
            ext = extensions[ext];
          } else {
            throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
          }
        }

        if (typeof ext === 'function') {
          ext = ext();
        }

        if (!showdown.helper.isArray(ext)) {
          ext = [ext];
        }

        var validExt = validate(ext, name);

        if (!validExt.valid) {
          throw Error(validExt.error);
        }

        for (var i = 0; i < ext.length; ++i) {
          switch (ext[i].type) {
            case 'lang':
              langExtensions.push(ext[i]);
              break;

            case 'output':
              outputModifiers.push(ext[i]);
              break;
          }

          if (ext[i].hasOwnProperty('listeners')) {
            for (var ln in ext[i].listeners) {
              if (ext[i].listeners.hasOwnProperty(ln)) {
                listen(ln, ext[i].listeners[ln]);
              }
            }
          }
        }
      }
      /**
       * LEGACY_SUPPORT
       * @param {*} ext
       * @param {string} name
       */


      function legacyExtensionLoading(ext, name) {
        if (typeof ext === 'function') {
          ext = ext(new showdown.Converter());
        }

        if (!showdown.helper.isArray(ext)) {
          ext = [ext];
        }

        var valid = validate(ext, name);

        if (!valid.valid) {
          throw Error(valid.error);
        }

        for (var i = 0; i < ext.length; ++i) {
          switch (ext[i].type) {
            case 'lang':
              langExtensions.push(ext[i]);
              break;

            case 'output':
              outputModifiers.push(ext[i]);
              break;

            default:
              // should never reach here
              throw Error('Extension loader error: Type unrecognized!!!');
          }
        }
      }
      /**
       * Listen to an event
       * @param {string} name
       * @param {function} callback
       */


      function listen(name, callback) {
        if (!showdown.helper.isString(name)) {
          throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + _typeof(name) + ' given');
        }

        if (typeof callback !== 'function') {
          throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + _typeof(callback) + ' given');
        }

        if (!listeners.hasOwnProperty(name)) {
          listeners[name] = [];
        }

        listeners[name].push(callback);
      }

      function rTrimInputText(text) {
        var rsp = text.match(/^\s*/)[0].length,
            rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
        return text.replace(rgx, '');
      }
      /**
       * Dispatch an event
       * @private
       * @param {string} evtName Event name
       * @param {string} text Text
       * @param {{}} options Converter Options
       * @param {{}} globals
       * @returns {string}
       */


      this._dispatch = function dispatch(evtName, text, options, globals) {
        if (listeners.hasOwnProperty(evtName)) {
          for (var ei = 0; ei < listeners[evtName].length; ++ei) {
            var nText = listeners[evtName][ei](evtName, text, this, options, globals);

            if (nText && typeof nText !== 'undefined') {
              text = nText;
            }
          }
        }

        return text;
      };
      /**
       * Listen to an event
       * @param {string} name
       * @param {function} callback
       * @returns {showdown.Converter}
       */


      this.listen = function (name, callback) {
        listen(name, callback);
        return this;
      };
      /**
       * Converts a markdown string into HTML
       * @param {string} text
       * @returns {*}
       */


      this.makeHtml = function (text) {
        //check if text is not falsy
        if (!text) {
          return text;
        }

        var globals = {
          gHtmlBlocks: [],
          gHtmlMdBlocks: [],
          gHtmlSpans: [],
          gUrls: {},
          gTitles: {},
          gDimensions: {},
          gListLevel: 0,
          hashLinkCounts: {},
          langExtensions: langExtensions,
          outputModifiers: outputModifiers,
          converter: this,
          ghCodeBlocks: [],
          metadata: {
            parsed: {},
            raw: '',
            format: ''
          }
        }; // This lets us use ¨ trema as an escape char to avoid md5 hashes
        // The choice of character is arbitrary; anything that isn't
        // magic in Markdown will work.

        text = text.replace(/¨/g, '¨T'); // Replace $ with ¨D
        // RegExp interprets $ as a special character
        // when it's in a replacement string

        text = text.replace(/\$/g, '¨D'); // Standardize line endings

        text = text.replace(/\r\n/g, '\n'); // DOS to Unix

        text = text.replace(/\r/g, '\n'); // Mac to Unix
        // Stardardize line spaces

        text = text.replace(/\u00A0/g, '&nbsp;');

        if (options.smartIndentationFix) {
          text = rTrimInputText(text);
        } // Make sure text begins and ends with a couple of newlines:


        text = '\n\n' + text + '\n\n'; // detab

        text = showdown.subParser('detab')(text, options, globals);
        /**
         * Strip any lines consisting only of spaces and tabs.
         * This makes subsequent regexs easier to write, because we can
         * match consecutive blank lines with /\n+/ instead of something
         * contorted like /[ \t]*\n+/
         */

        text = text.replace(/^[ \t]+$/mg, ''); //run languageExtensions

        showdown.helper.forEach(langExtensions, function (ext) {
          text = showdown.subParser('runExtension')(ext, text, options, globals);
        }); // run the sub parsers

        text = showdown.subParser('metadata')(text, options, globals);
        text = showdown.subParser('hashPreCodeTags')(text, options, globals);
        text = showdown.subParser('githubCodeBlocks')(text, options, globals);
        text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
        text = showdown.subParser('hashCodeTags')(text, options, globals);
        text = showdown.subParser('stripLinkDefinitions')(text, options, globals);
        text = showdown.subParser('blockGamut')(text, options, globals);
        text = showdown.subParser('unhashHTMLSpans')(text, options, globals);
        text = showdown.subParser('unescapeSpecialChars')(text, options, globals); // attacklab: Restore dollar signs

        text = text.replace(/¨D/g, '$$'); // attacklab: Restore tremas

        text = text.replace(/¨T/g, '¨'); // render a complete html document instead of a partial if the option is enabled

        text = showdown.subParser('completeHTMLDocument')(text, options, globals); // Run output modifiers

        showdown.helper.forEach(outputModifiers, function (ext) {
          text = showdown.subParser('runExtension')(ext, text, options, globals);
        }); // update metadata

        metadata = globals.metadata;
        return text;
      };
      /**
       * Converts an HTML string into a markdown string
       * @param src
       * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
       * @returns {string}
       */


      this.makeMarkdown = this.makeMd = function (src, HTMLParser) {
        // replace \r\n with \n
        src = src.replace(/\r\n/g, '\n');
        src = src.replace(/\r/g, '\n'); // old macs
        // due to an edge case, we need to find this: > <
        // to prevent removing of non silent white spaces
        // ex: <em>this is</em> <strong>sparta</strong>

        src = src.replace(/>[ \t]+</, '>¨NBSP;<');

        if (!HTMLParser) {
          if (window && window.document) {
            HTMLParser = window.document;
          } else {
            throw new Error('HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM');
          }
        }

        var doc = HTMLParser.createElement('div');
        doc.innerHTML = src;
        var globals = {
          preList: substitutePreCodeTags(doc)
        }; // remove all newlines and collapse spaces

        clean(doc); // some stuff, like accidental reference links must now be escaped
        // TODO
        // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);

        var nodes = doc.childNodes,
            mdDoc = '';

        for (var i = 0; i < nodes.length; i++) {
          mdDoc += showdown.subParser('makeMarkdown.node')(nodes[i], globals);
        }

        function clean(node) {
          for (var n = 0; n < node.childNodes.length; ++n) {
            var child = node.childNodes[n];

            if (child.nodeType === 3) {
              if (!/\S/.test(child.nodeValue)) {
                node.removeChild(child);
                --n;
              } else {
                child.nodeValue = child.nodeValue.split('\n').join(' ');
                child.nodeValue = child.nodeValue.replace(/(\s)+/g, '$1');
              }
            } else if (child.nodeType === 1) {
              clean(child);
            }
          }
        } // find all pre tags and replace contents with placeholder
        // we need this so that we can remove all indentation from html
        // to ease up parsing


        function substitutePreCodeTags(doc) {
          var pres = doc.querySelectorAll('pre'),
              presPH = [];

          for (var i = 0; i < pres.length; ++i) {
            if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === 'code') {
              var content = pres[i].firstChild.innerHTML.trim(),
                  language = pres[i].firstChild.getAttribute('data-language') || ''; // if data-language attribute is not defined, then we look for class language-*

              if (language === '') {
                var classes = pres[i].firstChild.className.split(' ');

                for (var c = 0; c < classes.length; ++c) {
                  var matches = classes[c].match(/^language-(.+)$/);

                  if (matches !== null) {
                    language = matches[1];
                    break;
                  }
                }
              } // unescape html entities in content


              content = showdown.helper.unescapeHTMLEntities(content);
              presPH.push(content);
              pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
            } else {
              presPH.push(pres[i].innerHTML);
              pres[i].innerHTML = '';
              pres[i].setAttribute('prenum', i.toString());
            }
          }

          return presPH;
        }

        return mdDoc;
      };
      /**
       * Set an option of this Converter instance
       * @param {string} key
       * @param {*} value
       */


      this.setOption = function (key, value) {
        options[key] = value;
      };
      /**
       * Get the option of this Converter instance
       * @param {string} key
       * @returns {*}
       */


      this.getOption = function (key) {
        return options[key];
      };
      /**
       * Get the options of this Converter instance
       * @returns {{}}
       */


      this.getOptions = function () {
        return options;
      };
      /**
       * Add extension to THIS converter
       * @param {{}} extension
       * @param {string} [name=null]
       */


      this.addExtension = function (extension, name) {
        name = name || null;

        _parseExtension(extension, name);
      };
      /**
       * Use a global registered extension with THIS converter
       * @param {string} extensionName Name of the previously registered extension
       */


      this.useExtension = function (extensionName) {
        _parseExtension(extensionName);
      };
      /**
       * Set the flavor THIS converter should use
       * @param {string} name
       */


      this.setFlavor = function (name) {
        if (!flavor.hasOwnProperty(name)) {
          throw Error(name + ' flavor was not found');
        }

        var preset = flavor[name];
        setConvFlavor = name;

        for (var option in preset) {
          if (preset.hasOwnProperty(option)) {
            options[option] = preset[option];
          }
        }
      };
      /**
       * Get the currently set flavor of this converter
       * @returns {string}
       */


      this.getFlavor = function () {
        return setConvFlavor;
      };
      /**
       * Remove an extension from THIS converter.
       * Note: This is a costly operation. It's better to initialize a new converter
       * and specify the extensions you wish to use
       * @param {Array} extension
       */


      this.removeExtension = function (extension) {
        if (!showdown.helper.isArray(extension)) {
          extension = [extension];
        }

        for (var a = 0; a < extension.length; ++a) {
          var ext = extension[a];

          for (var i = 0; i < langExtensions.length; ++i) {
            if (langExtensions[i] === ext) {
              langExtensions[i].splice(i, 1);
            }
          }

          for (var ii = 0; ii < outputModifiers.length; ++i) {
            if (outputModifiers[ii] === ext) {
              outputModifiers[ii].splice(i, 1);
            }
          }
        }
      };
      /**
       * Get all extension of THIS converter
       * @returns {{language: Array, output: Array}}
       */


      this.getAllExtensions = function () {
        return {
          language: langExtensions,
          output: outputModifiers
        };
      };
      /**
       * Get the metadata of the previously parsed document
       * @param raw
       * @returns {string|{}}
       */


      this.getMetadata = function (raw) {
        if (raw) {
          return metadata.raw;
        } else {
          return metadata.parsed;
        }
      };
      /**
       * Get the metadata format of the previously parsed document
       * @returns {string}
       */


      this.getMetadataFormat = function () {
        return metadata.format;
      };
      /**
       * Private: set a single key, value metadata pair
       * @param {string} key
       * @param {string} value
       */


      this._setMetadataPair = function (key, value) {
        metadata.parsed[key] = value;
      };
      /**
       * Private: set metadata format
       * @param {string} format
       */


      this._setMetadataFormat = function (format) {
        metadata.format = format;
      };
      /**
       * Private: set metadata raw text
       * @param {string} raw
       */


      this._setMetadataRaw = function (raw) {
        metadata.raw = raw;
      };
    };
    /**
     * Turn Markdown link shortcuts into XHTML <a> tags.
     */


    showdown.subParser('anchors', function (text, options, globals) {

      text = globals.converter._dispatch('anchors.before', text, options, globals);

      var writeAnchorTag = function writeAnchorTag(wholeMatch, linkText, linkId, url, m5, m6, title) {
        if (showdown.helper.isUndefined(title)) {
          title = '';
        }

        linkId = linkId.toLowerCase(); // Special case for explicit empty url

        if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
          url = '';
        } else if (!url) {
          if (!linkId) {
            // lower-case and turn embedded newlines into spaces
            linkId = linkText.toLowerCase().replace(/ ?\n/g, ' ');
          }

          url = '#' + linkId;

          if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
            url = globals.gUrls[linkId];

            if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
              title = globals.gTitles[linkId];
            }
          } else {
            return wholeMatch;
          }
        } //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance


        url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
        var result = '<a href="' + url + '"';

        if (title !== '' && title !== null) {
          title = title.replace(/"/g, '&quot;'); //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance

          title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
          result += ' title="' + title + '"';
        } // optionLinksInNewWindow only applies
        // to external links. Hash links (#) open in same page


        if (options.openLinksInNewWindow && !/^#/.test(url)) {
          // escaped _
          result += ' rel="noopener noreferrer" target="¨E95Eblank"';
        }

        result += '>' + linkText + '</a>';
        return result;
      }; // First, handle reference-style links: [link text] [id]


      text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag); // Next, inline-style links: [link text](url "optional title")
      // cases with crazy urls like ./image/cat1).png

      text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag); // normal cases

      text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag); // handle reference-style shortcuts: [link text]
      // These must come last in case you've also got [link test][1]
      // or [link test](/foo)

      text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag); // Lastly handle GithubMentions if option is enabled

      if (options.ghMentions) {
        text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function (wm, st, escape, mentions, username) {
          if (escape === '\\') {
            return st + mentions;
          } //check if options.ghMentionsLink is a string


          if (!showdown.helper.isString(options.ghMentionsLink)) {
            throw new Error('ghMentionsLink option must be a string');
          }

          var lnk = options.ghMentionsLink.replace(/\{u}/g, username),
              target = '';

          if (options.openLinksInNewWindow) {
            target = ' rel="noopener noreferrer" target="¨E95Eblank"';
          }

          return st + '<a href="' + lnk + '"' + target + '>' + mentions + '</a>';
        });
      }

      text = globals.converter._dispatch('anchors.after', text, options, globals);
      return text;
    }); // url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]

    var simpleURLRegex = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,
        simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,
        delimUrlRegex = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,
        simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi,
        delimMailRegex = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi,
        replaceLink = function replaceLink(options) {

      return function (wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
        link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
        var lnkTxt = link,
            append = '',
            target = '',
            lmc = leadingMagicChars || '',
            tmc = trailingMagicChars || '';

        if (/^www\./i.test(link)) {
          link = link.replace(/^www\./i, 'http://www.');
        }

        if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) {
          append = trailingPunctuation;
        }

        if (options.openLinksInNewWindow) {
          target = ' rel="noopener noreferrer" target="¨E95Eblank"';
        }

        return lmc + '<a href="' + link + '"' + target + '>' + lnkTxt + '</a>' + append + tmc;
      };
    },
        replaceMail = function replaceMail(options, globals) {

      return function (wholeMatch, b, mail) {
        var href = 'mailto:';
        b = b || '';
        mail = showdown.subParser('unescapeSpecialChars')(mail, options, globals);

        if (options.encodeEmails) {
          href = showdown.helper.encodeEmailAddress(href + mail);
          mail = showdown.helper.encodeEmailAddress(mail);
        } else {
          href = href + mail;
        }

        return b + '<a href="' + href + '">' + mail + '</a>';
      };
    };

    showdown.subParser('autoLinks', function (text, options, globals) {

      text = globals.converter._dispatch('autoLinks.before', text, options, globals);
      text = text.replace(delimUrlRegex, replaceLink(options));
      text = text.replace(delimMailRegex, replaceMail(options, globals));
      text = globals.converter._dispatch('autoLinks.after', text, options, globals);
      return text;
    });
    showdown.subParser('simplifiedAutoLinks', function (text, options, globals) {

      if (!options.simplifiedAutoLink) {
        return text;
      }

      text = globals.converter._dispatch('simplifiedAutoLinks.before', text, options, globals);

      if (options.excludeTrailingPunctuationFromURLs) {
        text = text.replace(simpleURLRegex2, replaceLink(options));
      } else {
        text = text.replace(simpleURLRegex, replaceLink(options));
      }

      text = text.replace(simpleMailRegex, replaceMail(options, globals));
      text = globals.converter._dispatch('simplifiedAutoLinks.after', text, options, globals);
      return text;
    });
    /**
     * These are all the transformations that form block-level
     * tags like paragraphs, headers, and list items.
     */

    showdown.subParser('blockGamut', function (text, options, globals) {

      text = globals.converter._dispatch('blockGamut.before', text, options, globals); // we parse blockquotes first so that we can have headings and hrs
      // inside blockquotes

      text = showdown.subParser('blockQuotes')(text, options, globals);
      text = showdown.subParser('headers')(text, options, globals); // Do Horizontal Rules:

      text = showdown.subParser('horizontalRule')(text, options, globals);
      text = showdown.subParser('lists')(text, options, globals);
      text = showdown.subParser('codeBlocks')(text, options, globals);
      text = showdown.subParser('tables')(text, options, globals); // We already ran _HashHTMLBlocks() before, in Markdown(), but that
      // was to escape raw HTML in the original Markdown source. This time,
      // we're escaping the markup we've just created, so that we don't wrap
      // <p> tags around block-level tags.

      text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
      text = showdown.subParser('paragraphs')(text, options, globals);
      text = globals.converter._dispatch('blockGamut.after', text, options, globals);
      return text;
    });
    showdown.subParser('blockQuotes', function (text, options, globals) {

      text = globals.converter._dispatch('blockQuotes.before', text, options, globals); // add a couple extra lines after the text and endtext mark

      text = text + '\n\n';
      var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;

      if (options.splitAdjacentBlockquotes) {
        rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
      }

      text = text.replace(rgx, function (bq) {
        // attacklab: hack around Konqueror 3.5.4 bug:
        // "----------bug".replace(/^-/g,"") == "bug"
        bq = bq.replace(/^[ \t]*>[ \t]?/gm, ''); // trim one level of quoting
        // attacklab: clean up hack

        bq = bq.replace(/¨0/g, '');
        bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines

        bq = showdown.subParser('githubCodeBlocks')(bq, options, globals);
        bq = showdown.subParser('blockGamut')(bq, options, globals); // recurse

        bq = bq.replace(/(^|\n)/g, '$1  '); // These leading spaces screw with <pre> content, so we need to fix that:

        bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (wholeMatch, m1) {
          var pre = m1; // attacklab: hack around Konqueror 3.5.4 bug:

          pre = pre.replace(/^  /mg, '¨0');
          pre = pre.replace(/¨0/g, '');
          return pre;
        });
        return showdown.subParser('hashBlock')('<blockquote>\n' + bq + '\n</blockquote>', options, globals);
      });
      text = globals.converter._dispatch('blockQuotes.after', text, options, globals);
      return text;
    });
    /**
     * Process Markdown `<pre><code>` blocks.
     */

    showdown.subParser('codeBlocks', function (text, options, globals) {

      text = globals.converter._dispatch('codeBlocks.before', text, options, globals); // sentinel workarounds for lack of \A and \Z, safari\khtml bug

      text += '¨0';
      var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
      text = text.replace(pattern, function (wholeMatch, m1, m2) {
        var codeblock = m1,
            nextChar = m2,
            end = '\n';
        codeblock = showdown.subParser('outdent')(codeblock, options, globals);
        codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
        codeblock = showdown.subParser('detab')(codeblock, options, globals);
        codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines

        codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines

        if (options.omitExtraWLInCodeBlocks) {
          end = '';
        }

        codeblock = '<pre><code>' + codeblock + end + '</code></pre>';
        return showdown.subParser('hashBlock')(codeblock, options, globals) + nextChar;
      }); // strip sentinel

      text = text.replace(/¨0/, '');
      text = globals.converter._dispatch('codeBlocks.after', text, options, globals);
      return text;
    });
    /**
     *
     *   *  Backtick quotes are used for <code></code> spans.
     *
     *   *  You can use multiple backticks as the delimiters if you want to
     *     include literal backticks in the code span. So, this input:
     *
     *         Just type ``foo `bar` baz`` at the prompt.
     *
     *       Will translate to:
     *
     *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
     *
     *    There's no arbitrary limit to the number of backticks you
     *    can use as delimters. If you need three consecutive backticks
     *    in your code, use four for delimiters, etc.
     *
     *  *  You can use spaces to get literal backticks at the edges:
     *
     *         ... type `` `bar` `` ...
     *
     *       Turns to:
     *
     *         ... type <code>`bar`</code> ...
     */

    showdown.subParser('codeSpans', function (text, options, globals) {

      text = globals.converter._dispatch('codeSpans.before', text, options, globals);

      if (typeof text === 'undefined') {
        text = '';
      }

      text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function (wholeMatch, m1, m2, m3) {
        var c = m3;
        c = c.replace(/^([ \t]*)/g, ''); // leading whitespace

        c = c.replace(/[ \t]*$/g, ''); // trailing whitespace

        c = showdown.subParser('encodeCode')(c, options, globals);
        c = m1 + '<code>' + c + '</code>';
        c = showdown.subParser('hashHTMLSpans')(c, options, globals);
        return c;
      });
      text = globals.converter._dispatch('codeSpans.after', text, options, globals);
      return text;
    });
    /**
     * Create a full HTML document from the processed markdown
     */

    showdown.subParser('completeHTMLDocument', function (text, options, globals) {

      if (!options.completeHTMLDocument) {
        return text;
      }

      text = globals.converter._dispatch('completeHTMLDocument.before', text, options, globals);
      var doctype = 'html',
          doctypeParsed = '<!DOCTYPE HTML>\n',
          title = '',
          charset = '<meta charset="utf-8">\n',
          lang = '',
          metadata = '';

      if (typeof globals.metadata.parsed.doctype !== 'undefined') {
        doctypeParsed = '<!DOCTYPE ' + globals.metadata.parsed.doctype + '>\n';
        doctype = globals.metadata.parsed.doctype.toString().toLowerCase();

        if (doctype === 'html' || doctype === 'html5') {
          charset = '<meta charset="utf-8">';
        }
      }

      for (var meta in globals.metadata.parsed) {
        if (globals.metadata.parsed.hasOwnProperty(meta)) {
          switch (meta.toLowerCase()) {
            case 'doctype':
              break;

            case 'title':
              title = '<title>' + globals.metadata.parsed.title + '</title>\n';
              break;

            case 'charset':
              if (doctype === 'html' || doctype === 'html5') {
                charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
              } else {
                charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
              }

              break;

            case 'language':
            case 'lang':
              lang = ' lang="' + globals.metadata.parsed[meta] + '"';
              metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
              break;

            default:
              metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
          }
        }
      }

      text = doctypeParsed + '<html' + lang + '>\n<head>\n' + title + charset + metadata + '</head>\n<body>\n' + text.trim() + '\n</body>\n</html>';
      text = globals.converter._dispatch('completeHTMLDocument.after', text, options, globals);
      return text;
    });
    /**
     * Convert all tabs to spaces
     */

    showdown.subParser('detab', function (text, options, globals) {

      text = globals.converter._dispatch('detab.before', text, options, globals); // expand first n-1 tabs

      text = text.replace(/\t(?=\t)/g, '    '); // g_tab_width
      // replace the nth with two sentinels

      text = text.replace(/\t/g, '¨A¨B'); // use the sentinel to anchor our regex so it doesn't explode

      text = text.replace(/¨B(.+?)¨A/g, function (wholeMatch, m1) {
        var leadingText = m1,
            numSpaces = 4 - leadingText.length % 4; // g_tab_width
        // there *must* be a better way to do this:

        for (var i = 0; i < numSpaces; i++) {
          leadingText += ' ';
        }

        return leadingText;
      }); // clean up sentinels

      text = text.replace(/¨A/g, '    '); // g_tab_width

      text = text.replace(/¨B/g, '');
      text = globals.converter._dispatch('detab.after', text, options, globals);
      return text;
    });
    showdown.subParser('ellipsis', function (text, options, globals) {

      text = globals.converter._dispatch('ellipsis.before', text, options, globals);
      text = text.replace(/\.\.\./g, '…');
      text = globals.converter._dispatch('ellipsis.after', text, options, globals);
      return text;
    });
    /**
     * Turn emoji codes into emojis
     *
     * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
     */

    showdown.subParser('emoji', function (text, options, globals) {

      if (!options.emoji) {
        return text;
      }

      text = globals.converter._dispatch('emoji.before', text, options, globals);
      var emojiRgx = /:([\S]+?):/g;
      text = text.replace(emojiRgx, function (wm, emojiCode) {
        if (showdown.helper.emojis.hasOwnProperty(emojiCode)) {
          return showdown.helper.emojis[emojiCode];
        }

        return wm;
      });
      text = globals.converter._dispatch('emoji.after', text, options, globals);
      return text;
    });
    /**
     * Smart processing for ampersands and angle brackets that need to be encoded.
     */

    showdown.subParser('encodeAmpsAndAngles', function (text, options, globals) {

      text = globals.converter._dispatch('encodeAmpsAndAngles.before', text, options, globals); // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
      // http://bumppo.net/projects/amputator/

      text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, '&amp;'); // Encode naked <'s

      text = text.replace(/<(?![a-z\/?$!])/gi, '&lt;'); // Encode <

      text = text.replace(/</g, '&lt;'); // Encode >

      text = text.replace(/>/g, '&gt;');
      text = globals.converter._dispatch('encodeAmpsAndAngles.after', text, options, globals);
      return text;
    });
    /**
     * Returns the string, with after processing the following backslash escape sequences.
     *
     * attacklab: The polite way to do this is with the new escapeCharacters() function:
     *
     *    text = escapeCharacters(text,"\\",true);
     *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
     *
     * ...but we're sidestepping its use of the (slow) RegExp constructor
     * as an optimization for Firefox.  This function gets called a LOT.
     */

    showdown.subParser('encodeBackslashEscapes', function (text, options, globals) {

      text = globals.converter._dispatch('encodeBackslashEscapes.before', text, options, globals);
      text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
      text = text.replace(/\\([`*_{}\[\]()>#+.!~=|-])/g, showdown.helper.escapeCharactersCallback);
      text = globals.converter._dispatch('encodeBackslashEscapes.after', text, options, globals);
      return text;
    });
    /**
     * Encode/escape certain characters inside Markdown code runs.
     * The point is that in code, these characters are literals,
     * and lose their special Markdown meanings.
     */

    showdown.subParser('encodeCode', function (text, options, globals) {

      text = globals.converter._dispatch('encodeCode.before', text, options, globals); // Encode all ampersands; HTML entities are not
      // entities within a Markdown code span.

      text = text.replace(/&/g, '&amp;') // Do the angle bracket song and dance:
      .replace(/</g, '&lt;').replace(/>/g, '&gt;') // Now, escape characters that are magic in Markdown:
      .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);
      text = globals.converter._dispatch('encodeCode.after', text, options, globals);
      return text;
    });
    /**
     * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
     * don't conflict with their use in Markdown for code, italics and strong.
     */

    showdown.subParser('escapeSpecialCharsWithinTagAttributes', function (text, options, globals) {

      text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.before', text, options, globals); // Build a regex to find HTML tags.

      var tags = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi,
          comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;
      text = text.replace(tags, function (wholeMatch) {
        return wholeMatch.replace(/(.)<\/?code>(?=.)/g, '$1`').replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
      });
      text = text.replace(comments, function (wholeMatch) {
        return wholeMatch.replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
      });
      text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.after', text, options, globals);
      return text;
    });
    /**
     * Handle github codeblocks prior to running HashHTML so that
     * HTML contained within the codeblock gets escaped properly
     * Example:
     * ```ruby
     *     def hello_world(x)
     *       puts "Hello, #{x}"
     *     end
     * ```
     */

    showdown.subParser('githubCodeBlocks', function (text, options, globals) {

      if (!options.ghCodeBlocks) {
        return text;
      }

      text = globals.converter._dispatch('githubCodeBlocks.before', text, options, globals);
      text += '¨0';
      text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function (wholeMatch, delim, language, codeblock) {
        var end = options.omitExtraWLInCodeBlocks ? '' : '\n'; // First parse the github code block

        codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
        codeblock = showdown.subParser('detab')(codeblock, options, globals);
        codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines

        codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing whitespace

        codeblock = '<pre><code' + (language ? ' class="' + language + ' language-' + language + '"' : '') + '>' + codeblock + end + '</code></pre>';
        codeblock = showdown.subParser('hashBlock')(codeblock, options, globals); // Since GHCodeblocks can be false positives, we need to
        // store the primitive text and the parsed text in a global var,
        // and then return a token

        return '\n\n¨G' + (globals.ghCodeBlocks.push({
          text: wholeMatch,
          codeblock: codeblock
        }) - 1) + 'G\n\n';
      }); // attacklab: strip sentinel

      text = text.replace(/¨0/, '');
      return globals.converter._dispatch('githubCodeBlocks.after', text, options, globals);
    });
    showdown.subParser('hashBlock', function (text, options, globals) {

      text = globals.converter._dispatch('hashBlock.before', text, options, globals);
      text = text.replace(/(^\n+|\n+$)/g, '');
      text = '\n\n¨K' + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';
      text = globals.converter._dispatch('hashBlock.after', text, options, globals);
      return text;
    });
    /**
     * Hash and escape <code> elements that should not be parsed as markdown
     */

    showdown.subParser('hashCodeTags', function (text, options, globals) {

      text = globals.converter._dispatch('hashCodeTags.before', text, options, globals);

      var repFunc = function repFunc(wholeMatch, match, left, right) {
        var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
        return '¨C' + (globals.gHtmlSpans.push(codeblock) - 1) + 'C';
      }; // Hash naked <code>


      text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '<code\\b[^>]*>', '</code>', 'gim');
      text = globals.converter._dispatch('hashCodeTags.after', text, options, globals);
      return text;
    });
    showdown.subParser('hashElement', function (text, options, globals) {

      return function (wholeMatch, m1) {
        var blockText = m1; // Undo double lines

        blockText = blockText.replace(/\n\n/g, '\n');
        blockText = blockText.replace(/^\n/, ''); // strip trailing blank lines

        blockText = blockText.replace(/\n+$/g, ''); // Replace the element text with a marker ("¨KxK" where x is its key)

        blockText = '\n\n¨K' + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';
        return blockText;
      };
    });
    showdown.subParser('hashHTMLBlocks', function (text, options, globals) {

      text = globals.converter._dispatch('hashHTMLBlocks.before', text, options, globals);

      var blockTags = ['pre', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'table', 'dl', 'ol', 'ul', 'script', 'noscript', 'form', 'fieldset', 'iframe', 'math', 'style', 'section', 'header', 'footer', 'nav', 'article', 'aside', 'address', 'audio', 'canvas', 'figure', 'hgroup', 'output', 'video', 'p'],
          repFunc = function repFunc(wholeMatch, match, left, right) {
        var txt = wholeMatch; // check if this html element is marked as markdown
        // if so, it's contents should be parsed as markdown

        if (left.search(/\bmarkdown\b/) !== -1) {
          txt = left + globals.converter.makeHtml(match) + right;
        }

        return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
      };

      if (options.backslashEscapesHTMLTags) {
        // encode backslash escaped HTML tags
        text = text.replace(/\\<(\/?[^>]+?)>/g, function (wm, inside) {
          return '&lt;' + inside + '&gt;';
        });
      } // hash HTML Blocks


      for (var i = 0; i < blockTags.length; ++i) {
        var opTagPos,
            rgx1 = new RegExp('^ {0,3}(<' + blockTags[i] + '\\b[^>]*>)', 'im'),
            patLeft = '<' + blockTags[i] + '\\b[^>]*>',
            patRight = '</' + blockTags[i] + '>'; // 1. Look for the first position of the first opening HTML tag in the text

        while ((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1) {
          // if the HTML tag is \ escaped, we need to escape it and break
          //2. Split the text in that position
          var subTexts = showdown.helper.splitAtIndex(text, opTagPos),
              //3. Match recursively
          newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, 'im'); // prevent an infinite loop

          if (newSubText1 === subTexts[1]) {
            break;
          }

          text = subTexts[0].concat(newSubText1);
        }
      } // HR SPECIAL CASE


      text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, showdown.subParser('hashElement')(text, options, globals)); // Special case for standalone HTML comments

      text = showdown.helper.replaceRecursiveRegExp(text, function (txt) {
        return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
      }, '^ {0,3}<!--', '-->', 'gm'); // PHP and ASP-style processor instructions (<?...?> and <%...%>)

      text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, showdown.subParser('hashElement')(text, options, globals));
      text = globals.converter._dispatch('hashHTMLBlocks.after', text, options, globals);
      return text;
    });
    /**
     * Hash span elements that should not be parsed as markdown
     */

    showdown.subParser('hashHTMLSpans', function (text, options, globals) {

      text = globals.converter._dispatch('hashHTMLSpans.before', text, options, globals);

      function hashHTMLSpan(html) {
        return '¨C' + (globals.gHtmlSpans.push(html) - 1) + 'C';
      } // Hash Self Closing tags


      text = text.replace(/<[^>]+?\/>/gi, function (wm) {
        return hashHTMLSpan(wm);
      }); // Hash tags without properties

      text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function (wm) {
        return hashHTMLSpan(wm);
      }); // Hash tags with properties

      text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function (wm) {
        return hashHTMLSpan(wm);
      }); // Hash self closing tags without />

      text = text.replace(/<[^>]+?>/gi, function (wm) {
        return hashHTMLSpan(wm);
      });
      /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/

      text = globals.converter._dispatch('hashHTMLSpans.after', text, options, globals);
      return text;
    });
    /**
     * Unhash HTML spans
     */

    showdown.subParser('unhashHTMLSpans', function (text, options, globals) {

      text = globals.converter._dispatch('unhashHTMLSpans.before', text, options, globals);

      for (var i = 0; i < globals.gHtmlSpans.length; ++i) {
        var repText = globals.gHtmlSpans[i],
            // limiter to prevent infinite loop (assume 10 as limit for recurse)
        limit = 0;

        while (/¨C(\d+)C/.test(repText)) {
          var num = RegExp.$1;
          repText = repText.replace('¨C' + num + 'C', globals.gHtmlSpans[num]);

          if (limit === 10) {
            console.error('maximum nesting of 10 spans reached!!!');
            break;
          }

          ++limit;
        }

        text = text.replace('¨C' + i + 'C', repText);
      }

      text = globals.converter._dispatch('unhashHTMLSpans.after', text, options, globals);
      return text;
    });
    /**
     * Hash and escape <pre><code> elements that should not be parsed as markdown
     */

    showdown.subParser('hashPreCodeTags', function (text, options, globals) {

      text = globals.converter._dispatch('hashPreCodeTags.before', text, options, globals);

      var repFunc = function repFunc(wholeMatch, match, left, right) {
        // encode html entities
        var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
        return '\n\n¨G' + (globals.ghCodeBlocks.push({
          text: wholeMatch,
          codeblock: codeblock
        }) - 1) + 'G\n\n';
      }; // Hash <pre><code>


      text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^ {0,3}</code>\\s*</pre>', 'gim');
      text = globals.converter._dispatch('hashPreCodeTags.after', text, options, globals);
      return text;
    });
    showdown.subParser('headers', function (text, options, globals) {

      text = globals.converter._dispatch('headers.before', text, options, globals);
      var headerLevelStart = isNaN(parseInt(options.headerLevelStart)) ? 1 : parseInt(options.headerLevelStart),
          // Set text-style headers:
      //	Header 1
      //	========
      //
      //	Header 2
      //	--------
      //
      setextRegexH1 = options.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
          setextRegexH2 = options.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
      text = text.replace(setextRegexH1, function (wholeMatch, m1) {
        var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
            hID = options.noHeaderId ? '' : ' id="' + headerId(m1) + '"',
            hLevel = headerLevelStart,
            hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
        return showdown.subParser('hashBlock')(hashBlock, options, globals);
      });
      text = text.replace(setextRegexH2, function (matchFound, m1) {
        var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
            hID = options.noHeaderId ? '' : ' id="' + headerId(m1) + '"',
            hLevel = headerLevelStart + 1,
            hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
        return showdown.subParser('hashBlock')(hashBlock, options, globals);
      }); // atx-style headers:
      //  # Header 1
      //  ## Header 2
      //  ## Header 2 with closing hashes ##
      //  ...
      //  ###### Header 6
      //

      var atxStyle = options.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;
      text = text.replace(atxStyle, function (wholeMatch, m1, m2) {
        var hText = m2;

        if (options.customizedHeaderId) {
          hText = m2.replace(/\s?\{([^{]+?)}\s*$/, '');
        }

        var span = showdown.subParser('spanGamut')(hText, options, globals),
            hID = options.noHeaderId ? '' : ' id="' + headerId(m2) + '"',
            hLevel = headerLevelStart - 1 + m1.length,
            header = '<h' + hLevel + hID + '>' + span + '</h' + hLevel + '>';
        return showdown.subParser('hashBlock')(header, options, globals);
      });

      function headerId(m) {
        var title, prefix; // It is separate from other options to allow combining prefix and customized

        if (options.customizedHeaderId) {
          var match = m.match(/\{([^{]+?)}\s*$/);

          if (match && match[1]) {
            m = match[1];
          }
        }

        title = m; // Prefix id to prevent causing inadvertent pre-existing style matches.

        if (showdown.helper.isString(options.prefixHeaderId)) {
          prefix = options.prefixHeaderId;
        } else if (options.prefixHeaderId === true) {
          prefix = 'section-';
        } else {
          prefix = '';
        }

        if (!options.rawPrefixHeaderId) {
          title = prefix + title;
        }

        if (options.ghCompatibleHeaderId) {
          title = title.replace(/ /g, '-') // replace previously escaped chars (&, ¨ and $)
          .replace(/&amp;/g, '').replace(/¨T/g, '').replace(/¨D/g, '') // replace rest of the chars (&~$ are repeated as they might have been escaped)
          // borrowed from github's redcarpet (some they should produce similar results)
          .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, '').toLowerCase();
        } else if (options.rawHeaderId) {
          title = title.replace(/ /g, '-') // replace previously escaped chars (&, ¨ and $)
          .replace(/&amp;/g, '&').replace(/¨T/g, '¨').replace(/¨D/g, '$') // replace " and '
          .replace(/["']/g, '-').toLowerCase();
        } else {
          title = title.replace(/[^\w]/g, '').toLowerCase();
        }

        if (options.rawPrefixHeaderId) {
          title = prefix + title;
        }

        if (globals.hashLinkCounts[title]) {
          title = title + '-' + globals.hashLinkCounts[title]++;
        } else {
          globals.hashLinkCounts[title] = 1;
        }

        return title;
      }

      text = globals.converter._dispatch('headers.after', text, options, globals);
      return text;
    });
    /**
     * Turn Markdown link shortcuts into XHTML <a> tags.
     */

    showdown.subParser('horizontalRule', function (text, options, globals) {

      text = globals.converter._dispatch('horizontalRule.before', text, options, globals);
      var key = showdown.subParser('hashBlock')('<hr />', options, globals);
      text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
      text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
      text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);
      text = globals.converter._dispatch('horizontalRule.after', text, options, globals);
      return text;
    });
    /**
     * Turn Markdown image shortcuts into <img> tags.
     */

    showdown.subParser('images', function (text, options, globals) {

      text = globals.converter._dispatch('images.before', text, options, globals);
      var inlineRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
          crazyRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g,
          base64RegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
          referenceRegExp = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g,
          refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;

      function writeImageTagBase64(wholeMatch, altText, linkId, url, width, height, m5, title) {
        url = url.replace(/\s/g, '');
        return writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title);
      }

      function writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title) {
        var gUrls = globals.gUrls,
            gTitles = globals.gTitles,
            gDims = globals.gDimensions;
        linkId = linkId.toLowerCase();

        if (!title) {
          title = '';
        } // Special case for explicit empty url


        if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
          url = '';
        } else if (url === '' || url === null) {
          if (linkId === '' || linkId === null) {
            // lower-case and turn embedded newlines into spaces
            linkId = altText.toLowerCase().replace(/ ?\n/g, ' ');
          }

          url = '#' + linkId;

          if (!showdown.helper.isUndefined(gUrls[linkId])) {
            url = gUrls[linkId];

            if (!showdown.helper.isUndefined(gTitles[linkId])) {
              title = gTitles[linkId];
            }

            if (!showdown.helper.isUndefined(gDims[linkId])) {
              width = gDims[linkId].width;
              height = gDims[linkId].height;
            }
          } else {
            return wholeMatch;
          }
        }

        altText = altText.replace(/"/g, '&quot;') //altText = showdown.helper.escapeCharacters(altText, '*_', false);
        .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback); //url = showdown.helper.escapeCharacters(url, '*_', false);

        url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
        var result = '<img src="' + url + '" alt="' + altText + '"';

        if (title && showdown.helper.isString(title)) {
          title = title.replace(/"/g, '&quot;') //title = showdown.helper.escapeCharacters(title, '*_', false);
          .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
          result += ' title="' + title + '"';
        }

        if (width && height) {
          width = width === '*' ? 'auto' : width;
          height = height === '*' ? 'auto' : height;
          result += ' width="' + width + '"';
          result += ' height="' + height + '"';
        }

        result += ' />';
        return result;
      } // First, handle reference-style labeled images: ![alt text][id]


      text = text.replace(referenceRegExp, writeImageTag); // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
      // base64 encoded images

      text = text.replace(base64RegExp, writeImageTagBase64); // cases with crazy urls like ./image/cat1).png

      text = text.replace(crazyRegExp, writeImageTag); // normal cases

      text = text.replace(inlineRegExp, writeImageTag); // handle reference-style shortcuts: ![img text]

      text = text.replace(refShortcutRegExp, writeImageTag);
      text = globals.converter._dispatch('images.after', text, options, globals);
      return text;
    });
    showdown.subParser('italicsAndBold', function (text, options, globals) {

      text = globals.converter._dispatch('italicsAndBold.before', text, options, globals); // it's faster to have 3 separate regexes for each case than have just one
      // because of backtracing, in some cases, it could lead to an exponential effect
      // called "catastrophic backtrace". Ominous!

      function parseInside(txt, left, right) {
        /*
        if (options.simplifiedAutoLink) {
          txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
        }
        */
        return left + txt + right;
      } // Parse underscores


      if (options.literalMidWordUnderscores) {
        text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
          return parseInside(txt, '<strong><em>', '</em></strong>');
        });
        text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
          return parseInside(txt, '<strong>', '</strong>');
        });
        text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function (wm, txt) {
          return parseInside(txt, '<em>', '</em>');
        });
      } else {
        text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
          return /\S$/.test(m) ? parseInside(m, '<strong><em>', '</em></strong>') : wm;
        });
        text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
          return /\S$/.test(m) ? parseInside(m, '<strong>', '</strong>') : wm;
        });
        text = text.replace(/_([^\s_][\s\S]*?)_/g, function (wm, m) {
          // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
          return /\S$/.test(m) ? parseInside(m, '<em>', '</em>') : wm;
        });
      } // Now parse asterisks


      if (options.literalMidWordAsterisks) {
        text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function (wm, lead, txt) {
          return parseInside(txt, lead + '<strong><em>', '</em></strong>');
        });
        text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function (wm, lead, txt) {
          return parseInside(txt, lead + '<strong>', '</strong>');
        });
        text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function (wm, lead, txt) {
          return parseInside(txt, lead + '<em>', '</em>');
        });
      } else {
        text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function (wm, m) {
          return /\S$/.test(m) ? parseInside(m, '<strong><em>', '</em></strong>') : wm;
        });
        text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function (wm, m) {
          return /\S$/.test(m) ? parseInside(m, '<strong>', '</strong>') : wm;
        });
        text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function (wm, m) {
          // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
          return /\S$/.test(m) ? parseInside(m, '<em>', '</em>') : wm;
        });
      }

      text = globals.converter._dispatch('italicsAndBold.after', text, options, globals);
      return text;
    });
    /**
     * Form HTML ordered (numbered) and unordered (bulleted) lists.
     */

    showdown.subParser('lists', function (text, options, globals) {
      /**
       * Process the contents of a single ordered or unordered list, splitting it
       * into individual list items.
       * @param {string} listStr
       * @param {boolean} trimTrailing
       * @returns {string}
       */

      function processListItems(listStr, trimTrailing) {
        // The $g_list_level global keeps track of when we're inside a list.
        // Each time we enter a list, we increment it; when we leave a list,
        // we decrement. If it's zero, we're not in a list anymore.
        //
        // We do this because when we're not inside a list, we want to treat
        // something like this:
        //
        //    I recommend upgrading to version
        //    8. Oops, now this line is treated
        //    as a sub-list.
        //
        // As a single paragraph, despite the fact that the second line starts
        // with a digit-period-space sequence.
        //
        // Whereas when we're inside a list (or sub-list), that line will be
        // treated as the start of a sub-list. What a kludge, huh? This is
        // an aspect of Markdown's syntax that's hard to parse perfectly
        // without resorting to mind-reading. Perhaps the solution is to
        // change the syntax rules such that sub-lists must start with a
        // starting cardinal number; e.g. "1." or "a.".
        globals.gListLevel++; // trim trailing blank lines:

        listStr = listStr.replace(/\n{2,}$/, '\n'); // attacklab: add sentinel to emulate \z

        listStr += '¨0';
        var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
            isParagraphed = /\n[ \t]*\n(?!¨0)/.test(listStr); // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
        // which is a syntax breaking change
        // activating this option reverts to old behavior

        if (options.disableForced4SpacesIndentedSublists) {
          rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
        }

        listStr = listStr.replace(rgx, function (wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
          checked = checked && checked.trim() !== '';
          var item = showdown.subParser('outdent')(m4, options, globals),
              bulletStyle = ''; // Support for github tasklists

          if (taskbtn && options.tasklists) {
            bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
            item = item.replace(/^[ \t]*\[(x|X| )?]/m, function () {
              var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';

              if (checked) {
                otp += ' checked';
              }

              otp += '>';
              return otp;
            });
          } // ISSUE #312
          // This input: - - - a
          // causes trouble to the parser, since it interprets it as:
          // <ul><li><li><li>a</li></li></li></ul>
          // instead of:
          // <ul><li>- - a</li></ul>
          // So, to prevent it, we will put a marker (¨A)in the beginning of the line
          // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser


          item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (wm2) {
            return '¨A' + wm2;
          }); // m1 - Leading line or
          // Has a double return (multi paragraph) or
          // Has sublist

          if (m1 || item.search(/\n{2,}/) > -1) {
            item = showdown.subParser('githubCodeBlocks')(item, options, globals);
            item = showdown.subParser('blockGamut')(item, options, globals);
          } else {
            // Recursion for sub-lists:
            item = showdown.subParser('lists')(item, options, globals);
            item = item.replace(/\n$/, ''); // chomp(item)

            item = showdown.subParser('hashHTMLBlocks')(item, options, globals); // Colapse double linebreaks

            item = item.replace(/\n\n+/g, '\n\n');

            if (isParagraphed) {
              item = showdown.subParser('paragraphs')(item, options, globals);
            } else {
              item = showdown.subParser('spanGamut')(item, options, globals);
            }
          } // now we need to remove the marker (¨A)


          item = item.replace('¨A', ''); // we can finally wrap the line in list item tags

          item = '<li' + bulletStyle + '>' + item + '</li>\n';
          return item;
        }); // attacklab: strip sentinel

        listStr = listStr.replace(/¨0/g, '');
        globals.gListLevel--;

        if (trimTrailing) {
          listStr = listStr.replace(/\s+$/, '');
        }

        return listStr;
      }

      function styleStartNumber(list, listType) {
        // check if ol and starts by a number different than 1
        if (listType === 'ol') {
          var res = list.match(/^ *(\d+)\./);

          if (res && res[1] !== '1') {
            return ' start="' + res[1] + '"';
          }
        }

        return '';
      }
      /**
       * Check and parse consecutive lists (better fix for issue #142)
       * @param {string} list
       * @param {string} listType
       * @param {boolean} trimTrailing
       * @returns {string}
       */


      function parseConsecutiveLists(list, listType, trimTrailing) {
        // check if we caught 2 or more consecutive lists by mistake
        // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
        var olRgx = options.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm,
            ulRgx = options.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm,
            counterRxg = listType === 'ul' ? olRgx : ulRgx,
            result = '';

        if (list.search(counterRxg) !== -1) {
          (function parseCL(txt) {
            var pos = txt.search(counterRxg),
                style = styleStartNumber(list, listType);

            if (pos !== -1) {
              // slice
              result += '\n\n<' + listType + style + '>\n' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n'; // invert counterType and listType

              listType = listType === 'ul' ? 'ol' : 'ul';
              counterRxg = listType === 'ul' ? olRgx : ulRgx; //recurse

              parseCL(txt.slice(pos));
            } else {
              result += '\n\n<' + listType + style + '>\n' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n';
            }
          })(list);
        } else {
          var style = styleStartNumber(list, listType);
          result = '\n\n<' + listType + style + '>\n' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n';
        }

        return result;
      }
      /** Start of list parsing **/


      text = globals.converter._dispatch('lists.before', text, options, globals); // add sentinel to hack around khtml/safari bug:
      // http://bugs.webkit.org/show_bug.cgi?id=11231

      text += '¨0';

      if (globals.gListLevel) {
        text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (wholeMatch, list, m2) {
          var listType = m2.search(/[*+-]/g) > -1 ? 'ul' : 'ol';
          return parseConsecutiveLists(list, listType, true);
        });
      } else {
        text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (wholeMatch, m1, list, m3) {
          var listType = m3.search(/[*+-]/g) > -1 ? 'ul' : 'ol';
          return parseConsecutiveLists(list, listType, false);
        });
      } // strip sentinel


      text = text.replace(/¨0/, '');
      text = globals.converter._dispatch('lists.after', text, options, globals);
      return text;
    });
    /**
     * Parse metadata at the top of the document
     */

    showdown.subParser('metadata', function (text, options, globals) {

      if (!options.metadata) {
        return text;
      }

      text = globals.converter._dispatch('metadata.before', text, options, globals);

      function parseMetadataContents(content) {
        // raw is raw so it's not changed in any way
        globals.metadata.raw = content; // escape chars forbidden in html attributes
        // double quotes

        content = content // ampersand first
        .replace(/&/g, '&amp;') // double quotes
        .replace(/"/g, '&quot;');
        content = content.replace(/\n {4}/g, ' ');
        content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function (wm, key, value) {
          globals.metadata.parsed[key] = value;
          return '';
        });
      }

      text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function (wholematch, format, content) {
        parseMetadataContents(content);
        return '¨M';
      });
      text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function (wholematch, format, content) {
        if (format) {
          globals.metadata.format = format;
        }

        parseMetadataContents(content);
        return '¨M';
      });
      text = text.replace(/¨M/g, '');
      text = globals.converter._dispatch('metadata.after', text, options, globals);
      return text;
    });
    /**
     * Remove one level of line-leading tabs or spaces
     */

    showdown.subParser('outdent', function (text, options, globals) {

      text = globals.converter._dispatch('outdent.before', text, options, globals); // attacklab: hack around Konqueror 3.5.4 bug:
      // "----------bug".replace(/^-/g,"") == "bug"

      text = text.replace(/^(\t|[ ]{1,4})/gm, '¨0'); // attacklab: g_tab_width
      // attacklab: clean up hack

      text = text.replace(/¨0/g, '');
      text = globals.converter._dispatch('outdent.after', text, options, globals);
      return text;
    });
    /**
     *
     */

    showdown.subParser('paragraphs', function (text, options, globals) {

      text = globals.converter._dispatch('paragraphs.before', text, options, globals); // Strip leading and trailing lines:

      text = text.replace(/^\n+/g, '');
      text = text.replace(/\n+$/g, '');
      var grafs = text.split(/\n{2,}/g),
          grafsOut = [],
          end = grafs.length; // Wrap <p> tags

      for (var i = 0; i < end; i++) {
        var str = grafs[i]; // if this is an HTML marker, copy it

        if (str.search(/¨(K|G)(\d+)\1/g) >= 0) {
          grafsOut.push(str); // test for presence of characters to prevent empty lines being parsed
          // as paragraphs (resulting in undesired extra empty paragraphs)
        } else if (str.search(/\S/) >= 0) {
          str = showdown.subParser('spanGamut')(str, options, globals);
          str = str.replace(/^([ \t]*)/g, '<p>');
          str += '</p>';
          grafsOut.push(str);
        }
      }
      /** Unhashify HTML blocks */


      end = grafsOut.length;

      for (i = 0; i < end; i++) {
        var blockText = '',
            grafsOutIt = grafsOut[i],
            codeFlag = false; // if this is a marker for an html block...
        // use RegExp.test instead of string.search because of QML bug

        while (/¨(K|G)(\d+)\1/.test(grafsOutIt)) {
          var delim = RegExp.$1,
              num = RegExp.$2;

          if (delim === 'K') {
            blockText = globals.gHtmlBlocks[num];
          } else {
            // we need to check if ghBlock is a false positive
            if (codeFlag) {
              // use encoded version of all text
              blockText = showdown.subParser('encodeCode')(globals.ghCodeBlocks[num].text, options, globals);
            } else {
              blockText = globals.ghCodeBlocks[num].codeblock;
            }
          }

          blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs

          grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText); // Check if grafsOutIt is a pre->code

          if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) {
            codeFlag = true;
          }
        }

        grafsOut[i] = grafsOutIt;
      }

      text = grafsOut.join('\n'); // Strip leading and trailing lines:

      text = text.replace(/^\n+/g, '');
      text = text.replace(/\n+$/g, '');
      return globals.converter._dispatch('paragraphs.after', text, options, globals);
    });
    /**
     * Run extension
     */

    showdown.subParser('runExtension', function (ext, text, options, globals) {

      if (ext.filter) {
        text = ext.filter(text, globals.converter, options);
      } else if (ext.regex) {
        // TODO remove this when old extension loading mechanism is deprecated
        var re = ext.regex;

        if (!(re instanceof RegExp)) {
          re = new RegExp(re, 'g');
        }

        text = text.replace(re, ext.replace);
      }

      return text;
    });
    /**
     * These are all the transformations that occur *within* block-level
     * tags like paragraphs, headers, and list items.
     */

    showdown.subParser('spanGamut', function (text, options, globals) {

      text = globals.converter._dispatch('spanGamut.before', text, options, globals);
      text = showdown.subParser('codeSpans')(text, options, globals);
      text = showdown.subParser('escapeSpecialCharsWithinTagAttributes')(text, options, globals);
      text = showdown.subParser('encodeBackslashEscapes')(text, options, globals); // Process anchor and image tags. Images must come first,
      // because ![foo][f] looks like an anchor.

      text = showdown.subParser('images')(text, options, globals);
      text = showdown.subParser('anchors')(text, options, globals); // Make links out of things like `<http://example.com/>`
      // Must come after anchors, because you can use < and >
      // delimiters in inline links like [this](<url>).

      text = showdown.subParser('autoLinks')(text, options, globals);
      text = showdown.subParser('simplifiedAutoLinks')(text, options, globals);
      text = showdown.subParser('emoji')(text, options, globals);
      text = showdown.subParser('underline')(text, options, globals);
      text = showdown.subParser('italicsAndBold')(text, options, globals);
      text = showdown.subParser('strikethrough')(text, options, globals);
      text = showdown.subParser('ellipsis')(text, options, globals); // we need to hash HTML tags inside spans

      text = showdown.subParser('hashHTMLSpans')(text, options, globals); // now we encode amps and angles

      text = showdown.subParser('encodeAmpsAndAngles')(text, options, globals); // Do hard breaks

      if (options.simpleLineBreaks) {
        // GFM style hard breaks
        // only add line breaks if the text does not contain a block (special case for lists)
        if (!/\n\n¨K/.test(text)) {
          text = text.replace(/\n+/g, '<br />\n');
        }
      } else {
        // Vanilla hard breaks
        text = text.replace(/  +\n/g, '<br />\n');
      }

      text = globals.converter._dispatch('spanGamut.after', text, options, globals);
      return text;
    });
    showdown.subParser('strikethrough', function (text, options, globals) {

      function parseInside(txt) {
        if (options.simplifiedAutoLink) {
          txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
        }

        return '<del>' + txt + '</del>';
      }

      if (options.strikethrough) {
        text = globals.converter._dispatch('strikethrough.before', text, options, globals);
        text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function (wm, txt) {
          return parseInside(txt);
        });
        text = globals.converter._dispatch('strikethrough.after', text, options, globals);
      }

      return text;
    });
    /**
     * Strips link definitions from text, stores the URLs and titles in
     * hash references.
     * Link defs are in the form: ^[id]: url "optional title"
     */

    showdown.subParser('stripLinkDefinitions', function (text, options, globals) {

      var regex = /^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm,
          base64Regex = /^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm; // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug

      text += '¨0';

      var replaceFunc = function replaceFunc(wholeMatch, linkId, url, width, height, blankLines, title) {
        linkId = linkId.toLowerCase();

        if (url.match(/^data:.+?\/.+?;base64,/)) {
          // remove newlines
          globals.gUrls[linkId] = url.replace(/\s/g, '');
        } else {
          globals.gUrls[linkId] = showdown.subParser('encodeAmpsAndAngles')(url, options, globals); // Link IDs are case-insensitive
        }

        if (blankLines) {
          // Oops, found blank lines, so it's not a title.
          // Put back the parenthetical statement we stole.
          return blankLines + title;
        } else {
          if (title) {
            globals.gTitles[linkId] = title.replace(/"|'/g, '&quot;');
          }

          if (options.parseImgDimensions && width && height) {
            globals.gDimensions[linkId] = {
              width: width,
              height: height
            };
          }
        } // Completely remove the definition from the text


        return '';
      }; // first we try to find base64 link references


      text = text.replace(base64Regex, replaceFunc);
      text = text.replace(regex, replaceFunc); // attacklab: strip sentinel

      text = text.replace(/¨0/, '');
      return text;
    });
    showdown.subParser('tables', function (text, options, globals) {

      if (!options.tables) {
        return text;
      }

      var tableRgx = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm,
          //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
      singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;

      function parseStyles(sLine) {
        if (/^:[ \t]*--*$/.test(sLine)) {
          return ' style="text-align:left;"';
        } else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) {
          return ' style="text-align:right;"';
        } else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) {
          return ' style="text-align:center;"';
        } else {
          return '';
        }
      }

      function parseHeaders(header, style) {
        var id = '';
        header = header.trim(); // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility

        if (options.tablesHeaderId || options.tableHeaderId) {
          id = ' id="' + header.replace(/ /g, '_').toLowerCase() + '"';
        }

        header = showdown.subParser('spanGamut')(header, options, globals);
        return '<th' + id + style + '>' + header + '</th>\n';
      }

      function parseCells(cell, style) {
        var subText = showdown.subParser('spanGamut')(cell, options, globals);
        return '<td' + style + '>' + subText + '</td>\n';
      }

      function buildTable(headers, cells) {
        var tb = '<table>\n<thead>\n<tr>\n',
            tblLgn = headers.length;

        for (var i = 0; i < tblLgn; ++i) {
          tb += headers[i];
        }

        tb += '</tr>\n</thead>\n<tbody>\n';

        for (i = 0; i < cells.length; ++i) {
          tb += '<tr>\n';

          for (var ii = 0; ii < tblLgn; ++ii) {
            tb += cells[i][ii];
          }

          tb += '</tr>\n';
        }

        tb += '</tbody>\n</table>\n';
        return tb;
      }

      function parseTable(rawTable) {
        var i,
            tableLines = rawTable.split('\n');

        for (i = 0; i < tableLines.length; ++i) {
          // strip wrong first and last column if wrapped tables are used
          if (/^ {0,3}\|/.test(tableLines[i])) {
            tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, '');
          }

          if (/\|[ \t]*$/.test(tableLines[i])) {
            tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
          } // parse code spans first, but we only support one line code spans


          tableLines[i] = showdown.subParser('codeSpans')(tableLines[i], options, globals);
        }

        var rawHeaders = tableLines[0].split('|').map(function (s) {
          return s.trim();
        }),
            rawStyles = tableLines[1].split('|').map(function (s) {
          return s.trim();
        }),
            rawCells = [],
            headers = [],
            styles = [],
            cells = [];
        tableLines.shift();
        tableLines.shift();

        for (i = 0; i < tableLines.length; ++i) {
          if (tableLines[i].trim() === '') {
            continue;
          }

          rawCells.push(tableLines[i].split('|').map(function (s) {
            return s.trim();
          }));
        }

        if (rawHeaders.length < rawStyles.length) {
          return rawTable;
        }

        for (i = 0; i < rawStyles.length; ++i) {
          styles.push(parseStyles(rawStyles[i]));
        }

        for (i = 0; i < rawHeaders.length; ++i) {
          if (showdown.helper.isUndefined(styles[i])) {
            styles[i] = '';
          }

          headers.push(parseHeaders(rawHeaders[i], styles[i]));
        }

        for (i = 0; i < rawCells.length; ++i) {
          var row = [];

          for (var ii = 0; ii < headers.length; ++ii) {
            if (showdown.helper.isUndefined(rawCells[i][ii])) ;

            row.push(parseCells(rawCells[i][ii], styles[ii]));
          }

          cells.push(row);
        }

        return buildTable(headers, cells);
      }

      text = globals.converter._dispatch('tables.before', text, options, globals); // find escaped pipe characters

      text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback); // parse multi column tables

      text = text.replace(tableRgx, parseTable); // parse one column tables

      text = text.replace(singeColTblRgx, parseTable);
      text = globals.converter._dispatch('tables.after', text, options, globals);
      return text;
    });
    showdown.subParser('underline', function (text, options, globals) {

      if (!options.underline) {
        return text;
      }

      text = globals.converter._dispatch('underline.before', text, options, globals);

      if (options.literalMidWordUnderscores) {
        text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
          return '<u>' + txt + '</u>';
        });
        text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
          return '<u>' + txt + '</u>';
        });
      } else {
        text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
          return /\S$/.test(m) ? '<u>' + m + '</u>' : wm;
        });
        text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
          return /\S$/.test(m) ? '<u>' + m + '</u>' : wm;
        });
      } // escape remaining underscores to prevent them being parsed by italic and bold


      text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);
      text = globals.converter._dispatch('underline.after', text, options, globals);
      return text;
    });
    /**
     * Swap back in all the special characters we've hidden.
     */

    showdown.subParser('unescapeSpecialChars', function (text, options, globals) {

      text = globals.converter._dispatch('unescapeSpecialChars.before', text, options, globals);
      text = text.replace(/¨E(\d+)E/g, function (wholeMatch, m1) {
        var charCodeToReplace = parseInt(m1);
        return String.fromCharCode(charCodeToReplace);
      });
      text = globals.converter._dispatch('unescapeSpecialChars.after', text, options, globals);
      return text;
    });
    showdown.subParser('makeMarkdown.blockquote', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes()) {
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          var innerTxt = showdown.subParser('makeMarkdown.node')(children[i], globals);

          if (innerTxt === '') {
            continue;
          }

          txt += innerTxt;
        }
      } // cleanup


      txt = txt.trim();
      txt = '> ' + txt.split('\n').join('\n> ');
      return txt;
    });
    showdown.subParser('makeMarkdown.codeBlock', function (node, globals) {

      var lang = node.getAttribute('language'),
          num = node.getAttribute('precodenum');
      return '```' + lang + '\n' + globals.preList[num] + '\n```';
    });
    showdown.subParser('makeMarkdown.codeSpan', function (node) {

      return '`' + node.innerHTML + '`';
    });
    showdown.subParser('makeMarkdown.emphasis', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes()) {
        txt += '*';
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }

        txt += '*';
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.header', function (node, globals, headerLevel) {

      var headerMark = new Array(headerLevel + 1).join('#'),
          txt = '';

      if (node.hasChildNodes()) {
        txt = headerMark + ' ';
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.hr', function () {

      return '---';
    });
    showdown.subParser('makeMarkdown.image', function (node) {

      var txt = '';

      if (node.hasAttribute('src')) {
        txt += '![' + node.getAttribute('alt') + '](';
        txt += '<' + node.getAttribute('src') + '>';

        if (node.hasAttribute('width') && node.hasAttribute('height')) {
          txt += ' =' + node.getAttribute('width') + 'x' + node.getAttribute('height');
        }

        if (node.hasAttribute('title')) {
          txt += ' "' + node.getAttribute('title') + '"';
        }

        txt += ')';
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.links', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes() && node.hasAttribute('href')) {
        var children = node.childNodes,
            childrenLength = children.length;
        txt = '[';

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }

        txt += '](';
        txt += '<' + node.getAttribute('href') + '>';

        if (node.hasAttribute('title')) {
          txt += ' "' + node.getAttribute('title') + '"';
        }

        txt += ')';
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.list', function (node, globals, type) {

      var txt = '';

      if (!node.hasChildNodes()) {
        return '';
      }

      var listItems = node.childNodes,
          listItemsLenght = listItems.length,
          listNum = node.getAttribute('start') || 1;

      for (var i = 0; i < listItemsLenght; ++i) {
        if (typeof listItems[i].tagName === 'undefined' || listItems[i].tagName.toLowerCase() !== 'li') {
          continue;
        } // define the bullet to use in list


        var bullet = '';

        if (type === 'ol') {
          bullet = listNum.toString() + '. ';
        } else {
          bullet = '- ';
        } // parse list item


        txt += bullet + showdown.subParser('makeMarkdown.listItem')(listItems[i], globals);
        ++listNum;
      } // add comment at the end to prevent consecutive lists to be parsed as one


      txt += '\n<!-- -->\n';
      return txt.trim();
    });
    showdown.subParser('makeMarkdown.listItem', function (node, globals) {

      var listItemTxt = '';
      var children = node.childNodes,
          childrenLenght = children.length;

      for (var i = 0; i < childrenLenght; ++i) {
        listItemTxt += showdown.subParser('makeMarkdown.node')(children[i], globals);
      } // if it's only one liner, we need to add a newline at the end


      if (!/\n$/.test(listItemTxt)) {
        listItemTxt += '\n';
      } else {
        // it's multiparagraph, so we need to indent
        listItemTxt = listItemTxt.split('\n').join('\n    ').replace(/^ {4}$/gm, '').replace(/\n\n+/g, '\n\n');
      }

      return listItemTxt;
    });
    showdown.subParser('makeMarkdown.node', function (node, globals, spansOnly) {

      spansOnly = spansOnly || false;
      var txt = ''; // edge case of text without wrapper paragraph

      if (node.nodeType === 3) {
        return showdown.subParser('makeMarkdown.txt')(node, globals);
      } // HTML comment


      if (node.nodeType === 8) {
        return '<!--' + node.data + '-->\n\n';
      } // process only node elements


      if (node.nodeType !== 1) {
        return '';
      }

      var tagName = node.tagName.toLowerCase();

      switch (tagName) {
        //
        // BLOCKS
        //
        case 'h1':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 1) + '\n\n';
          }

          break;

        case 'h2':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 2) + '\n\n';
          }

          break;

        case 'h3':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 3) + '\n\n';
          }

          break;

        case 'h4':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 4) + '\n\n';
          }

          break;

        case 'h5':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 5) + '\n\n';
          }

          break;

        case 'h6':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.header')(node, globals, 6) + '\n\n';
          }

          break;

        case 'p':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.paragraph')(node, globals) + '\n\n';
          }

          break;

        case 'blockquote':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.blockquote')(node, globals) + '\n\n';
          }

          break;

        case 'hr':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.hr')(node, globals) + '\n\n';
          }

          break;

        case 'ol':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ol') + '\n\n';
          }

          break;

        case 'ul':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ul') + '\n\n';
          }

          break;

        case 'precode':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.codeBlock')(node, globals) + '\n\n';
          }

          break;

        case 'pre':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.pre')(node, globals) + '\n\n';
          }

          break;

        case 'table':
          if (!spansOnly) {
            txt = showdown.subParser('makeMarkdown.table')(node, globals) + '\n\n';
          }

          break;
        //
        // SPANS
        //

        case 'code':
          txt = showdown.subParser('makeMarkdown.codeSpan')(node, globals);
          break;

        case 'em':
        case 'i':
          txt = showdown.subParser('makeMarkdown.emphasis')(node, globals);
          break;

        case 'strong':
        case 'b':
          txt = showdown.subParser('makeMarkdown.strong')(node, globals);
          break;

        case 'del':
          txt = showdown.subParser('makeMarkdown.strikethrough')(node, globals);
          break;

        case 'a':
          txt = showdown.subParser('makeMarkdown.links')(node, globals);
          break;

        case 'img':
          txt = showdown.subParser('makeMarkdown.image')(node, globals);
          break;

        default:
          txt = node.outerHTML + '\n\n';
      } // common normalization
      // TODO eventually


      return txt;
    });
    showdown.subParser('makeMarkdown.paragraph', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes()) {
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }
      } // some text normalization


      txt = txt.trim();
      return txt;
    });
    showdown.subParser('makeMarkdown.pre', function (node, globals) {

      var num = node.getAttribute('prenum');
      return '<pre>' + globals.preList[num] + '</pre>';
    });
    showdown.subParser('makeMarkdown.strikethrough', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes()) {
        txt += '~~';
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }

        txt += '~~';
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.strong', function (node, globals) {

      var txt = '';

      if (node.hasChildNodes()) {
        txt += '**';
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }

        txt += '**';
      }

      return txt;
    });
    showdown.subParser('makeMarkdown.table', function (node, globals) {

      var txt = '',
          tableArray = [[], []],
          headings = node.querySelectorAll('thead>tr>th'),
          rows = node.querySelectorAll('tbody>tr'),
          i,
          ii;

      for (i = 0; i < headings.length; ++i) {
        var headContent = showdown.subParser('makeMarkdown.tableCell')(headings[i], globals),
            allign = '---';

        if (headings[i].hasAttribute('style')) {
          var style = headings[i].getAttribute('style').toLowerCase().replace(/\s/g, '');

          switch (style) {
            case 'text-align:left;':
              allign = ':---';
              break;

            case 'text-align:right;':
              allign = '---:';
              break;

            case 'text-align:center;':
              allign = ':---:';
              break;
          }
        }

        tableArray[0][i] = headContent.trim();
        tableArray[1][i] = allign;
      }

      for (i = 0; i < rows.length; ++i) {
        var r = tableArray.push([]) - 1,
            cols = rows[i].getElementsByTagName('td');

        for (ii = 0; ii < headings.length; ++ii) {
          var cellContent = ' ';

          if (typeof cols[ii] !== 'undefined') {
            cellContent = showdown.subParser('makeMarkdown.tableCell')(cols[ii], globals);
          }

          tableArray[r].push(cellContent);
        }
      }

      var cellSpacesCount = 3;

      for (i = 0; i < tableArray.length; ++i) {
        for (ii = 0; ii < tableArray[i].length; ++ii) {
          var strLen = tableArray[i][ii].length;

          if (strLen > cellSpacesCount) {
            cellSpacesCount = strLen;
          }
        }
      }

      for (i = 0; i < tableArray.length; ++i) {
        for (ii = 0; ii < tableArray[i].length; ++ii) {
          if (i === 1) {
            if (tableArray[i][ii].slice(-1) === ':') {
              tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, '-') + ':';
            } else {
              tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, '-');
            }
          } else {
            tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
          }
        }

        txt += '| ' + tableArray[i].join(' | ') + ' |\n';
      }

      return txt.trim();
    });
    showdown.subParser('makeMarkdown.tableCell', function (node, globals) {

      var txt = '';

      if (!node.hasChildNodes()) {
        return '';
      }

      var children = node.childNodes,
          childrenLength = children.length;

      for (var i = 0; i < childrenLength; ++i) {
        txt += showdown.subParser('makeMarkdown.node')(children[i], globals, true);
      }

      return txt.trim();
    });
    showdown.subParser('makeMarkdown.txt', function (node) {

      var txt = node.nodeValue; // multiple spaces are collapsed

      txt = txt.replace(/ +/g, ' '); // replace the custom ¨NBSP; with a space

      txt = txt.replace(/¨NBSP;/g, ' '); // ", <, > and & should replace escaped html entities

      txt = showdown.helper.unescapeHTMLEntities(txt); // escape markdown magic characters
      // emphasis, strong and strikethrough - can appear everywhere
      // we also escape pipe (|) because of tables
      // and escape ` because of code blocks and spans

      txt = txt.replace(/([*_~|`])/g, '\\$1'); // escape > because of blockquotes

      txt = txt.replace(/^(\s*)>/g, '\\$1>'); // hash character, only troublesome at the beginning of a line because of headers

      txt = txt.replace(/^#/gm, '\\#'); // horizontal rules

      txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, '$1\\$2$3'); // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer

      txt = txt.replace(/^( {0,3}\d+)\./gm, '$1\\.'); // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)

      txt = txt.replace(/^( {0,3})([+-])/gm, '$1\\$2'); // images and links, ] followed by ( is problematic, so we escape it

      txt = txt.replace(/]([\s]*)\(/g, '\\]$1\\('); // reference URIs must also be escaped

      txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, '\\[$1]:');
      return txt;
    });
    var root = this; // AMD Loader

    if (module.exports) {
      module.exports = showdown; // Regular Browser loader
    } else {
      root.showdown = showdown;
    }
  }).call(commonjsGlobal);
})(showdown$1);

var showdown = showdown$1.exports;

var markdownConverter = null;
function markdownToHtml(markdown) {
  return _getMarkdownConverter().makeHtml(markdown || "").replace(/…/g, "...");
}

function _getMarkdownConverter() {
  if (!markdownConverter) {
    markdownConverter = new showdown.Converter();
    markdownConverter.setFlavor("github");
    markdownConverter.setOption("simplifiedAutoLink", false);
    markdownConverter.setOption("underline", true);
    markdownConverter.setOption("openLinksInNewWindow", true);
  }

  return markdownConverter;
}

function MarkdownContent(_ref) {
  var markdown = _ref.markdown,
      className = _ref.className;
  var root = useRef(null);
  useEffect(function () {
    if (window.Android && window.Android.openUrlInBrowser) {
      var _root$current;

      var links = ((_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.getElementsByTagName("a")) || [];

      for (var i = 0; i < links.length; i++) {
        links[i].addEventListener("click", _openUrlInBrowser);
      }

      return function () {
        for (var _i = 0; _i < links.length; _i++) {
          links[_i].removeEventListener("click", _openUrlInBrowser);
        }
      };
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: root,
    className: className,
    dangerouslySetInnerHTML: {
      __html: markdownToHtml(markdown)
    }
  });
}

function _openUrlInBrowser(evt) {
  evt.preventDefault();
  window.Android.openUrlInBrowser(evt.target.href);
}

var styles$c = {"spinner":"Image-module_spinner__1ATG-","spinner__inner":"Image-module_spinner__inner__3t66o","lds-ring":"Image-module_lds-ring__3OO2t"};

var _excluded$8 = ["src", "alt", "className", "showSpinner", "onLoad"];
function Img(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      className = _ref.className,
      showSpinner = _ref.showSpinner,
      onLoad = _ref.onLoad,
      props = _objectWithoutProperties$1(_ref, _excluded$8);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var isMounted = useRef(true);
  useEffect(function () {
    return function () {
      return isMounted.current = false;
    };
  }, []);
  useEffect(function () {
    var image = new Image();

    image.onload = function () {
      if (isMounted.current) {
        setLoaded(true);
      }
    };

    image.onerror = function () {
      setTimeout(function () {
        if (isMounted.current) {
          image.src = src;
        }
      }, 500);
    };

    image.src = src;
  }, [src]);

  if (loaded) {
    return /*#__PURE__*/React.createElement("img", _extends$2({
      className: classnames(styles$c.image, className),
      src: src,
      alt: alt,
      onLoad: onLoad
    }, props));
  }

  return showSpinner ? /*#__PURE__*/React.createElement(Spinner, null) : null;
}

function Spinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$c.spinner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$c.spinner__inner
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$c.spinner__inner
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$c.spinner__inner
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$c.spinner__inner
  }));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes$1;

var freeGlobal$1 = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$8 = freeGlobal || freeSelf || Function('return this')();
var _root = root$8;

var root$7 = _root;
/** Built-in value references. */

var _Symbol2 = root$7.Symbol;
var _Symbol$6 = _Symbol2;

var _Symbol$5 = _Symbol$6;
/** Used for built-in method references. */

var objectProto$f = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$d = objectProto$f.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$f.toString;
/** Built-in value references. */

var symToStringTag$1 = _Symbol$5 ? _Symbol$5.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$e.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var _Symbol$4 = _Symbol$6,
    getRawTag = _getRawTag,
    objectToString = _objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = _Symbol$4 ? _Symbol$4.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag$7(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

var _baseGetTag = baseGetTag$7;

function isObjectLike$a(value) {
  return value != null && _typeof(value) == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$9 = isObjectLike_1;
/** `Object#toString` result references. */

var argsTag$3 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$6(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$8 = isObjectLike_1;
/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$c = objectProto$d.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments$4 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$8(value) && hasOwnProperty$c.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$4;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$g = Array.isArray;
var isArray_1 = isArray$g;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
  var root = _root,
      stubFalse = stubFalse_1;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse;
  module.exports = isBuffer;
})(isBuffer$4, isBuffer$4.exports);

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex$4(value, length) {
  var type = _typeof(value);

  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex$4;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$5 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$7 = isObjectLike_1;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$4] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$6(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$6;

var _nodeUtil = {exports: {}};

(function (module, exports) {
  var freeGlobal = _freeGlobal;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$5 = _baseUnary,
    nodeUtil$3 = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$3 && nodeUtil$3.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray$3 = nodeIsTypedArray ? baseUnary$5(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;

var baseTimes = _baseTimes,
    isArguments$3 = isArguments_1,
    isArray$f = isArray_1,
    isBuffer$3 = isBuffer$4.exports,
    isIndex$3 = _isIndex,
    isTypedArray$2 = isTypedArray_1;
/** Used for built-in method references. */

var objectProto$c = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$b = objectProto$c.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$f(value),
      isArg = !isArr && isArguments$3(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$b.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$3(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$b;
  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;

var isPrototype$3 = _isPrototype,
    nativeKeys = _nativeKeys;
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$a.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$a.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys$2;

function isObject$9(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$9;

var baseGetTag$4 = _baseGetTag,
    isObject$8 = isObject_1;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$2(value) {
  if (!isObject$8(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var isFunction$1 = isFunction_1,
    isLength$1 = isLength_1;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike$8(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$8;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$7 = isArrayLike_1;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys$7(object) {
  return isArrayLike$7(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$7;

var baseFor = _baseFor,
    keys$6 = keys_1;
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */

function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$6);
}

var _baseForOwn = baseForOwn$2;

var isArrayLike$6 = isArrayLike_1;
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseEach$1(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike$6(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn$1 = _baseForOwn,
    createBaseEach = _createBaseEach;
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */

var baseEach$3 = createBaseEach(baseForOwn$1);
var _baseEach = baseEach$3;

var baseEach$2 = _baseEach;
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function baseFilter$1(collection, predicate) {
  var result = [];
  baseEach$2(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

var _baseFilter = baseFilter$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$4(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq$4;

var eq$3 = eq_1;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf$4(array, key) {
  var length = array.length;

  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var root$6 = _root;
/** Used to detect overreaching core-js shims. */

var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource$2;

var isFunction = isFunction_1,
    isMasked = _isMasked,
    isObject$7 = isObject_1,
    toSource$1 = _toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$9 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$9.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative$1(value) {
  if (!isObject$7(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$5 = _root;
/* Built-in method references that are verified to be native. */

var Map$3 = getNative$6(root$5, 'Map');
var _Map = Map$3;

var getNative$5 = _getNative;
/* Built-in method references that are verified to be native. */

var nativeCreate$4 = getNative$5(Object, 'create');
var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet$1(key) {
  var data = this.__data__;

  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }

  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;
/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache$2)(),
    'string': new Hash()
  };
}

var _mapCacheClear = mapCacheClear$1;

function isKeyable$1(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$2 = _MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE$1 = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet$1(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache$1) {
    var pairs = data.__data__;

    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache$2(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;
var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$1();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome = _arraySome,
    cacheHas$1 = _cacheHas;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$4 = _root;
/** Built-in value references. */

var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var _Symbol$3 = _Symbol$6,
    Uint8Array$1 = _Uint8Array,
    eq$2 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;
/** `Object#toString` result references. */

var boolTag$2 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$5 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto$2 = _Symbol$3 ? _Symbol$3.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$2:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }

      return true;

    case boolTag$2:
    case dateTag$3:
    case numberTag$2:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$2(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$2:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$5:
      var convert = mapToArray;

    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$2; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush$3;

var arrayPush$2 = _arrayPush,
    isArray$e = isArray_1;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$e(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter$1 = _arrayFilter,
    stubArray$1 = stubArray_1;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$3;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$5 = keys_1;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$5, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$3 = 1;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$5.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$3 = _root;
/* Built-in method references that are verified to be native. */

var DataView$1 = getNative$4(root$3, 'DataView');
var _DataView = DataView$1;

var getNative$3 = _getNative,
    root$2 = _root;
/* Built-in method references that are verified to be native. */

var Promise$2 = getNative$3(root$2, 'Promise');
var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$1 = _root;
/* Built-in method references that are verified to be native. */

var Set$1 = getNative$2(root$1, 'Set');
var _Set = Set$1;

var getNative$1 = _getNative,
    root = _root;
/* Built-in method references that are verified to be native. */

var WeakMap$1 = getNative$1(root, 'WeakMap');
var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map = _Map,
    Promise$1 = _Promise,
    Set = _Set,
    WeakMap = _WeakMap,
    baseGetTag$3 = _baseGetTag,
    toSource = _toSource;
/** `Object#toString` result references. */

var mapTag$4 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$4 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag$5 = baseGetTag$3; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView && getTag$5(new DataView(new ArrayBuffer(1))) != dataViewTag$2 || Map && getTag$5(new Map()) != mapTag$4 || Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag || Set && getTag$5(new Set()) != setTag$4 || WeakMap && getTag$5(new WeakMap()) != weakMapTag$1) {
  getTag$5 = function getTag(value) {
    var result = baseGetTag$3(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$4;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$4;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var _getTag = getTag$5;

var Stack$2 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$4 = _getTag,
    isArray$d = isArray_1,
    isBuffer$2 = isBuffer$4.exports,
    isTypedArray$1 = isTypedArray_1;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$2 = 1;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$1 = '[object Object]';
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$4.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$d(object),
      othIsArr = isArray$d(other),
      objTag = objIsArr ? arrayTag$1 : getTag$4(object),
      othTag = othIsArr ? arrayTag$1 : getTag$4(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1,
      othIsObj = othTag == objectTag$1,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$2());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack$2());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$6 = isObjectLike_1;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */

function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike$6(value) && !isObjectLike$6(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack$1 = _Stack,
    baseIsEqual$2 = _baseIsEqual;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$6 = isObject_1;
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */

function isStrictComparable$2(value) {
  return value === value && !isObject$6(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$4 = keys_1;
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */

function getMatchData$1(object) {
  var result = keys$4(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }

  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatches$1(source) {
  var matchData = getMatchData(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;
/** `Object#toString` result references. */

var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$5(value) {
  return _typeof(value) == 'symbol' || isObjectLike$5(value) && baseGetTag$2(value) == symbolTag$2;
}

var isSymbol_1 = isSymbol$5;

var isArray$c = isArray_1,
    isSymbol$4 = isSymbol_1;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey$3(value, object) {
  if (isArray$c(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$4(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey$3;

var MapCache = _MapCache;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;

var memoize = memoize_1;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$4(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap$4;

var _Symbol$2 = _Symbol$6,
    arrayMap$3 = _arrayMap,
    isArray$b = isArray_1,
    isSymbol$3 = isSymbol_1;
/** Used as references for various `Number` constants. */

var INFINITY$2 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol$2 ? _Symbol$2.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$b(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$1) + '';
  }

  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray$a = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath$4(value, object) {
  if (isArray$a(value)) {
    return value;
  }

  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$4;

var isSymbol$2 = isSymbol_1;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$3 = _castPath,
    toKey$4 = _toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet$4(object, path) {
  path = castPath$3(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet$4;

var baseGet$3 = _baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isIndex$2 = _isIndex,
    isLength = isLength_1,
    toKey$3 = _toKey;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */

function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$2(key, length) && (isArray$9(object) || isArguments$2(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */

function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$2;

var baseIsEqual$1 = _baseIsEqual,
    get = get_1,
    hasIn$1 = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }

  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn$1(object, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$5(value) {
  return value;
}

var identity_1 = identity$5;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$2 = _baseGet;
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyDeep$1(path) {
  return function (object) {
    return baseGet$2(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */

function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$4 = identity_1,
    isArray$8 = isArray_1,
    property = property_1;
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */

function baseIteratee$5(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity$4;
  }

  if (_typeof(value) == 'object') {
    return isArray$8(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }

  return property(value);
}

var _baseIteratee = baseIteratee$5;

var arrayFilter = _arrayFilter,
    baseFilter = _baseFilter,
    baseIteratee$4 = _baseIteratee,
    isArray$7 = isArray_1;
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */

function filter(collection, predicate) {
  var func = isArray$7(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee$4(predicate));
}

var filter_1 = filter;

var baseIteratee$3 = _baseIteratee,
    isArrayLike$5 = isArrayLike_1,
    keys$3 = keys_1;
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */

function createFind$1(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);

    if (!isArrayLike$5(collection)) {
      var iteratee = baseIteratee$3(predicate);
      collection = keys$3(collection);

      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }

    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }

  return -1;
}

var _baseFindIndex = baseFindIndex$2;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;
/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$5 = isObject_1,
    isSymbol$1 = isSymbol_1;
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$1(value)) {
    return NAN;
  }

  if (isObject$5(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$5(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber$1;

var toNumber = toNumber_1;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */

function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

var toFinite_1 = toFinite$2;

var toFinite$1 = toFinite_1;
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */

function toInteger$1(value) {
  var result = toFinite$1(value),
      remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

var toInteger_1 = toInteger$1;

var baseFindIndex$1 = _baseFindIndex,
    baseIteratee$2 = _baseIteratee,
    toInteger = toInteger_1;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$2 = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */

function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;

  if (!length) {
    return -1;
  }

  var index = fromIndex == null ? 0 : toInteger(fromIndex);

  if (index < 0) {
    index = nativeMax$2(length + index, 0);
  }

  return baseFindIndex$1(array, baseIteratee$2(predicate), index);
}

var findIndex_1 = findIndex$1;

var createFind = _createFind,
    findIndex = findIndex_1;
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */

var find = createFind(findIndex);
var find_1 = find;

var MAX_HISTORY = 5;
function AppBrowser(_ref) {
  var searchHistory = _ref.searchHistory,
      cachedPages = _ref.cachedPages;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      typing = _useState2[0],
      setTyping = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      searchQuery = _useState4[0],
      setSearchQuery = _useState4[1];

  var cachedPage = find_1(cachedPages || [], function (x) {
    return x.query === searchQuery;
  });

  function handleSearchHistoryItemClick(query) {
    setTyping(false);
    setSearchQuery(query);
  }

  function handleSearchBarFocus() {
    if (!typing) {
      setTyping(true);
      setSearchQuery("");
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.browser
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchQuery: searchQuery,
    onFocus: handleSearchBarFocus,
    onChange: setSearchQuery
  }), typing ? /*#__PURE__*/React.createElement(HistoryBar, {
    searchHistory: searchHistory,
    searchQuery: searchQuery,
    cachedPages: cachedPages,
    onQueryChange: handleSearchHistoryItemClick
  }) : cachedPage ? /*#__PURE__*/React.createElement(CachedPage, {
    src: cachedPage.src
  }) : /*#__PURE__*/React.createElement(OfflinePage, null));
}

function SearchBar(_ref2) {
  var searchQuery = _ref2.searchQuery,
      onFocus = _ref2.onFocus,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.search
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: classnames(styles$d.search__input, "data-hj-allow"),
    placeholder: "Search or type a URL",
    value: searchQuery,
    onFocus: onFocus,
    onChange: function onChange(evt) {
      return _onChange(evt.target.value);
    }
  }));
}

function HistoryBar(_ref3) {
  var searchHistory = _ref3.searchHistory,
      searchQuery = _ref3.searchQuery,
      cachedPages = _ref3.cachedPages,
      onQueryChange = _ref3.onQueryChange;

  var _filterHistory = filterHistory(searchHistory, searchQuery),
      _filterHistory2 = _slicedToArray(_filterHistory, 2),
      filteredHistory = _filterHistory2[0],
      moreHistoryResults = _filterHistory2[1];

  var searchQueryTrimmed = searchQuery.trim();
  var queriesWithCachedPages = (cachedPages || []).map(function (x) {
    return x.query;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.history
  }, filteredHistory.map(function (query, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles$d.history__item,
      onClick: function onClick() {
        return onQueryChange(query);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: classnames(styles$d.history__item__icon, "icon-clock")
    }), searchQueryTrimmed === "" ? query : /*#__PURE__*/React.createElement(MarkdownContent, {
      className: styles$d.history__item__text,
      markdown: replaceCaseInsensitive(query, searchQueryTrimmed, "**$&**")
    }), queriesWithCachedPages.includes(query) ? /*#__PURE__*/React.createElement("span", {
      className: styles$d.history__item__cached
    }, "cached") : null);
  }), moreHistoryResults ? /*#__PURE__*/React.createElement("div", {
    className: styles$d.history__more
  }, "More search history available, type to filter") : null, searchQueryTrimmed !== "" && filteredHistory.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: styles$d.history__more
  }, "No search history for ", /*#__PURE__*/React.createElement("b", null, searchQueryTrimmed)) : null);
}

function OfflinePage() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.offline
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles$d.offline__title
  }, "You are offline."), /*#__PURE__*/React.createElement("div", {
    className: styles$d.offline__text
  }, "Your recent searches are still available.", /*#__PURE__*/React.createElement("br", null), "Click on the search bar to view them."));
}

function CachedPage(_ref4) {
  var src = _ref4.src;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.cached
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$d.cached__note
  }, "Cached version"), /*#__PURE__*/React.createElement(Img, {
    src: src,
    className: styles$d.cached__image
  }));
}

function filterHistory(searchHistory, searchQuery) {
  if (searchQuery) {
    searchQuery = searchQuery.toLowerCase();
    searchHistory = filter_1(searchHistory, function (x) {
      return x.toLowerCase().includes(searchQuery);
    });
  }

  return [searchHistory.slice(0, MAX_HISTORY), searchHistory.length > MAX_HISTORY];
}

var hammer = {exports: {}};

(function (module) {
  (function (window, document, exportName, undefined$1) {

    var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
    var TEST_ELEMENT = document.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
     * set a timeout with a given scope
     * @param {Function} fn
     * @param {Number} timeout
     * @param {Object} context
     * @returns {number}
     */

    function setTimeoutContext(fn, timeout, context) {
      return setTimeout(bindFn(fn, context), timeout);
    }
    /**
     * if the argument is an array, we want to execute the fn on each entry
     * if it aint an array we don't want to do a thing.
     * this is used by all the methods that accept a single and array argument.
     * @param {*|Array} arg
     * @param {String} fn
     * @param {Object} [context]
     * @returns {Boolean}
     */


    function invokeArrayArg(arg, fn, context) {
      if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
      }

      return false;
    }
    /**
     * walk objects and arrays
     * @param {Object} obj
     * @param {Function} iterator
     * @param {Object} context
     */


    function each(obj, iterator, context) {
      var i;

      if (!obj) {
        return;
      }

      if (obj.forEach) {
        obj.forEach(iterator, context);
      } else if (obj.length !== undefined$1) {
        i = 0;

        while (i < obj.length) {
          iterator.call(context, obj[i], i, obj);
          i++;
        }
      } else {
        for (i in obj) {
          obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
      }
    }
    /**
     * wrap a method with a deprecation warning and stack trace
     * @param {Function} method
     * @param {String} name
     * @param {String} message
     * @returns {Function} A new function wrapping the supplied method.
     */


    function deprecate(method, name, message) {
      var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
      return function () {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
        var log = window.console && (window.console.warn || window.console.log);

        if (log) {
          log.call(window.console, deprecationMessage, stack);
        }

        return method.apply(this, arguments);
      };
    }
    /**
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} target
     * @param {...Object} objects_to_assign
     * @returns {Object} target
     */


    var assign;

    if (typeof Object.assign !== 'function') {
      assign = function assign(target) {
        if (target === undefined$1 || target === null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];

          if (source !== undefined$1 && source !== null) {
            for (var nextKey in source) {
              if (source.hasOwnProperty(nextKey)) {
                output[nextKey] = source[nextKey];
              }
            }
          }
        }

        return output;
      };
    } else {
      assign = Object.assign;
    }
    /**
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} dest
     * @param {Object} src
     * @param {Boolean} [merge=false]
     * @returns {Object} dest
     */


    var extend = deprecate(function extend(dest, src, merge) {
      var keys = Object.keys(src);
      var i = 0;

      while (i < keys.length) {
        if (!merge || merge && dest[keys[i]] === undefined$1) {
          dest[keys[i]] = src[keys[i]];
        }

        i++;
      }

      return dest;
    }, 'extend', 'Use `assign`.');
    /**
     * merge the values from src in the dest.
     * means that properties that exist in dest will not be overwritten by src
     * @param {Object} dest
     * @param {Object} src
     * @returns {Object} dest
     */

    var merge = deprecate(function merge(dest, src) {
      return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
     * simple class inheritance
     * @param {Function} child
     * @param {Function} base
     * @param {Object} [properties]
     */

    function inherit(child, base, properties) {
      var baseP = base.prototype,
          childP;
      childP = child.prototype = Object.create(baseP);
      childP.constructor = child;
      childP._super = baseP;

      if (properties) {
        assign(childP, properties);
      }
    }
    /**
     * simple function bind
     * @param {Function} fn
     * @param {Object} context
     * @returns {Function}
     */


    function bindFn(fn, context) {
      return function boundFn() {
        return fn.apply(context, arguments);
      };
    }
    /**
     * let a boolean value also be a function that must return a boolean
     * this first item in args will be used as the context
     * @param {Boolean|Function} val
     * @param {Array} [args]
     * @returns {Boolean}
     */


    function boolOrFn(val, args) {
      if (_typeof(val) == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined$1 : undefined$1, args);
      }

      return val;
    }
    /**
     * use the val2 when val1 is undefined
     * @param {*} val1
     * @param {*} val2
     * @returns {*}
     */


    function ifUndefined(val1, val2) {
      return val1 === undefined$1 ? val2 : val1;
    }
    /**
     * addEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function addEventListeners(target, types, handler) {
      each(splitStr(types), function (type) {
        target.addEventListener(type, handler, false);
      });
    }
    /**
     * removeEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function removeEventListeners(target, types, handler) {
      each(splitStr(types), function (type) {
        target.removeEventListener(type, handler, false);
      });
    }
    /**
     * find if a node is in the given parent
     * @method hasParent
     * @param {HTMLElement} node
     * @param {HTMLElement} parent
     * @return {Boolean} found
     */


    function hasParent(node, parent) {
      while (node) {
        if (node == parent) {
          return true;
        }

        node = node.parentNode;
      }

      return false;
    }
    /**
     * small indexOf wrapper
     * @param {String} str
     * @param {String} find
     * @returns {Boolean} found
     */


    function inStr(str, find) {
      return str.indexOf(find) > -1;
    }
    /**
     * split string on whitespace
     * @param {String} str
     * @returns {Array} words
     */


    function splitStr(str) {
      return str.trim().split(/\s+/g);
    }
    /**
     * find if a array contains the object using indexOf or a simple polyFill
     * @param {Array} src
     * @param {String} find
     * @param {String} [findByKey]
     * @return {Boolean|Number} false when not found, or the index
     */


    function inArray(src, find, findByKey) {
      if (src.indexOf && !findByKey) {
        return src.indexOf(find);
      } else {
        var i = 0;

        while (i < src.length) {
          if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) {
            return i;
          }

          i++;
        }

        return -1;
      }
    }
    /**
     * convert array-like objects to real arrays
     * @param {Object} obj
     * @returns {Array}
     */


    function toArray(obj) {
      return Array.prototype.slice.call(obj, 0);
    }
    /**
     * unique array with objects based on a key (like 'id') or just by the array's value
     * @param {Array} src [{id:1},{id:2},{id:1}]
     * @param {String} [key]
     * @param {Boolean} [sort=False]
     * @returns {Array} [{id:1},{id:2}]
     */


    function uniqueArray(src, key, sort) {
      var results = [];
      var values = [];
      var i = 0;

      while (i < src.length) {
        var val = key ? src[i][key] : src[i];

        if (inArray(values, val) < 0) {
          results.push(src[i]);
        }

        values[i] = val;
        i++;
      }

      if (sort) {
        if (!key) {
          results = results.sort();
        } else {
          results = results.sort(function sortUniqueArray(a, b) {
            return a[key] > b[key];
          });
        }
      }

      return results;
    }
    /**
     * get the prefixed property
     * @param {Object} obj
     * @param {String} property
     * @returns {String|Undefined} prefixed
     */


    function prefixed(obj, property) {
      var prefix, prop;
      var camelProp = property[0].toUpperCase() + property.slice(1);
      var i = 0;

      while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = prefix ? prefix + camelProp : property;

        if (prop in obj) {
          return prop;
        }

        i++;
      }

      return undefined$1;
    }
    /**
     * get a unique id
     * @returns {number} uniqueId
     */


    var _uniqueId = 1;

    function uniqueId() {
      return _uniqueId++;
    }
    /**
     * get the window object of an element
     * @param {HTMLElement} element
     * @returns {DocumentView|Window}
     */


    function getWindowForElement(element) {
      var doc = element.ownerDocument || element;
      return doc.defaultView || doc.parentWindow || window;
    }

    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = ('ontouchstart' in window);
    var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined$1;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ['x', 'y'];
    var PROPS_CLIENT_XY = ['clientX', 'clientY'];
    /**
     * create new input type manager
     * @param {Manager} manager
     * @param {Function} callback
     * @returns {Input}
     * @constructor
     */

    function Input(manager, callback) {
      var self = this;
      this.manager = manager;
      this.callback = callback;
      this.element = manager.element;
      this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
      // so when disabled the input events are completely bypassed.

      this.domHandler = function (ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
          self.handler(ev);
        }
      };

      this.init();
    }

    Input.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function handler() {},

      /**
       * bind the events
       */
      init: function init() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      },

      /**
       * unbind the events
       */
      destroy: function destroy() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      }
    };
    /**
     * create new input type manager
     * called by the Manager constructor
     * @param {Hammer} manager
     * @returns {Input}
     */

    function createInputInstance(manager) {
      var Type;
      var inputClass = manager.options.inputClass;

      if (inputClass) {
        Type = inputClass;
      } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
      } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
      } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
      } else {
        Type = TouchMouseInput;
      }

      return new Type(manager, inputHandler);
    }
    /**
     * handle input events
     * @param {Manager} manager
     * @param {String} eventType
     * @param {Object} input
     */


    function inputHandler(manager, eventType, input) {
      var pointersLen = input.pointers.length;
      var changedPointersLen = input.changedPointers.length;
      var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
      var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
      input.isFirst = !!isFirst;
      input.isFinal = !!isFinal;

      if (isFirst) {
        manager.session = {};
      } // source event is the normalized value of the domEvents
      // like 'touchstart, mouseup, pointerdown'


      input.eventType = eventType; // compute scale, rotation etc

      computeInputData(manager, input); // emit secret event

      manager.emit('hammer.input', input);
      manager.recognize(input);
      manager.session.prevInput = input;
    }
    /**
     * extend the data with some usable properties like scale, rotate, velocity etc
     * @param {Object} manager
     * @param {Object} input
     */


    function computeInputData(manager, input) {
      var session = manager.session;
      var pointers = input.pointers;
      var pointersLength = pointers.length; // store the first input to calculate the distance and direction

      if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
      } // to compute scale and rotation we need to store the multiple touches


      if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
      } else if (pointersLength === 1) {
        session.firstMultiple = false;
      }

      var firstInput = session.firstInput;
      var firstMultiple = session.firstMultiple;
      var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
      var center = input.center = getCenter(pointers);
      input.timeStamp = now();
      input.deltaTime = input.timeStamp - firstInput.timeStamp;
      input.angle = getAngle(offsetCenter, center);
      input.distance = getDistance(offsetCenter, center);
      computeDeltaXY(session, input);
      input.offsetDirection = getDirection(input.deltaX, input.deltaY);
      var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
      input.overallVelocityX = overallVelocity.x;
      input.overallVelocityY = overallVelocity.y;
      input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
      input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
      input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
      input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
      computeIntervalInputData(session, input); // find the correct target

      var target = manager.element;

      if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
      }

      input.target = target;
    }

    function computeDeltaXY(session, input) {
      var center = input.center;
      var offset = session.offsetDelta || {};
      var prevDelta = session.prevDelta || {};
      var prevInput = session.prevInput || {};

      if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
          x: prevInput.deltaX || 0,
          y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
          x: center.x,
          y: center.y
        };
      }

      input.deltaX = prevDelta.x + (center.x - offset.x);
      input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
     * velocity is calculated every x ms
     * @param {Object} session
     * @param {Object} input
     */


    function computeIntervalInputData(session, input) {
      var last = session.lastInterval || input,
          deltaTime = input.timeStamp - last.timeStamp,
          velocity,
          velocityX,
          velocityY,
          direction;

      if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined$1)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);
        session.lastInterval = input;
      } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
      }

      input.velocity = velocity;
      input.velocityX = velocityX;
      input.velocityY = velocityY;
      input.direction = direction;
    }
    /**
     * create a simple clone from the input used for storage of firstInput and firstMultiple
     * @param {Object} input
     * @returns {Object} clonedInputData
     */


    function simpleCloneInputData(input) {
      // make a simple copy of the pointers because we will get a reference if we don't
      // we only need clientXY for the calculations
      var pointers = [];
      var i = 0;

      while (i < input.pointers.length) {
        pointers[i] = {
          clientX: round(input.pointers[i].clientX),
          clientY: round(input.pointers[i].clientY)
        };
        i++;
      }

      return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
      };
    }
    /**
     * get the center of all the pointers
     * @param {Array} pointers
     * @return {Object} center contains `x` and `y` properties
     */


    function getCenter(pointers) {
      var pointersLength = pointers.length; // no need to loop when only one touch

      if (pointersLength === 1) {
        return {
          x: round(pointers[0].clientX),
          y: round(pointers[0].clientY)
        };
      }

      var x = 0,
          y = 0,
          i = 0;

      while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
      }

      return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
      };
    }
    /**
     * calculate the velocity between two points. unit is in px per ms.
     * @param {Number} deltaTime
     * @param {Number} x
     * @param {Number} y
     * @return {Object} velocity `x` and `y`
     */


    function getVelocity(deltaTime, x, y) {
      return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
      };
    }
    /**
     * get the direction between two points
     * @param {Number} x
     * @param {Number} y
     * @return {Number} direction
     */


    function getDirection(x, y) {
      if (x === y) {
        return DIRECTION_NONE;
      }

      if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
      }

      return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
     * calculate the absolute distance between two points
     * @param {Object} p1 {x, y}
     * @param {Object} p2 {x, y}
     * @param {Array} [props] containing x and y keys
     * @return {Number} distance
     */


    function getDistance(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }

      var x = p2[props[0]] - p1[props[0]],
          y = p2[props[1]] - p1[props[1]];
      return Math.sqrt(x * x + y * y);
    }
    /**
     * calculate the angle between two coordinates
     * @param {Object} p1
     * @param {Object} p2
     * @param {Array} [props] containing x and y keys
     * @return {Number} angle
     */


    function getAngle(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }

      var x = p2[props[0]] - p1[props[0]],
          y = p2[props[1]] - p1[props[1]];
      return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
     * calculate the rotation degrees between two pointersets
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} rotation
     */


    function getRotation(start, end) {
      return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
     * calculate the scale factor between two pointersets
     * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} scale
     */


    function getScale(start, end) {
      return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }

    var MOUSE_INPUT_MAP = {
      mousedown: INPUT_START,
      mousemove: INPUT_MOVE,
      mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
     * Mouse events input
     * @constructor
     * @extends Input
     */

    function MouseInput() {
      this.evEl = MOUSE_ELEMENT_EVENTS;
      this.evWin = MOUSE_WINDOW_EVENTS;
      this.pressed = false; // mousedown state

      Input.apply(this, arguments);
    }

    inherit(MouseInput, Input, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down

        if (eventType & INPUT_START && ev.button === 0) {
          this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
          eventType = INPUT_END;
        } // mouse must be down


        if (!this.pressed) {
          return;
        }

        if (eventType & INPUT_END) {
          this.pressed = false;
        }

        this.callback(this.manager, eventType, {
          pointers: [ev],
          changedPointers: [ev],
          pointerType: INPUT_TYPE_MOUSE,
          srcEvent: ev
        });
      }
    });
    var POINTER_INPUT_MAP = {
      pointerdown: INPUT_START,
      pointermove: INPUT_MOVE,
      pointerup: INPUT_END,
      pointercancel: INPUT_CANCEL,
      pointerout: INPUT_CANCEL
    }; // in IE10 the pointer types is defined as an enum

    var IE10_POINTER_TYPE_ENUM = {
      2: INPUT_TYPE_TOUCH,
      3: INPUT_TYPE_PEN,
      4: INPUT_TYPE_MOUSE,
      5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816

    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive

    if (window.MSPointerEvent && !window.PointerEvent) {
      POINTER_ELEMENT_EVENTS = 'MSPointerDown';
      POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
     * Pointer events input
     * @constructor
     * @extends Input
     */


    function PointerEventInput() {
      this.evEl = POINTER_ELEMENT_EVENTS;
      this.evWin = POINTER_WINDOW_EVENTS;
      Input.apply(this, arguments);
      this.store = this.manager.session.pointerEvents = [];
    }

    inherit(PointerEventInput, Input, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType == INPUT_TYPE_TOUCH; // get index of the event in the store

        var storeIndex = inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down

        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
          if (storeIndex < 0) {
            store.push(ev);
            storeIndex = store.length - 1;
          }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
          removePointer = true;
        } // it not found, so the pointer hasn't been down (so it's probably a hover)


        if (storeIndex < 0) {
          return;
        } // update the event in the store


        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
          pointers: store,
          changedPointers: [ev],
          pointerType: pointerType,
          srcEvent: ev
        });

        if (removePointer) {
          // remove from the store
          store.splice(storeIndex, 1);
        }
      }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
      touchstart: INPUT_START,
      touchmove: INPUT_MOVE,
      touchend: INPUT_END,
      touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * Touch events input
     * @constructor
     * @extends Input
     */

    function SingleTouchInput() {
      this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
      this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
      this.started = false;
      Input.apply(this, arguments);
    }

    inherit(SingleTouchInput, Input, {
      handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?

        if (type === INPUT_START) {
          this.started = true;
        }

        if (!this.started) {
          return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type); // when done, reset the started state

        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
          this.started = false;
        }

        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    /**
     * @this {TouchInput}
     * @param {Object} ev
     * @param {Number} type flag
     * @returns {undefined|Array} [all, changed]
     */

    function normalizeSingleTouches(ev, type) {
      var all = toArray(ev.touches);
      var changed = toArray(ev.changedTouches);

      if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
      }

      return [all, changed];
    }

    var TOUCH_INPUT_MAP = {
      touchstart: INPUT_START,
      touchmove: INPUT_MOVE,
      touchend: INPUT_END,
      touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * Multi-user touch events input
     * @constructor
     * @extends Input
     */

    function TouchInput() {
      this.evTarget = TOUCH_TARGET_EVENTS;
      this.targetIds = {};
      Input.apply(this, arguments);
    }

    inherit(TouchInput, Input, {
      handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);

        if (!touches) {
          return;
        }

        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    /**
     * @this {TouchInput}
     * @param {Object} ev
     * @param {Number} type flag
     * @returns {undefined|Array} [all, changed]
     */

    function getTouches(ev, type) {
      var allTouches = toArray(ev.touches);
      var targetIds = this.targetIds; // when there is only one touch, the process can be simplified

      if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
      }

      var i,
          targetTouches,
          changedTouches = toArray(ev.changedTouches),
          changedTargetTouches = [],
          target = this.target; // get target touches from touches

      targetTouches = allTouches.filter(function (touch) {
        return hasParent(touch.target, target);
      }); // collect touches

      if (type === INPUT_START) {
        i = 0;

        while (i < targetTouches.length) {
          targetIds[targetTouches[i].identifier] = true;
          i++;
        }
      } // filter changed touches to only contain touches that exist in the collected target ids


      i = 0;

      while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
          changedTargetTouches.push(changedTouches[i]);
        } // cleanup removed touches


        if (type & (INPUT_END | INPUT_CANCEL)) {
          delete targetIds[changedTouches[i].identifier];
        }

        i++;
      }

      if (!changedTargetTouches.length) {
        return;
      }

      return [// merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
      uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true), changedTargetTouches];
    }
    /**
     * Combined touch and mouse input
     *
     * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
     * This because touch devices also emit mouse events while doing a touch.
     *
     * @constructor
     * @extends Input
     */


    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;

    function TouchMouseInput() {
      Input.apply(this, arguments);
      var handler = bindFn(this.handler, this);
      this.touch = new TouchInput(this.manager, handler);
      this.mouse = new MouseInput(this.manager, handler);
      this.primaryTouch = null;
      this.lastTouches = [];
    }

    inherit(TouchMouseInput, Input, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH,
            isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
          return;
        } // when we're in a touch event, record touches to  de-dupe synthetic mouse event


        if (isTouch) {
          recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
          return;
        }

        this.callback(manager, inputEvent, inputData);
      },

      /**
       * remove the event listeners
       */
      destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
      }
    });

    function recordTouches(eventType, eventData) {
      if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
      } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
      }
    }

    function setLastTouch(eventData) {
      var touch = eventData.changedPointers[0];

      if (touch.identifier === this.primaryTouch) {
        var lastTouch = {
          x: touch.clientX,
          y: touch.clientY
        };
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;

        var removeLastTouch = function removeLastTouch() {
          var i = lts.indexOf(lastTouch);

          if (i > -1) {
            lts.splice(i, 1);
          }
        };

        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
      }
    }

    function isSyntheticEvent(eventData) {
      var x = eventData.srcEvent.clientX,
          y = eventData.srcEvent.clientY;

      for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x),
            dy = Math.abs(y - t.y);

        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
          return true;
        }
      }

      return false;
    }

    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined$1; // magical touchAction value

    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented

    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
     * Touch Action
     * sets the touchAction property or uses the js alternative
     * @param {Manager} manager
     * @param {String} value
     * @constructor
     */

    function TouchAction(manager, value) {
      this.manager = manager;
      this.set(value);
    }

    TouchAction.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function set(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
          value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
          this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }

        this.actions = value.toLowerCase().trim();
      },

      /**
       * just re-set the touchAction value
       */
      update: function update() {
        this.set(this.manager.options.touchAction);
      },

      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function compute() {
        var actions = [];
        each(this.manager.recognizers, function (recognizer) {
          if (boolOrFn(recognizer.options.enable, [recognizer])) {
            actions = actions.concat(recognizer.getTouchAction());
          }
        });
        return cleanTouchActions(actions.join(' '));
      },

      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function preventDefaults(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection; // if the touch action did prevented once this session

        if (this.manager.session.prevented) {
          srcEvent.preventDefault();
          return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
          //do not prevent defaults if this is a tap gesture
          var isTapPointer = input.pointers.length === 1;
          var isTapMovement = input.distance < 2;
          var isTapTouchTime = input.deltaTime < 250;

          if (isTapPointer && isTapMovement && isTapTouchTime) {
            return;
          }
        }

        if (hasPanX && hasPanY) {
          // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
          return;
        }

        if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
          return this.preventSrc(srcEvent);
        }
      },

      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function preventSrc(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
      }
    };
    /**
     * when the touchActions are collected they are not a valid value, so we need to clean things up. *
     * @param {String} actions
     * @returns {*}
     */

    function cleanTouchActions(actions) {
      // none
      if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
      }

      var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
      var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
      // for different directions, e.g. horizontal pan but vertical swipe?)
      // we need none (as otherwise with pan-x pan-y combined none of these
      // recognizers will work, since the browser would handle all panning

      if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
      } // pan-x OR pan-y


      if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
      } // manipulation


      if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
      }

      return TOUCH_ACTION_AUTO;
    }

    function getTouchActionProps() {
      if (!NATIVE_TOUCH_ACTION) {
        return false;
      }

      var touchMap = {};
      var cssSupports = window.CSS && window.CSS.supports;
      ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
      });
      return touchMap;
    }
    /**
     * Recognizer flow explained; *
     * All recognizers have the initial state of POSSIBLE when a input session starts.
     * The definition of a input session is from the first input until the last input, with all it's movement in it. *
     * Example session for mouse-input: mousedown -> mousemove -> mouseup
     *
     * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
     * which determines with state it should be.
     *
     * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
     * POSSIBLE to give it another change on the next cycle.
     *
     *               Possible
     *                  |
     *            +-----+---------------+
     *            |                     |
     *      +-----+-----+               |
     *      |           |               |
     *   Failed      Cancelled          |
     *                          +-------+------+
     *                          |              |
     *                      Recognized       Began
     *                                         |
     *                                      Changed
     *                                         |
     *                                  Ended/Recognized
     */


    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
     * Recognizer
     * Every recognizer needs to extend from this class.
     * @constructor
     * @param {Object} options
     */

    function Recognizer(options) {
      this.options = assign({}, this.defaults, options || {});
      this.id = uniqueId();
      this.manager = null; // default is enable true

      this.options.enable = ifUndefined(this.options.enable, true);
      this.state = STATE_POSSIBLE;
      this.simultaneous = {};
      this.requireFail = [];
    }

    Recognizer.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},

      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function set(options) {
        assign(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state

        this.manager && this.manager.touchAction.update();
        return this;
      },

      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function recognizeWith(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
          return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

        if (!simultaneous[otherRecognizer.id]) {
          simultaneous[otherRecognizer.id] = otherRecognizer;
          otherRecognizer.recognizeWith(this);
        }

        return this;
      },

      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function dropRecognizeWith(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
          return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
      },

      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function requireFailure(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
          return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

        if (inArray(requireFail, otherRecognizer) === -1) {
          requireFail.push(otherRecognizer);
          otherRecognizer.requireFailure(this);
        }

        return this;
      },

      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function dropRequireFailure(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
          return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);

        if (index > -1) {
          this.requireFail.splice(index, 1);
        }

        return this;
      },

      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function hasRequireFailures() {
        return this.requireFail.length > 0;
      },

      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function canRecognizeWith(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
      },

      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function emit(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
          self.manager.emit(event, input);
        } // 'panstart' and 'panmove'


        if (state < STATE_ENDED) {
          emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) {
          // additional event(panleft, panright, pinchin, pinchout...)
          emit(input.additionalEvent);
        } // panend and pancancel


        if (state >= STATE_ENDED) {
          emit(self.options.event + stateStr(state));
        }
      },

      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function tryEmit(input) {
        if (this.canEmit()) {
          return this.emit(input);
        } // it's failing anyway


        this.state = STATE_FAILED;
      },

      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function canEmit() {
        var i = 0;

        while (i < this.requireFail.length) {
          if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
            return false;
          }

          i++;
        }

        return true;
      },

      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData); // is is enabled and allow recognizing?

        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
          this.reset();
          this.state = STATE_FAILED;
          return;
        } // reset when we've reached the end


        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
          this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
        // so trigger an event

        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
          this.tryEmit(inputDataClone);
        }
      },

      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function process(inputData) {},
      // jshint ignore:line

      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function getTouchAction() {},

      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function reset() {}
    };
    /**
     * get a usable string, used as event postfix
     * @param {Const} state
     * @returns {String} state
     */

    function stateStr(state) {
      if (state & STATE_CANCELLED) {
        return 'cancel';
      } else if (state & STATE_ENDED) {
        return 'end';
      } else if (state & STATE_CHANGED) {
        return 'move';
      } else if (state & STATE_BEGAN) {
        return 'start';
      }

      return '';
    }
    /**
     * direction cons to string
     * @param {Const} direction
     * @returns {String}
     */


    function directionStr(direction) {
      if (direction == DIRECTION_DOWN) {
        return 'down';
      } else if (direction == DIRECTION_UP) {
        return 'up';
      } else if (direction == DIRECTION_LEFT) {
        return 'left';
      } else if (direction == DIRECTION_RIGHT) {
        return 'right';
      }

      return '';
    }
    /**
     * get a recognizer by name if it is bound to a manager
     * @param {Recognizer|String} otherRecognizer
     * @param {Recognizer} recognizer
     * @returns {Recognizer}
     */


    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
      var manager = recognizer.manager;

      if (manager) {
        return manager.get(otherRecognizer);
      }

      return otherRecognizer;
    }
    /**
     * This recognizer is just used as a base for the simple attribute recognizers.
     * @constructor
     * @extends Recognizer
     */


    function AttrRecognizer() {
      Recognizer.apply(this, arguments);
    }

    inherit(AttrRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },

      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function attrTest(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
      },

      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function process(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED

        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
          return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
          if (eventType & INPUT_END) {
            return state | STATE_ENDED;
          } else if (!(state & STATE_BEGAN)) {
            return STATE_BEGAN;
          }

          return state | STATE_CHANGED;
        }

        return STATE_FAILED;
      }
    });
    /**
     * Pan
     * Recognized when the pointer is down and moved in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */

    function PanRecognizer() {
      AttrRecognizer.apply(this, arguments);
      this.pX = null;
      this.pY = null;
    }

    inherit(PanRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
      },
      getTouchAction: function getTouchAction() {
        var direction = this.options.direction;
        var actions = [];

        if (direction & DIRECTION_HORIZONTAL) {
          actions.push(TOUCH_ACTION_PAN_Y);
        }

        if (direction & DIRECTION_VERTICAL) {
          actions.push(TOUCH_ACTION_PAN_X);
        }

        return actions;
      },
      directionTest: function directionTest(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY; // lock to axis?

        if (!(direction & options.direction)) {
          if (options.direction & DIRECTION_HORIZONTAL) {
            direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
            hasMoved = x != this.pX;
            distance = Math.abs(input.deltaX);
          } else {
            direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
            hasMoved = y != this.pY;
            distance = Math.abs(input.deltaY);
          }
        }

        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
      },
      attrTest: function attrTest(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
      },
      emit: function emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = directionStr(input.direction);

        if (direction) {
          input.additionalEvent = this.options.event + direction;
        }

        this._super.emit.call(this, input);
      }
    });
    /**
     * Pinch
     * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
     * @constructor
     * @extends AttrRecognizer
     */

    function PinchRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }

    inherit(PinchRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function getTouchAction() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function attrTest(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
      },
      emit: function emit(input) {
        if (input.scale !== 1) {
          var inOut = input.scale < 1 ? 'in' : 'out';
          input.additionalEvent = this.options.event + inOut;
        }

        this._super.emit.call(this, input);
      }
    });
    /**
     * Press
     * Recognized when the pointer is down for x ms without any movement.
     * @constructor
     * @extends Recognizer
     */

    function PressRecognizer() {
      Recognizer.apply(this, arguments);
      this._timer = null;
      this._input = null;
    }

    inherit(PressRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: 'press',
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low

      },
      getTouchAction: function getTouchAction() {
        return [TOUCH_ACTION_AUTO];
      },
      process: function process(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input; // we only allow little movement
        // and we've reached an end event, so a tap is possible

        if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
          this.reset();
        } else if (input.eventType & INPUT_START) {
          this.reset();
          this._timer = setTimeoutContext(function () {
            this.state = STATE_RECOGNIZED;
            this.tryEmit();
          }, options.time, this);
        } else if (input.eventType & INPUT_END) {
          return STATE_RECOGNIZED;
        }

        return STATE_FAILED;
      },
      reset: function reset() {
        clearTimeout(this._timer);
      },
      emit: function emit(input) {
        if (this.state !== STATE_RECOGNIZED) {
          return;
        }

        if (input && input.eventType & INPUT_END) {
          this.manager.emit(this.options.event + 'up', input);
        } else {
          this._input.timeStamp = now();
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    /**
     * Rotate
     * Recognized when two or more pointer are moving in a circular motion.
     * @constructor
     * @extends AttrRecognizer
     */

    function RotateRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }

    inherit(RotateRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function getTouchAction() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function attrTest(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
      }
    });
    /**
     * Swipe
     * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */

    function SwipeRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }

    inherit(SwipeRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
      },
      getTouchAction: function getTouchAction() {
        return PanRecognizer.prototype.getTouchAction.call(this);
      },
      attrTest: function attrTest(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
          velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
          velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
          velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
      },
      emit: function emit(input) {
        var direction = directionStr(input.offsetDirection);

        if (direction) {
          this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
      }
    });
    /**
     * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
     * between the given interval and position. The delay option can be used to recognize multi-taps without firing
     * a single tap.
     *
     * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
     * multi-taps being recognized.
     * @constructor
     * @extends Recognizer
     */

    function TapRecognizer() {
      Recognizer.apply(this, arguments); // previous time and center,
      // used for tap counting

      this.pTime = false;
      this.pCenter = false;
      this._timer = null;
      this._input = null;
      this.count = 0;
    }

    inherit(TapRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position

      },
      getTouchAction: function getTouchAction() {
        return [TOUCH_ACTION_MANIPULATION];
      },
      process: function process(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();

        if (input.eventType & INPUT_START && this.count === 0) {
          return this.failTimeout();
        } // we only allow little movement
        // and we've reached an end event, so a tap is possible


        if (validMovement && validTouchTime && validPointers) {
          if (input.eventType != INPUT_END) {
            return this.failTimeout();
          }

          var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
          var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
          this.pTime = input.timeStamp;
          this.pCenter = input.center;

          if (!validMultiTap || !validInterval) {
            this.count = 1;
          } else {
            this.count += 1;
          }

          this._input = input; // if tap count matches we have recognized it,
          // else it has began recognizing...

          var tapCount = this.count % options.taps;

          if (tapCount === 0) {
            // no failing requirements, immediately trigger the tap event
            // or wait as long as the multitap interval to trigger
            if (!this.hasRequireFailures()) {
              return STATE_RECOGNIZED;
            } else {
              this._timer = setTimeoutContext(function () {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
              }, options.interval, this);
              return STATE_BEGAN;
            }
          }
        }

        return STATE_FAILED;
      },
      failTimeout: function failTimeout() {
        this._timer = setTimeoutContext(function () {
          this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
      },
      reset: function reset() {
        clearTimeout(this._timer);
      },
      emit: function emit() {
        if (this.state == STATE_RECOGNIZED) {
          this._input.tapCount = this.count;
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    /**
     * Simple way to create a manager with a default set of recognizers.
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */

    function Hammer(element, options) {
      options = options || {};
      options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
      return new Manager(element, options);
    }
    /**
     * @const {string}
     */


    Hammer.VERSION = '2.0.7';
    /**
     * default settings
     * @namespace
     */

    Hammer.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: false,

      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: TOUCH_ACTION_COMPUTE,

      /**
       * @type {Boolean}
       * @default true
       */
      enable: true,

      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,

      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,

      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [// RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
      [RotateRecognizer, {
        enable: false
      }], [PinchRecognizer, {
        enable: false
      }, ['rotate']], [SwipeRecognizer, {
        direction: DIRECTION_HORIZONTAL
      }], [PanRecognizer, {
        direction: DIRECTION_HORIZONTAL
      }, ['swipe']], [TapRecognizer], [TapRecognizer, {
        event: 'doubletap',
        taps: 2
      }, ['tap']], [PressRecognizer]],

      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
      }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
     * Manager
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */

    function Manager(element, options) {
      this.options = assign({}, Hammer.defaults, options || {});
      this.options.inputTarget = this.options.inputTarget || element;
      this.handlers = {};
      this.session = {};
      this.recognizers = [];
      this.oldCssProps = {};
      this.element = element;
      this.input = createInputInstance(this);
      this.touchAction = new TouchAction(this, this.options.touchAction);
      toggleCssProps(this, true);
      each(this.options.recognizers, function (item) {
        var recognizer = this.add(new item[0](item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
      }, this);
    }

    Manager.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function set(options) {
        assign(this.options, options); // Options that need a little more setup

        if (options.touchAction) {
          this.touchAction.update();
        }

        if (options.inputTarget) {
          // Clean up existing event listeners and reinitialize
          this.input.destroy();
          this.input.target = options.inputTarget;
          this.input.init();
        }

        return this;
      },

      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function stop(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
      },

      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function recognize(inputData) {
        var session = this.session;

        if (session.stopped) {
          return;
        } // run the touch-action polyfill


        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`

        var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
        // or when we're in a new session

        if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
          curRecognizer = session.curRecognizer = null;
        }

        var i = 0;

        while (i < recognizers.length) {
          recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
          // 1.   allow if the session is NOT forced stopped (see the .stop() method)
          // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
          //      that is being recognized.
          // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
          //      this can be setup with the `recognizeWith()` method on the recognizer.

          if (session.stopped !== FORCED_STOP && ( // 1
          !curRecognizer || recognizer == curRecognizer || // 2
          recognizer.canRecognizeWith(curRecognizer))) {
            // 3
            recognizer.recognize(inputData);
          } else {
            recognizer.reset();
          } // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
          // current active recognizer. but only if we don't already have an active recognizer


          if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
            curRecognizer = session.curRecognizer = recognizer;
          }

          i++;
        }
      },

      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function get(recognizer) {
        if (recognizer instanceof Recognizer) {
          return recognizer;
        }

        var recognizers = this.recognizers;

        for (var i = 0; i < recognizers.length; i++) {
          if (recognizers[i].options.event == recognizer) {
            return recognizers[i];
          }
        }

        return null;
      },

      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function add(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
          return this;
        } // remove existing


        var existing = this.get(recognizer.options.event);

        if (existing) {
          this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
      },

      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function remove(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
          return this;
        }

        recognizer = this.get(recognizer); // let's make sure this recognizer exists

        if (recognizer) {
          var recognizers = this.recognizers;
          var index = inArray(recognizers, recognizer);

          if (index !== -1) {
            recognizers.splice(index, 1);
            this.touchAction.update();
          }
        }

        return this;
      },

      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function on(events, handler) {
        if (events === undefined$1) {
          return;
        }

        if (handler === undefined$1) {
          return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function (event) {
          handlers[event] = handlers[event] || [];
          handlers[event].push(handler);
        });
        return this;
      },

      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function off(events, handler) {
        if (events === undefined$1) {
          return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function (event) {
          if (!handler) {
            delete handlers[event];
          } else {
            handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
          }
        });
        return this;
      },

      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function emit(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
          triggerDomEvent(event, data);
        } // no handlers, so skip it all


        var handlers = this.handlers[event] && this.handlers[event].slice();

        if (!handlers || !handlers.length) {
          return;
        }

        data.type = event;

        data.preventDefault = function () {
          data.srcEvent.preventDefault();
        };

        var i = 0;

        while (i < handlers.length) {
          handlers[i](data);
          i++;
        }
      },

      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function destroy() {
        this.element && toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
      }
    };
    /**
     * add/remove the css properties as defined in manager.options.cssProps
     * @param {Manager} manager
     * @param {Boolean} add
     */

    function toggleCssProps(manager, add) {
      var element = manager.element;

      if (!element.style) {
        return;
      }

      var prop;
      each(manager.options.cssProps, function (value, name) {
        prop = prefixed(element.style, name);

        if (add) {
          manager.oldCssProps[prop] = element.style[prop];
          element.style[prop] = value;
        } else {
          element.style[prop] = manager.oldCssProps[prop] || '';
        }
      });

      if (!add) {
        manager.oldCssProps = {};
      }
    }
    /**
     * trigger dom event
     * @param {String} event
     * @param {Object} data
     */


    function triggerDomEvent(event, data) {
      var gestureEvent = document.createEvent('Event');
      gestureEvent.initEvent(event, true, true);
      gestureEvent.gesture = data;
      data.target.dispatchEvent(gestureEvent);
    }

    assign(Hammer, {
      INPUT_START: INPUT_START,
      INPUT_MOVE: INPUT_MOVE,
      INPUT_END: INPUT_END,
      INPUT_CANCEL: INPUT_CANCEL,
      STATE_POSSIBLE: STATE_POSSIBLE,
      STATE_BEGAN: STATE_BEGAN,
      STATE_CHANGED: STATE_CHANGED,
      STATE_ENDED: STATE_ENDED,
      STATE_RECOGNIZED: STATE_RECOGNIZED,
      STATE_CANCELLED: STATE_CANCELLED,
      STATE_FAILED: STATE_FAILED,
      DIRECTION_NONE: DIRECTION_NONE,
      DIRECTION_LEFT: DIRECTION_LEFT,
      DIRECTION_RIGHT: DIRECTION_RIGHT,
      DIRECTION_UP: DIRECTION_UP,
      DIRECTION_DOWN: DIRECTION_DOWN,
      DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
      DIRECTION_VERTICAL: DIRECTION_VERTICAL,
      DIRECTION_ALL: DIRECTION_ALL,
      Manager: Manager,
      Input: Input,
      TouchAction: TouchAction,
      TouchInput: TouchInput,
      MouseInput: MouseInput,
      PointerEventInput: PointerEventInput,
      TouchMouseInput: TouchMouseInput,
      SingleTouchInput: SingleTouchInput,
      Recognizer: Recognizer,
      AttrRecognizer: AttrRecognizer,
      Tap: TapRecognizer,
      Pan: PanRecognizer,
      Swipe: SwipeRecognizer,
      Pinch: PinchRecognizer,
      Rotate: RotateRecognizer,
      Press: PressRecognizer,
      on: addEventListeners,
      off: removeEventListeners,
      each: each,
      merge: merge,
      extend: extend,
      assign: assign,
      inherit: inherit,
      bindFn: bindFn,
      prefixed: prefixed
    }); // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.

    var freeGlobal = typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}; // jshint ignore:line

    freeGlobal.Hammer = Hammer;

    if (typeof undefined$1 === 'function' && undefined$1.amd) {
      undefined$1(function () {
        return Hammer;
      });
    } else if (module.exports) {
      module.exports = Hammer;
    } else {
      window[exportName] = Hammer;
    }
  })(window, document, 'Hammer');
})(hammer);

var Hammer = hammer.exports;

var _excluded$7 = ["children", "className", "onSwipe", "onSwipeLeft", "onSwipeRight", "onPanMove", "onPanStart", "onPanEnd", "panThreshold"];
function GestureDetector(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onSwipe = _ref.onSwipe,
      onSwipeLeft = _ref.onSwipeLeft,
      onSwipeRight = _ref.onSwipeRight,
      onPanMove = _ref.onPanMove,
      onPanStart = _ref.onPanStart,
      onPanEnd = _ref.onPanEnd,
      panThreshold = _ref.panThreshold,
      props = _objectWithoutProperties$1(_ref, _excluded$7);

  var root = useRef();
  var manager = useRef();
  useEffect(function () {
    manager.current = new Hammer.Manager(root.current);
    return function () {
      manager.current.destroy();
    };
  }, []);
  useEffect(function () {
    // TODO: consider support for removing recognizers.
    var managerInst = manager.current;

    if ((onSwipe || onSwipeLeft || onSwipeRight) && !managerInst.get("swipe")) {
      managerInst.add(new Hammer.Swipe());
    }

    if ((onPanMove || onPanStart || onPanEnd) && !managerInst.get("pan")) {
      var panOptions = {};

      if (panThreshold !== undefined) {
        panOptions.threshold = panThreshold;
      }

      managerInst.add(new Hammer.Pan(panOptions));
    }
  }, [onSwipe, onSwipeLeft, onSwipeRight, onPanMove, onPanStart, onPanEnd, panThreshold]);
  useEffect(function () {
    // console.log("useEffect onSwipe");
    onSwipe && manager.current.on("swipe", onSwipe);
    return function () {
      return manager.current.off("swipe");
    };
  }, [onSwipe]);
  useEffect(function () {
    // console.log("useEffect onSwipeLeft");
    onSwipeLeft && manager.current.on("swipeleft", onSwipeLeft);
    return function () {
      return manager.current.off("swipeleft");
    };
  }, [onSwipeLeft]);
  useEffect(function () {
    // console.log("useEffect onSwipeRight");
    onSwipeRight && manager.current.on("swiperight", onSwipeRight);
    return function () {
      return manager.current.off("swiperight");
    };
  }, [onSwipeRight]);
  useEffect(function () {
    // console.log("useEffect onPanStart");
    onPanStart && manager.current.on("panstart", onPanStart);
    return function () {
      return manager.current.off("panstart");
    };
  }, [onPanStart]);
  useEffect(function () {
    // console.log("useEffect onPanMove");
    onPanMove && manager.current.on("panmove", onPanMove);
    return function () {
      return manager.current.off("panmove");
    };
  }, [onPanMove]);
  useEffect(function () {
    // console.log("useEffect onPanEnd");
    onPanEnd && manager.current.on("panend", onPanEnd);
    return function () {
      return manager.current.off("panend");
    };
  }, [onPanEnd]);
  return /*#__PURE__*/React.createElement("div", _extends$2({
    className: className,
    ref: root
  }, props), children);
}

function MediaSlider(_ref) {
  _ref.sections;
      var items = _ref.items,
      defaultIndex = _ref.defaultIndex,
      disabled = _ref.disabled,
      onSlide = _ref.onSlide;
  var numItems = items.length;

  var _useState = useState(defaultIndex),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      deltaX = _useState4[0],
      setDeltaX = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dragging = _useState6[0],
      setDragging = _useState6[1];

  var indexRef = useRef(defaultIndex);
  var sliderRef = useRef();
  var translateX = index / numItems * -100 + "%";
  var slideTo = useCallback(function (newIndex) {
    indexRef.current = newIndex;
    setIndex(newIndex);
    onSlide && onSlide(newIndex);
  }, [setIndex, onSlide]);
  var panMoveHandler = useCallback(function (evt) {
    !disabled && setDeltaX(evt.deltaX);
  }, [disabled]);
  var panStartHandler = useCallback(function (evt) {
    !disabled && setDragging(true);
  }, [disabled]);
  var panEndHandler = useCallback(function (evt) {
    if (disabled) {
      return;
    }

    var currentIndex = indexRef.current;
    setDragging(false);
    var currentWidth = sliderRef.current.parentElement.clientWidth;

    if ((evt.deltaX > currentWidth * 0.4 || evt.velocityX > 0.5) && currentIndex > 0) {
      slideTo(currentIndex - 1);
    } else if ((evt.deltaX < -currentWidth * 0.4 || evt.velocityX < -0.5) && currentIndex < numItems - 1) {
      slideTo(currentIndex + 1);
    }

    setDeltaX(0);
  }, [disabled, slideTo, numItems]);
  return /*#__PURE__*/React.createElement(GestureDetector, {
    className: "MediaSlider",
    onPanMove: panMoveHandler,
    onPanStart: panStartHandler,
    onPanEnd: panEndHandler,
    panThreshold: 0
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    className: classnames("MediaSlider-inner", {
      dragging: dragging
    }),
    style: {
      width: numItems * 100 + "%",
      transform: "translateX(calc(".concat(translateX, " + ").concat(deltaX, "px))")
    }
  }, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Item, {
      key: i,
      index: i,
      item: item,
      numItems: numItems,
      currentIndex: index
    });
  })));
}

function Item(_ref2) {
  var item = _ref2.item,
      index = _ref2.index,
      currentIndex = _ref2.currentIndex,
      numItems = _ref2.numItems;

  if (index < currentIndex - 1 || index > currentIndex + 1) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "MediaSlider-item",
    style: {
      width: 100 / numItems + "%",
      left: index / numItems * 100 + "%"
    }
  }, item);
}

var styles$b = {"wrapper":"ZoomableImage-module_wrapper__2WCkC","content":"ZoomableImage-module_content__1OPMr"};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var initialState = {
  wrapperComponent: null,
  contentComponent: null,
  previousScale: 1,
  scale: 1,
  positionX: 0,
  positionY: 0,
  options: {
    disabled: false,
    transformEnabled: true,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    limitToWrapper: false,
    centerContent: true,
    wrapperClass: "",
    contentClass: ""
  },
  wheel: {
    disabled: false,
    step: 5,
    wheelEnabled: true,
    touchPadEnabled: true,
    limitsOnWheel: false
  },
  pan: {
    disabled: false,
    panAnimationType: "linear",
    lockAxisX: false,
    lockAxisY: false,
    velocity: true,
    velocityEqualToMove: true,
    velocitySensitivity: 2,
    velocityActiveScale: 1,
    velocityMinSpeed: 1,
    velocityBaseTime: 1600,
    velocityAnimationType: "easeOutQuart",
    padding: true,
    paddingSize: 30,
    panReturnAnimationTime: 400,
    panReturnAnimationType: "easeOut",
    disableOnTarget: []
  },
  pinch: {
    disabled: false
  },
  zoomIn: {
    disabled: false,
    step: 20,
    animation: true,
    animationType: "easeOut",
    animationTime: 200
  },
  zoomOut: {
    disabled: false,
    step: 20,
    animation: true,
    animationType: "easeOut",
    animationTime: 200
  },
  doubleClick: {
    disabled: false,
    step: 20,
    mode: "zoomIn",
    animation: true,
    animationType: "easeOut",
    animationTime: 200
  },
  reset: {
    disabled: false,
    animation: true,
    animationType: "easeOut",
    animationTime: 200
  },
  scalePadding: {
    disabled: false,
    size: 0.2,
    animationTime: 200,
    animationType: "easeOut"
  }
};
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */

var roundNumber = function roundNumber(num, decimal) {
  return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */


var checkIsNumber = function checkIsNumber(num, defaultValue) {
  return typeof num === "number" ? num : defaultValue;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */


var boundLimiter = function boundLimiter(value, minBound, maxBound, isActive) {
  if (!isActive) return roundNumber(value, 2);
  if (value < minBound) return roundNumber(minBound, 2);
  if (value > maxBound) return roundNumber(maxBound, 2);
  return roundNumber(value, 2);
};
/**
 * Calculate bounding area of zoomed/panned element
 */


var calculateBoundingArea = function calculateBoundingArea(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, limitToWrapper) {
  var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (limitToWrapper ? 1 : 0.5) : 0;
  var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (limitToWrapper ? 1 : 0.5) : 0;
  var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
  var maxPositionX = scaleWidthFactor;
  var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
  var maxPositionY = scaleHeightFactor;
  return {
    minPositionX: minPositionX,
    maxPositionX: maxPositionX,
    minPositionY: minPositionY,
    maxPositionY: maxPositionY
  };
};
/**
 * Returns distance between two points x,y
 */


var getDistance = function getDistance(firstPoint, secondPoint) {
  return Math.sqrt(Math.pow(firstPoint.pageX - secondPoint.pageX, 2) + Math.pow(firstPoint.pageY - secondPoint.pageY, 2));
};
/**
 * Delete undefined values from object keys
 * Used for deleting empty props
 */


var deleteUndefinedProps = function deleteUndefinedProps(value) {
  var newObject = _assign({}, value);

  Object.keys(newObject).forEach(function (key) {
    return newObject[key] === undefined && delete newObject[key];
  });
  return newObject;
};
/**
 * Fire callback if it's function
 */


var handleCallback = function handleCallback(callback, props) {
  if (callback && typeof callback === "function") {
    callback(props);
  }
};

var handleWheelStop = function handleWheelStop(previousEvent, event, stateProvider) {
  var scale = stateProvider.scale,
      _a = stateProvider.options,
      maxScale = _a.maxScale,
      minScale = _a.minScale;
  if (!previousEvent) return false;
  if (scale < maxScale || scale > minScale) return true;
  if (Math.sign(previousEvent.deltaY) !== Math.sign(event.deltaY)) return true;
  if (previousEvent.deltaY > 0 && previousEvent.deltaY < event.deltaY) return true;
  if (previousEvent.deltaY < 0 && previousEvent.deltaY > event.deltaY) return true;
  if (Math.sign(previousEvent.deltaY) !== Math.sign(event.deltaY)) return true;
  return false;
};

var mergeProps = function mergeProps(initialState, dynamicProps) {
  return Object.keys(initialState).reduce(function (acc, curr) {
    if (_typeof(dynamicProps[curr]) === "object" && dynamicProps[curr] !== null) {
      acc[curr] = _assign(_assign({}, initialState[curr]), dynamicProps[curr]);
    } else {
      acc[curr] = dynamicProps[curr] === undefined ? initialState[curr] : dynamicProps[curr];
    }

    return acc;
  }, {});
};

function getWindowScaleY(wrapper) {
  if (!wrapper) return 0;
  return window.innerHeight / wrapper.offsetHeight;
}

function getWindowScaleX(wrapper) {
  if (!wrapper) return 0;
  return window.innerWidth / wrapper.offsetWidth;
}
/**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */


var easeOut = function easeOut(t) {
  return -Math.cos(t * Math.PI) / 2 + 0.5;
}; // linear


var linear = function linear(t) {
  return t;
}; // accelerating from zero velocity


var easeInQuad = function easeInQuad(t) {
  return t * t;
}; // decelerating to zero velocity


var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
}; // acceleration until halfway, then deceleration


var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}; // accelerating from zero velocity


var easeInCubic = function easeInCubic(t) {
  return t * t * t;
}; // decelerating to zero velocity


var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // acceleration until halfway, then deceleration


var easeInOutCubic = function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}; // accelerating from zero velocity


var easeInQuart = function easeInQuart(t) {
  return t * t * t * t;
}; // decelerating to zero velocity


var easeOutQuart = function easeOutQuart(t) {
  return 1 - --t * t * t * t;
}; // acceleration until halfway, then deceleration


var easeInOutQuart = function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}; // accelerating from zero velocity


var easeInQuint = function easeInQuint(t) {
  return t * t * t * t * t;
}; // decelerating to zero velocity


var easeOutQuint = function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
}; // acceleration until halfway, then deceleration


var easeInOutQuint = function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};

var availableAnimations = {
  easeOut: easeOut,
  linear: linear,
  easeInQuad: easeInQuad,
  easeOutQuad: easeOutQuad,
  easeInOutQuad: easeInOutQuad,
  easeInCubic: easeInCubic,
  easeOutCubic: easeOutCubic,
  easeInOutCubic: easeInOutCubic,
  easeInQuart: easeInQuart,
  easeOutQuart: easeOutQuart,
  easeInOutQuart: easeInOutQuart,
  easeInQuint: easeInQuint,
  easeOutQuint: easeOutQuint,
  easeInOutQuint: easeInOutQuint
};

function handleDisableAnimation() {
  if (!this.mounted) return;

  if (this.animation) {
    cancelAnimationFrame(this.animation);
  }

  this.animate = false;
  this.animation = false;
  this.velocity = false;
}

function animate(animationName, animationTime, callback) {
  var _this = this;

  if (!this.mounted) return;
  var startTime = new Date().getTime();
  var lastStep = 1; // if another animation is active

  handleDisableAnimation.call(this); // new animation

  this.animation = function () {
    if (!_this.animation || !_this.mounted) return;
    var frameTime = new Date().getTime() - startTime;
    var animationProgress = frameTime / animationTime;
    var animationType = availableAnimations[animationName];
    var step = animationType(animationProgress);

    if (frameTime >= animationTime) {
      callback(lastStep);
      _this.animation = null;
    } else {
      callback(step);
      requestAnimationFrame(_this.animation);
    }
  };

  requestAnimationFrame(this.animation);
}

function animateComponent(_a) {
  var _this = this;

  var targetState = _a.targetState,
      speed = _a.speed,
      type = _a.type;
  var _b = this.stateProvider,
      scale = _b.scale,
      positionX = _b.positionX,
      positionY = _b.positionY;
  var scaleDiff = targetState.scale - scale;
  var positionXDiff = targetState.positionX - positionX;
  var positionYDiff = targetState.positionY - positionY;

  if (speed === 0) {
    this.stateProvider.previousScale = this.stateProvider.scale;
    this.stateProvider.scale = targetState.scale;
    this.stateProvider.positionX = targetState.positionX;
    this.stateProvider.positionY = targetState.positionY;
    this.applyTransformation();
  } else {
    // animation start timestamp
    animate.call(this, type, speed, function (step) {
      _this.stateProvider.previousScale = _this.stateProvider.scale;
      _this.stateProvider.scale = scale + scaleDiff * step;
      _this.stateProvider.positionX = positionX + positionXDiff * step;
      _this.stateProvider.positionY = positionY + positionYDiff * step; // apply animation changes

      _this.applyTransformation();
    });
  }
}

function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
  var scalePadding = enablePadding ? zoomPadding : 0;
  var minScaleWithPadding = minScale - scalePadding;
  if (!isNaN(maxScale) && zoom >= maxScale) return maxScale;
  if (!isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
  return zoom;
}

function checkPositionBounds(positionX, positionY, bounds, limitToBounds, paddingValue, wrapperComponent) {
  var minPositionX = bounds.minPositionX,
      minPositionY = bounds.minPositionY,
      maxPositionX = bounds.maxPositionX,
      maxPositionY = bounds.maxPositionY;
  var paddingX = wrapperComponent ? paddingValue * wrapperComponent.offsetWidth / 100 : 0;
  var paddingY = wrapperComponent ? paddingValue * wrapperComponent.offsetHeight / 100 : 0;
  var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
  var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
  return {
    x: x,
    y: y
  };
}

function getDelta(event, customDelta) {
  var deltaY = event ? event.deltaY < 0 ? 1 : -1 : 0;
  var delta = checkIsNumber(customDelta, deltaY);
  return delta;
}

function wheelMousePosition(event, contentComponent, scale) {
  var contentRect = contentComponent.getBoundingClientRect(); // mouse position x, y over wrapper component

  var mouseX = (event.clientX - contentRect.left) / scale;
  var mouseY = (event.clientY - contentRect.top) / scale;
  if (isNaN(mouseX) || isNaN(mouseY)) console.error("No mouse or touch offset found");
  return {
    mouseX: mouseX,
    mouseY: mouseY
  };
}

function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
  var wrapperWidth = wrapperComponent.offsetWidth;
  var wrapperHeight = wrapperComponent.offsetHeight;
  var contentWidth = contentComponent.offsetWidth;
  var contentHeight = contentComponent.offsetHeight;
  var newContentWidth = contentWidth * newScale;
  var newContentHeight = contentHeight * newScale;
  var newDiffWidth = wrapperWidth - newContentWidth;
  var newDiffHeight = wrapperHeight - newContentHeight;
  return {
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    newContentWidth: newContentWidth,
    newDiffWidth: newDiffWidth,
    newContentHeight: newContentHeight,
    newDiffHeight: newDiffHeight
  };
}

function handleCalculatePositions(mouseX, mouseY, newScale, bounds, limitToBounds) {
  var _a = this.stateProvider,
      scale = _a.scale,
      positionX = _a.positionX,
      positionY = _a.positionY,
      transformEnabled = _a.options.transformEnabled;
  var scaleDifference = newScale - scale;
  if (typeof mouseX !== "number" || typeof mouseY !== "number") return console.error("Mouse X and Y position were not provided!");
  if (!transformEnabled) return {
    newPositionX: positionX,
    newPositionY: positionY
  };
  var calculatedPositionX = positionX - mouseX * scaleDifference;
  var calculatedPositionY = positionY - mouseY * scaleDifference; // do not limit to bounds when there is padding animation,
  // it causes animation strange behaviour

  var newPositions = checkPositionBounds(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, null);
  return newPositions;
}

function getClientPosition(event) {
  var touches = event.touches; // Mobile points

  if (touches && touches.length === 1) {
    return {
      clientX: touches[0].clientX,
      clientY: touches[0].clientY
    };
  } // Desktop points


  if (!touches) {
    return {
      clientX: event.clientX,
      clientY: event.clientY
    };
  }

  return null;
}

function handlePanning(event) {
  var _a = this.stateProvider,
      scale = _a.scale,
      positionX = _a.positionX,
      positionY = _a.positionY,
      _b = _a.options,
      limitToBounds = _b.limitToBounds,
      minScale = _b.minScale,
      _c = _a.pan,
      lockAxisX = _c.lockAxisX,
      lockAxisY = _c.lockAxisY,
      padding = _c.padding,
      paddingSize = _c.paddingSize,
      wrapperComponent = _a.wrapperComponent;
  if (!this.startCoords) return;
  var _d = this.startCoords,
      x = _d.x,
      y = _d.y;
  var positions = getClientPosition(event);
  if (!positions) return console.error("Cannot find mouse client positions");
  var clientX = positions.clientX,
      clientY = positions.clientY; // Get Position

  var mouseX = clientX - x;
  var mouseY = clientY - y;
  var newPositionX = lockAxisX ? positionX : mouseX;
  var newPositionY = lockAxisY ? positionY : mouseY; // padding

  var paddingValue = padding && scale >= minScale ? paddingSize : 0; // If position didn't change

  if (newPositionX === positionX && newPositionY === positionY) return;
  var calculatedPosition = checkPositionBounds(newPositionX, newPositionY, this.bounds, limitToBounds, paddingValue, wrapperComponent); // Save panned position

  handlePaddingAnimation.call(this, calculatedPosition.x, calculatedPosition.y);
}

function handlePanningAnimation() {
  var _a = this.stateProvider,
      scale = _a.scale,
      minScale = _a.options.minScale,
      _b = _a.pan,
      disabled = _b.disabled,
      padding = _b.padding,
      panReturnAnimationTime = _b.panReturnAnimationTime,
      panReturnAnimationType = _b.panReturnAnimationType;
  var isDisabled = disabled || scale < minScale || !padding;
  if (isDisabled) return;
  var targetState = handlePanToBounds.call(this);
  animateComponent.call(this, {
    targetState: targetState,
    speed: panReturnAnimationTime,
    type: panReturnAnimationType
  });
}

function handlePanToBounds() {
  var _a = this.stateProvider,
      positionX = _a.positionX,
      positionY = _a.positionY,
      scale = _a.scale,
      _b = _a.options,
      disabled = _b.disabled,
      limitToBounds = _b.limitToBounds,
      limitToWrapper = _b.limitToWrapper;
  var wrapperComponent = this.state.wrapperComponent;
  if (disabled) return;
  var _c = this.bounds,
      maxPositionX = _c.maxPositionX,
      minPositionX = _c.minPositionX,
      maxPositionY = _c.maxPositionY,
      minPositionY = _c.minPositionY;
  var xChanged = positionX > maxPositionX || positionX < minPositionX;
  var yChanged = positionY > maxPositionY || positionY < minPositionY;
  var mouseX = positionX > maxPositionX ? wrapperComponent.offsetWidth : this.stateProvider.minPositionX || 0;
  var mouseY = positionY > maxPositionY ? wrapperComponent.offsetHeight : this.stateProvider.minPositionY || 0;
  var mousePosX = mouseX;
  var mousePosY = mouseY;

  var _d = handleCalculatePositions.call(this, mousePosX, mousePosY, scale, this.bounds, limitToBounds || limitToWrapper),
      x = _d.x,
      y = _d.y;

  return {
    scale: scale,
    positionX: xChanged ? x : positionX,
    positionY: yChanged ? y : positionY
  };
}

function handlePaddingAnimation(positionX, positionY) {
  var padding = this.stateProvider.pan.padding;
  if (!padding) return;
  this.stateProvider.positionX = positionX;
  this.stateProvider.positionY = positionY;
  this.applyTransformation();
}

function handleCalculateZoom(delta, step, disablePadding, getTarget, isBtnFunction) {
  var _a = this.stateProvider,
      scale = _a.scale,
      _b = _a.options,
      maxScale = _b.maxScale,
      minScale = _b.minScale,
      _c = _a.scalePadding,
      size = _c.size,
      disabled = _c.disabled,
      wrapperComponent = _a.wrapperComponent;
  var targetScale = null;

  if (isBtnFunction) {
    var scaleFactor = window.innerWidth * 0.0001;
    var zoomFactor = delta < 0 ? 30 : 20;
    targetScale = scale + (step - step * scaleFactor) * delta * (scale / zoomFactor);
  } else {
    var wrapperToWindowScale = 2 - window.innerWidth / wrapperComponent.offsetWidth;
    var scaleFactor = Math.max(0.2, Math.min(0.99, wrapperToWindowScale));
    var zoomFactor = 20;
    targetScale = scale + step * delta * ((scale - scale * scaleFactor) / zoomFactor);
  }

  if (getTarget) return targetScale;
  var paddingEnabled = disablePadding ? false : !disabled;
  var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled);
  return newScale;
}

function handleCalculateBounds(newScale, limitToWrapper) {
  var _a = this.stateProvider,
      wrapperComponent = _a.wrapperComponent,
      contentComponent = _a.contentComponent;

  var _b = getComponentsSizes(wrapperComponent, contentComponent, newScale),
      wrapperWidth = _b.wrapperWidth,
      wrapperHeight = _b.wrapperHeight,
      newContentWidth = _b.newContentWidth,
      newDiffWidth = _b.newDiffWidth,
      newContentHeight = _b.newContentHeight,
      newDiffHeight = _b.newDiffHeight;

  var bounds = calculateBoundingArea(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, limitToWrapper); // Save bounds

  this.bounds = bounds;
  return bounds;
}
/**
 * Wheel zoom event
 */


function handleWheelZoom(event) {
  var _a = this.stateProvider,
      scale = _a.scale,
      contentComponent = _a.contentComponent,
      limitToBounds = _a.options.limitToBounds,
      _b = _a.scalePadding,
      size = _b.size,
      disabled = _b.disabled,
      _c = _a.wheel,
      step = _c.step,
      limitsOnWheel = _c.limitsOnWheel;
  event.preventDefault();
  event.stopPropagation();
  var delta = getDelta(event, null);
  var newScale = handleCalculateZoom.call(this, delta, step, !event.ctrlKey); // if scale not change

  if (scale === newScale) return;
  var bounds = handleCalculateBounds.call(this, newScale, !limitsOnWheel);

  var _d = wheelMousePosition(event, contentComponent, scale),
      mouseX = _d.mouseX,
      mouseY = _d.mouseY;

  var isLimitedToBounds = limitToBounds && (disabled || size === 0 || limitsOnWheel);

  var _e = handleCalculatePositions.call(this, mouseX, mouseY, newScale, bounds, isLimitedToBounds),
      x = _e.x,
      y = _e.y;

  this.bounds = bounds;
  this.stateProvider.previousScale = scale;
  this.stateProvider.scale = newScale;
  this.stateProvider.positionX = x;
  this.stateProvider.positionY = y;
  this.applyTransformation();
}
/**
 * Zoom for animations
 */


function handleZoomToPoint(isDisabled, scale, mouseX, mouseY, event) {
  var _a = this.stateProvider,
      contentComponent = _a.contentComponent,
      _b = _a.options,
      disabled = _b.disabled,
      minScale = _b.minScale,
      maxScale = _b.maxScale,
      limitToBounds = _b.limitToBounds,
      limitToWrapper = _b.limitToWrapper;
  if (disabled || isDisabled) return;
  var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, null, null);
  var bounds = handleCalculateBounds.call(this, newScale, limitToWrapper);
  var mousePosX = mouseX;
  var mousePosY = mouseY; // if event is present - use it's mouse position

  if (event) {
    var mousePosition = wheelMousePosition(event, contentComponent, scale);
    mousePosX = mousePosition.mouseX;
    mousePosY = mousePosition.mouseY;
  }

  var _c = handleCalculatePositions.call(this, mousePosX, mousePosY, newScale, bounds, limitToBounds),
      x = _c.x,
      y = _c.y;

  return {
    scale: newScale,
    positionX: x,
    positionY: y
  };
}

function handlePaddingAnimation$1() {
  var _a = this.stateProvider,
      scale = _a.scale,
      wrapperComponent = _a.wrapperComponent,
      _b = _a.options,
      minScale = _b.minScale,
      limitToBounds = _b.limitToBounds,
      _c = _a.scalePadding,
      disabled = _c.disabled,
      animationTime = _c.animationTime,
      animationType = _c.animationType;
  var isDisabled = disabled || scale >= minScale;

  if (scale >= 1 || limitToBounds) {
    // fire fit to bounds animation
    handlePanningAnimation.call(this);
  }

  if (isDisabled) return;
  var mouseX = wrapperComponent.offsetWidth / 2;
  var mouseY = wrapperComponent.offsetHeight / 2;
  var targetState = handleZoomToPoint.call(this, false, minScale, mouseX, mouseY, null);
  animateComponent.call(this, {
    targetState: targetState,
    speed: animationTime,
    type: animationType
  });
}
/**
 * Button zoom events
 */


function handleDoubleClick(event) {
  event.preventDefault();
  event.stopPropagation();
  var _a = this.stateProvider,
      contentComponent = _a.contentComponent,
      scale = _a.scale,
      _b = _a.doubleClick,
      disabled = _b.disabled,
      mode = _b.mode,
      step = _b.step,
      animationTime = _b.animationTime,
      animationType = _b.animationType;

  if (mode === "reset") {
    return resetTransformations.call(this, event, animationTime);
  }

  var delta = mode === "zoomOut" ? -1 : 1;
  var newScale = handleCalculateZoom.call(this, delta, step, undefined, undefined, true);

  var _c = wheelMousePosition(event, contentComponent, scale),
      mouseX = _c.mouseX,
      mouseY = _c.mouseY;

  var targetState = handleZoomToPoint.call(this, disabled, newScale, mouseX, mouseY);
  if (targetState.scale === scale) return;
  var targetScale = handleCalculateZoom.call(this, delta, step, true, undefined, true);
  var time = getButtonAnimationTime(targetScale, newScale, animationTime);
  animateComponent.call(this, {
    targetState: targetState,
    speed: time,
    type: animationType
  });
}

function handleZoomControls(customDelta, customStep) {
  var _a = this.stateProvider,
      scale = _a.scale,
      positionX = _a.positionX,
      positionY = _a.positionY,
      wrapperComponent = _a.wrapperComponent,
      zoomIn = _a.zoomIn,
      zoomOut = _a.zoomOut;
  var wrapperWidth = wrapperComponent.offsetWidth;
  var wrapperHeight = wrapperComponent.offsetHeight;
  var mouseX = (wrapperWidth / 2 - positionX) / scale;
  var mouseY = (wrapperHeight / 2 - positionY) / scale;
  var newScale = handleCalculateZoom.call(this, customDelta, customStep, undefined, undefined, true);
  var isZoomIn = newScale > scale;
  var animationSpeed = isZoomIn ? zoomIn.animationTime : zoomOut.animationTime;
  var animationType = isZoomIn ? zoomIn.animationType : zoomOut.animationType;
  var isDisabled = isZoomIn ? zoomIn.disabled : zoomOut.disabled;
  var targetState = handleZoomToPoint.call(this, isDisabled, newScale, mouseX, mouseY);
  if (targetState.scale === scale) return;
  var targetScale = handleCalculateZoom.call(this, customDelta, customStep, true, undefined, true);
  var time = getButtonAnimationTime(targetScale, newScale, animationSpeed);
  animateComponent.call(this, {
    targetState: targetState,
    speed: time,
    type: animationType
  });
}

function resetTransformations(animationSpeed) {
  var _a = this.props.defaultValues,
      defaultScale = _a.defaultScale,
      defaultPositionX = _a.defaultPositionX,
      defaultPositionY = _a.defaultPositionY;
  var _b = this.stateProvider,
      scale = _b.scale,
      positionX = _b.positionX,
      positionY = _b.positionY,
      reset = _b.reset,
      _c = _b.options,
      disabled = _c.disabled,
      limitToBounds = _c.limitToBounds,
      centerContent = _c.centerContent,
      limitToWrapper = _c.limitToWrapper;
  if (disabled || reset.disabled) return;
  if (scale === defaultScale && positionX === defaultPositionX && positionY === defaultPositionY) return;
  var speed = typeof animationSpeed === "number" ? animationSpeed : reset.animationTime;
  var targetScale = checkIsNumber(defaultScale, initialState.scale);
  var newPositionX = checkIsNumber(defaultPositionX, initialState.positionX);
  var newPositionY = checkIsNumber(defaultPositionY, initialState.positionY);

  if (limitToBounds && !limitToWrapper || centerContent) {
    var bounds = handleCalculateBounds.call(this, targetScale, limitToWrapper);
    newPositionX = bounds.minPositionX;
    newPositionY = bounds.minPositionY;
  }

  var targetState = {
    scale: targetScale,
    positionX: newPositionX,
    positionY: newPositionY
  };
  animateComponent.call(this, {
    targetState: targetState,
    speed: speed,
    type: reset.animationType
  });
}

function getButtonAnimationTime(targetScale, newScale, time) {
  return time * (newScale / targetScale);
}

function round(number, decimal) {
  var roundNumber = Math.pow(10, decimal);
  return Math.round(number * roundNumber) / roundNumber;
}

function getCurrentDistance(event) {
  return getDistance(event.touches[0], event.touches[1]);
}

function checkIfInfinite(number) {
  return number === Infinity || number === -Infinity;
}

function calculatePinchZoom(currentDistance, pinchStartDistance) {
  var _a = this.stateProvider,
      _b = _a.options,
      minScale = _b.minScale,
      maxScale = _b.maxScale,
      _c = _a.scalePadding,
      size = _c.size,
      disabled = _c.disabled;
  if (typeof pinchStartDistance !== "number" || typeof currentDistance !== "number") return console.error("Pinch touches distance was not provided");
  if (currentDistance < 0) return;
  var touchProportion = currentDistance / pinchStartDistance;
  var scaleDifference = touchProportion * this.pinchStartScale;
  return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled);
}

function calculateMidpoint(event, scale, contentComponent) {
  var contentRect = contentComponent.getBoundingClientRect();
  var touches = event.touches;
  var firstPointX = round(touches[0].clientX - contentRect.left, 5);
  var firstPointY = round(touches[0].clientY - contentRect.top, 5);
  var secondPointX = round(touches[1].clientX - contentRect.left, 5);
  var secondPointY = round(touches[1].clientY - contentRect.top, 5);
  return {
    mouseX: (firstPointX + secondPointX) / 2 / scale,
    mouseY: (firstPointY + secondPointY) / 2 / scale
  };
}

function handleZoomPinch(event) {
  var _a = this.stateProvider,
      scale = _a.scale,
      _b = _a.options,
      limitToBounds = _b.limitToBounds,
      limitToWrapper = _b.limitToWrapper,
      _c = _a.scalePadding,
      disabled = _c.disabled,
      size = _c.size,
      limitsOnWheel = _a.wheel.limitsOnWheel,
      pinch = _a.pinch;
  var contentComponent = this.state.contentComponent;
  if (pinch.disabled || this.stateProvider.options.disabled) return;

  if (event.cancelable) {
    event.preventDefault();
    event.stopPropagation();
  } // if one finger starts from outside of wrapper


  if (this.pinchStartDistance === null) return; // Position transformation

  var _d = calculateMidpoint(event, scale, contentComponent),
      mouseX = _d.mouseX,
      mouseY = _d.mouseY; // if touches goes off of the wrapper element


  if (checkIfInfinite(mouseX) || checkIfInfinite(mouseY)) return;
  var currentDistance = getCurrentDistance(event);
  var newScale = calculatePinchZoom.call(this, currentDistance, this.pinchStartDistance);
  if (checkIfInfinite(newScale) || newScale === scale) return; // Get new element sizes to calculate bounds

  var bounds = handleCalculateBounds.call(this, newScale, limitToWrapper); // Calculate transformations

  var isLimitedToBounds = limitToBounds && (disabled || size === 0 || limitsOnWheel);

  var _e = handleCalculatePositions.call(this, mouseX, mouseY, newScale, bounds, isLimitedToBounds),
      x = _e.x,
      y = _e.y;

  this.lastDistance = currentDistance;
  this.stateProvider.positionX = x;
  this.stateProvider.positionY = y;
  this.stateProvider.scale = newScale;
  this.stateProvider.previousScale = scale; // update component transformation

  this.applyTransformation();
}

var throttleTime = 30;

function velocityTimeSpeed(speed, animationTime) {
  var velocityEqualToMove = this.stateProvider.pan.velocityEqualToMove;

  if (velocityEqualToMove) {
    return animationTime - animationTime / Math.max(1, speed);
  }

  return animationTime;
}

function handleEnableVelocity() {
  this.setState({
    startAnimation: false
  });
}

function handleFireVelocity() {
  this.setState({
    startAnimation: true
  });
}

function animateVelocity() {
  var _this = this;

  var _a = this.stateProvider,
      positionX = _a.positionX,
      positionY = _a.positionY,
      limitToBounds = _a.options.limitToBounds,
      _b = _a.pan,
      velocityBaseTime = _b.velocityBaseTime,
      lockAxisX = _b.lockAxisX,
      lockAxisY = _b.lockAxisY,
      velocityAnimationType = _b.velocityAnimationType,
      panReturnAnimationTime = _b.panReturnAnimationTime,
      panReturnAnimationType = _b.panReturnAnimationType,
      padding = _b.padding,
      paddingSize = _b.paddingSize,
      wrapperComponent = _a.wrapperComponent;
  if (!this.mounted) return;
  if (!this.velocity || !this.bounds) return handleDisableAnimation.call(this);
  var _c = this.bounds,
      maxPositionX = _c.maxPositionX,
      minPositionX = _c.minPositionX,
      maxPositionY = _c.maxPositionY,
      minPositionY = _c.minPositionY;
  var _d = this.velocity,
      velocityX = _d.velocityX,
      velocityY = _d.velocityY,
      velocity = _d.velocity;
  var animationTime = velocityTimeSpeed.call(this, velocity, velocityBaseTime);

  if (!animationTime) {
    handlePanningAnimation.call(this);
    return;
  }

  var targetX = velocityX;
  var targetY = velocityY; // pan return animation

  var newAnimationTime = animationTime > panReturnAnimationTime ? animationTime : panReturnAnimationTime;
  var paddingValue = padding ? paddingSize : 0;
  var paddingX = wrapperComponent ? paddingValue * wrapperComponent.offsetWidth / 100 : 0;
  var paddingY = wrapperComponent ? paddingValue * wrapperComponent.offsetHeight / 100 : 0;
  var maxTargetX = maxPositionX + paddingX;
  var minTargetX = minPositionX - paddingX;
  var maxTargetY = maxPositionY + paddingY;
  var minTargetY = minPositionY - paddingY;
  var startPosition = checkPositionBounds(positionX, positionY, this.bounds, limitToBounds, paddingValue, wrapperComponent);
  var startTime = new Date().getTime(); // animation start timestamp

  animate.call(this, velocityAnimationType, newAnimationTime, function (step) {
    var frameTime = new Date().getTime() - startTime;
    var animationProgress = frameTime / panReturnAnimationTime;
    var returnAnimation = availableAnimations[panReturnAnimationType];
    var customReturnStep = returnAnimation(animationProgress);
    if (frameTime > panReturnAnimationTime || customReturnStep > 1 || customReturnStep === Infinity || customReturnStep === -Infinity) customReturnStep = 1;
    var currentPositionX = getPosition(lockAxisX, targetX, step, customReturnStep, minPositionX, maxPositionX, limitToBounds, positionX, startPosition.x, minTargetX, maxTargetX);
    var currentPositionY = getPosition(lockAxisY, targetY, step, customReturnStep, minPositionY, maxPositionY, limitToBounds, positionY, startPosition.y, minTargetY, maxTargetY);

    if (positionX !== currentPositionX || positionY !== currentPositionY) {
      // Save panned position
      _this.stateProvider.positionX = currentPositionX;
      _this.stateProvider.positionY = currentPositionY; // apply animation changes

      _this.applyTransformation();
    }
  });
}

function calculateVelocityStart(event) {
  var _this = this;

  var _a = this.stateProvider,
      scale = _a.scale,
      disabled = _a.options.disabled,
      _b = _a.pan,
      velocity = _b.velocity,
      velocitySensitivity = _b.velocitySensitivity,
      velocityActiveScale = _b.velocityActiveScale,
      velocityMinSpeed = _b.velocityMinSpeed,
      wrapperComponent = _a.wrapperComponent;
  if (!velocity || velocityActiveScale >= scale || disabled) return;
  handleEnableVelocity.call(this);
  var now = Date.now();

  if (this.lastMousePosition) {
    var position_1 = getClientPosition(event);
    if (!position_1) return console.error("No mouse or touch position detected");
    var clientX = position_1.clientX,
        clientY = position_1.clientY;
    var distanceX = clientX - this.lastMousePosition.clientX;
    var distanceY = clientY - this.lastMousePosition.clientY;
    var interval = now - this.velocityTime;
    var wrapperToWindowScaleX = 2 - wrapperComponent.offsetWidth / window.innerWidth;
    var wrapperToWindowScaleY = 2 - wrapperComponent.offsetHeight / window.innerHeight;
    var scaledX = 20 * Math.max(velocityMinSpeed, Math.min(2, wrapperToWindowScaleX));
    var scaledY = 20 * Math.max(velocityMinSpeed, Math.min(2, wrapperToWindowScaleY));
    var velocityX = distanceX / interval * velocitySensitivity * scale * scaledX;
    var velocityY = distanceY / interval * velocitySensitivity * scale * scaledY;
    var speed = distanceX * distanceX + distanceY * distanceY;
    var velocity_1 = Math.sqrt(speed) / interval * velocitySensitivity;
    if (this.velocity && velocity_1 < this.velocity.velocity && this.throttle) return;
    this.velocity = {
      velocityX: velocityX,
      velocityY: velocityY,
      velocity: velocity_1
    }; // throttling

    if (this.throttle) clearTimeout(this.throttle);
    this.throttle = setTimeout(function () {
      if (_this.mounted) _this.throttle = false;
    }, throttleTime);
  }

  var position = getClientPosition(event);
  this.lastMousePosition = position;
  this.velocityTime = now;
}

function getPosition(isLocked, target, step, panReturnStep, minBound, maxBound, limitToBounds, offset, startPosition, minTarget, maxTarget) {
  if (limitToBounds) {
    if (startPosition > minBound && offset > maxBound) {
      var newPosition = startPosition - (startPosition - maxBound) * panReturnStep;
      if (newPosition > maxTarget) return maxTarget;
      if (newPosition < maxBound) return maxBound;
      return newPosition;
    }

    if (startPosition < minBound && offset < minBound) {
      var newPosition = startPosition - (startPosition - minBound) * panReturnStep;
      if (newPosition < minTarget) return minTarget;
      if (newPosition > minBound) return minBound;
      return newPosition;
    }
  }

  if (isLocked) return startPosition;
  var offsetPosition = offset + target * step;
  return boundLimiter(offsetPosition, minBound, maxBound, limitToBounds);
} // We want to make event listeners non-passive, and to do so have to check


function makePassiveEventOption(passive) {
  return passive;
}

var propsList = ["previousScale", "scale", "positionX", "positionY", "defaultPositionX", "defaultPositionY", "defaultScale", "onWheelStart", "onWheel", "onWheelStop", "onPanningStart", "onPanning", "onPanningStop", "onPinchingStart", "onPinching", "onPinchingStop", "onZoomChange", "options", "wheel", "scalePadding", "pan", "pinch", "zoomIn", "zoomOut", "doubleClick", "reset"];

var getValidPropsFromObject = function getValidPropsFromObject(props) {
  return Object.keys(props).reduce(function (acc, key) {
    if (propsList.includes(key)) {
      acc[key] = props[key];
    }

    return acc;
  }, {});
};

var Context = /*#__PURE__*/React.createContext({});
var wheelStopEventTimer = null;
var wheelStopEventTime = 180;
var wheelAnimationTimer = null;
var wheelAnimationTime = 100;

var StateProvider = function (_super) {
  __extends(StateProvider, _super);

  function StateProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.mounted = true;
    _this.state = {
      wrapperComponent: undefined,
      contentComponent: undefined
    };
    _this.stateProvider = _assign(_assign(_assign(_assign({}, initialState), mergeProps(initialState, _this.props.dynamicValues)), _this.props.defaultValues), {
      previousScale: _this.props.dynamicValues.scale || _this.props.defaultValues.scale || initialState.scale
    });
    _this.windowToWrapperScaleX = 0;
    _this.windowToWrapperScaleY = 0; // panning helpers

    _this.startCoords = null;
    _this.isDown = false; // pinch helpers

    _this.pinchStartDistance = null;
    _this.lastDistance = null;
    _this.pinchStartScale = null;
    _this.distance = null;
    _this.bounds = null; // velocity helpers

    _this.velocityTime = null;
    _this.lastMousePosition = null;
    _this.velocity = null;
    _this.offsetX = null;
    _this.offsetY = null;
    _this.throttle = false; // wheel helpers

    _this.previousWheelEvent = null;
    _this.lastScale = null; // animations helpers

    _this.animate = null;
    _this.animation = null;
    _this.maxBounds = null; //////////
    // Wheel
    //////////

    _this.handleWheel = function (event) {
      var _a = _this.stateProvider,
          scale = _a.scale,
          _b = _a.wheel,
          disabled = _b.disabled,
          wheelEnabled = _b.wheelEnabled,
          touchPadEnabled = _b.touchPadEnabled;
      var _c = _this.props,
          onWheelStart = _c.onWheelStart,
          onWheel = _c.onWheel,
          onWheelStop = _c.onWheelStop;
      var _d = _this.state,
          wrapperComponent = _d.wrapperComponent,
          contentComponent = _d.contentComponent;
      if (_this.isDown || disabled || _this.stateProvider.options.disabled || !wrapperComponent || !contentComponent) return; // ctrlKey detects if touchpad execute wheel or pinch gesture

      if (!wheelEnabled && !event.ctrlKey) return;
      if (!touchPadEnabled && event.ctrlKey) return; // Wheel start event

      if (!wheelStopEventTimer) {
        _this.lastScale = scale;
        handleDisableAnimation.call(_this);
        handleCallback(onWheelStart, _this.getCallbackProps());
      } // Wheel event


      handleWheelZoom.call(_this, event);
      handleCallback(onWheel, _this.getCallbackProps());

      _this.applyTransformation(null, null, null);

      _this.previousWheelEvent = event; // Wheel stop event

      if (handleWheelStop(_this.previousWheelEvent, event, _this.stateProvider)) {
        clearTimeout(wheelStopEventTimer);
        wheelStopEventTimer = setTimeout(function () {
          if (!_this.mounted) return;
          handleCallback(onWheelStop, _this.getCallbackProps());
          wheelStopEventTimer = null;
        }, wheelStopEventTime);
      } // cancel animation


      _this.animate = false; // fire animation

      _this.lastScale = _this.stateProvider.scale;
      clearTimeout(wheelAnimationTimer);
      wheelAnimationTimer = setTimeout(function () {
        if (!_this.mounted) return;
        handlePaddingAnimation$1.call(_this, event);
      }, wheelAnimationTime);
    }; //////////
    // Panning
    //////////


    _this.checkPanningTarget = function (event) {
      var disableOnTarget = _this.stateProvider.pan.disableOnTarget;
      return disableOnTarget.map(function (tag) {
        return tag.toUpperCase();
      }).includes(event.target.tagName) || disableOnTarget.find(function (element) {
        return event.target.classList.value.includes(element);
      });
    };

    _this.checkIsPanningActive = function (event) {
      var disabled = _this.stateProvider.pan.disabled;
      var _a = _this.state,
          wrapperComponent = _a.wrapperComponent,
          contentComponent = _a.contentComponent;
      return !_this.isDown || disabled || _this.stateProvider.options.disabled || event.touches && (event.touches.length !== 1 || Math.abs(_this.startCoords.x - event.touches[0].clientX) < 1 || Math.abs(_this.startCoords.y - event.touches[0].clientY) < 1) || !wrapperComponent || !contentComponent;
    };

    _this.handleSetUpPanning = function (x, y) {
      var _a = _this.stateProvider,
          positionX = _a.positionX,
          positionY = _a.positionY;
      _this.isDown = true;
      _this.startCoords = {
        x: x - positionX,
        y: y - positionY
      };
      handleCallback(_this.props.onPanningStart, _this.getCallbackProps());
    };

    _this.handleStartPanning = function (event) {
      var _a = _this.stateProvider,
          wrapperComponent = _a.wrapperComponent,
          scale = _a.scale,
          _b = _a.options,
          minScale = _b.minScale,
          maxScale = _b.maxScale,
          limitToWrapper = _b.limitToWrapper,
          disabled = _a.pan.disabled;
      var target = event.target,
          touches = event.touches;
      if (disabled || _this.stateProvider.options.disabled || wrapperComponent && !wrapperComponent.contains(target) || _this.checkPanningTarget(event) || scale < minScale || scale > maxScale) return;
      handleDisableAnimation.call(_this);
      _this.bounds = handleCalculateBounds.call(_this, scale, limitToWrapper); // Mobile points

      if (touches && touches.length === 1) {
        _this.handleSetUpPanning(touches[0].clientX, touches[0].clientY);
      } // Desktop points


      if (!touches) {
        _this.handleSetUpPanning(event.clientX, event.clientY);
      }
    };

    _this.handlePanning = function (event) {
      if (_this.isDown) event.preventDefault();
      if (_this.checkIsPanningActive(event)) return;
      event.stopPropagation();
      calculateVelocityStart.call(_this, event);
      handlePanning.call(_this, event);
      handleCallback(_this.props.onPanning, _this.getCallbackProps());
    };

    _this.handleStopPanning = function () {
      if (_this.isDown) {
        _this.isDown = false;
        _this.animate = false;
        _this.animation = false;
        handleFireVelocity.call(_this);
        handleCallback(_this.props.onPanningStop, _this.getCallbackProps());
        var _a = _this.stateProvider,
            velocity = _a.pan.velocity,
            scale = _a.scale; // start velocity animation

        if (_this.velocity && velocity && scale > 1) {
          animateVelocity.call(_this);
        } else {
          // fire fit to bounds animation
          handlePanningAnimation.call(_this);
        }
      }
    }; //////////
    // Pinch
    //////////


    _this.handlePinchStart = function (event) {
      var scale = _this.stateProvider.scale;
      event.preventDefault();
      event.stopPropagation();
      handleDisableAnimation.call(_this);
      var distance = getDistance(event.touches[0], event.touches[1]);
      _this.pinchStartDistance = distance;
      _this.lastDistance = distance;
      _this.pinchStartScale = scale;
      _this.isDown = false;
      handleCallback(_this.props.onPinchingStart, _this.getCallbackProps());
    };

    _this.handlePinch = function (event) {
      _this.isDown = false;
      handleZoomPinch.call(_this, event);
      handleCallback(_this.props.onPinching, _this.getCallbackProps());
    };

    _this.handlePinchStop = function () {
      if (typeof _this.pinchStartScale === "number") {
        _this.isDown = false;
        _this.velocity = null;
        _this.lastDistance = null;
        _this.pinchStartScale = null;
        _this.pinchStartDistance = null;
        handlePaddingAnimation$1.call(_this);
        handleCallback(_this.props.onPinchingStop, _this.getCallbackProps());
      }
    }; //////////
    // Touch Events
    //////////


    _this.handleTouchStart = function (event) {
      var _a = _this.stateProvider,
          wrapperComponent = _a.wrapperComponent,
          contentComponent = _a.contentComponent,
          scale = _a.scale,
          _b = _a.options,
          disabled = _b.disabled,
          minScale = _b.minScale;
      var touches = event.touches;
      if (disabled || !wrapperComponent || !contentComponent || scale < minScale) return;
      handleDisableAnimation.call(_this);
      if (touches && touches.length === 1) return _this.handleStartPanning(event);
      if (touches && touches.length === 2) return _this.handlePinchStart(event);
    };

    _this.handleTouch = function (event) {
      var _a = _this.stateProvider,
          pan = _a.pan,
          pinch = _a.pinch,
          options = _a.options;
      if (options.disabled) return;
      if (!pan.disabled && event.touches.length === 1) return _this.handlePanning(event);
      if (!pinch.disabled && event.touches.length === 2) return _this.handlePinch(event);
    };

    _this.handleTouchStop = function () {
      _this.handleStopPanning();

      _this.handlePinchStop();
    }; //////////
    // Controls
    //////////


    _this.zoomIn = function (event) {
      var _a = _this.stateProvider,
          _b = _a.zoomIn,
          disabled = _b.disabled,
          step = _b.step,
          options = _a.options;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (!event) throw Error("Zoom in function requires event prop");
      if (disabled || options.disabled || !wrapperComponent || !contentComponent) return;
      handleZoomControls.call(_this, 1, step);
    };

    _this.zoomOut = function (event) {
      var _a = _this.stateProvider,
          _b = _a.zoomOut,
          disabled = _b.disabled,
          step = _b.step,
          options = _a.options;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (!event) throw Error("Zoom out function requires event prop");
      if (disabled || options.disabled || !wrapperComponent || !contentComponent) return;
      handleZoomControls.call(_this, -1, step);
    };

    _this.handleDbClick = function (event) {
      var _a = _this.stateProvider,
          options = _a.options,
          _b = _a.doubleClick,
          disabled = _b.disabled,
          step = _b.step;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (!event) throw Error("Double click function requires event prop");
      if (disabled || options.disabled || !wrapperComponent || !contentComponent) return;
      handleDoubleClick.call(_this, event, 1, step);
    };

    _this.setScale = function (newScale, speed, type) {
      if (speed === void 0) {
        speed = 200;
      }

      if (type === void 0) {
        type = "easeOut";
      }

      var _a = _this.stateProvider,
          positionX = _a.positionX,
          positionY = _a.positionY,
          scale = _a.scale,
          disabled = _a.options.disabled;
      var _b = _this.state,
          wrapperComponent = _b.wrapperComponent,
          contentComponent = _b.contentComponent;
      if (disabled || !wrapperComponent || !contentComponent) return;
      var targetState = {
        positionX: positionX,
        positionY: positionY,
        scale: isNaN(newScale) ? scale : newScale
      };
      animateComponent.call(_this, {
        targetState: targetState,
        speed: speed,
        type: type
      });
    };

    _this.setPositionX = function (newPosX, speed, type) {
      if (speed === void 0) {
        speed = 200;
      }

      if (type === void 0) {
        type = "easeOut";
      }

      var _a = _this.stateProvider,
          positionX = _a.positionX,
          positionY = _a.positionY,
          scale = _a.scale,
          _b = _a.options,
          disabled = _b.disabled,
          transformEnabled = _b.transformEnabled;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (disabled || !transformEnabled || !wrapperComponent || !contentComponent) return;
      var targetState = {
        positionX: isNaN(newPosX) ? positionX : newPosX,
        positionY: positionY,
        scale: scale
      };
      animateComponent.call(_this, {
        targetState: targetState,
        speed: speed,
        type: type
      });
    };

    _this.setPositionY = function (newPosY, speed, type) {
      if (speed === void 0) {
        speed = 200;
      }

      if (type === void 0) {
        type = "easeOut";
      }

      var _a = _this.stateProvider,
          positionX = _a.positionX,
          scale = _a.scale,
          positionY = _a.positionY,
          _b = _a.options,
          disabled = _b.disabled,
          transformEnabled = _b.transformEnabled;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (disabled || !transformEnabled || !wrapperComponent || !contentComponent) return;
      var targetState = {
        positionX: positionX,
        positionY: isNaN(newPosY) ? positionY : newPosY,
        scale: scale
      };
      animateComponent.call(_this, {
        targetState: targetState,
        speed: speed,
        type: type
      });
    };

    _this.setTransform = function (newPosX, newPosY, newScale, speed, type) {
      if (speed === void 0) {
        speed = 200;
      }

      if (type === void 0) {
        type = "easeOut";
      }

      var _a = _this.stateProvider,
          positionX = _a.positionX,
          positionY = _a.positionY,
          scale = _a.scale,
          _b = _a.options,
          disabled = _b.disabled,
          transformEnabled = _b.transformEnabled;
      var _c = _this.state,
          wrapperComponent = _c.wrapperComponent,
          contentComponent = _c.contentComponent;
      if (disabled || !transformEnabled || !wrapperComponent || !contentComponent) return;
      var targetState = {
        positionX: isNaN(newPosX) ? positionX : newPosX,
        positionY: isNaN(newPosY) ? positionY : newPosY,
        scale: isNaN(newScale) ? scale : newScale
      };
      animateComponent.call(_this, {
        targetState: targetState,
        speed: speed,
        type: type
      });
    };

    _this.resetTransform = function () {
      var _a = _this.stateProvider.options,
          disabled = _a.disabled,
          transformEnabled = _a.transformEnabled;
      if (disabled || !transformEnabled) return;
      resetTransformations.call(_this);
    };

    _this.setDefaultState = function () {
      _this.animation = null;
      _this.stateProvider = _assign(_assign(_assign({}, _this.stateProvider), {
        scale: initialState.scale,
        positionX: initialState.positionX,
        positionY: initialState.positionY
      }), _this.props.defaultValues);

      _this.forceUpdate();
    }; //////////
    // Setters
    //////////


    _this.setWrapperComponent = function (wrapperComponent) {
      _this.setState({
        wrapperComponent: wrapperComponent
      });
    };

    _this.setContentComponent = function (contentComponent) {
      _this.setState({
        contentComponent: contentComponent
      }, function () {
        var _a = _this.stateProvider,
            wrapperComponent = _a.wrapperComponent,
            _b = _a.options,
            centerContent = _b.centerContent,
            limitToBounds = _b.limitToBounds,
            limitToWrapper = _b.limitToWrapper,
            scale = _a.scale;
        var _c = _this.props.defaultValues,
            positionX = _c.positionX,
            positionY = _c.positionY;

        if (limitToBounds && !limitToWrapper || centerContent && !positionX && !positionY) {
          var transform = "translate(25%, 25%) scale(" + scale + ")";
          contentComponent.style.transform = transform;
          contentComponent.style.WebkitTransform = transform; // force update to inject state to the context

          _this.forceUpdate();

          var startTime_1 = new Date().getTime();
          var maxTimeWait_1 = 2000;
          var interval_1 = setInterval(function () {
            if (wrapperComponent.offsetWidth) {
              var bounds = handleCalculateBounds.call(_this, scale, false);
              _this.stateProvider.positionX = bounds.minPositionX;
              _this.stateProvider.positionY = bounds.minPositionY;

              _this.applyTransformation(null, null, null);

              clearInterval(interval_1);
              interval_1 = null;
            } else if (new Date().getTime() - startTime_1 > maxTimeWait_1) {
              clearInterval(interval_1);
              interval_1 = null;
            }
          }, 20);
        } else {
          _this.applyTransformation(null, null, null);
        }
      });
    };

    _this.applyTransformation = function (newScale, posX, posY) {
      if (!_this.mounted) return;
      var contentComponent = _this.state.contentComponent;
      var onZoomChange = _this.props.onZoomChange;
      var _a = _this.stateProvider,
          previousScale = _a.previousScale,
          scale = _a.scale,
          positionX = _a.positionX,
          positionY = _a.positionY;
      if (!contentComponent) return console.error("There is no content component");
      var transform = "translate(" + (posX || positionX) + "px, " + (posY || positionY) + "px) scale(" + (newScale || scale) + ")";
      contentComponent.style.transform = transform;
      contentComponent.style.WebkitTransform = transform; // force update to inject state to the context

      _this.forceUpdate();

      if (onZoomChange && previousScale !== scale) {
        handleCallback(onZoomChange, _this.getCallbackProps());
      }
    }; //////////
    // Props
    //////////


    _this.getCallbackProps = function () {
      return getValidPropsFromObject(_this.stateProvider);
    };

    return _this;
  }

  StateProvider.prototype.componentDidMount = function () {
    var passiveOption = makePassiveEventOption(false); // Panning on window to allow panning when mouse is out of wrapper

    window.addEventListener("mousedown", this.handleStartPanning, passiveOption);
    window.addEventListener("mousemove", this.handlePanning, passiveOption);
    window.addEventListener("mouseup", this.handleStopPanning, passiveOption);
  };

  StateProvider.prototype.componentWillUnmount = function () {
    var passiveOption = makePassiveEventOption(false);
    window.removeEventListener("mousedown", this.handleStartPanning, passiveOption);
    window.removeEventListener("mousemove", this.handlePanning, passiveOption);
    window.removeEventListener("mouseup", this.handleStopPanning, passiveOption);
    handleDisableAnimation.call(this);
  };

  StateProvider.prototype.componentDidUpdate = function (oldProps, oldState) {
    var _a = this.state,
        wrapperComponent = _a.wrapperComponent,
        contentComponent = _a.contentComponent;
    var dynamicValues = this.props.dynamicValues;

    if (!oldState.contentComponent && contentComponent) {
      this.stateProvider.contentComponent = contentComponent;
    }

    if (!oldState.wrapperComponent && wrapperComponent && wrapperComponent !== undefined) {
      this.stateProvider.wrapperComponent = wrapperComponent;
      this.windowToWrapperScaleX = getWindowScaleX(wrapperComponent);
      this.windowToWrapperScaleY = getWindowScaleY(wrapperComponent); // Zooming events on wrapper

      var passiveOption = makePassiveEventOption(false);
      wrapperComponent.addEventListener("wheel", this.handleWheel, passiveOption);
      wrapperComponent.addEventListener("dblclick", this.handleDbClick, passiveOption);
      wrapperComponent.addEventListener("touchstart", this.handleTouchStart, passiveOption);
      wrapperComponent.addEventListener("touchmove", this.handleTouch, passiveOption);
      wrapperComponent.addEventListener("touchend", this.handleTouchStop, passiveOption);
    } // set bound for animations


    if (wrapperComponent && contentComponent || oldProps.dynamicValues !== dynamicValues) {
      this.maxBounds = handleCalculateBounds.call(this, this.stateProvider.scale, this.stateProvider.options.limitToWrapper);
    } // must be at the end of the update function, updates


    if (oldProps.dynamicValues && oldProps.dynamicValues !== dynamicValues) {
      this.animation = null;
      this.stateProvider = _assign(_assign({}, this.stateProvider), mergeProps(this.stateProvider, dynamicValues));
      this.applyTransformation(null, null, null);
    }
  };

  StateProvider.prototype.render = function () {
    var _a = this.state,
        wrapperComponent = _a.wrapperComponent,
        contentComponent = _a.contentComponent;
    /**
     * Context provider value
     */

    var value = {
      loaded: Boolean(wrapperComponent && contentComponent),
      state: this.getCallbackProps(),
      dispatch: {
        setScale: this.setScale,
        setPositionX: this.setPositionX,
        setPositionY: this.setPositionY,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        setTransform: this.setTransform,
        resetTransform: this.resetTransform,
        setDefaultState: this.setDefaultState
      },
      nodes: {
        setWrapperComponent: this.setWrapperComponent,
        setContentComponent: this.setContentComponent
      }
    };
    var children = this.props.children;
    var content = typeof children === "function" ? children(_assign(_assign({}, value.state), value.dispatch)) : children;
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, content);
  };

  return StateProvider;
}(Component);

var TransformWrapper = function TransformWrapper(_a) {
  var children = _a.children,
      defaultPositionX = _a.defaultPositionX,
      defaultPositionY = _a.defaultPositionY,
      defaultScale = _a.defaultScale,
      onWheelStart = _a.onWheelStart,
      onWheel = _a.onWheel,
      onWheelStop = _a.onWheelStop,
      onPanningStart = _a.onPanningStart,
      onPanning = _a.onPanning,
      onPanningStop = _a.onPanningStop,
      onPinchingStart = _a.onPinchingStart,
      onPinching = _a.onPinching,
      onPinchingStop = _a.onPinchingStop,
      onZoomChange = _a.onZoomChange,
      rest = __rest(_a, ["children", "defaultPositionX", "defaultPositionY", "defaultScale", "onWheelStart", "onWheel", "onWheelStop", "onPanningStart", "onPanning", "onPanningStop", "onPinchingStart", "onPinching", "onPinchingStop", "onZoomChange"]);

  var props = _assign({}, rest);

  if (props.options && props.options.limitToWrapper) {
    props.options.limitToBounds = true;
  }

  return /*#__PURE__*/React.createElement(StateProvider, {
    defaultValues: deleteUndefinedProps({
      positionX: defaultPositionX,
      positionY: defaultPositionY,
      scale: defaultScale
    }),
    dynamicValues: deleteUndefinedProps(getValidPropsFromObject(props)),
    onWheelStart: onWheelStart,
    onWheel: onWheel,
    onWheelStop: onWheelStop,
    onPanningStart: onPanningStart,
    onPanning: onPanning,
    onPanningStop: onPanningStop,
    onPinchingStart: onPinchingStart,
    onPinching: onPinching,
    onPinchingStop: onPinchingStop,
    onZoomChange: onZoomChange
  }, children);
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".TransformComponent-module_container__3NwNd {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.TransformComponent-module_content__TZU5O {\n  display: flex;\n  flex-wrap: wrap;\n  width: fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.TransformComponent-module_content__TZU5O img {\n  pointer-events: none;\n}\n";
var styles$a = {
  "container": "TransformComponent-module_container__3NwNd",
  "content": "TransformComponent-module_content__TZU5O"
};
styleInject(css);

var TransformComponent = function (_super) {
  __extends(TransformComponent, _super);

  function TransformComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.contentRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  TransformComponent.prototype.componentDidMount = function () {
    var nodes = this.context.nodes;
    nodes.setWrapperComponent(this.wrapperRef.current);
    nodes.setContentComponent(this.contentRef.current);
  };

  TransformComponent.prototype.render = function () {
    var children = this.props.children;
    var _a = this.context.state,
        positionX = _a.positionX,
        positionY = _a.positionY,
        scale = _a.scale,
        _b = _a.options,
        wrapperClass = _b.wrapperClass,
        contentClass = _b.contentClass;
    var style = {
      WebkitTransform: "translate(" + positionX + "px, " + positionY + "px) scale(" + scale + ")",
      transform: "translate(" + positionX + "px, " + positionY + "px) scale(" + scale + ")"
    };
    return /*#__PURE__*/React.createElement("div", {
      ref: this.wrapperRef,
      className: "react-transform-component " + styles$a.container + " " + wrapperClass
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.contentRef,
      className: "react-transform-element " + styles$a.content + " " + contentClass,
      style: style
    }, children));
  };

  return TransformComponent;
}(React.Component);

TransformComponent.contextType = Context;

var _excluded$6 = ["disabled", "disablePan", "noCenter", "limitToBounds", "resetOnDoubleClick", "onZoomChange", "onLoad"];

function ZoomableImage(_ref) {
  var disabled = _ref.disabled,
      disablePan = _ref.disablePan,
      noCenter = _ref.noCenter,
      limitToBounds = _ref.limitToBounds,
      resetOnDoubleClick = _ref.resetOnDoubleClick,
      onZoomChange = _ref.onZoomChange;
      _ref.onLoad;
      var imageProps = _objectWithoutProperties$1(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement(TransformWrapper, {
    options: {
      disabled: disabled,
      centerContent: !noCenter,
      wrapperClass: styles$b.wrapper,
      contentClass: styles$b.content,
      limitToBounds: limitToBounds
    },
    pan: {
      disabled: disablePan
    },
    doubleClick: resetOnDoubleClick ? {
      mode: "reset"
    } : {
      disabled: true
    },
    onZoomChange: onZoomChange
  }, /*#__PURE__*/React.createElement(TransformComponent, null, /*#__PURE__*/React.createElement(Img, imageProps)));
}
ZoomableImage.defaultProps = {
  limitToBounds: true
};

var urlJoin = {exports: {}};

(function (module) {
  (function (name, context, definition) {
    if (module.exports) module.exports = definition();else context[name] = definition();
  })('urljoin', commonjsGlobal, function () {
    function normalize(strArray) {
      var resultArray = [];

      if (strArray.length === 0) {
        return '';
      }

      if (typeof strArray[0] !== 'string') {
        throw new TypeError('Url must be a string. Received ' + strArray[0]);
      } // If the first part is a plain protocol, we combine it with the next part.


      if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
        var first = strArray.shift();
        strArray[0] = first + strArray[0];
      } // There must be two or three slashes in the file protocol, two slashes in anything else.


      if (strArray[0].match(/^file:\/\/\//)) {
        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
      } else {
        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
      }

      for (var i = 0; i < strArray.length; i++) {
        var component = strArray[i];

        if (typeof component !== 'string') {
          throw new TypeError('Url must be a string. Received ' + component);
        }

        if (component === '') {
          continue;
        }

        if (i > 0) {
          // Removing the starting slashes for each component but the first.
          component = component.replace(/^[\/]+/, '');
        }

        if (i < strArray.length - 1) {
          // Removing the ending slashes for each component but the last.
          component = component.replace(/[\/]+$/, '');
        } else {
          // For the last component we will combine multiple slashes to a single one.
          component = component.replace(/[\/]+$/, '/');
        }

        resultArray.push(component);
      }

      var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
      // remove trailing slash before parameters or hash

      str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

      var parts = str.split('?');
      str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
      return str;
    }

    return function () {
      var input;

      if (_typeof(arguments[0]) === 'object') {
        input = arguments[0];
      } else {
        input = [].slice.call(arguments);
      }

      return normalize(input);
    };
  });
})(urlJoin);

var urljoin = urlJoin.exports;

function AppPhotos(_ref) {
  var sections = _ref.sections,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, sections.length === 0 ? /*#__PURE__*/React.createElement(NoPhotos, null) : /*#__PURE__*/React.createElement(PhotosIndex, {
    sections: sections,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "photo", ":defaultSectionId/:defaultPhotoId"),
    render: function render(props) {
      return /*#__PURE__*/React.createElement(PhotosDetails, {
        key: "".concat(props.match.params.section_id, "_").concat(props.match.params.photo_id),
        appUrl: appUrl,
        sections: sections
      });
    }
  }), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

function PhotosIndex(_ref2) {
  var sections = _ref2.sections,
      appUrl = _ref2.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-index-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-index"
  }, sections.map(function (section, section_id) {
    return /*#__PURE__*/React.createElement("div", {
      className: "AppPhotos-section",
      key: section_id
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppPhotos-section-name"
    }, section.name), /*#__PURE__*/React.createElement("div", {
      className: "AppPhotos-photogrid"
    }, section.photos.map(function (photo, photo_id) {
      return /*#__PURE__*/React.createElement(Link, {
        key: photo_id,
        to: urljoin(appUrl, "photo", "".concat(section_id, "/").concat(photo_id))
      }, /*#__PURE__*/React.createElement(PhotoGridThumbnail, {
        photo: photo
      }));
    })));
  })));
}

function NoPhotos() {
  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-no-photos"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-no-photos-title"
  }, "No Photos or Videos")));
}

function PhotoGridThumbnail(_ref3) {
  var photo = _ref3.photo;
  var video = photo.video,
      url = photo.url,
      thumbnail = photo.thumbnail;
  var src = video ? thumbnail : url;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-photogrid-thumb"
  }, /*#__PURE__*/React.createElement(Img, {
    src: src,
    className: "AppPhotos-photogrid-thumb-image"
  }), video ? /*#__PURE__*/React.createElement("i", {
    className: "AppPhotos-photogrid-thumb-play icon icon-play"
  }) : null);
}

function sectionsToList(sections) {
  var lst = [];
  sections.forEach(function (section, sectionId) {
    section.photos.forEach(function (photo, photoId) {
      lst.push("".concat(sectionId, "_").concat(photoId));
    });
  });
  return lst;
}

var PhotosDetails = withRouter(function PhotosDetails(_ref4) {
  var sections = _ref4.sections,
      appUrl = _ref4.appUrl,
      match = _ref4.match,
      history = _ref4.history;
  var _match$params = match.params,
      defaultSectionId = _match$params.defaultSectionId,
      defaultPhotoId = _match$params.defaultPhotoId;
  var photos = sectionsToList(sections);
  var defaultIndex = photos.indexOf("".concat(defaultSectionId, "_").concat(defaultPhotoId));

  var _useState = useState(defaultIndex),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isZoomed = _useState4[0],
      setIsZoomed = _useState4[1];

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray(_useMeasure, 2),
      screenRef = _useMeasure2[0],
      height = _useMeasure2[1].height;

  function slideHandler(newIndex) {
    var _photos$newIndex$spli = photos[newIndex].split("_"),
        _photos$newIndex$spli2 = _slicedToArray(_photos$newIndex$spli, 2),
        sectionId = _photos$newIndex$spli2[0],
        photoId = _photos$newIndex$spli2[1];

    history.replace(urljoin(appUrl, "photo", sectionId, photoId));
    setIndex(newIndex);
  }

  function zoomChangeHandler(isZoomedNew) {
    setIsZoomed(isZoomedNew);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-photo-details",
    ref: screenRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-photo-details-header"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppPhotos-photo-details-header-back-btn",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  }))), /*#__PURE__*/React.createElement(MediaSlider, {
    sections: sections,
    items: photos.map(function (photo, i) {
      var _photo$split = photo.split("_"),
          _photo$split2 = _slicedToArray(_photo$split, 2),
          sectionId = _photo$split2[0],
          photoId = _photo$split2[1];

      return /*#__PURE__*/React.createElement(Media, {
        key: photo,
        photo: sections[sectionId].photos[photoId],
        maxHeight: height,
        isActive: index === i,
        onZoomChange: zoomChangeHandler
      });
    }),
    disabled: isZoomed,
    defaultIndex: defaultIndex,
    onSlide: slideHandler
  }));
});

function Media(_ref5) {
  var photo = _ref5.photo,
      maxHeight = _ref5.maxHeight,
      isActive = _ref5.isActive,
      onZoomChange = _ref5.onZoomChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-photo-details-photo-wrapper"
  }, photo.video ? /*#__PURE__*/React.createElement(Video$1, {
    src: photo.url
  }) : /*#__PURE__*/React.createElement(Photo, {
    src: photo.url,
    isActive: isActive,
    maxHeight: maxHeight,
    onZoomChange: onZoomChange
  }), photo.date ? /*#__PURE__*/React.createElement("div", {
    className: "AppPhotos-photo-details-photo-info"
  }, photo.date) : null);
}

function Photo(_ref6) {
  var src = _ref6.src,
      maxHeight = _ref6.maxHeight,
      isActive = _ref6.isActive,
      onZoomChange = _ref6.onZoomChange;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isZoomed = _useState6[0],
      setIsZoomed = _useState6[1];

  function zoomChangeHandler(evt) {
    var isZoomedNow = evt.scale !== 1;

    if (isZoomedNow !== isZoomed) {
      setIsZoomed(isZoomedNow);
      onZoomChange && onZoomChange(isZoomedNow);
    }
  } // css max-height: 100% doesn't work on certain cases, for example when parent elements also have
  // max-size: 100%. To overcome this, we specify max-height in pixels (and object-fit: contain).


  return /*#__PURE__*/React.createElement(ZoomableImage, {
    key: src,
    disabled: !isActive,
    disablePan: !isZoomed,
    onZoomChange: zoomChangeHandler,
    className: "AppPhotos-photo-details-photo",
    src: src,
    style: {
      maxHeight: maxHeight
    },
    showSpinner: true
  });
}

function Video$1(_ref7) {
  var src = _ref7.src;
  return /*#__PURE__*/React.createElement("video", {
    className: "AppPhotos-photo-details-video",
    preload: "auto",
    controls: true,
    controlsList: "nodownload nofullscreen noremoteplayback",
    poster: "noposter",
    autoPlay: true
  }, /*#__PURE__*/React.createElement("source", {
    src: src,
    type: "video/mp4"
  }), "Your browser does not support the video tag.");
}

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */

function baseSum$1(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);

    if (current !== undefined) {
      result = result === undefined ? current : result + current;
    }
  }

  return result;
}

var _baseSum = baseSum$1;

var baseIteratee$1 = _baseIteratee,
    baseSum = _baseSum;
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */

function sumBy(array, iteratee) {
  return array && array.length ? baseSum(array, baseIteratee$1(iteratee)) : 0;
}

var sumBy_1 = sumBy;

var CONTACT_COLORS = ["#fe7312", "#D85395", "#DCE045", "#780E45", "#75A495", "#BBDA05", "#FFD7E2", "#FFEB4A", "#FF4DB9", "#F9B3EB"];
function ContactPhoto(_ref) {
  var contact = _ref.contact,
      className = _ref.className,
      size = _ref.size;
  size = size || 40;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("ContactPhoto", className),
    style: {
      width: size,
      height: size,
      fontSize: size / 2
    }
  }, contact.photo ? /*#__PURE__*/React.createElement("img", {
    src: contact.photo,
    alt: ""
  }) : /*#__PURE__*/React.createElement("div", {
    className: "ContactPhoto-icon icon-user",
    style: {
      backgroundColor: _contactColor(contact)
    }
  }));
}

function _contactColor(contact) {
  var num = sumBy_1(contact.name, function (_char) {
    return _char.charCodeAt(0);
  });
  return CONTACT_COLORS[num % CONTACT_COLORS.length];
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

function AppMessages(_ref) {
  var contacts = _ref.contacts,
      appTitle = _ref.appTitle,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  function imageClickHandler(src, text) {
    setImage({
      src: src,
      text: text
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "AppMessages"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(MessagesIndex$2, {
    contacts: contacts,
    appTitle: appTitle,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "contact", ":contact_id")
  }, /*#__PURE__*/React.createElement(Contact$1, {
    appUrl: appUrl,
    contacts: contacts,
    onImageClick: imageClickHandler
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))), image ? /*#__PURE__*/React.createElement(ImageView, {
    src: image.src,
    text: image.text,
    onClose: function onClose() {
      return setImage(null);
    }
  }) : null);
}

function MessagesIndex$2(_ref2) {
  var contacts = _ref2.contacts,
      appTitle = _ref2.appTitle,
      appUrl = _ref2.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index-header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index-title"
  }, appTitle || "Messages"), /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index-subtitle"
  }, "No unread messages"))), /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-index-contacts"
  }, contacts.map(function (contact, contact_id) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "AppMessages-index-contact-link",
      key: contact_id,
      to: urljoin(appUrl, "contact", contact_id.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact-icon-wrapper"
    }, /*#__PURE__*/React.createElement(ContactPhoto, {
      contact: contact
    })), /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact-name"
    }, contact.name || contact.number, /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact-date"
    }, last_1(contact.threads).date)), /*#__PURE__*/React.createElement("div", {
      className: "AppMessages-index-contact-last-message"
    }, limitString(last_1(last_1(contact.threads).messages).text, 40)))));
  }))));
}

function Contact$1(_ref3) {
  var contacts = _ref3.contacts,
      appUrl = _ref3.appUrl,
      onImageClick = _ref3.onImageClick;

  var _useParams = useParams(),
      contact_id = _useParams.contact_id;

  var contact = contacts[contact_id];
  var name = contact.name,
      number = contact.number,
      threads = contact.threads;
  var scroller = useRef();
  useEffect(function () {
    scroller.current.scrollTop = scroller.current.scrollHeight;
  }, []); // TODO: not always?

  return /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppMessages-contact-back-button",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  })), /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-details"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-details-name"
  }, name), number ? /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-details-phone"
  }, number) : null))), /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-messages-wrapper",
    ref: scroller
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-messages"
  }, threads.map(function (thread, i) {
    return /*#__PURE__*/React.createElement(Thread, {
      key: i,
      thread: thread,
      contact: contact,
      onImageClick: onImageClick
    });
  }))));
}

function Thread(_ref4) {
  var thread = _ref4.thread,
      contact = _ref4.contact,
      onImageClick = _ref4.onImageClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-thread"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-thread-date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-thread-date-value"
  }, thread.date)), thread.messages.map(function (msg, i) {
    return /*#__PURE__*/React.createElement(Message$2, {
      key: i,
      msg: msg,
      contact: contact,
      onImageClick: onImageClick
    });
  }));
}

function Message$2(_ref5) {
  var msg = _ref5.msg,
      contact = _ref5.contact,
      onImageClick = _ref5.onImageClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("AppMessages-contact-msg", msg.type)
  }, msg.type === "in" ? /*#__PURE__*/React.createElement(ContactPhoto, {
    className: "AppMessages-contact-from-photo",
    contact: contact,
    size: 30
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: classnames("AppMessages-contact-msg-content", {
      text: !!msg.text,
      image: !!msg.image,
      sticker: !!msg.sticker,
      deleted: !!msg.deleted,
      emoji: msg.text && isEmoji(msg.text)
    })
  }, /*#__PURE__*/React.createElement(MessageImage, {
    src: msg.image || msg.sticker,
    onClick: onImageClick
  }), msg.deleted ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "AppMessages-contect-msg-deleted-icon icon-no-sign"
  }), "You deleted this message") : /*#__PURE__*/React.createElement(MarkdownContent, {
    markdown: msg.text,
    className: "AppMessages-contact-msg-text"
  })), /*#__PURE__*/React.createElement("div", {
    className: "AppMessages-contact-msg-time"
  }, msg.time));
}

function MessageImage(_ref6) {
  var src = _ref6.src,
      _onClick = _ref6.onClick;

  if (!src) {
    return null;
  }

  return /*#__PURE__*/React.createElement("img", {
    className: "AppMessages-contact-msg-content-image",
    onClick: function onClick() {
      return _onClick(src);
    },
    src: src,
    alt: ""
  });
}

function ImageView(_ref7) {
  var src = _ref7.src;
      _ref7.text;
      var onClose = _ref7.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "ChatImageView"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ChatImageView-close icon-cancel",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(ZoomableImage, {
    src: src,
    className: "AppFolder-file-image",
    showSpinner: true
  }));
}

var styles$9 = {"root":"AppPhoneCalls-module_root__21H_H","header":"AppPhoneCalls-module_header__1SbW8","header__title":"AppPhoneCalls-module_header__title__1kGUS","footer":"AppPhoneCalls-module_footer__39FX-","footer__item":"AppPhoneCalls-module_footer__item__2-CLi","active":"AppPhoneCalls-module_active__N-2cK","history":"AppPhoneCalls-module_history__RFmYr","history__empty":"AppPhoneCalls-module_history__empty__2tWbT","history__segment":"AppPhoneCalls-module_history__segment__3ds64","history__segment__title":"AppPhoneCalls-module_history__segment__title__1_mGK","history__segment__calls":"AppPhoneCalls-module_history__segment__calls__18En-","call":"AppPhoneCalls-module_call__q7ZUw","call__data":"AppPhoneCalls-module_call__data__3Rc7q","call__iconWrapper":"AppPhoneCalls-module_call__iconWrapper__3t7ze","call__details":"AppPhoneCalls-module_call__details__2XJ6E","call__name":"AppPhoneCalls-module_call__name__31gRo","call__time":"AppPhoneCalls-module_call__time__3PqMB","call__recording":"AppPhoneCalls-module_call__recording__s59hk","call__recording__icon":"AppPhoneCalls-module_call__recording__icon__2JF6E","call__type":"AppPhoneCalls-module_call__type__33qGY","call__direction":"AppPhoneCalls-module_call__direction__3Tq3A","dialer":"AppPhoneCalls-module_dialer__1ZJkX","dialer__number":"AppPhoneCalls-module_dialer__number__2Cso4","dialer__pad":"AppPhoneCalls-module_dialer__pad__1L8Y6","dialer__pad__grid":"AppPhoneCalls-module_dialer__pad__grid__2VJeD","dialer__pad__key":"AppPhoneCalls-module_dialer__pad__key__38WlM","activeCall":"AppPhoneCalls-module_activeCall__1Tafv","activeCall__title":"AppPhoneCalls-module_activeCall__title__wpCMu","callButton":"AppPhoneCalls-module_callButton__2ZW8l","start":"AppPhoneCalls-module_start__1pcg5","end":"AppPhoneCalls-module_end__2kbdR"};

var PhoneStateContext = /*#__PURE__*/createContext(null);
function usePhoneState() {
  return useContext(PhoneStateContext);
}
var UiStateContext = /*#__PURE__*/createContext(null);
function useUiState() {
  return useContext(UiStateContext);
}

function ContactInfo(_ref) {
  var contact = _ref.contact,
      showFullInfo = _ref.showFullInfo,
      isOpen = _ref.isOpen;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("ContactInfo-info", {
      hidden: !isOpen
    })
  }, /*#__PURE__*/React.createElement(ContactDetails, {
    contact: contact,
    showFullInfo: showFullInfo
  }), /*#__PURE__*/React.createElement("div", {
    className: "ContactInfo-icons"
  }, /*#__PURE__*/React.createElement(CallButton$1, {
    contact: contact
  })));
}

function ContactDetails(_ref2) {
  var contact = _ref2.contact,
      showFullInfo = _ref2.showFullInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: "ContactInfo-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ContactInfo-details-item"
  }, contact.number), showFullInfo && contact.email ? /*#__PURE__*/React.createElement("div", {
    className: "ContactInfo-details-item"
  }, contact.email) : null);
}

function CallButton$1(_ref3) {
  var contact = _ref3.contact;
  var UiState = useUiState();

  if (!contact.number || contact.number.length <= 6) {
    return null;
  }

  function clickHandler() {
    if (!contact.callable) {
      UiState.showAlert("You can't call this number right now.");
      return;
    }

    var callConfirmProps = {};

    if (window.Android && window.Android.dialPhoneNumber) {
      callConfirmProps.onYes = function () {
        return dialPhoneNumberNative(UiState, contact.number);
      };
    } else {
      callConfirmProps.yesHref = getPhoneUrl(contact.number);
    }

    UiState.confirm(_objectSpread2({
      text: "This phone is offline. Want to call from your phone? Don't worry, this is part of the game 😎. Data rates may apply.",
      yesText: "Make the call",
      noText: "No"
    }, callConfirmProps));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "ContactInfo-icon call icon-phone",
    onClick: clickHandler
  });
}

function getPhoneUrl(phoneNumber) {
  return "tel:".concat(phoneNumber);
}

function dialPhoneNumberNative(UiState, phoneNumber) {
  var result = undefined;

  try {
    result = window.Android.dialPhoneNumber(getPhoneUrl(phoneNumber));
  } catch (e) {
    result = false;
  }

  if (result === false) {
    UiState.showAlert("Could not make the phone call. Please use a phone to dial **".concat(phoneNumber, "**"));
  }
}

var styles$8 = {"clickable":"Clickable-module_clickable__3ttO_"};

var _excluded$5 = ["onClick", "className", "children"];
var MIN_CLICK_INTERVAL_MS = 80; // should be longer than the duration between onTouchEnd and onClick

/**
 * A component for treating touch events as clicks, for two reasons:
 * 1. Reduce the delay until onClick is fired on touch devices.
 * 2. Prevent onClick misfire on some cases, for example after a swipe.
 */

function Clickable(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties$1(_ref, _excluded$5);

  var root = useRef();
  var lastClickTime = useRef(0); // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent#event_order
  // event fire order:
  // - touchstart
  // - touchend
  // - (mouse events)
  // - click

  function touchEndHandler(evt) {
    // Prevent the following click event
    evt.preventDefault(); // In case the user holds the element

    lastClickTime.current = nowMs();
  }

  function clickHandler(evt) {
    evt.preventDefault(); // if there was a recent touch, ignore this click event

    var now = nowMs();

    if (now - lastClickTime.current > MIN_CLICK_INTERVAL_MS) {
      lastClickTime.current = now;
      onClick(evt);
    }
  }

  useEffect(function () {
    // In React 17, onTouchStart registers a passive event, which does not support preventDefault.
    // See: https://github.com/facebook/react/issues/8968#issuecomment-690139615
    function touchStartHandler(evt) {
      evt.preventDefault();
      onClick(evt);
      lastClickTime.current = nowMs();
    }

    var element = root.current;
    element.addEventListener("touchstart", touchStartHandler);
    return function () {
      return element.removeEventListener("touchstart", touchStartHandler);
    };
  }, [onClick]);
  return /*#__PURE__*/React.createElement("div", _extends$2({
    ref: root,
    className: classnames(styles$8.clickable, className),
    onClick: onClick ? clickHandler : undefined,
    onTouchEnd: onClick ? touchEndHandler : undefined
  }, props), children);
}

function nowMs() {
  return performance && performance.now ? performance.now() : Date.now();
}

var FADE_OUT_DURATION_MS = 2000;
function SoundPlayer(_ref) {
  var src = _ref.src,
      volume = _ref.volume,
      className = _ref.className,
      pauseMusic = _ref.pauseMusic,
      children = _ref.children;
  var phoneState = usePhoneState();
  var _state = {
    _sound: null,
    _playing: false
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      playing = _useState2[0],
      setPlaying = _useState2[1];

  function onStop() {
    pauseMusic && phoneState.resumeMusic();
  }

  useEffect(function () {
    if (_state._playing !== playing) {
      if (!playing && _state.sound) {
        _stopSound(_state._sound);

        onStop();
        _state._sound = null;
      }

      if (playing) {
        if (!_state._sound) {
          _state._sound = new Howl({
            src: [src],
            volume: volume || 1,
            onend: function onend() {
              onStop();
              setPlaying(false);
            }
          });
        }

        _state._sound.play();

        pauseMusic && phoneState.pauseMusic();
      }

      _state._playing = playing;
    }

    return function () {
      if (_state._sound) {
        _stopSound(_state._sound);

        onStop();
      }
    };
  });

  function clickHandler(evt) {
    evt.stopPropagation();
    setPlaying(!playing);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("SoundPlayer", className, {
      playing: playing
    }),
    onClick: clickHandler
  }, children);
}

function _stopSound(sound, fadeOutDuration) {
  if (fadeOutDuration) {
    sound.fade(sound.volume(), 0, FADE_OUT_DURATION_MS);
    setTimeout(function () {
      return sound.stop();
    }, FADE_OUT_DURATION_MS);
  } else {
    sound.stop();
  }
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax$1 = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */

function baseRange$1(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$1(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }

  return result;
}

var _baseRange = baseRange$1;

var eq$1 = eq_1,
    isArrayLike$4 = isArrayLike_1,
    isIndex$1 = _isIndex,
    isObject$4 = isObject_1;
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */

function isIterateeCall$2(value, index, object) {
  if (!isObject$4(object)) {
    return false;
  }

  var type = _typeof(index);

  if (type == 'number' ? isArrayLike$4(object) && isIndex$1(index, object.length) : type == 'string' && index in object) {
    return eq$1(object[index], value);
  }

  return false;
}

var _isIterateeCall = isIterateeCall$2;

var baseRange = _baseRange,
    isIterateeCall$1 = _isIterateeCall,
    toFinite = toFinite_1;
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */

function createRange$1(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall$1(start, end, step)) {
      end = step = undefined;
    } // Ensure the sign of `-0` is preserved.


    start = toFinite(start);

    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }

    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange$1;

var createRange = _createRange;
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */

var range = createRange();
var range_1 = range;

function AppPhoneCalls(_ref) {
  var calls = _ref.calls,
      dialer = _ref.dialer;
  var State = useAppStore();
  var currentScreen = State.currentScreen;
  var showFooter = !!dialer;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialing = _useState2[0],
      setDialing = _useState2[1];

  function dialHandler(number) {
    var _dialer$number;

    setDialing({
      number: number,
      audioUrl: ((_dialer$number = dialer[number]) === null || _dialer$number === void 0 ? void 0 : _dialer$number.audioUrl) || "noAnswer"
    });
  }

  function callEndedHandler() {
    setDialing(null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.root
  }, /*#__PURE__*/React.createElement(Header$2, null), currentScreen === "history" ? /*#__PURE__*/React.createElement(CallHistory, {
    calls: calls
  }) : currentScreen === "dialer" ? /*#__PURE__*/React.createElement(Dialer, {
    numbers: dialer,
    onDial: dialHandler
  }) : null, showFooter ? /*#__PURE__*/React.createElement(Footer, {
    items: [{
      name: "dialer",
      title: "Dial Pad"
    }, {
      name: "history",
      title: "Recents"
    }],
    activeItem: currentScreen,
    onNavigate: function onNavigate(to) {
      return State.setCurrentScreen(to);
    }
  }) : null, dialing ? /*#__PURE__*/React.createElement(ActiveCall, {
    number: dialing.number,
    audioUrl: dialing.audioUrl,
    onEnded: callEndedHandler
  }) : null);
}

var AppPhoneCalls$1 = observer(AppPhoneCalls);

function Header$2() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.header
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$9.header__title
  }, "Phone")));
}

function Footer(_ref2) {
  var items = _ref2.items,
      activeItem = _ref2.activeItem,
      onNavigate = _ref2.onNavigate;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.footer
  }, items.map(function (_ref3) {
    var name = _ref3.name,
        title = _ref3.title;
    return /*#__PURE__*/React.createElement("div", {
      key: name,
      className: classnames(styles$9.footer__item, activeItem === name ? styles$9.active : null),
      onClick: function onClick() {
        return onNavigate(name);
      }
    }, title);
  }));
}

function ActiveCall(_ref4) {
  var number = _ref4.number,
      audioUrl = _ref4.audioUrl,
      onEnded = _ref4.onEnded;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ending = _useState4[0],
      setEnding = _useState4[1];

  var _useState5 = useState("Dialing..."),
      _useState6 = _slicedToArray(_useState5, 2),
      status = _useState6[0],
      setStatus = _useState6[1];

  var audioRef = useRef();
  var dialToneRef = useRef(new Howl({
    src: [dialTone],
    loop: true,
    volume: 0.8
  }));
  var noAnswer = audioUrl === "noAnswer";
  useEffect(function () {
    if (ending) {
      dialToneRef.current && dialToneRef.current.stop();
      audioRef.current && audioRef.current.stop();
      var timeout = setTimeout(onEnded, 2000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [ending, onEnded]);
  useEffect(function () {
    dialToneRef.current.play();

    if (!noAnswer) {
      audioRef.current = new Howl({
        src: [audioUrl],
        volume: 1,
        onend: function onend() {
          setStatus("Call ended");
          setEnding(true);
        }
      });
    }

    var timeout = setTimeout(function () {
      dialToneRef.current.stop();

      if (noAnswer) {
        setStatus("No answer");
        setEnding(true);
      } else {
        audioRef.current.play();
        setStatus("Call in progress");
      }
    }, 7000);
    return function () {
      clearTimeout(timeout);
      audioRef.current && audioRef.current.stop();
    };
  }, [noAnswer, audioUrl]);

  function endHandler() {
    if (!ending) {
      setStatus("Call ended");
      setEnding(true);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.activeCall
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.activeCall__status
  }, status), /*#__PURE__*/React.createElement("div", {
    className: styles$9.activeCall__title
  }, number), /*#__PURE__*/React.createElement(CallButton, {
    type: "end",
    onClick: endHandler
  }));
}

var Dialer = observer(function Dialer(_ref5) {
  var onDial = _ref5.onDial;
  var State = useAppStore();
  var dialerNumber = State.dialerNumber;

  function addDigit(digit) {
    State.setDialerNumber(dialerNumber + digit);
  }

  function removeDigit() {
    if (dialerNumber.length > 0) {
      State.setDialerNumber(dialerNumber.slice(0, -1));
    }
  }

  function dialClickHandler() {
    if (dialerNumber.length > 0) {
      onDial(dialerNumber);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.dialer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.dialer__number
  }, dialerNumber), /*#__PURE__*/React.createElement("div", {
    className: styles$9.dialer__pad
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.dialer__pad__grid
  }, range_1(1, 10).map(function (i) {
    return /*#__PURE__*/React.createElement(Clickable, {
      key: i,
      className: classnames(styles$9.dialer__pad__key, "i".concat(i)),
      onClick: function onClick() {
        return addDigit(i.toString());
      }
    }, i);
  }), /*#__PURE__*/React.createElement(Clickable, {
    className: classnames(styles$9.dialer__pad__key, styles$9.erase),
    onClick: removeDigit
  }, "⌫"), /*#__PURE__*/React.createElement(Clickable, {
    className: classnames(styles$9.dialer__pad__key, "i0"),
    onClick: function onClick(evt) {
      return addDigit("0");
    }
  }, "0"), /*#__PURE__*/React.createElement(Clickable, {
    className: classnames(styles$9.dialer__pad__key, "iplus"),
    onClick: function onClick(evt) {
      return addDigit("+");
    }
  }, "+"))), /*#__PURE__*/React.createElement(CallButton, {
    type: "start",
    onClick: dialClickHandler
  }));
});

function CallHistory(_ref6) {
  var calls = _ref6.calls;

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      openCall = _useState8[0],
      setOpenCall = _useState8[1];

  function handleToggle(callId) {
    setOpenCall(callId === openCall ? null : callId);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.history
  }, !calls || calls.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: styles$9.history__empty
  }, "No recent calls") : null, calls.map(function (segment, segment_id) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9.history__segment,
      key: segment_id
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$9.history__segment__title
    }, segment.date), /*#__PURE__*/React.createElement("div", {
      className: styles$9.history__segment__calls
    }, segment.calls.map(function (call, call_id) {
      return /*#__PURE__*/React.createElement(Call, {
        key: call_id,
        call: call,
        callId: "".concat(segment_id, "_").concat(call_id),
        isOpen: openCall === "".concat(segment_id, "_").concat(call_id),
        onToggle: handleToggle
      });
    })));
  }));
}

function Call(_ref7) {
  var call = _ref7.call,
      callId = _ref7.callId,
      isOpen = _ref7.isOpen,
      onToggle = _ref7.onToggle;
  var contact = call.contact;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.call
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__data,
    onClick: function onClick() {
      return onToggle(callId);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__iconWrapper
  }, /*#__PURE__*/React.createElement(ContactPhoto, {
    contact: contact
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__details
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__name
  }, contact.name || contact.number, call.recording ? /*#__PURE__*/React.createElement(CallRecording, {
    audioSrc: call.recording
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__type
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-phone"
  }), /*#__PURE__*/React.createElement("i", {
    className: classnames(styles$9.call__direction, call.direction === "in" ? "icon-left" : "icon-right")
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$9.call__time
  }, call.time))), /*#__PURE__*/React.createElement(ContactInfo, {
    contact: contact,
    isOpen: isOpen
  }));
}

function CallRecording(_ref8) {
  var audioSrc = _ref8.audioSrc;
  return /*#__PURE__*/React.createElement(SoundPlayer, {
    src: audioSrc,
    pauseMusic: true,
    className: styles$9.call__recording
  }, /*#__PURE__*/React.createElement("i", {
    className: classnames(styles$9.call__recording__icon, "icon-play")
  }), /*#__PURE__*/React.createElement("i", {
    className: classnames(styles$9.call__recording__icon, "icon-stop")
  }));
}

function CallButton(_ref9) {
  var type = _ref9.type,
      onClick = _ref9.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$9.callButton, styles$9[type], "icon-phone"),
    onClick: onClick
  });
}

var _Symbol$1 = _Symbol$6,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1;
/** Built-in value references. */

var spreadableSymbol = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */

function isFlattenable$1(value) {
  return isArray$6(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$1 = _arrayPush,
    isFlattenable = _isFlattenable;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}

var _baseFlatten = baseFlatten$2;

var baseEach$1 = _baseEach,
    isArrayLike$3 = isArrayLike_1;
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function baseMap$1(collection, iteratee) {
  var index = -1,
      result = isArrayLike$3(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$1;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);

  while (length--) {
    array[length] = array[length].value;
  }

  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */

function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);
    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }

    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }

  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */

function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);

    if (result) {
      if (index >= ordersLength) {
        return result;
      }

      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap$2 = _arrayMap,
    baseGet$1 = _baseGet,
    baseIteratee = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary$4 = _baseUnary,
    compareMultiple = _compareMultiple,
    identity$3 = identity_1,
    isArray$5 = isArray_1;
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */

function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$2(iteratees, function (iteratee) {
      if (isArray$5(iteratee)) {
        return function (value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }

      return iteratee;
    });
  } else {
    iteratees = [identity$3];
  }

  var index = -1;
  iteratees = arrayMap$2(iteratees, baseUnary$4(baseIteratee));
  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap$2(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });
  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest$2(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant$1;

var getNative = _getNative;

var defineProperty$2 = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty = defineProperty$2;

var constant = constant_1,
    defineProperty$1 = _defineProperty,
    identity$2 = identity_1;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString$1 = !defineProperty$1 ? identity$2 : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;

var identity$1 = identity_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest$2(func, start) {
  return setToString$1(overRest$1(func, start, identity$1), func + '');
}

var _baseRest = baseRest$2;

var baseFlatten$1 = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest$1 = _baseRest,
    isIterateeCall = _isIterateeCall;
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */

var sortBy = baseRest$1(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }

  var length = iteratees.length;

  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }

  return baseOrderBy(collection, baseFlatten$1(iteratees, 1), []);
});
var sortBy_1 = sortBy;

function AppContacts(_ref) {
  var contacts = _ref.contacts,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppContacts"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(ContactList, {
    contacts: contacts,
    appUrl: appUrl
  }))));
}

var ContactList = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ContactList, _React$Component);

  var _super = _createSuper(ContactList);

  function ContactList(props) {
    var _this;

    _classCallCheck$1(this, ContactList);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleContactToggle", function (contactId) {
      _this.setState({
        openContact: _this.state.openContact === contactId ? null : contactId
      });
    });

    _this.state = {
      openContact: null
    };
    return _this;
  }

  _createClass$1(ContactList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var contacts = this.props.contacts;
      var openContact = this.state.openContact;
      return /*#__PURE__*/React.createElement("div", {
        className: "AppContacts-list-scroller"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppContacts-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppContacts-list-header"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "AppContacts-list-title"
      }, "Contacts"))), /*#__PURE__*/React.createElement("div", {
        className: "AppContacts-list-segments"
      }, contacts.map(function (segment, segment_id) {
        return /*#__PURE__*/React.createElement("div", {
          className: "AppContacts-list-segment",
          key: segment_id
        }, /*#__PURE__*/React.createElement("div", {
          className: "AppContacts-list-segment-title"
        }, segment.name), /*#__PURE__*/React.createElement("div", {
          className: "AppContacts-list-segment-contacts"
        }, _sortContacts(segment.contacts, segment.sort).map(function (contact, contact_id) {
          return /*#__PURE__*/React.createElement(Contact, {
            key: contact_id,
            contact: contact,
            id: "".concat(segment_id, "_").concat(contact_id),
            isOpen: openContact === "".concat(segment_id, "_").concat(contact_id),
            onToggle: _this2.handleContactToggle
          });
        })));
      }))));
    }
  }]);

  return ContactList;
}(React.Component);

function Contact(_ref2) {
  var contact = _ref2.contact,
      id = _ref2.id,
      isOpen = _ref2.isOpen,
      onToggle = _ref2.onToggle;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact-data",
    onClick: function onClick() {
      return onToggle(id);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact-icon-wrapper"
  }, /*#__PURE__*/React.createElement(ContactPhoto, {
    contact: contact
  })), /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact-name"
  }, contact.name)), /*#__PURE__*/React.createElement("div", {
    className: "AppContacts-list-contact-expand-icon icon-dot-3"
  })), /*#__PURE__*/React.createElement(ContactInfo, {
    contact: contact,
    showFullInfo: true,
    isOpen: isOpen
  }));
}

function _sortContacts(contacts, shouldSort) {
  if (shouldSort === false) {
    // default is true
    return contacts;
  }

  return sortBy_1(contacts, "name");
}

function AppNotes(_ref) {
  var notes = _ref.notes,
      appTitle = _ref.appTitle,
      itemTitle = _ref.itemTitle,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppNotes"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(NotesIndex, {
    notes: notes,
    appTitle: appTitle,
    itemTitle: itemTitle,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "note", ":note_id")
  }, /*#__PURE__*/React.createElement(Note, {
    appUrl: appUrl,
    notes: notes
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

function NotesIndex(_ref2) {
  var notes = _ref2.notes,
      appTitle = _ref2.appTitle,
      itemTitle = _ref2.itemTitle,
      appUrl = _ref2.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index-header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index-title"
  }, appTitle || "Notes"), /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index-subtitle"
  }, "".concat(notes.length, " ").concat(itemTitle || "note").concat(pluralize(notes.length))))), /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-index-notes"
  }, notes.map(function (note, note_id) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "AppNotes-index-note-link",
      key: note_id,
      to: urljoin(appUrl, "note", note_id.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppNotes-index-note"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppNotes-index-note-contents"
    }, note.title ? /*#__PURE__*/React.createElement("div", {
      className: "AppNotes-index-note-title"
    }, note.title) : null, /*#__PURE__*/React.createElement(MarkdownContent, {
      className: "AppNotes-index-note-text",
      markdown: limitString(note.text.split("\n")[0], 50)
    }))));
  }))));
}

function Note(_ref3) {
  var notes = _ref3.notes,
      appUrl = _ref3.appUrl;

  var _useParams = useParams(),
      note_id = _useParams.note_id;

  var note = notes[note_id];
  var title = note.title,
      text = note.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-note"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-note-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppNotes-note-back-button",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-note-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNotes-note-title"
  }, title), /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "AppNotes-note-text",
    markdown: text
  })));
}

var _excluded$4 = ["className", "formClassName"];
// 1. enclosing in a <form> with autocomplete="off"
// 2. data-lpignore="true" to disable LastPass
// 3. autocomplete="new-password" (https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
// 4. adding "search" to the class name to make lastpass think it's a search field

function PasswordInput(_ref) {
  var className = _ref.className,
      formClassName = _ref.formClassName,
      props = _objectWithoutProperties$1(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    action: "#",
    className: formClassName,
    onSubmit: function onSubmit(evt) {
      return evt.preventDefault();
    },
    style: {
      display: "block",
      width: "100%",
      marginTop: 0
    }
  }, /*#__PURE__*/React.createElement("input", _extends$2({}, props, {
    className: classnames(className, "lastpass-fake-search"),
    type: "password",
    "data-lpignore": "true",
    autoComplete: "new-password"
  })));
}

var lunr$1 = {exports: {}};

/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

(function (module, exports) {

  (function () {
    /**
     * A convenience function for configuring and constructing
     * a new lunr Index.
     *
     * A lunr.Builder instance is created and the pipeline setup
     * with a trimmer, stop word filter and stemmer.
     *
     * This builder object is yielded to the configuration function
     * that is passed as a parameter, allowing the list of fields
     * and other builder parameters to be customised.
     *
     * All documents _must_ be added within the passed config function.
     *
     * @example
     * var idx = lunr(function () {
     *   this.field('title')
     *   this.field('body')
     *   this.ref('id')
     *
     *   documents.forEach(function (doc) {
     *     this.add(doc)
     *   }, this)
     * })
     *
     * @see {@link lunr.Builder}
     * @see {@link lunr.Pipeline}
     * @see {@link lunr.trimmer}
     * @see {@link lunr.stopWordFilter}
     * @see {@link lunr.stemmer}
     * @namespace {function} lunr
     */
    var lunr = function lunr(config) {
      var builder = new lunr.Builder();
      builder.pipeline.add(lunr.trimmer, lunr.stopWordFilter, lunr.stemmer);
      builder.searchPipeline.add(lunr.stemmer);
      config.call(builder, builder);
      return builder.build();
    };

    lunr.version = "2.3.9";
    /*!
     * lunr.utils
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * A namespace containing utils for the rest of the lunr library
     * @namespace lunr.utils
     */

    lunr.utils = {};
    /**
     * Print a warning message to the console.
     *
     * @param {String} message The message to be printed.
     * @memberOf lunr.utils
     * @function
     */

    lunr.utils.warn = function (global) {
      /* eslint-disable no-console */
      return function (message) {
        if (global.console && console.warn) {
          console.warn(message);
        }
      };
      /* eslint-enable no-console */
    }(this);
    /**
     * Convert an object to a string.
     *
     * In the case of `null` and `undefined` the function returns
     * the empty string, in all other cases the result of calling
     * `toString` on the passed object is returned.
     *
     * @param {Any} obj The object to convert to a string.
     * @return {String} string representation of the passed object.
     * @memberOf lunr.utils
     */


    lunr.utils.asString = function (obj) {
      if (obj === void 0 || obj === null) {
        return "";
      } else {
        return obj.toString();
      }
    };
    /**
     * Clones an object.
     *
     * Will create a copy of an existing object such that any mutations
     * on the copy cannot affect the original.
     *
     * Only shallow objects are supported, passing a nested object to this
     * function will cause a TypeError.
     *
     * Objects with primitives, and arrays of primitives are supported.
     *
     * @param {Object} obj The object to clone.
     * @return {Object} a clone of the passed object.
     * @throws {TypeError} when a nested object is passed.
     * @memberOf Utils
     */


    lunr.utils.clone = function (obj) {
      if (obj === null || obj === undefined) {
        return obj;
      }

      var clone = Object.create(null),
          keys = Object.keys(obj);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i],
            val = obj[key];

        if (Array.isArray(val)) {
          clone[key] = val.slice();
          continue;
        }

        if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
          clone[key] = val;
          continue;
        }

        throw new TypeError("clone is not deep and does not support nested objects");
      }

      return clone;
    };

    lunr.FieldRef = function (docRef, fieldName, stringValue) {
      this.docRef = docRef;
      this.fieldName = fieldName;
      this._stringValue = stringValue;
    };

    lunr.FieldRef.joiner = "/";

    lunr.FieldRef.fromString = function (s) {
      var n = s.indexOf(lunr.FieldRef.joiner);

      if (n === -1) {
        throw "malformed field ref string";
      }

      var fieldRef = s.slice(0, n),
          docRef = s.slice(n + 1);
      return new lunr.FieldRef(docRef, fieldRef, s);
    };

    lunr.FieldRef.prototype.toString = function () {
      if (this._stringValue == undefined) {
        this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef;
      }

      return this._stringValue;
    };
    /*!
     * lunr.Set
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * A lunr set.
     *
     * @constructor
     */


    lunr.Set = function (elements) {
      this.elements = Object.create(null);

      if (elements) {
        this.length = elements.length;

        for (var i = 0; i < this.length; i++) {
          this.elements[elements[i]] = true;
        }
      } else {
        this.length = 0;
      }
    };
    /**
     * A complete set that contains all elements.
     *
     * @static
     * @readonly
     * @type {lunr.Set}
     */


    lunr.Set.complete = {
      intersect: function intersect(other) {
        return other;
      },
      union: function union() {
        return this;
      },
      contains: function contains() {
        return true;
      }
    };
    /**
     * An empty set that contains no elements.
     *
     * @static
     * @readonly
     * @type {lunr.Set}
     */

    lunr.Set.empty = {
      intersect: function intersect() {
        return this;
      },
      union: function union(other) {
        return other;
      },
      contains: function contains() {
        return false;
      }
    };
    /**
     * Returns true if this set contains the specified object.
     *
     * @param {object} object - Object whose presence in this set is to be tested.
     * @returns {boolean} - True if this set contains the specified object.
     */

    lunr.Set.prototype.contains = function (object) {
      return !!this.elements[object];
    };
    /**
     * Returns a new set containing only the elements that are present in both
     * this set and the specified set.
     *
     * @param {lunr.Set} other - set to intersect with this set.
     * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
     */


    lunr.Set.prototype.intersect = function (other) {
      var a,
          b,
          elements,
          intersection = [];

      if (other === lunr.Set.complete) {
        return this;
      }

      if (other === lunr.Set.empty) {
        return other;
      }

      if (this.length < other.length) {
        a = this;
        b = other;
      } else {
        a = other;
        b = this;
      }

      elements = Object.keys(a.elements);

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        if (element in b.elements) {
          intersection.push(element);
        }
      }

      return new lunr.Set(intersection);
    };
    /**
     * Returns a new set combining the elements of this and the specified set.
     *
     * @param {lunr.Set} other - set to union with this set.
     * @return {lunr.Set} a new set that is the union of this and the specified set.
     */


    lunr.Set.prototype.union = function (other) {
      if (other === lunr.Set.complete) {
        return lunr.Set.complete;
      }

      if (other === lunr.Set.empty) {
        return this;
      }

      return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)));
    };
    /**
     * A function to calculate the inverse document frequency for
     * a posting. This is shared between the builder and the index
     *
     * @private
     * @param {object} posting - The posting for a given term
     * @param {number} documentCount - The total number of documents.
     */


    lunr.idf = function (posting, documentCount) {
      var documentsWithTerm = 0;

      for (var fieldName in posting) {
        if (fieldName == '_index') continue; // Ignore the term index, its not a field

        documentsWithTerm += Object.keys(posting[fieldName]).length;
      }

      var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
      return Math.log(1 + Math.abs(x));
    };
    /**
     * A token wraps a string representation of a token
     * as it is passed through the text processing pipeline.
     *
     * @constructor
     * @param {string} [str=''] - The string token being wrapped.
     * @param {object} [metadata={}] - Metadata associated with this token.
     */


    lunr.Token = function (str, metadata) {
      this.str = str || "";
      this.metadata = metadata || {};
    };
    /**
     * Returns the token string that is being wrapped by this object.
     *
     * @returns {string}
     */


    lunr.Token.prototype.toString = function () {
      return this.str;
    };
    /**
     * A token update function is used when updating or optionally
     * when cloning a token.
     *
     * @callback lunr.Token~updateFunction
     * @param {string} str - The string representation of the token.
     * @param {Object} metadata - All metadata associated with this token.
     */

    /**
     * Applies the given function to the wrapped string token.
     *
     * @example
     * token.update(function (str, metadata) {
     *   return str.toUpperCase()
     * })
     *
     * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
     * @returns {lunr.Token}
     */


    lunr.Token.prototype.update = function (fn) {
      this.str = fn(this.str, this.metadata);
      return this;
    };
    /**
     * Creates a clone of this token. Optionally a function can be
     * applied to the cloned token.
     *
     * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
     * @returns {lunr.Token}
     */


    lunr.Token.prototype.clone = function (fn) {
      fn = fn || function (s) {
        return s;
      };

      return new lunr.Token(fn(this.str, this.metadata), this.metadata);
    };
    /*!
     * lunr.tokenizer
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * A function for splitting a string into tokens ready to be inserted into
     * the search index. Uses `lunr.tokenizer.separator` to split strings, change
     * the value of this property to change how strings are split into tokens.
     *
     * This tokenizer will convert its parameter to a string by calling `toString` and
     * then will split this string on the character in `lunr.tokenizer.separator`.
     * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
     *
     * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
     * added as metadata to every token that is created from the object to be tokenized.
     *
     * @static
     * @param {?(string|object|object[])} obj - The object to convert into tokens
     * @param {?object} metadata - Optional metadata to associate with every token
     * @returns {lunr.Token[]}
     * @see {@link lunr.Pipeline}
     */


    lunr.tokenizer = function (obj, metadata) {
      if (obj == null || obj == undefined) {
        return [];
      }

      if (Array.isArray(obj)) {
        return obj.map(function (t) {
          return new lunr.Token(lunr.utils.asString(t).toLowerCase(), lunr.utils.clone(metadata));
        });
      }

      var str = obj.toString().toLowerCase(),
          len = str.length,
          tokens = [];

      for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        var _char = str.charAt(sliceEnd),
            sliceLength = sliceEnd - sliceStart;

        if (_char.match(lunr.tokenizer.separator) || sliceEnd == len) {
          if (sliceLength > 0) {
            var tokenMetadata = lunr.utils.clone(metadata) || {};
            tokenMetadata["position"] = [sliceStart, sliceLength];
            tokenMetadata["index"] = tokens.length;
            tokens.push(new lunr.Token(str.slice(sliceStart, sliceEnd), tokenMetadata));
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    };
    /**
     * The separator used to split a string into tokens. Override this property to change the behaviour of
     * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
     *
     * @static
     * @see lunr.tokenizer
     */


    lunr.tokenizer.separator = /[\s\-]+/;
    /*!
     * lunr.Pipeline
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * lunr.Pipelines maintain an ordered list of functions to be applied to all
     * tokens in documents entering the search index and queries being ran against
     * the index.
     *
     * An instance of lunr.Index created with the lunr shortcut will contain a
     * pipeline with a stop word filter and an English language stemmer. Extra
     * functions can be added before or after either of these functions or these
     * default functions can be removed.
     *
     * When run the pipeline will call each function in turn, passing a token, the
     * index of that token in the original list of all tokens and finally a list of
     * all the original tokens.
     *
     * The output of functions in the pipeline will be passed to the next function
     * in the pipeline. To exclude a token from entering the index the function
     * should return undefined, the rest of the pipeline will not be called with
     * this token.
     *
     * For serialisation of pipelines to work, all functions used in an instance of
     * a pipeline should be registered with lunr.Pipeline. Registered functions can
     * then be loaded. If trying to load a serialised pipeline that uses functions
     * that are not registered an error will be thrown.
     *
     * If not planning on serialising the pipeline then registering pipeline functions
     * is not necessary.
     *
     * @constructor
     */

    lunr.Pipeline = function () {
      this._stack = [];
    };

    lunr.Pipeline.registeredFunctions = Object.create(null);
    /**
     * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
     * string as well as all known metadata. A pipeline function can mutate the token string
     * or mutate (or add) metadata for a given token.
     *
     * A pipeline function can indicate that the passed token should be discarded by returning
     * null, undefined or an empty string. This token will not be passed to any downstream pipeline
     * functions and will not be added to the index.
     *
     * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
     * to any downstream pipeline functions and all will returned tokens will be added to the index.
     *
     * Any number of pipeline functions may be chained together using a lunr.Pipeline.
     *
     * @interface lunr.PipelineFunction
     * @param {lunr.Token} token - A token from the document being processed.
     * @param {number} i - The index of this token in the complete list of tokens for this document/field.
     * @param {lunr.Token[]} tokens - All tokens for this document/field.
     * @returns {(?lunr.Token|lunr.Token[])}
     */

    /**
     * Register a function with the pipeline.
     *
     * Functions that are used in the pipeline should be registered if the pipeline
     * needs to be serialised, or a serialised pipeline needs to be loaded.
     *
     * Registering a function does not add it to a pipeline, functions must still be
     * added to instances of the pipeline for them to be used when running a pipeline.
     *
     * @param {lunr.PipelineFunction} fn - The function to check for.
     * @param {String} label - The label to register this function with
     */

    lunr.Pipeline.registerFunction = function (fn, label) {
      if (label in this.registeredFunctions) {
        lunr.utils.warn('Overwriting existing registered function: ' + label);
      }

      fn.label = label;
      lunr.Pipeline.registeredFunctions[fn.label] = fn;
    };
    /**
     * Warns if the function is not registered as a Pipeline function.
     *
     * @param {lunr.PipelineFunction} fn - The function to check for.
     * @private
     */


    lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
      var isRegistered = fn.label && fn.label in this.registeredFunctions;

      if (!isRegistered) {
        lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn);
      }
    };
    /**
     * Loads a previously serialised pipeline.
     *
     * All functions to be loaded must already be registered with lunr.Pipeline.
     * If any function from the serialised data has not been registered then an
     * error will be thrown.
     *
     * @param {Object} serialised - The serialised pipeline to load.
     * @returns {lunr.Pipeline}
     */


    lunr.Pipeline.load = function (serialised) {
      var pipeline = new lunr.Pipeline();
      serialised.forEach(function (fnName) {
        var fn = lunr.Pipeline.registeredFunctions[fnName];

        if (fn) {
          pipeline.add(fn);
        } else {
          throw new Error('Cannot load unregistered function: ' + fnName);
        }
      });
      return pipeline;
    };
    /**
     * Adds new functions to the end of the pipeline.
     *
     * Logs a warning if the function has not been registered.
     *
     * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
     */


    lunr.Pipeline.prototype.add = function () {
      var fns = Array.prototype.slice.call(arguments);
      fns.forEach(function (fn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(fn);

        this._stack.push(fn);
      }, this);
    };
    /**
     * Adds a single function after a function that already exists in the
     * pipeline.
     *
     * Logs a warning if the function has not been registered.
     *
     * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
     * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
     */


    lunr.Pipeline.prototype.after = function (existingFn, newFn) {
      lunr.Pipeline.warnIfFunctionNotRegistered(newFn);

      var pos = this._stack.indexOf(existingFn);

      if (pos == -1) {
        throw new Error('Cannot find existingFn');
      }

      pos = pos + 1;

      this._stack.splice(pos, 0, newFn);
    };
    /**
     * Adds a single function before a function that already exists in the
     * pipeline.
     *
     * Logs a warning if the function has not been registered.
     *
     * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
     * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
     */


    lunr.Pipeline.prototype.before = function (existingFn, newFn) {
      lunr.Pipeline.warnIfFunctionNotRegistered(newFn);

      var pos = this._stack.indexOf(existingFn);

      if (pos == -1) {
        throw new Error('Cannot find existingFn');
      }

      this._stack.splice(pos, 0, newFn);
    };
    /**
     * Removes a function from the pipeline.
     *
     * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
     */


    lunr.Pipeline.prototype.remove = function (fn) {
      var pos = this._stack.indexOf(fn);

      if (pos == -1) {
        return;
      }

      this._stack.splice(pos, 1);
    };
    /**
     * Runs the current list of functions that make up the pipeline against the
     * passed tokens.
     *
     * @param {Array} tokens The tokens to run through the pipeline.
     * @returns {Array}
     */


    lunr.Pipeline.prototype.run = function (tokens) {
      var stackLength = this._stack.length;

      for (var i = 0; i < stackLength; i++) {
        var fn = this._stack[i];
        var memo = [];

        for (var j = 0; j < tokens.length; j++) {
          var result = fn(tokens[j], j, tokens);
          if (result === null || result === void 0 || result === '') continue;

          if (Array.isArray(result)) {
            for (var k = 0; k < result.length; k++) {
              memo.push(result[k]);
            }
          } else {
            memo.push(result);
          }
        }

        tokens = memo;
      }

      return tokens;
    };
    /**
     * Convenience method for passing a string through a pipeline and getting
     * strings out. This method takes care of wrapping the passed string in a
     * token and mapping the resulting tokens back to strings.
     *
     * @param {string} str - The string to pass through the pipeline.
     * @param {?object} metadata - Optional metadata to associate with the token
     * passed to the pipeline.
     * @returns {string[]}
     */


    lunr.Pipeline.prototype.runString = function (str, metadata) {
      var token = new lunr.Token(str, metadata);
      return this.run([token]).map(function (t) {
        return t.toString();
      });
    };
    /**
     * Resets the pipeline by removing any existing processors.
     *
     */


    lunr.Pipeline.prototype.reset = function () {
      this._stack = [];
    };
    /**
     * Returns a representation of the pipeline ready for serialisation.
     *
     * Logs a warning if the function has not been registered.
     *
     * @returns {Array}
     */


    lunr.Pipeline.prototype.toJSON = function () {
      return this._stack.map(function (fn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(fn);
        return fn.label;
      });
    };
    /*!
     * lunr.Vector
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * A vector is used to construct the vector space of documents and queries. These
     * vectors support operations to determine the similarity between two documents or
     * a document and a query.
     *
     * Normally no parameters are required for initializing a vector, but in the case of
     * loading a previously dumped vector the raw elements can be provided to the constructor.
     *
     * For performance reasons vectors are implemented with a flat array, where an elements
     * index is immediately followed by its value. E.g. [index, value, index, value]. This
     * allows the underlying array to be as sparse as possible and still offer decent
     * performance when being used for vector calculations.
     *
     * @constructor
     * @param {Number[]} [elements] - The flat list of element index and element value pairs.
     */


    lunr.Vector = function (elements) {
      this._magnitude = 0;
      this.elements = elements || [];
    };
    /**
     * Calculates the position within the vector to insert a given index.
     *
     * This is used internally by insert and upsert. If there are duplicate indexes then
     * the position is returned as if the value for that index were to be updated, but it
     * is the callers responsibility to check whether there is a duplicate at that index
     *
     * @param {Number} insertIdx - The index at which the element should be inserted.
     * @returns {Number}
     */


    lunr.Vector.prototype.positionForIndex = function (index) {
      // For an empty vector the tuple can be inserted at the beginning
      if (this.elements.length == 0) {
        return 0;
      }

      var start = 0,
          end = this.elements.length / 2,
          sliceLength = end - start,
          pivotPoint = Math.floor(sliceLength / 2),
          pivotIndex = this.elements[pivotPoint * 2];

      while (sliceLength > 1) {
        if (pivotIndex < index) {
          start = pivotPoint;
        }

        if (pivotIndex > index) {
          end = pivotPoint;
        }

        if (pivotIndex == index) {
          break;
        }

        sliceLength = end - start;
        pivotPoint = start + Math.floor(sliceLength / 2);
        pivotIndex = this.elements[pivotPoint * 2];
      }

      if (pivotIndex == index) {
        return pivotPoint * 2;
      }

      if (pivotIndex > index) {
        return pivotPoint * 2;
      }

      if (pivotIndex < index) {
        return (pivotPoint + 1) * 2;
      }
    };
    /**
     * Inserts an element at an index within the vector.
     *
     * Does not allow duplicates, will throw an error if there is already an entry
     * for this index.
     *
     * @param {Number} insertIdx - The index at which the element should be inserted.
     * @param {Number} val - The value to be inserted into the vector.
     */


    lunr.Vector.prototype.insert = function (insertIdx, val) {
      this.upsert(insertIdx, val, function () {
        throw "duplicate index";
      });
    };
    /**
     * Inserts or updates an existing index within the vector.
     *
     * @param {Number} insertIdx - The index at which the element should be inserted.
     * @param {Number} val - The value to be inserted into the vector.
     * @param {function} fn - A function that is called for updates, the existing value and the
     * requested value are passed as arguments
     */


    lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
      this._magnitude = 0;
      var position = this.positionForIndex(insertIdx);

      if (this.elements[position] == insertIdx) {
        this.elements[position + 1] = fn(this.elements[position + 1], val);
      } else {
        this.elements.splice(position, 0, insertIdx, val);
      }
    };
    /**
     * Calculates the magnitude of this vector.
     *
     * @returns {Number}
     */


    lunr.Vector.prototype.magnitude = function () {
      if (this._magnitude) return this._magnitude;
      var sumOfSquares = 0,
          elementsLength = this.elements.length;

      for (var i = 1; i < elementsLength; i += 2) {
        var val = this.elements[i];
        sumOfSquares += val * val;
      }

      return this._magnitude = Math.sqrt(sumOfSquares);
    };
    /**
     * Calculates the dot product of this vector and another vector.
     *
     * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
     * @returns {Number}
     */


    lunr.Vector.prototype.dot = function (otherVector) {
      var dotProduct = 0,
          a = this.elements,
          b = otherVector.elements,
          aLen = a.length,
          bLen = b.length,
          aVal = 0,
          bVal = 0,
          i = 0,
          j = 0;

      while (i < aLen && j < bLen) {
        aVal = a[i], bVal = b[j];

        if (aVal < bVal) {
          i += 2;
        } else if (aVal > bVal) {
          j += 2;
        } else if (aVal == bVal) {
          dotProduct += a[i + 1] * b[j + 1];
          i += 2;
          j += 2;
        }
      }

      return dotProduct;
    };
    /**
     * Calculates the similarity between this vector and another vector.
     *
     * @param {lunr.Vector} otherVector - The other vector to calculate the
     * similarity with.
     * @returns {Number}
     */


    lunr.Vector.prototype.similarity = function (otherVector) {
      return this.dot(otherVector) / this.magnitude() || 0;
    };
    /**
     * Converts the vector to an array of the elements within the vector.
     *
     * @returns {Number[]}
     */


    lunr.Vector.prototype.toArray = function () {
      var output = new Array(this.elements.length / 2);

      for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
        output[j] = this.elements[i];
      }

      return output;
    };
    /**
     * A JSON serializable representation of the vector.
     *
     * @returns {Number[]}
     */


    lunr.Vector.prototype.toJSON = function () {
      return this.elements;
    };
    /* eslint-disable */

    /*!
     * lunr.stemmer
     * Copyright (C) 2020 Oliver Nightingale
     * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
     */

    /**
     * lunr.stemmer is an english language stemmer, this is a JavaScript
     * implementation of the PorterStemmer taken from http://tartarus.org/~martin
     *
     * @static
     * @implements {lunr.PipelineFunction}
     * @param {lunr.Token} token - The string to stem
     * @returns {lunr.Token}
     * @see {@link lunr.Pipeline}
     * @function
     */


    lunr.stemmer = function () {
      var step2list = {
        "ational": "ate",
        "tional": "tion",
        "enci": "ence",
        "anci": "ance",
        "izer": "ize",
        "bli": "ble",
        "alli": "al",
        "entli": "ent",
        "eli": "e",
        "ousli": "ous",
        "ization": "ize",
        "ation": "ate",
        "ator": "ate",
        "alism": "al",
        "iveness": "ive",
        "fulness": "ful",
        "ousness": "ous",
        "aliti": "al",
        "iviti": "ive",
        "biliti": "ble",
        "logi": "log"
      },
          step3list = {
        "icate": "ic",
        "ative": "",
        "alize": "al",
        "iciti": "ic",
        "ical": "ic",
        "ful": "",
        "ness": ""
      },
          c = "[^aeiou]",
          // consonant
      v = "[aeiouy]",
          // vowel
      C = c + "[^aeiouy]*",
          // consonant sequence
      V = v + "[aeiou]*",
          // vowel sequence
      mgr0 = "^(" + C + ")?" + V + C,
          // [C]VC... is m>0
      meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",
          // [C]VC[V] is m=1
      mgr1 = "^(" + C + ")?" + V + C + V + C,
          // [C]VCVC... is m>1
      s_v = "^(" + C + ")?" + v; // vowel in stem

      var re_mgr0 = new RegExp(mgr0);
      var re_mgr1 = new RegExp(mgr1);
      var re_meq1 = new RegExp(meq1);
      var re_s_v = new RegExp(s_v);
      var re_1a = /^(.+?)(ss|i)es$/;
      var re2_1a = /^(.+?)([^s])s$/;
      var re_1b = /^(.+?)eed$/;
      var re2_1b = /^(.+?)(ed|ing)$/;
      var re_1b_2 = /.$/;
      var re2_1b_2 = /(at|bl|iz)$/;
      var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
      var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");
      var re_1c = /^(.+?[^aeiou])y$/;
      var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
      var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
      var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
      var re2_4 = /^(.+?)(s|t)(ion)$/;
      var re_5 = /^(.+?)e$/;
      var re_5_1 = /ll$/;
      var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

      var porterStemmer = function porterStemmer(w) {
        var stem, suffix, firstch, re, re2, re3, re4;

        if (w.length < 3) {
          return w;
        }

        firstch = w.substr(0, 1);

        if (firstch == "y") {
          w = firstch.toUpperCase() + w.substr(1);
        } // Step 1a


        re = re_1a;
        re2 = re2_1a;

        if (re.test(w)) {
          w = w.replace(re, "$1$2");
        } else if (re2.test(w)) {
          w = w.replace(re2, "$1$2");
        } // Step 1b


        re = re_1b;
        re2 = re2_1b;

        if (re.test(w)) {
          var fp = re.exec(w);
          re = re_mgr0;

          if (re.test(fp[1])) {
            re = re_1b_2;
            w = w.replace(re, "");
          }
        } else if (re2.test(w)) {
          var fp = re2.exec(w);
          stem = fp[1];
          re2 = re_s_v;

          if (re2.test(stem)) {
            w = stem;
            re2 = re2_1b_2;
            re3 = re3_1b_2;
            re4 = re4_1b_2;

            if (re2.test(w)) {
              w = w + "e";
            } else if (re3.test(w)) {
              re = re_1b_2;
              w = w.replace(re, "");
            } else if (re4.test(w)) {
              w = w + "e";
            }
          }
        } // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)


        re = re_1c;

        if (re.test(w)) {
          var fp = re.exec(w);
          stem = fp[1];
          w = stem + "i";
        } // Step 2


        re = re_2;

        if (re.test(w)) {
          var fp = re.exec(w);
          stem = fp[1];
          suffix = fp[2];
          re = re_mgr0;

          if (re.test(stem)) {
            w = stem + step2list[suffix];
          }
        } // Step 3


        re = re_3;

        if (re.test(w)) {
          var fp = re.exec(w);
          stem = fp[1];
          suffix = fp[2];
          re = re_mgr0;

          if (re.test(stem)) {
            w = stem + step3list[suffix];
          }
        } // Step 4


        re = re_4;
        re2 = re2_4;

        if (re.test(w)) {
          var fp = re.exec(w);
          stem = fp[1];
          re = re_mgr1;

          if (re.test(stem)) {
            w = stem;
          }
        } else if (re2.test(w)) {
          var fp = re2.exec(w);
          stem = fp[1] + fp[2];
          re2 = re_mgr1;

          if (re2.test(stem)) {
            w = stem;
          }
        } // Step 5


        re = re_5;

        if (re.test(w)) {
          var fp = re.exec(w);
          stem = fp[1];
          re = re_mgr1;
          re2 = re_meq1;
          re3 = re3_5;

          if (re.test(stem) || re2.test(stem) && !re3.test(stem)) {
            w = stem;
          }
        }

        re = re_5_1;
        re2 = re_mgr1;

        if (re.test(w) && re2.test(w)) {
          re = re_1b_2;
          w = w.replace(re, "");
        } // and turn initial Y back to y


        if (firstch == "y") {
          w = firstch.toLowerCase() + w.substr(1);
        }

        return w;
      };

      return function (token) {
        return token.update(porterStemmer);
      };
    }();

    lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer');
    /*!
     * lunr.stopWordFilter
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
     * list of stop words.
     *
     * The built in lunr.stopWordFilter is built using this generator and can be used
     * to generate custom stopWordFilters for applications or non English languages.
     *
     * @function
     * @param {Array} token The token to pass through the filter
     * @returns {lunr.PipelineFunction}
     * @see lunr.Pipeline
     * @see lunr.stopWordFilter
     */

    lunr.generateStopWordFilter = function (stopWords) {
      var words = stopWords.reduce(function (memo, stopWord) {
        memo[stopWord] = stopWord;
        return memo;
      }, {});
      return function (token) {
        if (token && words[token.toString()] !== token.toString()) return token;
      };
    };
    /**
     * lunr.stopWordFilter is an English language stop word list filter, any words
     * contained in the list will not be passed through the filter.
     *
     * This is intended to be used in the Pipeline. If the token does not pass the
     * filter then undefined will be returned.
     *
     * @function
     * @implements {lunr.PipelineFunction}
     * @params {lunr.Token} token - A token to check for being a stop word.
     * @returns {lunr.Token}
     * @see {@link lunr.Pipeline}
     */


    lunr.stopWordFilter = lunr.generateStopWordFilter(['a', 'able', 'about', 'across', 'after', 'all', 'almost', 'also', 'am', 'among', 'an', 'and', 'any', 'are', 'as', 'at', 'be', 'because', 'been', 'but', 'by', 'can', 'cannot', 'could', 'dear', 'did', 'do', 'does', 'either', 'else', 'ever', 'every', 'for', 'from', 'get', 'got', 'had', 'has', 'have', 'he', 'her', 'hers', 'him', 'his', 'how', 'however', 'i', 'if', 'in', 'into', 'is', 'it', 'its', 'just', 'least', 'let', 'like', 'likely', 'may', 'me', 'might', 'most', 'must', 'my', 'neither', 'no', 'nor', 'not', 'of', 'off', 'often', 'on', 'only', 'or', 'other', 'our', 'own', 'rather', 'said', 'say', 'says', 'she', 'should', 'since', 'so', 'some', 'than', 'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'tis', 'to', 'too', 'twas', 'us', 'wants', 'was', 'we', 'were', 'what', 'when', 'where', 'which', 'while', 'who', 'whom', 'why', 'will', 'with', 'would', 'yet', 'you', 'your']);
    lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');
    /*!
     * lunr.trimmer
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * lunr.trimmer is a pipeline function for trimming non word
     * characters from the beginning and end of tokens before they
     * enter the index.
     *
     * This implementation may not work correctly for non latin
     * characters and should either be removed or adapted for use
     * with languages with non-latin characters.
     *
     * @static
     * @implements {lunr.PipelineFunction}
     * @param {lunr.Token} token The token to pass through the filter
     * @returns {lunr.Token}
     * @see lunr.Pipeline
     */

    lunr.trimmer = function (token) {
      return token.update(function (s) {
        return s.replace(/^\W+/, '').replace(/\W+$/, '');
      });
    };

    lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer');
    /*!
     * lunr.TokenSet
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * A token set is used to store the unique list of all tokens
     * within an index. Token sets are also used to represent an
     * incoming query to the index, this query token set and index
     * token set are then intersected to find which tokens to look
     * up in the inverted index.
     *
     * A token set can hold multiple tokens, as in the case of the
     * index token set, or it can hold a single token as in the
     * case of a simple query token set.
     *
     * Additionally token sets are used to perform wildcard matching.
     * Leading, contained and trailing wildcards are supported, and
     * from this edit distance matching can also be provided.
     *
     * Token sets are implemented as a minimal finite state automata,
     * where both common prefixes and suffixes are shared between tokens.
     * This helps to reduce the space used for storing the token set.
     *
     * @constructor
     */

    lunr.TokenSet = function () {
      this["final"] = false;
      this.edges = {};
      this.id = lunr.TokenSet._nextId;
      lunr.TokenSet._nextId += 1;
    };
    /**
     * Keeps track of the next, auto increment, identifier to assign
     * to a new tokenSet.
     *
     * TokenSets require a unique identifier to be correctly minimised.
     *
     * @private
     */


    lunr.TokenSet._nextId = 1;
    /**
     * Creates a TokenSet instance from the given sorted array of words.
     *
     * @param {String[]} arr - A sorted array of strings to create the set from.
     * @returns {lunr.TokenSet}
     * @throws Will throw an error if the input array is not sorted.
     */

    lunr.TokenSet.fromArray = function (arr) {
      var builder = new lunr.TokenSet.Builder();

      for (var i = 0, len = arr.length; i < len; i++) {
        builder.insert(arr[i]);
      }

      builder.finish();
      return builder.root;
    };
    /**
     * Creates a token set from a query clause.
     *
     * @private
     * @param {Object} clause - A single clause from lunr.Query.
     * @param {string} clause.term - The query clause term.
     * @param {number} [clause.editDistance] - The optional edit distance for the term.
     * @returns {lunr.TokenSet}
     */


    lunr.TokenSet.fromClause = function (clause) {
      if ('editDistance' in clause) {
        return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
      } else {
        return lunr.TokenSet.fromString(clause.term);
      }
    };
    /**
     * Creates a token set representing a single string with a specified
     * edit distance.
     *
     * Insertions, deletions, substitutions and transpositions are each
     * treated as an edit distance of 1.
     *
     * Increasing the allowed edit distance will have a dramatic impact
     * on the performance of both creating and intersecting these TokenSets.
     * It is advised to keep the edit distance less than 3.
     *
     * @param {string} str - The string to create the token set from.
     * @param {number} editDistance - The allowed edit distance to match.
     * @returns {lunr.Vector}
     */


    lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
      var root = new lunr.TokenSet();
      var stack = [{
        node: root,
        editsRemaining: editDistance,
        str: str
      }];

      while (stack.length) {
        var frame = stack.pop(); // no edit

        if (frame.str.length > 0) {
          var _char2 = frame.str.charAt(0),
              noEditNode;

          if (_char2 in frame.node.edges) {
            noEditNode = frame.node.edges[_char2];
          } else {
            noEditNode = new lunr.TokenSet();
            frame.node.edges[_char2] = noEditNode;
          }

          if (frame.str.length == 1) {
            noEditNode["final"] = true;
          }

          stack.push({
            node: noEditNode,
            editsRemaining: frame.editsRemaining,
            str: frame.str.slice(1)
          });
        }

        if (frame.editsRemaining == 0) {
          continue;
        } // insertion


        if ("*" in frame.node.edges) {
          var insertionNode = frame.node.edges["*"];
        } else {
          var insertionNode = new lunr.TokenSet();
          frame.node.edges["*"] = insertionNode;
        }

        if (frame.str.length == 0) {
          insertionNode["final"] = true;
        }

        stack.push({
          node: insertionNode,
          editsRemaining: frame.editsRemaining - 1,
          str: frame.str
        }); // deletion
        // can only do a deletion if we have enough edits remaining
        // and if there are characters left to delete in the string

        if (frame.str.length > 1) {
          stack.push({
            node: frame.node,
            editsRemaining: frame.editsRemaining - 1,
            str: frame.str.slice(1)
          });
        } // deletion
        // just removing the last character from the str


        if (frame.str.length == 1) {
          frame.node["final"] = true;
        } // substitution
        // can only do a substitution if we have enough edits remaining
        // and if there are characters left to substitute


        if (frame.str.length >= 1) {
          if ("*" in frame.node.edges) {
            var substitutionNode = frame.node.edges["*"];
          } else {
            var substitutionNode = new lunr.TokenSet();
            frame.node.edges["*"] = substitutionNode;
          }

          if (frame.str.length == 1) {
            substitutionNode["final"] = true;
          }

          stack.push({
            node: substitutionNode,
            editsRemaining: frame.editsRemaining - 1,
            str: frame.str.slice(1)
          });
        } // transposition
        // can only do a transposition if there are edits remaining
        // and there are enough characters to transpose


        if (frame.str.length > 1) {
          var charA = frame.str.charAt(0),
              charB = frame.str.charAt(1),
              transposeNode;

          if (charB in frame.node.edges) {
            transposeNode = frame.node.edges[charB];
          } else {
            transposeNode = new lunr.TokenSet();
            frame.node.edges[charB] = transposeNode;
          }

          if (frame.str.length == 1) {
            transposeNode["final"] = true;
          }

          stack.push({
            node: transposeNode,
            editsRemaining: frame.editsRemaining - 1,
            str: charA + frame.str.slice(2)
          });
        }
      }

      return root;
    };
    /**
     * Creates a TokenSet from a string.
     *
     * The string may contain one or more wildcard characters (*)
     * that will allow wildcard matching when intersecting with
     * another TokenSet.
     *
     * @param {string} str - The string to create a TokenSet from.
     * @returns {lunr.TokenSet}
     */


    lunr.TokenSet.fromString = function (str) {
      var node = new lunr.TokenSet(),
          root = node;
      /*
       * Iterates through all characters within the passed string
       * appending a node for each character.
       *
       * When a wildcard character is found then a self
       * referencing edge is introduced to continually match
       * any number of any characters.
       */

      for (var i = 0, len = str.length; i < len; i++) {
        var _char3 = str[i],
            _final = i == len - 1;

        if (_char3 == "*") {
          node.edges[_char3] = node;
          node["final"] = _final;
        } else {
          var next = new lunr.TokenSet();
          next["final"] = _final;
          node.edges[_char3] = next;
          node = next;
        }
      }

      return root;
    };
    /**
     * Converts this TokenSet into an array of strings
     * contained within the TokenSet.
     *
     * This is not intended to be used on a TokenSet that
     * contains wildcards, in these cases the results are
     * undefined and are likely to cause an infinite loop.
     *
     * @returns {string[]}
     */


    lunr.TokenSet.prototype.toArray = function () {
      var words = [];
      var stack = [{
        prefix: "",
        node: this
      }];

      while (stack.length) {
        var frame = stack.pop(),
            edges = Object.keys(frame.node.edges),
            len = edges.length;

        if (frame.node["final"]) {
          /* In Safari, at this point the prefix is sometimes corrupted, see:
           * https://github.com/olivernn/lunr.js/issues/279 Calling any
           * String.prototype method forces Safari to "cast" this string to what
           * it's supposed to be, fixing the bug. */
          frame.prefix.charAt(0);
          words.push(frame.prefix);
        }

        for (var i = 0; i < len; i++) {
          var edge = edges[i];
          stack.push({
            prefix: frame.prefix.concat(edge),
            node: frame.node.edges[edge]
          });
        }
      }

      return words;
    };
    /**
     * Generates a string representation of a TokenSet.
     *
     * This is intended to allow TokenSets to be used as keys
     * in objects, largely to aid the construction and minimisation
     * of a TokenSet. As such it is not designed to be a human
     * friendly representation of the TokenSet.
     *
     * @returns {string}
     */


    lunr.TokenSet.prototype.toString = function () {
      // NOTE: Using Object.keys here as this.edges is very likely
      // to enter 'hash-mode' with many keys being added
      //
      // avoiding a for-in loop here as it leads to the function
      // being de-optimised (at least in V8). From some simple
      // benchmarks the performance is comparable, but allowing
      // V8 to optimize may mean easy performance wins in the future.
      if (this._str) {
        return this._str;
      }

      var str = this["final"] ? '1' : '0',
          labels = Object.keys(this.edges).sort(),
          len = labels.length;

      for (var i = 0; i < len; i++) {
        var label = labels[i],
            node = this.edges[label];
        str = str + label + node.id;
      }

      return str;
    };
    /**
     * Returns a new TokenSet that is the intersection of
     * this TokenSet and the passed TokenSet.
     *
     * This intersection will take into account any wildcards
     * contained within the TokenSet.
     *
     * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
     * @returns {lunr.TokenSet}
     */


    lunr.TokenSet.prototype.intersect = function (b) {
      var output = new lunr.TokenSet(),
          frame = undefined;
      var stack = [{
        qNode: b,
        output: output,
        node: this
      }];

      while (stack.length) {
        frame = stack.pop(); // NOTE: As with the #toString method, we are using
        // Object.keys and a for loop instead of a for-in loop
        // as both of these objects enter 'hash' mode, causing
        // the function to be de-optimised in V8

        var qEdges = Object.keys(frame.qNode.edges),
            qLen = qEdges.length,
            nEdges = Object.keys(frame.node.edges),
            nLen = nEdges.length;

        for (var q = 0; q < qLen; q++) {
          var qEdge = qEdges[q];

          for (var n = 0; n < nLen; n++) {
            var nEdge = nEdges[n];

            if (nEdge == qEdge || qEdge == '*') {
              var node = frame.node.edges[nEdge],
                  qNode = frame.qNode.edges[qEdge],
                  _final2 = node["final"] && qNode["final"],
                  next = undefined;

              if (nEdge in frame.output.edges) {
                // an edge already exists for this character
                // no need to create a new node, just set the finality
                // bit unless this node is already final
                next = frame.output.edges[nEdge];
                next["final"] = next["final"] || _final2;
              } else {
                // no edge exists yet, must create one
                // set the finality bit and insert it
                // into the output
                next = new lunr.TokenSet();
                next["final"] = _final2;
                frame.output.edges[nEdge] = next;
              }

              stack.push({
                qNode: qNode,
                output: next,
                node: node
              });
            }
          }
        }
      }

      return output;
    };

    lunr.TokenSet.Builder = function () {
      this.previousWord = "";
      this.root = new lunr.TokenSet();
      this.uncheckedNodes = [];
      this.minimizedNodes = {};
    };

    lunr.TokenSet.Builder.prototype.insert = function (word) {
      var node,
          commonPrefix = 0;

      if (word < this.previousWord) {
        throw new Error("Out of order word insertion");
      }

      for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
        if (word[i] != this.previousWord[i]) break;
        commonPrefix++;
      }

      this.minimize(commonPrefix);

      if (this.uncheckedNodes.length == 0) {
        node = this.root;
      } else {
        node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
      }

      for (var i = commonPrefix; i < word.length; i++) {
        var nextNode = new lunr.TokenSet(),
            _char4 = word[i];
        node.edges[_char4] = nextNode;
        this.uncheckedNodes.push({
          parent: node,
          "char": _char4,
          child: nextNode
        });
        node = nextNode;
      }

      node["final"] = true;
      this.previousWord = word;
    };

    lunr.TokenSet.Builder.prototype.finish = function () {
      this.minimize(0);
    };

    lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
      for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
        var node = this.uncheckedNodes[i],
            childKey = node.child.toString();

        if (childKey in this.minimizedNodes) {
          node.parent.edges[node["char"]] = this.minimizedNodes[childKey];
        } else {
          // Cache the key for this node since
          // we know it can't change anymore
          node.child._str = childKey;
          this.minimizedNodes[childKey] = node.child;
        }

        this.uncheckedNodes.pop();
      }
    };
    /*!
     * lunr.Index
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * An index contains the built index of all documents and provides a query interface
     * to the index.
     *
     * Usually instances of lunr.Index will not be created using this constructor, instead
     * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
     * used to load previously built and serialized indexes.
     *
     * @constructor
     * @param {Object} attrs - The attributes of the built search index.
     * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
     * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
     * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
     * @param {string[]} attrs.fields - The names of indexed document fields.
     * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
     */


    lunr.Index = function (attrs) {
      this.invertedIndex = attrs.invertedIndex;
      this.fieldVectors = attrs.fieldVectors;
      this.tokenSet = attrs.tokenSet;
      this.fields = attrs.fields;
      this.pipeline = attrs.pipeline;
    };
    /**
     * A result contains details of a document matching a search query.
     * @typedef {Object} lunr.Index~Result
     * @property {string} ref - The reference of the document this result represents.
     * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
     * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
     */

    /**
     * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
     * query language which itself is parsed into an instance of lunr.Query.
     *
     * For programmatically building queries it is advised to directly use lunr.Query, the query language
     * is best used for human entered text rather than program generated text.
     *
     * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
     * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
     * or 'world', though those that contain both will rank higher in the results.
     *
     * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
     * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
     * wildcards will increase the number of documents that will be found but can also have a negative
     * impact on query performance, especially with wildcards at the beginning of a term.
     *
     * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
     * hello in the title field will match this query. Using a field not present in the index will lead
     * to an error being thrown.
     *
     * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
     * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
     * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
     * Avoid large values for edit distance to improve query performance.
     *
     * Each term also supports a presence modifier. By default a term's presence in document is optional, however
     * this can be changed to either required or prohibited. For a term's presence to be required in a document the
     * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
     * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
     * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
     *
     * To escape special characters the backslash character '\' can be used, this allows searches to include
     * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
     * of attempting to apply a boost of 2 to the search term "foo".
     *
     * @typedef {string} lunr.Index~QueryString
     * @example <caption>Simple single term query</caption>
     * hello
     * @example <caption>Multiple term query</caption>
     * hello world
     * @example <caption>term scoped to a field</caption>
     * title:hello
     * @example <caption>term with a boost of 10</caption>
     * hello^10
     * @example <caption>term with an edit distance of 2</caption>
     * hello~2
     * @example <caption>terms with presence modifiers</caption>
     * -foo +bar baz
     */

    /**
     * Performs a search against the index using lunr query syntax.
     *
     * Results will be returned sorted by their score, the most relevant results
     * will be returned first.  For details on how the score is calculated, please see
     * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
     *
     * For more programmatic querying use lunr.Index#query.
     *
     * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
     * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
     * @returns {lunr.Index~Result[]}
     */


    lunr.Index.prototype.search = function (queryString) {
      return this.query(function (query) {
        var parser = new lunr.QueryParser(queryString, query);
        parser.parse();
      });
    };
    /**
     * A query builder callback provides a query object to be used to express
     * the query to perform on the index.
     *
     * @callback lunr.Index~queryBuilder
     * @param {lunr.Query} query - The query object to build up.
     * @this lunr.Query
     */

    /**
     * Performs a query against the index using the yielded lunr.Query object.
     *
     * If performing programmatic queries against the index, this method is preferred
     * over lunr.Index#search so as to avoid the additional query parsing overhead.
     *
     * A query object is yielded to the supplied function which should be used to
     * express the query to be run against the index.
     *
     * Note that although this function takes a callback parameter it is _not_ an
     * asynchronous operation, the callback is just yielded a query object to be
     * customized.
     *
     * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
     * @returns {lunr.Index~Result[]}
     */


    lunr.Index.prototype.query = function (fn) {
      // for each query clause
      // * process terms
      // * expand terms from token set
      // * find matching documents and metadata
      // * get document vectors
      // * score documents
      var query = new lunr.Query(this.fields),
          matchingFields = Object.create(null),
          queryVectors = Object.create(null),
          termFieldCache = Object.create(null),
          requiredMatches = Object.create(null),
          prohibitedMatches = Object.create(null);
      /*
       * To support field level boosts a query vector is created per
       * field. An empty vector is eagerly created to support negated
       * queries.
       */

      for (var i = 0; i < this.fields.length; i++) {
        queryVectors[this.fields[i]] = new lunr.Vector();
      }

      fn.call(query, query);

      for (var i = 0; i < query.clauses.length; i++) {
        /*
         * Unless the pipeline has been disabled for this term, which is
         * the case for terms with wildcards, we need to pass the clause
         * term through the search pipeline. A pipeline returns an array
         * of processed terms. Pipeline functions may expand the passed
         * term, which means we may end up performing multiple index lookups
         * for a single query term.
         */
        var clause = query.clauses[i],
            terms = null,
            clauseMatches = lunr.Set.empty;

        if (clause.usePipeline) {
          terms = this.pipeline.runString(clause.term, {
            fields: clause.fields
          });
        } else {
          terms = [clause.term];
        }

        for (var m = 0; m < terms.length; m++) {
          var term = terms[m];
          /*
           * Each term returned from the pipeline needs to use the same query
           * clause object, e.g. the same boost and or edit distance. The
           * simplest way to do this is to re-use the clause object but mutate
           * its term property.
           */

          clause.term = term;
          /*
           * From the term in the clause we create a token set which will then
           * be used to intersect the indexes token set to get a list of terms
           * to lookup in the inverted index
           */

          var termTokenSet = lunr.TokenSet.fromClause(clause),
              expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
          /*
           * If a term marked as required does not exist in the tokenSet it is
           * impossible for the search to return any matches. We set all the field
           * scoped required matches set to empty and stop examining any further
           * clauses.
           */

          if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
            for (var k = 0; k < clause.fields.length; k++) {
              var field = clause.fields[k];
              requiredMatches[field] = lunr.Set.empty;
            }

            break;
          }

          for (var j = 0; j < expandedTerms.length; j++) {
            /*
             * For each term get the posting and termIndex, this is required for
             * building the query vector.
             */
            var expandedTerm = expandedTerms[j],
                posting = this.invertedIndex[expandedTerm],
                termIndex = posting._index;

            for (var k = 0; k < clause.fields.length; k++) {
              /*
               * For each field that this query term is scoped by (by default
               * all fields are in scope) we need to get all the document refs
               * that have this term in that field.
               *
               * The posting is the entry in the invertedIndex for the matching
               * term from above.
               */
              var field = clause.fields[k],
                  fieldPosting = posting[field],
                  matchingDocumentRefs = Object.keys(fieldPosting),
                  termField = expandedTerm + "/" + field,
                  matchingDocumentsSet = new lunr.Set(matchingDocumentRefs);
              /*
               * if the presence of this term is required ensure that the matching
               * documents are added to the set of required matches for this clause.
               *
               */

              if (clause.presence == lunr.Query.presence.REQUIRED) {
                clauseMatches = clauseMatches.union(matchingDocumentsSet);

                if (requiredMatches[field] === undefined) {
                  requiredMatches[field] = lunr.Set.complete;
                }
              }
              /*
               * if the presence of this term is prohibited ensure that the matching
               * documents are added to the set of prohibited matches for this field,
               * creating that set if it does not yet exist.
               */


              if (clause.presence == lunr.Query.presence.PROHIBITED) {
                if (prohibitedMatches[field] === undefined) {
                  prohibitedMatches[field] = lunr.Set.empty;
                }

                prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet);
                /*
                 * Prohibited matches should not be part of the query vector used for
                 * similarity scoring and no metadata should be extracted so we continue
                 * to the next field
                 */

                continue;
              }
              /*
               * The query field vector is populated using the termIndex found for
               * the term and a unit value with the appropriate boost applied.
               * Using upsert because there could already be an entry in the vector
               * for the term we are working with. In that case we just add the scores
               * together.
               */


              queryVectors[field].upsert(termIndex, clause.boost, function (a, b) {
                return a + b;
              });
              /**
               * If we've already seen this term, field combo then we've already collected
               * the matching documents and metadata, no need to go through all that again
               */

              if (termFieldCache[termField]) {
                continue;
              }

              for (var l = 0; l < matchingDocumentRefs.length; l++) {
                /*
                 * All metadata for this term/field/document triple
                 * are then extracted and collected into an instance
                 * of lunr.MatchData ready to be returned in the query
                 * results
                 */
                var matchingDocumentRef = matchingDocumentRefs[l],
                    matchingFieldRef = new lunr.FieldRef(matchingDocumentRef, field),
                    metadata = fieldPosting[matchingDocumentRef],
                    fieldMatch;

                if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
                  matchingFields[matchingFieldRef] = new lunr.MatchData(expandedTerm, field, metadata);
                } else {
                  fieldMatch.add(expandedTerm, field, metadata);
                }
              }

              termFieldCache[termField] = true;
            }
          }
        }
        /**
         * If the presence was required we need to update the requiredMatches field sets.
         * We do this after all fields for the term have collected their matches because
         * the clause terms presence is required in _any_ of the fields not _all_ of the
         * fields.
         */


        if (clause.presence === lunr.Query.presence.REQUIRED) {
          for (var k = 0; k < clause.fields.length; k++) {
            var field = clause.fields[k];
            requiredMatches[field] = requiredMatches[field].intersect(clauseMatches);
          }
        }
      }
      /**
       * Need to combine the field scoped required and prohibited
       * matching documents into a global set of required and prohibited
       * matches
       */


      var allRequiredMatches = lunr.Set.complete,
          allProhibitedMatches = lunr.Set.empty;

      for (var i = 0; i < this.fields.length; i++) {
        var field = this.fields[i];

        if (requiredMatches[field]) {
          allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field]);
        }

        if (prohibitedMatches[field]) {
          allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field]);
        }
      }

      var matchingFieldRefs = Object.keys(matchingFields),
          results = [],
          matches = Object.create(null);
      /*
       * If the query is negated (contains only prohibited terms)
       * we need to get _all_ fieldRefs currently existing in the
       * index. This is only done when we know that the query is
       * entirely prohibited terms to avoid any cost of getting all
       * fieldRefs unnecessarily.
       *
       * Additionally, blank MatchData must be created to correctly
       * populate the results.
       */

      if (query.isNegated()) {
        matchingFieldRefs = Object.keys(this.fieldVectors);

        for (var i = 0; i < matchingFieldRefs.length; i++) {
          var matchingFieldRef = matchingFieldRefs[i];
          var fieldRef = lunr.FieldRef.fromString(matchingFieldRef);
          matchingFields[matchingFieldRef] = new lunr.MatchData();
        }
      }

      for (var i = 0; i < matchingFieldRefs.length; i++) {
        /*
         * Currently we have document fields that match the query, but we
         * need to return documents. The matchData and scores are combined
         * from multiple fields belonging to the same document.
         *
         * Scores are calculated by field, using the query vectors created
         * above, and combined into a final document score using addition.
         */
        var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
            docRef = fieldRef.docRef;

        if (!allRequiredMatches.contains(docRef)) {
          continue;
        }

        if (allProhibitedMatches.contains(docRef)) {
          continue;
        }

        var fieldVector = this.fieldVectors[fieldRef],
            score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
            docMatch;

        if ((docMatch = matches[docRef]) !== undefined) {
          docMatch.score += score;
          docMatch.matchData.combine(matchingFields[fieldRef]);
        } else {
          var match = {
            ref: docRef,
            score: score,
            matchData: matchingFields[fieldRef]
          };
          matches[docRef] = match;
          results.push(match);
        }
      }
      /*
       * Sort the results objects by score, highest first.
       */


      return results.sort(function (a, b) {
        return b.score - a.score;
      });
    };
    /**
     * Prepares the index for JSON serialization.
     *
     * The schema for this JSON blob will be described in a
     * separate JSON schema file.
     *
     * @returns {Object}
     */


    lunr.Index.prototype.toJSON = function () {
      var invertedIndex = Object.keys(this.invertedIndex).sort().map(function (term) {
        return [term, this.invertedIndex[term]];
      }, this);
      var fieldVectors = Object.keys(this.fieldVectors).map(function (ref) {
        return [ref, this.fieldVectors[ref].toJSON()];
      }, this);
      return {
        version: lunr.version,
        fields: this.fields,
        fieldVectors: fieldVectors,
        invertedIndex: invertedIndex,
        pipeline: this.pipeline.toJSON()
      };
    };
    /**
     * Loads a previously serialized lunr.Index
     *
     * @param {Object} serializedIndex - A previously serialized lunr.Index
     * @returns {lunr.Index}
     */


    lunr.Index.load = function (serializedIndex) {
      var attrs = {},
          fieldVectors = {},
          serializedVectors = serializedIndex.fieldVectors,
          invertedIndex = Object.create(null),
          serializedInvertedIndex = serializedIndex.invertedIndex,
          tokenSetBuilder = new lunr.TokenSet.Builder(),
          pipeline = lunr.Pipeline.load(serializedIndex.pipeline);

      if (serializedIndex.version != lunr.version) {
        lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'");
      }

      for (var i = 0; i < serializedVectors.length; i++) {
        var tuple = serializedVectors[i],
            ref = tuple[0],
            elements = tuple[1];
        fieldVectors[ref] = new lunr.Vector(elements);
      }

      for (var i = 0; i < serializedInvertedIndex.length; i++) {
        var tuple = serializedInvertedIndex[i],
            term = tuple[0],
            posting = tuple[1];
        tokenSetBuilder.insert(term);
        invertedIndex[term] = posting;
      }

      tokenSetBuilder.finish();
      attrs.fields = serializedIndex.fields;
      attrs.fieldVectors = fieldVectors;
      attrs.invertedIndex = invertedIndex;
      attrs.tokenSet = tokenSetBuilder.root;
      attrs.pipeline = pipeline;
      return new lunr.Index(attrs);
    };
    /*!
     * lunr.Builder
     * Copyright (C) 2020 Oliver Nightingale
     */

    /**
     * lunr.Builder performs indexing on a set of documents and
     * returns instances of lunr.Index ready for querying.
     *
     * All configuration of the index is done via the builder, the
     * fields to index, the document reference, the text processing
     * pipeline and document scoring parameters are all set on the
     * builder before indexing.
     *
     * @constructor
     * @property {string} _ref - Internal reference to the document reference field.
     * @property {string[]} _fields - Internal reference to the document fields to index.
     * @property {object} invertedIndex - The inverted index maps terms to document fields.
     * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
     * @property {object} documentLengths - Keeps track of the length of documents added to the index.
     * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
     * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
     * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
     * @property {number} documentCount - Keeps track of the total number of documents indexed.
     * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
     * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
     * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
     * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
     */


    lunr.Builder = function () {
      this._ref = "id";
      this._fields = Object.create(null);
      this._documents = Object.create(null);
      this.invertedIndex = Object.create(null);
      this.fieldTermFrequencies = {};
      this.fieldLengths = {};
      this.tokenizer = lunr.tokenizer;
      this.pipeline = new lunr.Pipeline();
      this.searchPipeline = new lunr.Pipeline();
      this.documentCount = 0;
      this._b = 0.75;
      this._k1 = 1.2;
      this.termIndex = 0;
      this.metadataWhitelist = [];
    };
    /**
     * Sets the document field used as the document reference. Every document must have this field.
     * The type of this field in the document should be a string, if it is not a string it will be
     * coerced into a string by calling toString.
     *
     * The default ref is 'id'.
     *
     * The ref should _not_ be changed during indexing, it should be set before any documents are
     * added to the index. Changing it during indexing can lead to inconsistent results.
     *
     * @param {string} ref - The name of the reference field in the document.
     */


    lunr.Builder.prototype.ref = function (ref) {
      this._ref = ref;
    };
    /**
     * A function that is used to extract a field from a document.
     *
     * Lunr expects a field to be at the top level of a document, if however the field
     * is deeply nested within a document an extractor function can be used to extract
     * the right field for indexing.
     *
     * @callback fieldExtractor
     * @param {object} doc - The document being added to the index.
     * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
     * @example <caption>Extracting a nested field</caption>
     * function (doc) { return doc.nested.field }
     */

    /**
     * Adds a field to the list of document fields that will be indexed. Every document being
     * indexed should have this field. Null values for this field in indexed documents will
     * not cause errors but will limit the chance of that document being retrieved by searches.
     *
     * All fields should be added before adding documents to the index. Adding fields after
     * a document has been indexed will have no effect on already indexed documents.
     *
     * Fields can be boosted at build time. This allows terms within that field to have more
     * importance when ranking search results. Use a field boost to specify that matches within
     * one field are more important than other fields.
     *
     * @param {string} fieldName - The name of a field to index in all documents.
     * @param {object} attributes - Optional attributes associated with this field.
     * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
     * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
     * @throws {RangeError} fieldName cannot contain unsupported characters '/'
     */


    lunr.Builder.prototype.field = function (fieldName, attributes) {
      if (/\//.test(fieldName)) {
        throw new RangeError("Field '" + fieldName + "' contains illegal character '/'");
      }

      this._fields[fieldName] = attributes || {};
    };
    /**
     * A parameter to tune the amount of field length normalisation that is applied when
     * calculating relevance scores. A value of 0 will completely disable any normalisation
     * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
     * will be clamped to the range 0 - 1.
     *
     * @param {number} number - The value to set for this tuning parameter.
     */


    lunr.Builder.prototype.b = function (number) {
      if (number < 0) {
        this._b = 0;
      } else if (number > 1) {
        this._b = 1;
      } else {
        this._b = number;
      }
    };
    /**
     * A parameter that controls the speed at which a rise in term frequency results in term
     * frequency saturation. The default value is 1.2. Setting this to a higher value will give
     * slower saturation levels, a lower value will result in quicker saturation.
     *
     * @param {number} number - The value to set for this tuning parameter.
     */


    lunr.Builder.prototype.k1 = function (number) {
      this._k1 = number;
    };
    /**
     * Adds a document to the index.
     *
     * Before adding fields to the index the index should have been fully setup, with the document
     * ref and all fields to index already having been specified.
     *
     * The document must have a field name as specified by the ref (by default this is 'id') and
     * it should have all fields defined for indexing, though null or undefined values will not
     * cause errors.
     *
     * Entire documents can be boosted at build time. Applying a boost to a document indicates that
     * this document should rank higher in search results than other documents.
     *
     * @param {object} doc - The document to add to the index.
     * @param {object} attributes - Optional attributes associated with this document.
     * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
     */


    lunr.Builder.prototype.add = function (doc, attributes) {
      var docRef = doc[this._ref],
          fields = Object.keys(this._fields);
      this._documents[docRef] = attributes || {};
      this.documentCount += 1;

      for (var i = 0; i < fields.length; i++) {
        var fieldName = fields[i],
            extractor = this._fields[fieldName].extractor,
            field = extractor ? extractor(doc) : doc[fieldName],
            tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
            terms = this.pipeline.run(tokens),
            fieldRef = new lunr.FieldRef(docRef, fieldName),
            fieldTerms = Object.create(null);
        this.fieldTermFrequencies[fieldRef] = fieldTerms;
        this.fieldLengths[fieldRef] = 0; // store the length of this field for this document

        this.fieldLengths[fieldRef] += terms.length; // calculate term frequencies for this field

        for (var j = 0; j < terms.length; j++) {
          var term = terms[j];

          if (fieldTerms[term] == undefined) {
            fieldTerms[term] = 0;
          }

          fieldTerms[term] += 1; // add to inverted index
          // create an initial posting if one doesn't exist

          if (this.invertedIndex[term] == undefined) {
            var posting = Object.create(null);
            posting["_index"] = this.termIndex;
            this.termIndex += 1;

            for (var k = 0; k < fields.length; k++) {
              posting[fields[k]] = Object.create(null);
            }

            this.invertedIndex[term] = posting;
          } // add an entry for this term/fieldName/docRef to the invertedIndex


          if (this.invertedIndex[term][fieldName][docRef] == undefined) {
            this.invertedIndex[term][fieldName][docRef] = Object.create(null);
          } // store all whitelisted metadata about this token in the
          // inverted index


          for (var l = 0; l < this.metadataWhitelist.length; l++) {
            var metadataKey = this.metadataWhitelist[l],
                metadata = term.metadata[metadataKey];

            if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
              this.invertedIndex[term][fieldName][docRef][metadataKey] = [];
            }

            this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata);
          }
        }
      }
    };
    /**
     * Calculates the average document length for this index
     *
     * @private
     */


    lunr.Builder.prototype.calculateAverageFieldLengths = function () {
      var fieldRefs = Object.keys(this.fieldLengths),
          numberOfFields = fieldRefs.length,
          accumulator = {},
          documentsWithField = {};

      for (var i = 0; i < numberOfFields; i++) {
        var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
            field = fieldRef.fieldName;
        documentsWithField[field] || (documentsWithField[field] = 0);
        documentsWithField[field] += 1;
        accumulator[field] || (accumulator[field] = 0);
        accumulator[field] += this.fieldLengths[fieldRef];
      }

      var fields = Object.keys(this._fields);

      for (var i = 0; i < fields.length; i++) {
        var fieldName = fields[i];
        accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
      }

      this.averageFieldLength = accumulator;
    };
    /**
     * Builds a vector space model of every document using lunr.Vector
     *
     * @private
     */


    lunr.Builder.prototype.createFieldVectors = function () {
      var fieldVectors = {},
          fieldRefs = Object.keys(this.fieldTermFrequencies),
          fieldRefsLength = fieldRefs.length,
          termIdfCache = Object.create(null);

      for (var i = 0; i < fieldRefsLength; i++) {
        var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
            fieldName = fieldRef.fieldName,
            fieldLength = this.fieldLengths[fieldRef],
            fieldVector = new lunr.Vector(),
            termFrequencies = this.fieldTermFrequencies[fieldRef],
            terms = Object.keys(termFrequencies),
            termsLength = terms.length;
        var fieldBoost = this._fields[fieldName].boost || 1,
            docBoost = this._documents[fieldRef.docRef].boost || 1;

        for (var j = 0; j < termsLength; j++) {
          var term = terms[j],
              tf = termFrequencies[term],
              termIndex = this.invertedIndex[term]._index,
              idf,
              score,
              scoreWithPrecision;

          if (termIdfCache[term] === undefined) {
            idf = lunr.idf(this.invertedIndex[term], this.documentCount);
            termIdfCache[term] = idf;
          } else {
            idf = termIdfCache[term];
          }

          score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
          score *= fieldBoost;
          score *= docBoost;
          scoreWithPrecision = Math.round(score * 1000) / 1000; // Converts 1.23456789 to 1.234.
          // Reducing the precision so that the vectors take up less
          // space when serialised. Doing it now so that they behave
          // the same before and after serialisation. Also, this is
          // the fastest approach to reducing a number's precision in
          // JavaScript.

          fieldVector.insert(termIndex, scoreWithPrecision);
        }

        fieldVectors[fieldRef] = fieldVector;
      }

      this.fieldVectors = fieldVectors;
    };
    /**
     * Creates a token set of all tokens in the index using lunr.TokenSet
     *
     * @private
     */


    lunr.Builder.prototype.createTokenSet = function () {
      this.tokenSet = lunr.TokenSet.fromArray(Object.keys(this.invertedIndex).sort());
    };
    /**
     * Builds the index, creating an instance of lunr.Index.
     *
     * This completes the indexing process and should only be called
     * once all documents have been added to the index.
     *
     * @returns {lunr.Index}
     */


    lunr.Builder.prototype.build = function () {
      this.calculateAverageFieldLengths();
      this.createFieldVectors();
      this.createTokenSet();
      return new lunr.Index({
        invertedIndex: this.invertedIndex,
        fieldVectors: this.fieldVectors,
        tokenSet: this.tokenSet,
        fields: Object.keys(this._fields),
        pipeline: this.searchPipeline
      });
    };
    /**
     * Applies a plugin to the index builder.
     *
     * A plugin is a function that is called with the index builder as its context.
     * Plugins can be used to customise or extend the behaviour of the index
     * in some way. A plugin is just a function, that encapsulated the custom
     * behaviour that should be applied when building the index.
     *
     * The plugin function will be called with the index builder as its argument, additional
     * arguments can also be passed when calling use. The function will be called
     * with the index builder as its context.
     *
     * @param {Function} plugin The plugin to apply.
     */


    lunr.Builder.prototype.use = function (fn) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(this);
      fn.apply(this, args);
    };
    /**
     * Contains and collects metadata about a matching document.
     * A single instance of lunr.MatchData is returned as part of every
     * lunr.Index~Result.
     *
     * @constructor
     * @param {string} term - The term this match data is associated with
     * @param {string} field - The field in which the term was found
     * @param {object} metadata - The metadata recorded about this term in this field
     * @property {object} metadata - A cloned collection of metadata associated with this document.
     * @see {@link lunr.Index~Result}
     */


    lunr.MatchData = function (term, field, metadata) {
      var clonedMetadata = Object.create(null),
          metadataKeys = Object.keys(metadata || {}); // Cloning the metadata to prevent the original
      // being mutated during match data combination.
      // Metadata is kept in an array within the inverted
      // index so cloning the data can be done with
      // Array#slice

      for (var i = 0; i < metadataKeys.length; i++) {
        var key = metadataKeys[i];
        clonedMetadata[key] = metadata[key].slice();
      }

      this.metadata = Object.create(null);

      if (term !== undefined) {
        this.metadata[term] = Object.create(null);
        this.metadata[term][field] = clonedMetadata;
      }
    };
    /**
     * An instance of lunr.MatchData will be created for every term that matches a
     * document. However only one instance is required in a lunr.Index~Result. This
     * method combines metadata from another instance of lunr.MatchData with this
     * objects metadata.
     *
     * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
     * @see {@link lunr.Index~Result}
     */


    lunr.MatchData.prototype.combine = function (otherMatchData) {
      var terms = Object.keys(otherMatchData.metadata);

      for (var i = 0; i < terms.length; i++) {
        var term = terms[i],
            fields = Object.keys(otherMatchData.metadata[term]);

        if (this.metadata[term] == undefined) {
          this.metadata[term] = Object.create(null);
        }

        for (var j = 0; j < fields.length; j++) {
          var field = fields[j],
              keys = Object.keys(otherMatchData.metadata[term][field]);

          if (this.metadata[term][field] == undefined) {
            this.metadata[term][field] = Object.create(null);
          }

          for (var k = 0; k < keys.length; k++) {
            var key = keys[k];

            if (this.metadata[term][field][key] == undefined) {
              this.metadata[term][field][key] = otherMatchData.metadata[term][field][key];
            } else {
              this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key]);
            }
          }
        }
      }
    };
    /**
     * Add metadata for a term/field pair to this instance of match data.
     *
     * @param {string} term - The term this match data is associated with
     * @param {string} field - The field in which the term was found
     * @param {object} metadata - The metadata recorded about this term in this field
     */


    lunr.MatchData.prototype.add = function (term, field, metadata) {
      if (!(term in this.metadata)) {
        this.metadata[term] = Object.create(null);
        this.metadata[term][field] = metadata;
        return;
      }

      if (!(field in this.metadata[term])) {
        this.metadata[term][field] = metadata;
        return;
      }

      var metadataKeys = Object.keys(metadata);

      for (var i = 0; i < metadataKeys.length; i++) {
        var key = metadataKeys[i];

        if (key in this.metadata[term][field]) {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key]);
        } else {
          this.metadata[term][field][key] = metadata[key];
        }
      }
    };
    /**
     * A lunr.Query provides a programmatic way of defining queries to be performed
     * against a {@link lunr.Index}.
     *
     * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
     * so the query object is pre-initialized with the right index fields.
     *
     * @constructor
     * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
     * @property {string[]} allFields - An array of all available fields in a lunr.Index.
     */


    lunr.Query = function (allFields) {
      this.clauses = [];
      this.allFields = allFields;
    };
    /**
     * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
     *
     * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
     * concatenation.
     *
     * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
     *
     * @constant
     * @default
     * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
     * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
     * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
     * @see lunr.Query~Clause
     * @see lunr.Query#clause
     * @see lunr.Query#term
     * @example <caption>query term with trailing wildcard</caption>
     * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
     * @example <caption>query term with leading and trailing wildcard</caption>
     * query.term('foo', {
     *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
     * })
     */


    lunr.Query.wildcard = new String("*");
    lunr.Query.wildcard.NONE = 0;
    lunr.Query.wildcard.LEADING = 1;
    lunr.Query.wildcard.TRAILING = 2;
    /**
     * Constants for indicating what kind of presence a term must have in matching documents.
     *
     * @constant
     * @enum {number}
     * @see lunr.Query~Clause
     * @see lunr.Query#clause
     * @see lunr.Query#term
     * @example <caption>query term with required presence</caption>
     * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
     */

    lunr.Query.presence = {
      /**
       * Term's presence in a document is optional, this is the default value.
       */
      OPTIONAL: 1,

      /**
       * Term's presence in a document is required, documents that do not contain
       * this term will not be returned.
       */
      REQUIRED: 2,

      /**
       * Term's presence in a document is prohibited, documents that do contain
       * this term will not be returned.
       */
      PROHIBITED: 3
    };
    /**
     * A single clause in a {@link lunr.Query} contains a term and details on how to
     * match that term against a {@link lunr.Index}.
     *
     * @typedef {Object} lunr.Query~Clause
     * @property {string[]} fields - The fields in an index this clause should be matched against.
     * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
     * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
     * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
     * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
     * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
     */

    /**
     * Adds a {@link lunr.Query~Clause} to this query.
     *
     * Unless the clause contains the fields to be matched all fields will be matched. In addition
     * a default boost of 1 is applied to the clause.
     *
     * @param {lunr.Query~Clause} clause - The clause to add to this query.
     * @see lunr.Query~Clause
     * @returns {lunr.Query}
     */

    lunr.Query.prototype.clause = function (clause) {
      if (!('fields' in clause)) {
        clause.fields = this.allFields;
      }

      if (!('boost' in clause)) {
        clause.boost = 1;
      }

      if (!('usePipeline' in clause)) {
        clause.usePipeline = true;
      }

      if (!('wildcard' in clause)) {
        clause.wildcard = lunr.Query.wildcard.NONE;
      }

      if (clause.wildcard & lunr.Query.wildcard.LEADING && clause.term.charAt(0) != lunr.Query.wildcard) {
        clause.term = "*" + clause.term;
      }

      if (clause.wildcard & lunr.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr.Query.wildcard) {
        clause.term = "" + clause.term + "*";
      }

      if (!('presence' in clause)) {
        clause.presence = lunr.Query.presence.OPTIONAL;
      }

      this.clauses.push(clause);
      return this;
    };
    /**
     * A negated query is one in which every clause has a presence of
     * prohibited. These queries require some special processing to return
     * the expected results.
     *
     * @returns boolean
     */


    lunr.Query.prototype.isNegated = function () {
      for (var i = 0; i < this.clauses.length; i++) {
        if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
          return false;
        }
      }

      return true;
    };
    /**
     * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
     * to the list of clauses that make up this query.
     *
     * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
     * to a token or token-like string should be done before calling this method.
     *
     * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
     * array, each term in the array will share the same options.
     *
     * @param {object|object[]} term - The term(s) to add to the query.
     * @param {object} [options] - Any additional properties to add to the query clause.
     * @returns {lunr.Query}
     * @see lunr.Query#clause
     * @see lunr.Query~Clause
     * @example <caption>adding a single term to a query</caption>
     * query.term("foo")
     * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
     * query.term("foo", {
     *   fields: ["title"],
     *   boost: 10,
     *   wildcard: lunr.Query.wildcard.TRAILING
     * })
     * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
     * query.term(lunr.tokenizer("foo bar"))
     */


    lunr.Query.prototype.term = function (term, options) {
      if (Array.isArray(term)) {
        term.forEach(function (t) {
          this.term(t, lunr.utils.clone(options));
        }, this);
        return this;
      }

      var clause = options || {};
      clause.term = term.toString();
      this.clause(clause);
      return this;
    };

    lunr.QueryParseError = function (message, start, end) {
      this.name = "QueryParseError";
      this.message = message;
      this.start = start;
      this.end = end;
    };

    lunr.QueryParseError.prototype = new Error();

    lunr.QueryLexer = function (str) {
      this.lexemes = [];
      this.str = str;
      this.length = str.length;
      this.pos = 0;
      this.start = 0;
      this.escapeCharPositions = [];
    };

    lunr.QueryLexer.prototype.run = function () {
      var state = lunr.QueryLexer.lexText;

      while (state) {
        state = state(this);
      }
    };

    lunr.QueryLexer.prototype.sliceString = function () {
      var subSlices = [],
          sliceStart = this.start,
          sliceEnd = this.pos;

      for (var i = 0; i < this.escapeCharPositions.length; i++) {
        sliceEnd = this.escapeCharPositions[i];
        subSlices.push(this.str.slice(sliceStart, sliceEnd));
        sliceStart = sliceEnd + 1;
      }

      subSlices.push(this.str.slice(sliceStart, this.pos));
      this.escapeCharPositions.length = 0;
      return subSlices.join('');
    };

    lunr.QueryLexer.prototype.emit = function (type) {
      this.lexemes.push({
        type: type,
        str: this.sliceString(),
        start: this.start,
        end: this.pos
      });
      this.start = this.pos;
    };

    lunr.QueryLexer.prototype.escapeCharacter = function () {
      this.escapeCharPositions.push(this.pos - 1);
      this.pos += 1;
    };

    lunr.QueryLexer.prototype.next = function () {
      if (this.pos >= this.length) {
        return lunr.QueryLexer.EOS;
      }

      var _char5 = this.str.charAt(this.pos);

      this.pos += 1;
      return _char5;
    };

    lunr.QueryLexer.prototype.width = function () {
      return this.pos - this.start;
    };

    lunr.QueryLexer.prototype.ignore = function () {
      if (this.start == this.pos) {
        this.pos += 1;
      }

      this.start = this.pos;
    };

    lunr.QueryLexer.prototype.backup = function () {
      this.pos -= 1;
    };

    lunr.QueryLexer.prototype.acceptDigitRun = function () {
      var _char6, charCode;

      do {
        _char6 = this.next();
        charCode = _char6.charCodeAt(0);
      } while (charCode > 47 && charCode < 58);

      if (_char6 != lunr.QueryLexer.EOS) {
        this.backup();
      }
    };

    lunr.QueryLexer.prototype.more = function () {
      return this.pos < this.length;
    };

    lunr.QueryLexer.EOS = 'EOS';
    lunr.QueryLexer.FIELD = 'FIELD';
    lunr.QueryLexer.TERM = 'TERM';
    lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE';
    lunr.QueryLexer.BOOST = 'BOOST';
    lunr.QueryLexer.PRESENCE = 'PRESENCE';

    lunr.QueryLexer.lexField = function (lexer) {
      lexer.backup();
      lexer.emit(lunr.QueryLexer.FIELD);
      lexer.ignore();
      return lunr.QueryLexer.lexText;
    };

    lunr.QueryLexer.lexTerm = function (lexer) {
      if (lexer.width() > 1) {
        lexer.backup();
        lexer.emit(lunr.QueryLexer.TERM);
      }

      lexer.ignore();

      if (lexer.more()) {
        return lunr.QueryLexer.lexText;
      }
    };

    lunr.QueryLexer.lexEditDistance = function (lexer) {
      lexer.ignore();
      lexer.acceptDigitRun();
      lexer.emit(lunr.QueryLexer.EDIT_DISTANCE);
      return lunr.QueryLexer.lexText;
    };

    lunr.QueryLexer.lexBoost = function (lexer) {
      lexer.ignore();
      lexer.acceptDigitRun();
      lexer.emit(lunr.QueryLexer.BOOST);
      return lunr.QueryLexer.lexText;
    };

    lunr.QueryLexer.lexEOS = function (lexer) {
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM);
      }
    }; // This matches the separator used when tokenising fields
    // within a document. These should match otherwise it is
    // not possible to search for some tokens within a document.
    //
    // It is possible for the user to change the separator on the
    // tokenizer so it _might_ clash with any other of the special
    // characters already used within the search string, e.g. :.
    //
    // This means that it is possible to change the separator in
    // such a way that makes some words unsearchable using a search
    // string.


    lunr.QueryLexer.termSeparator = lunr.tokenizer.separator;

    lunr.QueryLexer.lexText = function (lexer) {
      while (true) {
        var _char7 = lexer.next();

        if (_char7 == lunr.QueryLexer.EOS) {
          return lunr.QueryLexer.lexEOS;
        } // Escape character is '\'


        if (_char7.charCodeAt(0) == 92) {
          lexer.escapeCharacter();
          continue;
        }

        if (_char7 == ":") {
          return lunr.QueryLexer.lexField;
        }

        if (_char7 == "~") {
          lexer.backup();

          if (lexer.width() > 0) {
            lexer.emit(lunr.QueryLexer.TERM);
          }

          return lunr.QueryLexer.lexEditDistance;
        }

        if (_char7 == "^") {
          lexer.backup();

          if (lexer.width() > 0) {
            lexer.emit(lunr.QueryLexer.TERM);
          }

          return lunr.QueryLexer.lexBoost;
        } // "+" indicates term presence is required
        // checking for length to ensure that only
        // leading "+" are considered


        if (_char7 == "+" && lexer.width() === 1) {
          lexer.emit(lunr.QueryLexer.PRESENCE);
          return lunr.QueryLexer.lexText;
        } // "-" indicates term presence is prohibited
        // checking for length to ensure that only
        // leading "-" are considered


        if (_char7 == "-" && lexer.width() === 1) {
          lexer.emit(lunr.QueryLexer.PRESENCE);
          return lunr.QueryLexer.lexText;
        }

        if (_char7.match(lunr.QueryLexer.termSeparator)) {
          return lunr.QueryLexer.lexTerm;
        }
      }
    };

    lunr.QueryParser = function (str, query) {
      this.lexer = new lunr.QueryLexer(str);
      this.query = query;
      this.currentClause = {};
      this.lexemeIdx = 0;
    };

    lunr.QueryParser.prototype.parse = function () {
      this.lexer.run();
      this.lexemes = this.lexer.lexemes;
      var state = lunr.QueryParser.parseClause;

      while (state) {
        state = state(this);
      }

      return this.query;
    };

    lunr.QueryParser.prototype.peekLexeme = function () {
      return this.lexemes[this.lexemeIdx];
    };

    lunr.QueryParser.prototype.consumeLexeme = function () {
      var lexeme = this.peekLexeme();
      this.lexemeIdx += 1;
      return lexeme;
    };

    lunr.QueryParser.prototype.nextClause = function () {
      var completedClause = this.currentClause;
      this.query.clause(completedClause);
      this.currentClause = {};
    };

    lunr.QueryParser.parseClause = function (parser) {
      var lexeme = parser.peekLexeme();

      if (lexeme == undefined) {
        return;
      }

      switch (lexeme.type) {
        case lunr.QueryLexer.PRESENCE:
          return lunr.QueryParser.parsePresence;

        case lunr.QueryLexer.FIELD:
          return lunr.QueryParser.parseField;

        case lunr.QueryLexer.TERM:
          return lunr.QueryParser.parseTerm;

        default:
          var errorMessage = "expected either a field or a term, found " + lexeme.type;

          if (lexeme.str.length >= 1) {
            errorMessage += " with value '" + lexeme.str + "'";
          }

          throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }
    };

    lunr.QueryParser.parsePresence = function (parser) {
      var lexeme = parser.consumeLexeme();

      if (lexeme == undefined) {
        return;
      }

      switch (lexeme.str) {
        case "-":
          parser.currentClause.presence = lunr.Query.presence.PROHIBITED;
          break;

        case "+":
          parser.currentClause.presence = lunr.Query.presence.REQUIRED;
          break;

        default:
          var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
          throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      var nextLexeme = parser.peekLexeme();

      if (nextLexeme == undefined) {
        var errorMessage = "expecting term or field, found nothing";
        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      switch (nextLexeme.type) {
        case lunr.QueryLexer.FIELD:
          return lunr.QueryParser.parseField;

        case lunr.QueryLexer.TERM:
          return lunr.QueryParser.parseTerm;

        default:
          var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
          throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
      }
    };

    lunr.QueryParser.parseField = function (parser) {
      var lexeme = parser.consumeLexeme();

      if (lexeme == undefined) {
        return;
      }

      if (parser.query.allFields.indexOf(lexeme.str) == -1) {
        var possibleFields = parser.query.allFields.map(function (f) {
          return "'" + f + "'";
        }).join(', '),
            errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      parser.currentClause.fields = [lexeme.str];
      var nextLexeme = parser.peekLexeme();

      if (nextLexeme == undefined) {
        var errorMessage = "expecting term, found nothing";
        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      switch (nextLexeme.type) {
        case lunr.QueryLexer.TERM:
          return lunr.QueryParser.parseTerm;

        default:
          var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
          throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
      }
    };

    lunr.QueryParser.parseTerm = function (parser) {
      var lexeme = parser.consumeLexeme();

      if (lexeme == undefined) {
        return;
      }

      parser.currentClause.term = lexeme.str.toLowerCase();

      if (lexeme.str.indexOf("*") != -1) {
        parser.currentClause.usePipeline = false;
      }

      var nextLexeme = parser.peekLexeme();

      if (nextLexeme == undefined) {
        parser.nextClause();
        return;
      }

      switch (nextLexeme.type) {
        case lunr.QueryLexer.TERM:
          parser.nextClause();
          return lunr.QueryParser.parseTerm;

        case lunr.QueryLexer.FIELD:
          parser.nextClause();
          return lunr.QueryParser.parseField;

        case lunr.QueryLexer.EDIT_DISTANCE:
          return lunr.QueryParser.parseEditDistance;

        case lunr.QueryLexer.BOOST:
          return lunr.QueryParser.parseBoost;

        case lunr.QueryLexer.PRESENCE:
          parser.nextClause();
          return lunr.QueryParser.parsePresence;

        default:
          var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
          throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
      }
    };

    lunr.QueryParser.parseEditDistance = function (parser) {
      var lexeme = parser.consumeLexeme();

      if (lexeme == undefined) {
        return;
      }

      var editDistance = parseInt(lexeme.str, 10);

      if (isNaN(editDistance)) {
        var errorMessage = "edit distance must be numeric";
        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      parser.currentClause.editDistance = editDistance;
      var nextLexeme = parser.peekLexeme();

      if (nextLexeme == undefined) {
        parser.nextClause();
        return;
      }

      switch (nextLexeme.type) {
        case lunr.QueryLexer.TERM:
          parser.nextClause();
          return lunr.QueryParser.parseTerm;

        case lunr.QueryLexer.FIELD:
          parser.nextClause();
          return lunr.QueryParser.parseField;

        case lunr.QueryLexer.EDIT_DISTANCE:
          return lunr.QueryParser.parseEditDistance;

        case lunr.QueryLexer.BOOST:
          return lunr.QueryParser.parseBoost;

        case lunr.QueryLexer.PRESENCE:
          parser.nextClause();
          return lunr.QueryParser.parsePresence;

        default:
          var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
          throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
      }
    };

    lunr.QueryParser.parseBoost = function (parser) {
      var lexeme = parser.consumeLexeme();

      if (lexeme == undefined) {
        return;
      }

      var boost = parseInt(lexeme.str, 10);

      if (isNaN(boost)) {
        var errorMessage = "boost must be numeric";
        throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
      }

      parser.currentClause.boost = boost;
      var nextLexeme = parser.peekLexeme();

      if (nextLexeme == undefined) {
        parser.nextClause();
        return;
      }

      switch (nextLexeme.type) {
        case lunr.QueryLexer.TERM:
          parser.nextClause();
          return lunr.QueryParser.parseTerm;

        case lunr.QueryLexer.FIELD:
          parser.nextClause();
          return lunr.QueryParser.parseField;

        case lunr.QueryLexer.EDIT_DISTANCE:
          return lunr.QueryParser.parseEditDistance;

        case lunr.QueryLexer.BOOST:
          return lunr.QueryParser.parseBoost;

        case lunr.QueryLexer.PRESENCE:
          parser.nextClause();
          return lunr.QueryParser.parsePresence;

        default:
          var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
          throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
      }
    }
    /**
     * export the module via AMD, CommonJS or as a browser global
     * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
     */
    ;

    (function (root, factory) {
      {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like enviroments that support module.exports,
         * like Node.
         */
        module.exports = factory();
      }
    })(this, function () {
      /**
       * Just return a value to define the module export.
       * This example returns an object, but the module
       * can return a function as the exported value.
       */
      return lunr;
    });
  })();
})(lunr$1);

var lunr = lunr$1.exports;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach$2;

var defineProperty = _defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq = eq_1;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$3.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue$3(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$4.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    baseAssignValue = _baseAssignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$2(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject$4;

var copyObject$3 = _copyObject,
    keys$2 = keys_1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$3 = isObject_1,
    isPrototype$2 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;
/** Used for built-in method references. */

var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn$1(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$2 = isArrayLike_1;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
  var root = _root;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
})(_cloneBuffer, _cloneBuffer.exports);

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray$2;

var copyObject$1 = _copyObject,
    getSymbols$1 = _getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$1(source), object);
}

var _copySymbols = copySymbols$1;

var overArg = _overArg;
/** Built-in value references. */

var getPrototype$2 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;

var arrayPush = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols = _getSymbols,
    stubArray = stubArray_1;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype$1(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array = _Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var _Symbol = _Symbol$6;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;
/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor();

    case numberTag$1:
    case stringTag$2:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor();

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$2 = isObject_1;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate$1 = function () {
  function object() {}

  return function (proto) {
    if (!isObject$2(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype$1 = _isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject$1(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate(getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$3 = _getTag,
    isObjectLike$4 = isObjectLike_1;
/** `Object#toString` result references. */

var mapTag$2 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap$1(value) {
  return isObjectLike$4(value) && getTag$3(value) == mapTag$2;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$3 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap$1 = nodeIsMap ? baseUnary$3(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;

var getTag$2 = _getTag,
    isObjectLike$3 = isObjectLike_1;
/** `Object#toString` result references. */

var setTag$2 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet$1(value) {
  return isObjectLike$3(value) && getTag$2(value) == setTag$2;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$2 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet$1 = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue$1 = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$4 = isArray_1,
    isBuffer$1 = isBuffer$4.exports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys$1 = keys_1,
    keysIn = keysIn_1;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone$2(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$1(value)) {
    return value;
  }

  var isArr = isArray$4(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys$1;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue$1(result, key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$2;

var baseClone$1 = _baseClone;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

var identity = identity_1;
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */

function castFunction$2(value) {
  return typeof value == 'function' ? value : identity;
}

var _castFunction = castFunction$2;

var arrayEach = _arrayEach,
    baseEach = _baseEach,
    castFunction$1 = _castFunction,
    isArray$3 = isArray_1;
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */

function forEach(collection, iteratee) {
  var func = isArray$3(collection) ? arrayEach : baseEach;
  return func(collection, castFunction$1(iteratee));
}

var forEach_1 = forEach;

var DEFAULT_MAX_THREADS = 5;
function AppEmail(_ref) {
  var threads = _ref.threads,
      maxThreads = _ref.maxThreads,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(Inbox, {
    threads: threads,
    maxThreads: maxThreads || DEFAULT_MAX_THREADS,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "thread", ":threadId")
  }, /*#__PURE__*/React.createElement(EmailThread, {
    appUrl: appUrl,
    threads: threads
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "thread", ":threadId", "attachment", ":emailId"),
    render: function render(props) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: urljoin(appUrl, "thread", props.match.params.threadId)
      });
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "thread", ":threadId", "attachment", ":emailId", ":attchId")
  }, /*#__PURE__*/React.createElement(Attachment, {
    appUrl: appUrl,
    threads: threads
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

function Inbox(_ref2) {
  var threads = _ref2.threads,
      maxThreads = _ref2.maxThreads,
      appUrl = _ref2.appUrl;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  threads = cloneDeep_1(threads);
  forEach_1(threads, function (x, i) {
    return x.id = i;
  });
  var filteredThreads = searchQuery ? _searchThreads(threads, searchQuery) : threads;
  var firstThreads = filteredThreads.slice(0, maxThreads);
  var totalThreads = filteredThreads.length === threads.length ? threads.length <= maxThreads ? threads.length : "many" : filteredThreads.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-title"
  }, "Inbox"), /*#__PURE__*/React.createElement(SearchBox, {
    onSearch: function onSearch(q) {
      return setSearchQuery(q);
    }
  }), firstThreads.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-subtitle"
  }, "Showing ".concat(firstThreads.length, " of ").concat(totalThreads)) : null)), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-emails"
  }, firstThreads.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-no-results"
  }, "No messages matched your search.") : null, firstThreads.map(function (thread) {
    return /*#__PURE__*/React.createElement(InboxThread, {
      key: thread.id,
      thread: thread,
      appUrl: appUrl
    });
  }))));
}

function SearchBox(_ref3) {
  var onSearch = _ref3.onSearch;
  var input = useRef();

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      searchBoxValue = _useState4[0],
      setSearchBoxValue = _useState4[1];

  function searchHandler(evt) {
    evt.preventDefault();
    setSearchBoxValue(searchBoxValue);
    onSearch(searchBoxValue);
  }

  function clearHandler() {
    setSearchBoxValue("");
    onSearch("");
  }

  return /*#__PURE__*/React.createElement("form", {
    className: "AppEmail-inbox-search-bar",
    action: "#",
    onSubmit: searchHandler
  }, /*#__PURE__*/React.createElement("input", {
    type: "search",
    ref: input,
    className: "AppEmail-inbox-search-bar-input data-hj-allow",
    placeholder: "Search",
    value: searchBoxValue,
    onChange: function onChange(evt) {
      return setSearchBoxValue(evt.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames("AppEmail-inbox-search-bar-clear icon-cancel", {
      visible: searchBoxValue !== ""
    }),
    onClick: clearHandler
  }));
}

function InboxThread(_ref4) {
  var thread = _ref4.thread,
      appUrl = _ref4.appUrl;
  var emails = thread.emails,
      subject = thread.subject,
      contacts = thread.contacts;
  var lastEmail = last_1(thread.emails);
  return /*#__PURE__*/React.createElement(Link, {
    className: "AppEmail-inbox-email-link",
    key: thread.id,
    to: urljoin(appUrl, "thread", thread.id.toString())
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-email"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-email-date"
  }, lastEmail.dateShort, /*#__PURE__*/React.createElement("i", {
    className: "AppEmail-inbox-email-open-icon icon-right-open-big"
  })), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-email-from"
  }, contacts, emails.length > 1 ? /*#__PURE__*/React.createElement("span", {
    className: "AppEmail-inbox-email-count"
  }, emails.length) : null), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-inbox-email-subject"
  }, subject), /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "AppEmail-inbox-email-body",
    markdown: limitString(lastEmail.body.split("\n")[0], 100)
  })));
}

function EmailThread(_ref5) {
  var threads = _ref5.threads,
      appUrl = _ref5.appUrl;

  var _useParams = useParams(),
      threadId = _useParams.threadId;

  var thread = threads[threadId];
  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppEmail-thread-back-button",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread-subject"
  }, thread.subject), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread-emails"
  }, thread.emails.map(function (email, emailId) {
    return /*#__PURE__*/React.createElement(ThreadEmail, {
      key: emailId,
      threadId: threadId,
      emailId: emailId,
      email: email,
      appUrl: appUrl
    });
  }))));
}

function ThreadEmail(_ref6) {
  var email = _ref6.email,
      threadId = _ref6.threadId,
      emailId = _ref6.emailId,
      appUrl = _ref6.appUrl;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDetails = _useState6[0],
      toggleDetails = _useState6[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email-date"
  }, email.dateShort), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email-from-name"
  }, email.from.name || email.from.email), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email-to"
  }, "To: ", email.to.map(function (x) {
    return x.name || x.email;
  }).join(", "), /*#__PURE__*/React.createElement("span", {
    className: classnames("AppEmail-email-details-button icon-angle-down", {
      open: showDetails
    }),
    onClick: function onClick() {
      return toggleDetails(!showDetails);
    }
  })), /*#__PURE__*/React.createElement(EmailDetails, {
    email: email,
    visible: showDetails
  }), /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "AppEmail-email-body",
    markdown: email.body
  }), (email.attachments || []).map(function (attch, attchId) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "AppEmail-email-attachment-link",
      key: attchId,
      to: urljoin(appUrl, "thread", threadId.toString(), "attachment", emailId.toString(), attchId.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment-type"
    }, attch.type), /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment-name"
    }, attch.name), /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment-size"
    }, attch.size)), /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-email-attachment-download icon-download-alt"
    })));
  }));
}

function EmailDetails(_ref7) {
  var email = _ref7.email,
      visible = _ref7.visible;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("AppEmail-email-details", {
      visible: visible
    })
  }, /*#__PURE__*/React.createElement(EmailDetailsItem, {
    title: "From",
    value: "".concat(email.from.name, " <").concat(email.from.email, ">")
  }), /*#__PURE__*/React.createElement(EmailDetailsItem, {
    title: "To",
    value: email.to.map(function (x) {
      return "".concat(x.name, " <").concat(x.email, ">");
    }).join(", ")
  }), /*#__PURE__*/React.createElement(EmailDetailsItem, {
    title: "Date",
    value: email.dateLong
  }));
}

function EmailDetailsItem(_ref8) {
  var title = _ref8.title,
      value = _ref8.value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email-details-item-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-email-details-item-value"
  }, value));
}

var Attachment = observer(function (_ref9) {
  var threads = _ref9.threads,
      appUrl = _ref9.appUrl;

  var _useParams2 = useParams(),
      threadId = _useParams2.threadId,
      emailId = _useParams2.emailId,
      attchId = _useParams2.attchId;

  var State = useAppStore();
  var PhoneState = usePhoneState();
  var email = threads[threadId].emails[emailId];
  var attch = email.attachments[attchId];
  var locked = !!attch.password && !State.unlockedAttachments[attch.id];
  var downloading = !State.downloadedAttachments[attch.id];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      password = _useState8[0],
      setPassword = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      wrongPassword = _useState10[0],
      setWrongPassword = _useState10[1];

  useEffect(function () {
    if (downloading) {
      var timer = setTimeout(function () {
        return State.downloadAttachment(attch.id);
      }, 2000);
      return function () {
        return clearTimeout(timer);
      };
    }

    if (wrongPassword) {
      var _timer = setTimeout(function () {
        return setWrongPassword(false);
      }, 300);

      return function () {
        return clearTimeout(_timer);
      };
    }
  }, [State, attch.id, downloading, wrongPassword]);

  function onPasswordChange(newPassword) {
    setPassword(newPassword);
  }

  function onPasswordSubmit() {
    if (attch.password.toLowerCase() === password.toLowerCase()) {
      State.unlockAttachment(attch.id);

      if (attch.unlockEvent) {
        PhoneState.fireEvent(attch.unlockEvent, {
          delayMs: attch.unlockEventDelay
        });
      }
    } else {
      setWrongPassword(true);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-thread-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppEmail-thread-back-button",
    to: urljoin(appUrl, "thread", threadId.toString())
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  }))), /*#__PURE__*/React.createElement(AttachmentContent, {
    attch: attch,
    downloading: downloading,
    locked: locked,
    password: password,
    wrongPassword: wrongPassword,
    onPasswordChange: onPasswordChange,
    onPasswordSubmit: onPasswordSubmit
  }));
});

function AttachmentContent(_ref10) {
  var attch = _ref10.attch,
      downloading = _ref10.downloading,
      locked = _ref10.locked,
      password = _ref10.password,
      wrongPassword = _ref10.wrongPassword,
      onPasswordChange = _ref10.onPasswordChange,
      onPasswordSubmit = _ref10.onPasswordSubmit;

  if (downloading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-attachment-downloading"
    }, "Downloading ", /*#__PURE__*/React.createElement("b", null, "".concat(attch.name, ".").concat(attch.type)), "...");
  }

  if (locked) {
    return /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-attachment-password-protector"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-attachment-password-text"
    }, "This document is password protected."), /*#__PURE__*/React.createElement(PasswordInput, {
      className: classnames("AppEmail-attachment-password-textbox", {
        error: wrongPassword
      }),
      value: password,
      onChange: function onChange(evt) {
        return onPasswordChange(evt.target.value);
      },
      placeholder: "Enter password"
    }), /*#__PURE__*/React.createElement("div", {
      className: "AppEmail-attachment-password-submit",
      onClick: onPasswordSubmit
    }, "Unlock"));
  }

  return /*#__PURE__*/React.createElement(AttachmentImage, {
    attachment: attch
  });
}

function AttachmentImage(_ref11) {
  var attachment = _ref11.attachment;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppEmail-attachment-image-wrapper"
  }, /*#__PURE__*/React.createElement(ZoomableImage, {
    src: attachment.image,
    className: "AppEmail-attachment-image",
    resetOnDoubleClick: true,
    noCenter: true,
    limitToBounds: false
  }));
}

function _searchThreads(threads, q) {
  var idx = lunr(function () {
    var _this = this;

    this.ref("id");
    this.field("subject");
    this.field("body");
    this.field("fromName");
    this.field("fromEmail");
    forEach_1(threads, function (thread, threadId) {
      forEach_1(thread.emails, function (email, emailId) {
        _this.add({
          id: "".concat(threadId, "|").concat(emailId),
          subject: thread.subject,
          body: email.body,
          fromName: email.from.name,
          fromEmail: email.from.email
        });
      });
    });
  });
  var results = [];

  try {
    results = idx.search(escapeLunrQueryString(q));
  } catch (err) {// nothing
  }

  var threadIds = [];
  forEach_1(results, function (result) {
    var threadId = parseInt(result.ref.split("|")[0]);

    if (!threadIds.includes(threadId)) {
      threadIds.push(threadId);
    }
  });
  return threadIds.map(function (threadId) {
    return threads[threadId];
  });
}

function AppStreaming(_ref) {
  var sections = _ref.sections,
      titles = _ref.titles,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  var commonParams = {
    sections: sections,
    titles: titles,
    appUrl: appUrl
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(Index$1, commonParams)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "title", ":section_id", ":title_id")
  }, /*#__PURE__*/React.createElement(Title$1, commonParams)), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

function Index$1(_ref2) {
  var sections = _ref2.sections,
      titles = _ref2.titles,
      appUrl = _ref2.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-index-sections"
  }, sections.map(function (section, i) {
    return /*#__PURE__*/React.createElement(IndexSection, {
      key: i,
      sectionId: i,
      section: section,
      titles: titles,
      appUrl: appUrl
    });
  }));
}

function IndexSection(_ref3) {
  var section = _ref3.section,
      sectionId = _ref3.sectionId,
      titles = _ref3.titles,
      appUrl = _ref3.appUrl;
  var sectionTitles = section.titles.map(function (x) {
    return titles[x];
  });
  var screenRef = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      screenWidth = _useState2[0],
      setScreenWidth = _useState2[1];

  useEffect(function () {
    var _screenRef$current;

    var currentWidth = (_screenRef$current = screenRef.current) === null || _screenRef$current === void 0 ? void 0 : _screenRef$current.clientWidth;

    if (currentWidth && currentWidth !== screenWidth) {
      setScreenWidth(currentWidth);
    }
  }, [screenRef, screenWidth]);
  return /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-section",
    ref: screenRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-section-name"
  }, section.name), /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-section-titles"
  }, sectionTitles.map(function (title, titleId) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "AppStreaming-section-title",
      style: _objectSpread2({
        backgroundImage: "url(".concat(title.image, ")")
      }, calcTileDimensions(screenWidth)),
      key: titleId,
      to: urljoin(appUrl, "title", sectionId.toString(), titleId.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppStreaming-section-title-name"
    }, title.title));
  })));
}

function Title$1(_ref4) {
  var sections = _ref4.sections,
      titles = _ref4.titles,
      appUrl = _ref4.appUrl;

  var _useParams = useParams(),
      title_id = _useParams.title_id,
      section_id = _useParams.section_id;

  var title = titles[sections[section_id].titles[title_id]];
  var friends = title.friends;
  var friendsStr = "";
  forEach_1(friends, function (friend, i) {
    if (i === friends.length - 1 && i !== 0) friendsStr += " and ";else if (i > 0) friendsStr += ", ";
    friendsStr += friend;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppStreaming-title-back-button",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-bg",
    style: {
      backgroundImage: "url(".concat(title.image, ")")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-name"
  }, title.title)), /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-details-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "AppStreaming-title-details-info-detail"
  }, title.year), /*#__PURE__*/React.createElement("span", {
    className: "AppStreaming-title-details-info-detail"
  }, "".concat(title.seasons, " season").concat(pluralize(title.seasons))), /*#__PURE__*/React.createElement("span", {
    className: "AppStreaming-title-details-info-detail hd"
  }, "HD")), friends.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-friends"
  }, "Your friend".concat(pluralize(friends.length), " ").concat(friendsStr, " also like this title.")) : null, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-details-offline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-details-offline-title"
  }, "No Internet Connection"), /*#__PURE__*/React.createElement("div", {
    className: "AppStreaming-title-details-offline-text"
  }, "Check your network settings and try again."))));
}

function calcTileDimensions(screenWidth) {
  if (!screenWidth) {
    return {};
  }

  var tilesPerRow = screenWidth < 340 ? 2.8 : 3.8;
  var width = screenWidth / tilesPerRow;
  var height = width * 1.5;
  return {
    width: width,
    height: height
  };
}

var styles$7 = {"post":"AppSocial-module_post__cc0IY","profilePic":"AppSocial-module_profilePic__1Z9Jl","profilePic__image":"AppSocial-module_profilePic__image__3ZS0q","header":"AppSocial-module_header__2PayE","header__info":"AppSocial-module_header__info__nTYjT","header__name":"AppSocial-module_header__name__2L8B1","header__username":"AppSocial-module_header__username__3IYY4","header__time":"AppSocial-module_header__time__1y_ys","body":"AppSocial-module_body__1Hvom","image":"AppSocial-module_image__LxGSf","image__image":"AppSocial-module_image__image__2KHZ8","stats":"AppSocial-module_stats__1nZwa","stats__item":"AppSocial-module_stats__item__3Uz2j","youtube":"AppSocial-module_youtube__3qD2N","giphy":"AppSocial-module_giphy__qqt0A"};

function LoginScreen(_ref) {
  var username = _ref.username,
      password = _ref.password,
      onLogin = _ref.onLogin,
      className = _ref.className,
      usernameText = _ref.usernameText,
      usernameType = _ref.usernameType,
      submitText = _ref.submitText,
      errorText = _ref.errorText,
      backgroundColor = _ref.backgroundColor,
      appName = _ref.appName,
      children = _ref.children;
  var phoneState = usePhoneState();
  var storageKeyPrefix = "LoginScreen_".concat(appName || "", "_");
  var usernameValue = phoneState.storyState.sessionStorage["".concat(storageKeyPrefix, "username")] || "";
  var passwordValue = phoneState.storyState.sessionStorage["".concat(storageKeyPrefix, "password")] || "";

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showError = _useState2[0],
      setShowError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      errorAnimation = _useState4[0],
      setErrorAnimation = _useState4[1];

  usernameText = usernameText || "Username";
  var submitEnabled = usernameValue && passwordValue;

  function onSubmit() {
    if (username.toLowerCase() === usernameValue.toLowerCase() && password.toLowerCase() === passwordValue.toLowerCase()) {
      onLogin && onLogin();
    } else {
      setShowError(true);
      setErrorAnimation(true);
      setTimeout(function () {
        setErrorAnimation(false);
      }, 300);
    }
  }

  function handleUsernameChange(evt) {
    phoneState.setSessionStorage("".concat(storageKeyPrefix, "username"), evt.target.value);
  }

  function handlePasswordChange(evt) {
    phoneState.setSessionStorage("".concat(storageKeyPrefix, "password"), evt.target.value);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("LoginScreen", className),
    style: {
      backgroundColor: backgroundColor
    }
  }, children, /*#__PURE__*/React.createElement("input", {
    className: "LoginScreen-textbox username data-hj-allow",
    value: usernameValue,
    onChange: handleUsernameChange,
    placeholder: usernameText,
    type: usernameType || "text",
    "data-lpignore": "true"
  }), /*#__PURE__*/React.createElement(PasswordInput, {
    className: "LoginScreen-textbox password",
    value: passwordValue,
    onChange: handlePasswordChange,
    placeholder: "Password"
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames("LoginScreen-submit-button", {
      disabled: !submitEnabled,
      error: errorAnimation
    }),
    onClick: onSubmit
  }, submitText || "Log In"), /*#__PURE__*/React.createElement("div", {
    className: classnames("LoginScreen-error", {
      visible: showError
    })
  }, errorText || "Please check your ".concat(usernameText.toLowerCase(), " and password.")));
}

var LoginScreen$1 = observer(LoginScreen);

var HAS_WEBP = _hasWebpImageFormatSupport();
var IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
function vibrateShort() {
  vibrate(10);
}
function vibrate(durationMs) {
  if (window.Android && window.Android.vibrate) {
    try {
      window.Android.vibrate(durationMs);
    } catch (e) {}

    return;
  }

  window.navigator && window.navigator.vibrate && window.navigator.vibrate(durationMs);
}

function _hasWebpImageFormatSupport() {
  var elem = document.createElement("canvas");

  if (!!(elem.getContext && elem.getContext("2d"))) {
    // was able or not to get WebP representation
    return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
  } else {
    // very old browser like IE 8, canvas not supported
    return false;
  }
}

var APP_ICONS = {
  browser: browser,
  photos: photos,
  messages: messages,
  phone: phone,
  contacts: contacts,
  notes: notes,
  email: email,
  streaming: streaming,
  calculator: calculator,
  authenticator: authenticator,
  chat: chat,
  findFriends: findFriends,
  news: news,
  home: home,
  calendar: calendar,
  dating: dating,
  vault: HAS_WEBP ? vaultWebp : vault,
  social: HAS_WEBP ? socialWebp : social // pizza: HAS_WEBP ? pizzaWebp : pizza,

};
function getAppIconUrl(app) {
  return app.iconUrl || APP_ICONS[app.icon || app.type || app.name];
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x$1 = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;

function z(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;

reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

reactIs_production_min.isConcurrentMode = A;

reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k;
};

reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h;
};

reactIs_production_min.isElement = function (a) {
  return "object" === _typeof(a) && null !== a && a.$$typeof === c;
};

reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n;
};

reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};

reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};

reactIs_production_min.isMemo = function (a) {
  return z(a) === r;
};

reactIs_production_min.isPortal = function (a) {
  return z(a) === d;
};

reactIs_production_min.isProfiler = function (a) {
  return z(a) === g;
};

reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f;
};

reactIs_production_min.isSuspense = function (a) {
  return z(a) === p;
};

reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x$1 || a.$$typeof === y || a.$$typeof === v);
};

reactIs_production_min.typeOf = z;

var reactIs_development = {};

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (_typeof(object) === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    reactIs_development.AsyncMode = AsyncMode;
    reactIs_development.ConcurrentMode = ConcurrentMode;
    reactIs_development.ContextConsumer = ContextConsumer;
    reactIs_development.ContextProvider = ContextProvider;
    reactIs_development.Element = Element;
    reactIs_development.ForwardRef = ForwardRef;
    reactIs_development.Fragment = Fragment;
    reactIs_development.Lazy = Lazy;
    reactIs_development.Memo = Memo;
    reactIs_development.Portal = Portal;
    reactIs_development.Profiler = Profiler;
    reactIs_development.StrictMode = StrictMode;
    reactIs_development.Suspense = Suspense;
    reactIs_development.isAsyncMode = isAsyncMode;
    reactIs_development.isConcurrentMode = isConcurrentMode;
    reactIs_development.isContextConsumer = isContextConsumer;
    reactIs_development.isContextProvider = isContextProvider;
    reactIs_development.isElement = isElement;
    reactIs_development.isForwardRef = isForwardRef;
    reactIs_development.isFragment = isFragment;
    reactIs_development.isLazy = isLazy;
    reactIs_development.isMemo = isMemo;
    reactIs_development.isPortal = isPortal;
    reactIs_development.isProfiler = isProfiler;
    reactIs_development.isStrictMode = isStrictMode;
    reactIs_development.isSuspense = isSuspense;
    reactIs_development.isValidElementType = isValidElementType;
    reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var printWarning$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;
var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = assign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (_typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = _typeof(propValue);

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod

  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var defaultAttributes = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Converts string to KebabCase
 * Copied from scripts/helper. If anyone knows how to properly import it here
 * then please fix it.
 *
 * @param {string} string
 * @returns {string} A kebabized string
 */

var toKebabCase = function toKebabCase(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};
var createReactComponent = (function (iconName, iconNode) {
  var Component = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? 'currentColor' : _ref$color,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$strokeWidth = _ref.strokeWidth,
        strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
        rest = _objectWithoutPropertiesLoose(_ref, ["color", "size", "strokeWidth"]);

    return /*#__PURE__*/createElement('svg', _extends$1({
      ref: ref
    }, defaultAttributes, {
      width: size,
      height: size,
      stroke: color,
      strokeWidth: strokeWidth,
      className: "lucide lucide-" + toKebabCase(iconName)
    }, rest), iconNode.map(function (_ref2) {
      var tag = _ref2[0],
          attrs = _ref2[1];
      return /*#__PURE__*/createElement(tag, attrs);
    }));
  });
  Component.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  Component.displayName = "" + iconName;
  return Component;
});

var Heart = createReactComponent('Heart', [['path', {
  d: 'M20.42 4.58a5.4 5.4 0 00-7.65 0l-.77.78-.77-.78a5.4 5.4 0 00-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z',
  key: '17cbic'
}]]);
var IconHeart = Heart;

var MessageSquare = createReactComponent('MessageSquare', [['path', {
  d: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  key: 'oy5hii'
}]]);
var IconMessageSquare = MessageSquare;

var Repeat = createReactComponent('Repeat', [['path', {
  d: 'M17 2l4 4-4 4',
  key: '1cym3q'
}], ['path', {
  d: 'M3 11v-1a4 4 0 014-4h14',
  key: '1560lm'
}], ['path', {
  d: 'M7 22l-4-4 4-4',
  key: '1nsetm'
}], ['path', {
  d: 'M21 13v1a4 4 0 01-4 4H3',
  key: 'u4xipj'
}]]);
var IconRepeat = Repeat;

function AppSocial(_ref) {
  var messages = _ref.messages,
      notifications = _ref.notifications,
      feed = _ref.feed,
      profiles = _ref.profiles,
      login = _ref.login,
      theme = _ref.theme,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  var phoneState = usePhoneState();
  var themeClassName = theme ? "theme-".concat(theme) : null;

  if (login && !phoneState.storyState.unlockedApps.social) {
    return /*#__PURE__*/React.createElement(LoginScreen$1, {
      appName: "social",
      className: classnames("AppSocial-login", themeClassName),
      username: login.username,
      password: login.password,
      usernameText: "Email",
      usernameType: "email",
      onLogin: function onLogin() {
        return phoneState.unlockApp("social");
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "AppSocial-login-icon",
      src: login.icon || APP_ICONS.social,
      alt: ""
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("AppSocial", themeClassName)
  }, /*#__PURE__*/React.createElement(Header$1, {
    rootUrl: appUrl
  }), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(NewsFeed, {
    feed: feed,
    profiles: profiles,
    appUrl: appUrl,
    offline: !phoneState.isPhoneOnline
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "messages")
  }, /*#__PURE__*/React.createElement(MessagesIndex$1, {
    messages: messages,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "notifications")
  }, /*#__PURE__*/React.createElement(Notifications, {
    notifications: notifications || [],
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "messages/:threadId")
  }, /*#__PURE__*/React.createElement(MessagesThread$1, {
    appUrl: appUrl,
    messages: messages
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

var AppSocial$1 = observer(AppSocial);
var Header$1 = withRouter(function (_ref2) {
  var rootUrl = _ref2.rootUrl,
      location = _ref2.location;
  var pathname = location.pathname;
  var title = pathname.includes("messages") ? "Chat" : pathname.includes("notifications") ? "Notifications" : "News Feed";
  var indicatorLeft = pathname.includes("messages") ? "200%" : pathname.includes("notifications") ? "100%" : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-header-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-header-menu"
  }, /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    to: rootUrl,
    className: "AppSocial-header-menu-button"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-newspaper"
  })), /*#__PURE__*/React.createElement(NavLink, {
    to: urljoin(rootUrl, "notifications"),
    className: "AppSocial-header-menu-button"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-globe"
  })), /*#__PURE__*/React.createElement(NavLink, {
    to: urljoin(rootUrl, "messages"),
    className: "AppSocial-header-menu-button"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-comment"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-header-menu-indicator",
    style: {
      transform: "translateX(".concat(indicatorLeft, ")")
    }
  }));
});

function NewsFeed(_ref3) {
  var feed = _ref3.feed,
      profiles = _ref3.profiles,
      offline = _ref3.offline;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-newsfeed"
  }, feed ? feed.map(function (post, i) {
    return /*#__PURE__*/React.createElement(Post, {
      key: i,
      post: post,
      profile: profiles[post.profileId]
    });
  }) : offline ? /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-newsfeed-offline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-newsfeed-offline-icon icon-no-sign"
  }), "No Internet") : /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-newsfeed-no-news"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-newsfeed-no-news-icon icon-newspaper"
  }), "No News"));
}

function Notifications(_ref4) {
  var notifications = _ref4.notifications;
  var noNotifications = notifications.length === 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-notifications"
  }, noNotifications ? /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-notifications-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-notifications-none-icon icon-globe"
  }), "No Notifications") : null);
}

function MessagesIndex$1(_ref5) {
  var messages = _ref5.messages,
      appUrl = _ref5.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-messages"
  }, messages.map(function (thread, threadId) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "AppSocial-messages-contact",
      key: threadId,
      to: urljoin(appUrl, "messages", threadId.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppSocial-messages-contact-icon-wrapper"
    }, /*#__PURE__*/React.createElement(ContactPhoto, {
      contact: {
        photo: thread.photo || thread.contacts[0].photo
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "AppSocial-messages-contact-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppSocial-messages-contact-name"
    }, thread.name || thread.contacts[0].name), /*#__PURE__*/React.createElement("div", {
      className: "AppSocial-messages-contact-last-message"
    }, last_1(thread.messages).text, /*#__PURE__*/React.createElement("span", {
      className: "AppSocial-messages-contact-last-message-time"
    }, last_1(thread.messages).time))));
  }));
}

function MessagesThread$1(_ref6) {
  var messages = _ref6.messages;

  var _useParams = useParams(),
      threadId = _useParams.threadId;

  var thread = messages[threadId];
  var scroller = useRef();
  useEffect(function () {
    scroller.current.scrollTop = scroller.current.scrollHeight;
  }, []); // TODO: not always?

  return /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-thread"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-thread-top-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-thread-details-name"
  }, thread.name || thread.contacts[0].name)), /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-thread-messages-wrapper",
    ref: scroller
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-thread-messages"
  }, thread.messages.map(function (message, i) {
    return /*#__PURE__*/React.createElement(Message$1, {
      key: i,
      message: message,
      contacts: thread.contacts
    });
  }))));
}

function Message$1(_ref7) {
  var message = _ref7.message,
      contacts = _ref7.contacts;
  var fromIndex = message.fromIndex;
  var outgoing = fromIndex === -1;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("AppSocial-message", outgoing ? "out" : "in")
  }, outgoing ? null : /*#__PURE__*/React.createElement(ContactPhoto, {
    className: "AppSocial-message-from-photo",
    contact: {
      photo: contacts[fromIndex].photo
    },
    size: 30
  }), /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-message-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("AppSocial-message-content-inner", {
      text: !!message.text,
      image: !!message.image
    })
  }, message.image ? /*#__PURE__*/React.createElement("img", {
    className: "AppSocial-message-content-image",
    src: message.image,
    alt: ""
  }) : null, message.text), /*#__PURE__*/React.createElement("div", {
    className: "AppSocial-message-time"
  }, message.time)));
}

function Post(_ref8) {
  var post = _ref8.post,
      profile = _ref8.profile;
  var name = profile.name,
      username = profile.username,
      picture = profile.picture;
  var time = post.time,
      content = post.content,
      image = post.image,
      likes = post.likes,
      reposts = post.reposts,
      comments = post.comments,
      youtube = post.youtube,
      giphy = post.giphy;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.post
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7.profilePic
  }, /*#__PURE__*/React.createElement("img", {
    className: styles$7.profilePic__image,
    src: picture,
    alt: name
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$7.contents
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$7.header__info
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$7.header__name
  }, name), /*#__PURE__*/React.createElement("span", {
    className: styles$7.header__username
  }, "@".concat(username))), /*#__PURE__*/React.createElement("span", {
    className: styles$7.header__time
  }, time)), /*#__PURE__*/React.createElement(MarkdownContent, {
    className: styles$7.body,
    markdown: content
  }), image ? /*#__PURE__*/React.createElement("div", {
    className: styles$7.image
  }, /*#__PURE__*/React.createElement("img", {
    className: styles$7.image__image,
    src: image,
    alt: ""
  })) : youtube ? /*#__PURE__*/React.createElement(YoutubeVideo, {
    youtubeId: youtube
  }) : giphy ? /*#__PURE__*/React.createElement(Giphy, {
    gifId: giphy
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$7.stats
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7.stats__item
  }, /*#__PURE__*/React.createElement(IconHeart, {
    size: "1.1em"
  }), likes || null), /*#__PURE__*/React.createElement("div", {
    className: styles$7.stats__item
  }, /*#__PURE__*/React.createElement(IconRepeat, {
    size: "1.1em"
  }), reposts || null), /*#__PURE__*/React.createElement("div", {
    className: styles$7.stats__item
  }, /*#__PURE__*/React.createElement(IconMessageSquare, {
    size: "1.1em"
  }), comments || null))));
}

function YoutubeVideo(_ref9) {
  var youtubeId = _ref9.youtubeId;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.youtube
  }, /*#__PURE__*/React.createElement("iframe", {
    width: "100%",
    height: "auto",
    src: "https://www.youtube-nocookie.com/embed/".concat(youtubeId),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }));
}

function Giphy(_ref10) {
  var gifId = _ref10.gifId;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.giphy
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: 0,
      "padding-bottom": "75%",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://giphy.com/embed/".concat(gifId),
    width: "100%",
    height: "100%",
    style: {
      position: "absolute"
    },
    frameBorder: "0",
    className: "giphy-embed",
    title: "Giphy",
    allowFullScreen: true
  })));
}

var FILE_ICONS = {
  document: iconDocument,
  photo: iconPhoto
};
function AppFolder(_ref) {
  var items = _ref.items,
      folderName = _ref.folderName,
      bgImage = _ref.bgImage,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath,
      rootUrl = _ref.rootUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("AppFolder", {
      bgImage: !!bgImage
    }),
    style: {
      backgroundImage: bgImage ? "url(".concat(bgImage, ")") : null
    }
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(Folder, {
    title: folderName,
    items: items,
    appUrl: appUrl,
    rootUrl: rootUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, ":itemId")
  }, /*#__PURE__*/React.createElement(ItemContent, {
    appUrl: appUrl,
    items: items
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

function Folder(_ref2) {
  var title = _ref2.title,
      items = _ref2.items,
      appUrl = _ref2.appUrl,
      rootUrl = _ref2.rootUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder-items"
  }, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(FolderItem, {
      key: i,
      item: item,
      itemIndex: i,
      appUrl: appUrl,
      rootUrl: rootUrl
    });
  })));
}

function FolderItem(_ref3) {
  var item = _ref3.item,
      itemIndex = _ref3.itemIndex,
      appUrl = _ref3.appUrl,
      rootUrl = _ref3.rootUrl;
  var linkTo = item.type === "app" ? urljoin(rootUrl, item.appName) : urljoin(appUrl, itemIndex.toString());
  var icon = item.type === "app" ? APP_ICONS[item.icon || item.appName] : FILE_ICONS[item.icon];
  return /*#__PURE__*/React.createElement(Link, {
    to: linkTo
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder-item-icon-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    className: "AppFolder-folder-item-icon",
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-folder-item-name"
  }, item.title)));
}

function ItemContent(_ref4) {
  var appUrl = _ref4.appUrl,
      items = _ref4.items;

  var _useParams = useParams(),
      itemId = _useParams.itemId;

  var item = items[itemId]; // TODO: support other item types

  return /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-file"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppFolder-file-top-bar"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "AppFolder-file-back-button",
    to: appUrl
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  })), item.title), /*#__PURE__*/React.createElement(ZoomableImage, {
    src: item.image,
    className: "AppFolder-file-image",
    showSpinner: true
  }));
}

window.buffer = require("@otplib/preset-browser/buffer.js");

var otp = require("@otplib/preset-browser").authenticator;

var REFRESH_RATE_SEC = 30;
function AppAuthenticator(_ref) {
  var entries = _ref.entries;

  var _useState = useState(_getCodes(entries)),
      _useState2 = _slicedToArray(_useState, 2),
      codes = _useState2[0],
      setCodes = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      timeLeft = _useState4[0],
      setTimeLeft = _useState4[1];

  var timeLeftRef = useRef(REFRESH_RATE_SEC);
  useEffect(function () {
    timeLeftRef.current = REFRESH_RATE_SEC;
    var interval = setInterval(function () {
      timeLeftRef.current -= 1;

      if (timeLeftRef.current === 0) {
        setCodes(_getCodes(entries));
        timeLeftRef.current = 30;
      }

      setTimeLeft(timeLeftRef.current);
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [entries]);
  return /*#__PURE__*/React.createElement("div", {
    className: "AppAuthenticator"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppAuthenticator-title"
  }, "Authenticator"), /*#__PURE__*/React.createElement("div", {
    className: "AppAuthenticator-entries"
  }, entries.map(function (entry, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "AppAuthenticator-entry"
    }, /*#__PURE__*/React.createElement("div", {
      className: "AppAuthenticator-entry-code"
    }, codes[i].match(/.{1,3}/g).join(" ")), /*#__PURE__*/React.createElement("div", {
      className: "AppAuthenticator-entry-name"
    }, entry.name), /*#__PURE__*/React.createElement("div", {
      className: "AppAuthenticator-entry-time"
    }, timeLeft));
  })));
}

function _getCodes(entries) {
  otp.options = {
    step: 30,
    digits: 6,
    window: 10 // TODO: needed here or just on validation?

  };
  return entries.map(function (entry) {
    return otp.generate(entry.secret);
  });
}

function AppFindFriends(_ref) {
  var entries = _ref.entries;
      _ref.appUrl;
      _ref.appPath;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-title"
  }, "Find My Friends"), /*#__PURE__*/React.createElement(FindFriendsMap, {
    entry: entries[selected]
  }), /*#__PURE__*/React.createElement(FindFriendsList, {
    entries: entries,
    selected: selected,
    onSelected: function onSelected(index) {
      return setSelected(index);
    }
  }));
}

function FindFriendsMap(_ref2) {
  var entry = _ref2.entry;
  var src = entry ? entry.map : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-map",
    style: {
      backgroundImage: "url(".concat(src, ")")
    }
  });
}

function FindFriendsList(_ref3) {
  var entries = _ref3.entries,
      selected = _ref3.selected,
      onSelected = _ref3.onSelected;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-list"
  }, entries.map(function (entry, i) {
    return /*#__PURE__*/React.createElement(FindFriendsEntry, {
      key: i,
      index: i,
      entry: entry,
      isSelected: i === selected,
      onSelected: onSelected
    });
  }));
}

function FindFriendsEntry(_ref4) {
  var entry = _ref4.entry,
      index = _ref4.index,
      isSelected = _ref4.isSelected,
      onSelected = _ref4.onSelected;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-entry",
    onClick: function onClick() {
      return onSelected(index);
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "AppFindFriends-entry-img",
    src: entry.image,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-entry-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("AppFindFriends-entry-name", {
      selected: isSelected
    })
  }, entry.name), /*#__PURE__*/React.createElement("div", {
    className: "AppFindFriends-entry-location"
  }, entry.location, " - ", entry.time)));
}

function AppNews(_ref) {
  var title = _ref.title,
      items = _ref.items,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  var State = useAppStore();

  var filteredItems = _filterItems(items, State.visibleArticles);

  return /*#__PURE__*/React.createElement("div", {
    className: "AppNews"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(NewsIndex, {
    title: title,
    items: filteredItems,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "item", ":itemId")
  }, /*#__PURE__*/React.createElement(NewsItem, {
    appUrl: appUrl,
    items: filteredItems
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

var AppNews$1 = observer(AppNews);

function NewsIndex(_ref2) {
  var title = _ref2.title,
      items = _ref2.items;
      _ref2.appTitle;
      _ref2.itemTitle;
      var appUrl = _ref2.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppNews-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNews-index"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppNews-index-title"
  }, title || "Breaking News"), items.length > 0 ? /*#__PURE__*/React.createElement(NewsIndexItem, {
    featured: true,
    item: items[0],
    appUrl: appUrl
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "AppNews-index-items"
  }, items.slice(1).map(function (item, itemId) {
    return /*#__PURE__*/React.createElement(NewsIndexItem, {
      key: itemId,
      item: item,
      appUrl: appUrl
    });
  }))));
}

var NewsIndexItem = observer(function (_ref3) {
  var item = _ref3.item,
      featured = _ref3.featured,
      appUrl = _ref3.appUrl;
  var State = useAppStore();
  var unread = State.unreadArticles[item.id];
  return /*#__PURE__*/React.createElement(Link, {
    to: urljoin(appUrl, "item", item.id),
    className: classnames("NewsIndexItem", {
      featured: featured,
      list: !featured
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "NewsIndexItem-image",
    style: {
      backgroundImage: "url(\"".concat(item.image, "\")")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "NewsIndexItem-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "NewsIndexItem-title"
  }, unread ? /*#__PURE__*/React.createElement("span", {
    className: "NewsIndexItem-unread"
  }, "New") : null, item.title), item.subtitle ? /*#__PURE__*/React.createElement("div", {
    className: "NewsIndexItem-subtitle"
  }, item.subtitle) : null));
});

function NewsItem(_ref4) {
  var items = _ref4.items;
      _ref4.appUrl;

  var _useParams = useParams(),
      itemId = _useParams.itemId;

  var State = useAppStore();
  var item = find_1(items, function (x) {
    return x.id === itemId;
  });
  useEffect(function () {
    return State.markArticleAsRead(itemId);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "AppNews-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "NewsItem"
  }, /*#__PURE__*/React.createElement("img", {
    className: "NewsItem-image",
    src: item.image,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "NewsItem-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "NewsItem-title"
  }, item.title), /*#__PURE__*/React.createElement("div", {
    className: "NewsItem-subtitle"
  }, item.subtitle), /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "NewsItem-body",
    markdown: item.contents
  }))));
}

function _filterItems(items, visibleItems) {
  return (items || []).filter(function (x) {
    return x.visible || visibleItems[x.id];
  });
}

function DayDetails(_ref) {
  var selectedDay = _ref.selectedDay,
      events = _ref.events;
  var dayEvents = events.filter(function (event) {
    return dayjs(event.date).isSame(selectedDay, "day");
  });
  var titleText = selectedDay.format("MMM D, YYYY");
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-dayDetails-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-dayDetails-titleContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-dayDetails-title"
  }, "".concat(titleText, " \n\n"))), /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-dayDetails-body-container"
  }, /*#__PURE__*/React.createElement(Body, {
    events: dayEvents
  })));
}

function Body(_ref2) {
  var events = _ref2.events;

  if (events.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "AppCalendar-eventCell-body-noEvents"
    }, "No events");
  }

  return events.map(function (event, i) {
    return /*#__PURE__*/React.createElement(EventCell, {
      key: i,
      event: event
    });
  });
}

function EventCell(_ref3) {
  var event = _ref3.event;
  var time = dayjs(event.date).format("hh:mm A");
  var title = "".concat(time, " - ").concat(event.title || "[Untitled]");
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-eventCell-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-eventCell-title"
  }, title), event.body ? /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-eventCell-body"
  }, event.body) : null);
}

function CalendarHeader(_ref) {
  var selectedMonth = _ref.selectedMonth,
      onMonthChange = _ref.onMonthChange;
  var month = selectedMonth.format("MMMM");
  var year = selectedMonth.format("YYYY");
  var nextMonth = selectedMonth.clone().add(1, "month");
  var prevMonth = selectedMonth.clone().subtract(1, "month");
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-header"
  }, /*#__PURE__*/React.createElement(NavButton, {
    icon: "«",
    onClick: function onClick() {
      return onMonthChange(prevMonth);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-header-title"
  }, "".concat(month, " ").concat(year)), /*#__PURE__*/React.createElement(NavButton, {
    icon: "»",
    onClick: function onClick() {
      return onMonthChange(nextMonth);
    }
  }));
}

function NavButton(_ref2) {
  var icon = _ref2.icon,
      onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-navButton",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-navButton-icon"
  }, icon));
}

function DaysRuler() {
  var days = ["M", "T", "W", "T", "F", "S", "S"];
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-daysRuler"
  }, days.map(function (day, i) {
    return /*#__PURE__*/React.createElement(DaysRulerCell, {
      value: day,
      key: i
    });
  }));
}

function DaysRulerCell(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-daysRulerCell-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-daysRulerCell-text"
  }, value));
}

function buildCalendar(value) {
  var first = value.locale("en-gb").startOf("month").startOf("week");
  var last = value.locale("en-gb").endOf("month").endOf("week");
  var calendar = [];
  var day = first.clone().subtract(1, "day");

  while (day.isBefore(last, "day")) {
    var week = [];
    var i = void 0;

    for (i = 0; i < 7; i++) {
      day = day.add(1, "day");
      week.push(day);
    }

    calendar.push(week);
  }

  return calendar;
}
function dateExistsInArray(array, day) {
  var date;

  var _iterator = _createForOfIteratorHelper(array),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      date = _step.value;

      if (date.isSame(day, "day")) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}

function CalendarCell(_ref) {
  var dayValue = _ref.dayValue,
      onClick = _ref.onClick,
      isSelected = _ref.isSelected,
      hasEvents = _ref.hasEvents,
      outOfMonth = _ref.outOfMonth;
  var textStyle = classnames("AppCalendar-cell-text", {
    today: dayjs().isSame(dayValue, "day"),
    selected: isSelected
  });
  var container = classnames("AppCalendar-cell-container", {
    outOfMonth: outOfMonth
  });
  return outOfMonth ? /*#__PURE__*/React.createElement("div", {
    className: container
  }) : /*#__PURE__*/React.createElement("div", {
    className: container,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: textStyle
  }, dayValue.date().toString()), hasEvents ? /*#__PURE__*/React.createElement(EventsIndication, null) : null);
}

function EventsIndication() {
  return /*#__PURE__*/React.createElement("span", {
    className: "AppCalendar-cell-eventsIndication"
  });
}

function Calendar(_ref) {
  var selectedDay = _ref.selectedDay,
      selectedMonth = _ref.selectedMonth,
      onDaySelection = _ref.onDaySelection,
      eventsDates = _ref.eventsDates;
  var calendar = buildCalendar(selectedMonth);
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-calendar"
  }, calendar.map(function (week, i) {
    return /*#__PURE__*/React.createElement(WeekRow, {
      key: i,
      week: week,
      selectedDay: selectedDay,
      eventsDates: eventsDates,
      onDaySelection: onDaySelection,
      currentMonth: selectedMonth
    });
  }));
}

function WeekRow(_ref2) {
  var week = _ref2.week,
      selectedDay = _ref2.selectedDay,
      onDaySelection = _ref2.onDaySelection,
      eventsDates = _ref2.eventsDates,
      currentMonth = _ref2.currentMonth;
  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-week"
  }, week.map(function (day, i) {
    return /*#__PURE__*/React.createElement(CalendarCell, {
      key: i,
      dayValue: day,
      isSelected: selectedDay.isSame(day, "day"),
      outOfMonth: !currentMonth.isSame(day, "month"),
      hasEvents: dateExistsInArray(eventsDates, day),
      onClick: function onClick() {
        return onDaySelection(day);
      }
    });
  }));
}

function AppCalendar(_ref) {
  var events = _ref.events;
  var today = dayjs();

  var _useState = useState(today),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDay = _useState2[0],
      setSelectedDay = _useState2[1];

  var _useState3 = useState(today),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedMonth = _useState4[0],
      setSelectedMonth = _useState4[1];

  var eventsDates = events.map(function (event) {
    return dayjs(event.date);
  });

  function daySelectionHandler(day) {
    if (day.month() !== selectedMonth.month()) {
      setSelectedMonth(day);
    }

    setSelectedDay(day);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "AppCalendar-calendar-container"
  }, /*#__PURE__*/React.createElement(CalendarHeader, {
    selectedMonth: selectedMonth,
    onMonthChange: setSelectedMonth
  }), /*#__PURE__*/React.createElement(DaysRuler, null), /*#__PURE__*/React.createElement(Calendar, {
    selectedDay: selectedDay,
    selectedMonth: selectedMonth,
    onDaySelection: daySelectionHandler,
    eventsDates: eventsDates
  })), /*#__PURE__*/React.createElement(DayDetails, {
    events: events,
    selectedDay: selectedDay
  }));
}

var styles$6 = {"app":"AppSmartHome-module_app__2WhbE","index":"AppSmartHome-module_index__1wZAn","title":"AppSmartHome-module_title__2Lf9u","index__devices":"AppSmartHome-module_index__devices__2JOUd","index__help":"AppSmartHome-module_index__help__XhUTM","index__help__link":"AppSmartHome-module_index__help__link__2ZZ3u","deviceTile":"AppSmartHome-module_deviceTile__2FZyM","notification":"AppSmartHome-module_notification__2SqQ6","deviceTile__icon":"AppSmartHome-module_deviceTile__icon__2mXZK","deviceTile__name":"AppSmartHome-module_deviceTile__name__3XbMi","deviceTile__status":"AppSmartHome-module_deviceTile__status__3uExe","deviceTile__notification":"AppSmartHome-module_deviceTile__notification__1s7vA","deviceTile__toggle":"AppSmartHome-module_deviceTile__toggle__2k7nG","device":"AppSmartHome-module_device__1-KQ3","camera":"AppSmartHome-module_camera__3VJXw","camera__wrapper":"AppSmartHome-module_camera__wrapper__2eu61","camera__zoomableWrapper":"AppSmartHome-module_camera__zoomableWrapper__1Iou7","camera__zoomableContent":"AppSmartHome-module_camera__zoomableContent__pJDBF","camera__video":"AppSmartHome-module_camera__video__3zUJl","camera__connecting":"AppSmartHome-module_camera__connecting__3XpIK","camera__instructions":"AppSmartHome-module_camera__instructions__3n_pk","keypad":"AppSmartHome-module_keypad__134mU","actions":"AppSmartHome-module_actions__3eOpq","action__button":"AppSmartHome-module_action__button__2qN7c"};

var _excluded$3 = ["to", "disabled", "children"];
function OptionalLink(_ref) {
  var to = _ref.to,
      disabled = _ref.disabled,
      children = _ref.children,
      props = _objectWithoutProperties$1(_ref, _excluded$3);

  if (disabled) {
    return /*#__PURE__*/React.createElement("div", props, children);
  }

  return /*#__PURE__*/React.createElement(Link, _extends$2({
    to: to
  }, props), children);
}

var _excluded$2 = ["href", "onClick", "children"];
function ExternalLink(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutProperties$1(_ref, _excluded$2);

  function clickHandler(evt) {
    onClick && onClick(evt);

    if (window.Android && window.Android.openUrlInBrowser) {
      evt.preventDefault();
      window.Android.openUrlInBrowser(href);
    }
  }

  return /*#__PURE__*/React.createElement("a", _extends$2({
    href: href,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: clickHandler
  }, props), children);
}

var styles$5 = {"root":"PinKeyboard-module_root__3cGLO","title":"PinKeyboard-module_title__2FGmO","hint":"PinKeyboard-module_hint__oEDAq","value":"PinKeyboard-module_value__OeCxC","shake":"PinKeyboard-module_shake__1fSac","valueDigit":"PinKeyboard-module_valueDigit__35UDy","keyboard":"PinKeyboard-module_keyboard__WohBM","key":"PinKeyboard-module_key__XYJlL","erase":"PinKeyboard-module_erase__2xSKF"};

function PinKeyboard(_ref) {
  var title = _ref.title,
      hint = _ref.hint,
      password = _ref.password,
      className = _ref.className,
      darkMode = _ref.darkMode,
      onCancel = _ref.onCancel,
      onUnlock = _ref.onUnlock;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      animated = _useState4[0],
      setAnimated = _useState4[1];

  var passwords = Array.isArray(password) ? password : [password];
  passwords = passwords.map(function (x) {
    return x.toString();
  });
  var numDigits = passwords[0].length;

  function updateValue(evt, newValue) {
    evt.stopPropagation();

    if (newValue.length > numDigits) {
      return;
    }

    setValue(newValue);
    vibrateShort();

    if (passwords.includes(newValue)) {
      onUnlock && onUnlock();
      setValue("");
    } else if (newValue.length === numDigits) {
      setAnimated(true);
      setTimeout(function () {
        setAnimated(false);
        setValue("");
      }, 300);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$5.root, className, {
      darkMode: darkMode
    })
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: styles$5.title
  }, title) : null, hint ? /*#__PURE__*/React.createElement("div", {
    className: styles$5.hint
  }, hint) : null, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$5.value, {
      animated: animated
    })
  }, range_1(numDigits).map(function (i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: classnames(styles$5.valueDigit, {
        full: !!value[i]
      })
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$5.keyboard
  }, range_1(1, 10).map(function (i) {
    return /*#__PURE__*/React.createElement(Clickable, {
      key: i,
      className: classnames(styles$5.key, "i".concat(i)),
      onClick: function onClick(evt) {
        return updateValue(evt, value + i.toString());
      }
    }, i);
  }), /*#__PURE__*/React.createElement(Clickable, {
    className: classnames(styles$5.key, styles$5.erase),
    onClick: function onClick(evt) {
      return updateValue(evt, value.slice(0, -1));
    }
  }, "⌫"), /*#__PURE__*/React.createElement(Clickable, {
    className: classnames(styles$5.key, "i0"),
    onClick: function onClick(evt) {
      return updateValue(evt, value + "0");
    }
  }, "0")), onCancel ? /*#__PURE__*/React.createElement(Clickable, {
    className: styles$5.cancel,
    onClick: onCancel
  }, "Cancel") : null);
}

var component = {};

var check = {};

Object.defineProperty(check, "__esModule", {
  value: true
});
var _react$2 = React;

var _react2$2 = _interopRequireDefault$2(_react$2);

function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

check["default"] = function () {
  return _react2$2["default"].createElement('svg', {
    width: '14',
    height: '11',
    viewBox: '0 0 14 11'
  }, _react2$2["default"].createElement('path', {
    d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0',
    fill: '#fff',
    fillRule: 'evenodd'
  }));
};

var x = {};

Object.defineProperty(x, "__esModule", {
  value: true
});
var _react$1 = React;

var _react2$1 = _interopRequireDefault$1(_react$1);

function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

x["default"] = function () {
  return _react2$1["default"].createElement('svg', {
    width: '10',
    height: '10',
    viewBox: '0 0 10 10'
  }, _react2$1["default"].createElement('path', {
    d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12',
    fill: '#fff',
    fillRule: 'evenodd'
  }));
};

var util = {};

Object.defineProperty(util, "__esModule", {
  value: true
});
util.pointerCoord = pointerCoord; // Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;

    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return {
        x: touch.clientX,
        y: touch.clientY
      };
    }

    var pageX = event.pageX;

    if (pageX !== undefined) {
      return {
        x: pageX,
        y: event.pageY
      };
    }
  }

  return {
    x: 0,
    y: 0
  };
}

Object.defineProperty(component, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = React;

var _react2 = _interopRequireDefault(_react);

var _classnames = classnames;

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _check = check;

var _check2 = _interopRequireDefault(_check);

var _x = x;

var _x2 = _interopRequireDefault(_x);

var _util = util;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        // Disable linting rule here since this usage of setState inside
        // componentDidUpdate is OK; see
        // https://reactjs.org/docs/react-component.html#componentdidupdate
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          checked: !!this.props.checked
        });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      if (this.props.disabled) {
        return;
      }

      var checkbox = this.input;

      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;
      this.setState({
        checked: checked
      });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      if (this.props.disabled) {
        return;
      }

      this.startX = (0, _util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, _util.pointerCoord)(event).x;

        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({
            checked: false
          });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({
            checked: true
          });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, _util.pointerCoord)(event).x;

        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({
              checked: false
            });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({
              checked: true
            });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }

      this.setState({
        hasFocus: true
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;

      if (onBlur) {
        onBlur(event);
      }

      this.setState({
        hasFocus: false
      });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }

      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className;
          _props.icons;
          var inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2["default"])('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);
      return _react2["default"].createElement('div', {
        className: classes,
        onClick: this.handleClick,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd
      }, _react2["default"].createElement('div', {
        className: 'react-toggle-track'
      }, _react2["default"].createElement('div', {
        className: 'react-toggle-track-check'
      }, this.getIcon('checked')), _react2["default"].createElement('div', {
        className: 'react-toggle-track-x'
      }, this.getIcon('unchecked'))), _react2["default"].createElement('div', {
        className: 'react-toggle-thumb'
      }), _react2["default"].createElement('input', _extends({}, inputProps, {
        ref: function ref(_ref) {
          _this2.input = _ref;
        },
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: 'react-toggle-screenreader-only',
        type: 'checkbox'
      })));
    }
  }]);

  return Toggle;
}(_react.PureComponent);

var _default = component["default"] = Toggle;

Toggle.displayName = 'Toggle';
Toggle.defaultProps = {
  icons: {
    checked: _react2["default"].createElement(_check2["default"], null),
    unchecked: _react2["default"].createElement(_x2["default"], null)
  }
};
Toggle.propTypes = {
  checked: _propTypes2["default"].bool,
  disabled: _propTypes2["default"].bool,
  defaultChecked: _propTypes2["default"].bool,
  onChange: _propTypes2["default"].func,
  onFocus: _propTypes2["default"].func,
  onBlur: _propTypes2["default"].func,
  className: _propTypes2["default"].string,
  name: _propTypes2["default"].string,
  value: _propTypes2["default"].string,
  id: _propTypes2["default"].string,
  'aria-labelledby': _propTypes2["default"].string,
  'aria-label': _propTypes2["default"].string,
  icons: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].shape({
    checked: _propTypes2["default"].node,
    unchecked: _propTypes2["default"].node
  })])
};

var ICONS = {
  camera: iconCamera,
  light: iconLight,
  socket: iconSocket,
  doorlock: iconDoorlock
};
var DEVICE_TYPES_WITH_PAGE = {
  camera: true
};

function AppSmartHome(_ref) {
  var devices = _ref.devices,
      columns = _ref.columns,
      locked = _ref.locked,
      pin = _ref.pin,
      manual = _ref.manual,
      appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  var store = useAppStore();
  var keypadVisible = store.keypadVisible;

  var changeHandler = function changeHandler(deviceId, newState) {
    if (store.locked) {
      store.toggleKeypad(true);
    } else {
      store.setDeviceState(deviceId, newState);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.app
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(Index, {
    devices: devices,
    columns: columns,
    manual: manual,
    appUrl: appUrl,
    onChange: changeHandler
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, ":deviceId"),
    render: function render(_ref2) {
      var match = _ref2.match;
      return /*#__PURE__*/React.createElement(DevicePage, {
        device: find_1(devices, function (x) {
          return x.id === match.params.deviceId;
        })
      });
    }
  }), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))), locked ? /*#__PURE__*/React.createElement(Keypad, {
    pin: pin,
    visible: keypadVisible,
    onUnlock: function onUnlock() {
      return store.unlock();
    },
    onCancel: function onCancel() {
      return store.toggleKeypad(false);
    }
  }) : null);
}

var AppSmartHome$1 = observer(AppSmartHome);

function Keypad(_ref3) {
  var pin = _ref3.pin,
      visible = _ref3.visible,
      onUnlock = _ref3.onUnlock,
      onCancel = _ref3.onCancel;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$6.keypad, {
      visible: visible
    })
  }, /*#__PURE__*/React.createElement(PinKeyboard, {
    title: "To control your devices, enter your PIN",
    darkMode: true,
    password: pin,
    onUnlock: onUnlock,
    onCancel: onCancel
  }));
}

function Index(_ref4) {
  var devices = _ref4.devices,
      columns = _ref4.columns,
      manual = _ref4.manual,
      appUrl = _ref4.appUrl,
      onChange = _ref4.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.index
  }, /*#__PURE__*/React.createElement(Title, null, "Smart Home"), /*#__PURE__*/React.createElement("div", {
    className: styles$6.index__devices,
    style: {
      gridTemplateColumns: "1fr ".repeat(columns)
    }
  }, devices.map(function (device, i) {
    return /*#__PURE__*/React.createElement(DeviceTile, {
      key: i,
      device: device,
      index: i,
      appUrl: appUrl,
      onChange: onChange
    });
  })), manual ? /*#__PURE__*/React.createElement(HelpLink, null) : null);
}

Index.defaultProps = {
  columns: 2
};

function HelpLink() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.index__help
  }, "Need help?", /*#__PURE__*/React.createElement("br", null), "Check out the ", /*#__PURE__*/React.createElement(ExternalLink, {
    className: styles$6.index__help__link,
    href: "http://wisehometechnologies.com/app-instructions.pdf"
  }, "operating instructions"), ".");
}

function Title(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.title
  }, children);
}

var DeviceTile = observer(function (_ref6) {
  var device = _ref6.device,
      appUrl = _ref6.appUrl,
      onChange = _ref6.onChange;
  var store = useAppStore();

  var updatedDevice = _objectSpread2(_objectSpread2({}, device), store.deviceProps[device.id]);

  var id = updatedDevice.id,
      name = updatedDevice.name,
      type = updatedDevice.type,
      icon = updatedDevice.icon;
  var nofiticationText = store.notifications[device.id];
  return /*#__PURE__*/React.createElement(OptionalLink, {
    className: classnames(styles$6.deviceTile, nofiticationText ? styles$6.notification : null),
    to: urljoin(appUrl, id),
    disabled: !DEVICE_TYPES_WITH_PAGE[type]
  }, /*#__PURE__*/React.createElement("img", {
    src: ICONS[icon],
    className: styles$6.deviceTile__icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$6.deviceTile__name
  }, name), /*#__PURE__*/React.createElement(DeviceTileAction, {
    device: updatedDevice,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(DeviceTileNotification, {
    text: nofiticationText
  }));
});

function DeviceTileAction(_ref7) {
  var device = _ref7.device,
      onChange = _ref7.onChange;
  var type = device.type;

  if (type === "toggle") {
    return /*#__PURE__*/React.createElement(ToggleDeviceTileAction, {
      device: device,
      onChange: onChange
    });
  }

  return null;
}

var ToggleDeviceTileAction = observer(function (_ref8) {
  var device = _ref8.device,
      _onChange = _ref8.onChange;
  var id = device.id;
  var store = useAppStore();
  var toggleState = store.deviceState[id];
  var on = toggleState === undefined ? device["default"] || false : toggleState;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeviceTileStatus, null, on ? device.onText || "On" : device.offText || "Off"), /*#__PURE__*/React.createElement(_default, {
    className: styles$6.deviceTile__toggle,
    checked: on,
    icons: false,
    onChange: function onChange(e) {
      return _onChange(id, e.target.checked);
    }
  }));
});

function DeviceTileStatus(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.deviceTile__status
  }, children);
}

function DeviceTileNotification(_ref10) {
  var text = _ref10.text;

  if (!text) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.deviceTile__notification
  }, text);
}

var DevicePage = observer(function (_ref11) {
  var device = _ref11.device;
  var store = useAppStore();

  var updatedDevice = _objectSpread2(_objectSpread2({}, device), store.deviceProps[device.id]);

  useEffect(function () {
    store.clearDeviceNotification(device.id);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.device
  }, /*#__PURE__*/React.createElement(Title, null, updatedDevice.name), /*#__PURE__*/React.createElement(DevicePageContents, {
    device: updatedDevice
  }), /*#__PURE__*/React.createElement(DeviceActions, {
    device: updatedDevice
  }));
});

function DevicePageContents(_ref12) {
  var device = _ref12.device;
  var type = device.type;

  if (type === "camera") {
    return /*#__PURE__*/React.createElement(Camera, {
      device: device
    });
  }

  return null;
}

var Camera = observer(function (_ref13) {
  var device = _ref13.device;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      videoLoaded = _useState2[0],
      setVideoLoaded = _useState2[1];

  var store = useAppStore();
  var lightsOff = device.needsLight && !store.deviceState[device.needsLight];
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.camera
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$6.camera__wrapper, {
      lightsOff: lightsOff
    })
  }, /*#__PURE__*/React.createElement(TransformWrapper, {
    options: {
      limitToWrapper: true,
      wrapperClass: styles$6.camera__zoomableWrapper,
      contentClass: styles$6.camera__zoomableContent
    },
    doubleClick: {
      disabled: true
    }
  }, /*#__PURE__*/React.createElement(TransformComponent, null, /*#__PURE__*/React.createElement(VideoPlayer$1, {
    url: device.videoSource,
    style: {
      aspectRatio: device.videoAspectRatio
    },
    width: "100%",
    height: "auto",
    className: styles$6.camera__video,
    preload: "auto",
    poster: "noposter",
    autoPlay: true,
    loop: true,
    muted: true,
    onPlay: function onPlay() {
      return setVideoLoaded(true);
    }
  }))), videoLoaded ? null : /*#__PURE__*/React.createElement("div", {
    className: styles$6.camera__connecting
  }, "Connecting...")), /*#__PURE__*/React.createElement("div", {
    className: styles$6.camera__instructions
  }, IS_SAFARI ? "Slide two fingers to zoom" : "Pinch to zoom"));
});
var DeviceActions = observer(function (_ref14) {
  var device = _ref14.device;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.actions
  }, (device.actions || []).map(function (action, i) {
    return /*#__PURE__*/React.createElement(DeviceAction, {
      key: i,
      device: device,
      action: action
    });
  }));
});
var DeviceAction = observer(function (_ref15) {
  var action = _ref15.action;
  var type = action.type;

  if (type === "button") {
    return /*#__PURE__*/React.createElement(ButtonDeviceAction, {
      action: action
    });
  }

  return null;
});
var ButtonDeviceAction = observer(function (_ref16) {
  var action = _ref16.action;
  var PhoneState = usePhoneState();
  var store = useAppStore();

  var clickHandler = function clickHandler() {
    if (store.locked) {
      store.toggleKeypad(true);
    } else {
      PhoneState.fireEvent(action.event);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.action__button,
    onClick: clickHandler
  }, action.name);
});

var styles$4 = {"app":"AppDating-module_app__2bZgt","header":"AppDating-module_header__cFObG","header__title":"AppDating-module_header__title__3hEa8","header__button":"AppDating-module_header__button__332F7","right":"AppDating-module_right__3gEFO","messages":"AppDating-module_messages__devKc","messages__contact":"AppDating-module_messages__contact__v7nFm","messages__contact__iconWrapper":"AppDating-module_messages__contact__iconWrapper__2keRs","messages__contact__details":"AppDating-module_messages__contact__details__25oUh","messages__contact__name":"AppDating-module_messages__contact__name__2si-8","messages__contact__lastMessage":"AppDating-module_messages__contact__lastMessage__3tNTw","messages__contact__lastMessage__time":"AppDating-module_messages__contact__lastMessage__time__UHA3q","thread":"AppDating-module_thread__2wkIL","thread__title":"AppDating-module_thread__title__IPfji","thread__messagesWrapper":"AppDating-module_thread__messagesWrapper__ImZnw","thread__messages":"AppDating-module_thread__messages__VD1k_","message":"AppDating-module_message__32ufB","in":"AppDating-module_in__2V__c","withProfile":"AppDating-module_withProfile__op9HM","out":"AppDating-module_out__u1cAS","message__contactPhoto":"AppDating-module_message__contactPhoto__1dCZl","message__content":"AppDating-module_message__content__2C17-","message__content__inner":"AppDating-module_message__content__inner__2YVSh","text":"AppDating-module_text__1pTsB","emoji":"AppDating-module_emoji__1TOIU","message__content__image":"AppDating-module_message__content__image__3LQ3i","message__time":"AppDating-module_message__time__2trDe","matches__offline":"AppDating-module_matches__offline__3VWxL","matches__offline__icon":"AppDating-module_matches__offline__icon__3p5iZ","matches__empty":"AppDating-module_matches__empty__2kmKj","matches__empty__icon":"AppDating-module_matches__empty__icon__1LDOi"};

function AppDating(_ref) {
  var appTitle = _ref.appTitle,
      messages = _ref.messages;
      _ref.notifications;
      var appUrl = _ref.appUrl,
      appPath = _ref.appPath;
  var phoneState = usePhoneState();
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.app
  }, /*#__PURE__*/React.createElement(Header, {
    appTitle: appTitle,
    rootUrl: appUrl
  }), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: appPath
  }, /*#__PURE__*/React.createElement(MatchScreen, {
    appUrl: appUrl,
    offline: !phoneState.isPhoneOnline
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "messages")
  }, /*#__PURE__*/React.createElement(MessagesIndex, {
    messages: messages,
    appUrl: appUrl
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: urljoin(appPath, "messages/:threadId")
  }, /*#__PURE__*/React.createElement(MessagesThread, {
    appUrl: appUrl,
    messages: messages
  })), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: appUrl
  }))));
}

var AppDating$1 = observer(AppDating);

function Header(_ref2) {
  var appTitle = _ref2.appTitle,
      rootUrl = _ref2.rootUrl;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  pathname.includes("messages");
  var showMessages = !pathname.includes("messages");
  var title = pathname.includes("messages") ? "Messages" : appTitle || "MatchFinder";
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.header__title
  }, title), showMessages ? /*#__PURE__*/React.createElement(Link, {
    className: classnames(styles$4.header__button, styles$4.right),
    to: urljoin(rootUrl, "messages")
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-comment-1"
  })) : null);
}

function MatchScreen(_ref3) {
  var offline = _ref3.offline;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.matches
  }, offline ? /*#__PURE__*/React.createElement("div", {
    className: styles$4.matches__offline
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$4.matches__offline__icon, "icon-no-sign")
  }), "No internet") : /*#__PURE__*/React.createElement("div", {
    className: styles$4.matches__empty
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.matches__empty__icon
  }, ":("), "No matches nearby"));
}

function MessagesIndex(_ref4) {
  var messages = _ref4.messages,
      appUrl = _ref4.appUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.messages
  }, (messages || []).map(function (thread, threadId) {
    return /*#__PURE__*/React.createElement(Link, {
      className: styles$4.messages__contact,
      key: threadId,
      to: urljoin(appUrl, "messages", threadId.toString())
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4.messages__contact__iconWrapper
    }, /*#__PURE__*/React.createElement(ContactPhoto, {
      contact: thread.contact
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$4.messages__contact__details
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4.messages__contact__name
    }, thread.contact.name), /*#__PURE__*/React.createElement("div", {
      className: styles$4.messages__contact__lastMessage
    }, last_1(thread.messages).text, /*#__PURE__*/React.createElement("span", {
      className: styles$4.messages__contact__lastMessage__time
    }, last_1(thread.messages).time))));
  }));
}

function MessagesThread(_ref5) {
  var messages = _ref5.messages;
      _ref5.appUrl;

  var _useParams = useParams(),
      threadId = _useParams.threadId;

  var thread = messages[threadId];
  var scroller = useRef();
  useEffect(function () {
    scroller.current.scrollTop = scroller.current.scrollHeight;
  }, []); // TODO: not always?

  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.thread
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.thread__title
  }, thread.contact.name), /*#__PURE__*/React.createElement("div", {
    className: styles$4.thread__messagesWrapper,
    ref: scroller
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.thread__messages
  }, thread.messages.map(function (message, i) {
    return /*#__PURE__*/React.createElement(Message, {
      key: i,
      message: message,
      contact: thread.contact,
      showTime: i === 0 || thread.messages[i - 1].direction !== message.direction,
      showProfile: i === thread.messages.length - 1 || thread.messages[i + 1].direction !== message.direction
    });
  }))));
}

function Message(_ref6) {
  var message = _ref6.message,
      contact = _ref6.contact,
      showTime = _ref6.showTime,
      showProfile = _ref6.showProfile;
      _ref6.appUrl;
  var direction = message.direction;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$4.message, styles$4[direction], showProfile ? styles$4.withProfile : null)
  }, showProfile && direction === "in" ? /*#__PURE__*/React.createElement(ContactPhoto, {
    className: styles$4.message__contactPhoto,
    contact: contact,
    size: 30
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$4.message__content
  }, showTime ? /*#__PURE__*/React.createElement("div", {
    className: styles$4.message__time
  }, message.time) : null, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$4.message__content__inner, message.text ? styles$4.text : null, message.image ? styles$4.image : null, isEmoji(message.text) ? styles$4.emoji : null)
  }, message.image ? /*#__PURE__*/React.createElement("img", {
    className: styles$4.message__content__image,
    src: message.image,
    alt: ""
  }) : null, message.text)));
}

var APPS = {
  browser: AppBrowser,
  photos: AppPhotos,
  messages: AppMessages,
  phone: AppPhoneCalls$1,
  contacts: AppContacts,
  notes: AppNotes,
  email: AppEmail,
  streaming: AppStreaming,
  social: AppSocial$1,
  folder: AppFolder,
  authenticator: AppAuthenticator,
  findFriends: AppFindFriends,
  news: AppNews$1,
  calendar: AppCalendar,
  home: AppSmartHome$1,
  dating: AppDating$1
};

function PhoneHeader() {
  return /*#__PURE__*/React.createElement("div", {
    className: "PhoneHeader"
  }, /*#__PURE__*/React.createElement(Time, {
    className: "PhoneHeader-left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "PhoneHeader-right"
  }, /*#__PURE__*/React.createElement(SignalIcon, null), /*#__PURE__*/React.createElement(BatteryIcon, null)));
}

function Time(_ref) {
  var className = _ref.className;

  var _useState = useState(_getTime()),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  useEffect(function () {
    var interval = setInterval(function () {
      return setTime(_getTime());
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, time);
}

var SignalIcon = observer(function (_ref2) {
  _ref2.online;
  var phoneState = usePhoneState();
  var isPhoneOnline = phoneState.isPhoneOnline;
  var klass = isPhoneOnline ? "wifi" : "offline";
  var iconClass = isPhoneOnline ? "icon-signal" : "icon-no-sign";
  return /*#__PURE__*/React.createElement("i", {
    id: "header-signal-icon",
    className: "PhoneHeader-icon signal ".concat(klass, " ").concat(iconClass)
  });
});
var BatteryIcon = observer(function () {
  var phoneState = usePhoneState();
  var batteryLevel = typeof phoneState.storyState.batteryLevel === "number" ? phoneState.storyState.batteryLevel : 74;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "PhoneHeader-battery-percent"
  }, "".concat(batteryLevel, "%")), /*#__PURE__*/React.createElement("span", {
    className: "PhoneHeader-battery-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames("PhoneHeader-battery-bar-fill", {
      low: batteryLevel <= 20
    }),
    style: {
      width: "".concat(batteryLevel, "%")
    }
  })));
});

function _getTime() {
  return dayjs().format("h:mm A");
}

function PhoneFooter(_ref) {
  var rootUrl = _ref.rootUrl;
      _ref.story;
      _ref.history;
      var location = _ref.location,
      onExit = _ref.onExit;
  var uiState = useUiState();
  var pathname = location.pathname;
  var isHome = pathname === rootUrl;

  function exitClickHandler() {
    if (onExit) {
      uiState.confirm({
        text: "Leave phone?",
        onYes: onExit
      });
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("PhoneFooter", {
      home: isHome
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "PhoneFooter-cell"
  }, isHome ? /*#__PURE__*/React.createElement("div", {
    className: "PhoneFooter-button exit",
    onClick: exitClickHandler,
    onTouchStart: function onTouchStart() {
      return vibrateShort();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-left-open-big"
  })) : /*#__PURE__*/React.createElement(Link, {
    className: "PhoneFooter-button exit",
    to: rsplit(pathname, "/", 1)[0],
    onTouchStart: function onTouchStart() {
      return vibrateShort();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "PhoneFooter-button-icon icon-left-open-big"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "PhoneFooter-cell"
  }, /*#__PURE__*/React.createElement(Link, {
    to: rootUrl,
    onTouchStart: function onTouchStart() {
      return vibrateShort();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "PhoneFooter-home-button"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "PhoneFooter-cell"
  }));
}

var PhoneFooter$1 = withRouter(PhoneFooter);

function HomeScreen(_ref) {
  var apps = _ref.apps,
      appColumns = _ref.appColumns,
      appIconSize = _ref.appIconSize,
      backgroundImage = _ref.backgroundImage,
      rootUrl = _ref.rootUrl;
  apps = filter_1(apps, function (app) {
    return !app.hasOwnProperty("homeScreen") || app.homeScreen;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen",
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen-apps",
    style: {
      gridTemplateColumns: "1fr ".repeat(appColumns)
    }
  }, apps.map(function (app) {
    return /*#__PURE__*/React.createElement(AppIcon, {
      key: app.name,
      app: app,
      size: appIconSize,
      rootUrl: rootUrl
    });
  })));
}
HomeScreen.defaultProps = {
  appColumns: 4,
  appIconSize: "normal"
};
var AppIcon = observer(function (_ref2) {
  var _phoneState$getAppSto;

  var app = _ref2.app,
      size = _ref2.size,
      rootUrl = _ref2.rootUrl;
  var phoneState = usePhoneState();
  var notifs = ((_phoneState$getAppSto = phoneState.getAppStore(app.name)) === null || _phoneState$getAppSto === void 0 ? void 0 : _phoneState$getAppSto.notificationCounter) || 0;
  return /*#__PURE__*/React.createElement(Link, {
    to: urljoin(rootUrl, app.name)
  }, /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen-app",
    id: "app-icon-".concat(app.name)
  }, /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen-app-icon-wrapper ".concat(size)
  }, notifs ? /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen-app-notif-counter"
  }, notifs) : null, /*#__PURE__*/React.createElement("img", {
    src: getAppIconUrl(app),
    className: "HomeScreen-app-icon",
    alt: app.name
  })), /*#__PURE__*/React.createElement("div", {
    className: "HomeScreen-app-name"
  }, app.title)));
});

var BACKGROUND_IMAGES = {
  2: brokenScreen2,
  3: brokenScreen3
};
function PhoneBrokenScreen(_ref) {
  var type = _ref.type;

  if (!type) {
    return null;
  }

  var bgImg = BACKGROUND_IMAGES[type];
  return /*#__PURE__*/React.createElement("div", {
    className: "PhoneBrokenScreen",
    style: {
      backgroundImage: "url(".concat(bgImg, ")")
    }
  });
}

var styles$3 = {"root":"DotPatternKeyboard-module_root__2gUKj","title":"DotPatternKeyboard-module_title__2xEJH","hint":"DotPatternKeyboard-module_hint__3taf_","keyboard":"DotPatternKeyboard-module_keyboard__kAGDf","key":"DotPatternKeyboard-module_key__2AaZs"};

function DotPatternKeyboard(_ref) {
  var title = _ref.title;
      _ref.hint;
      var pattern = _ref.pattern,
      className = _ref.className,
      darkMode = _ref.darkMode,
      onCancel = _ref.onCancel,
      onUnlock = _ref.onUnlock;

  var _useState = useState(Array(9).fill(false)),
      _useState2 = _slicedToArray(_useState, 2),
      toggles = _useState2[0],
      setToggles = _useState2[1];

  function toggleValue(index) {
    var newToggles = _toConsumableArray(toggles);

    newToggles[index] = !newToggles[index];
    setToggles(newToggles);
    vibrateShort();

    if (_togglesToStr(newToggles) === pattern) {
      onUnlock();
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$3.root, className, {
      darkMode: darkMode
    })
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: styles$3.title
  }, title) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$3.keyboard
  }, toggles.map(function (value, i) {
    return /*#__PURE__*/React.createElement(Clickable, {
      key: i,
      className: classnames(styles$3.key, {
        darkMode: darkMode,
        on: !!value
      }),
      onClick: function onClick() {
        return toggleValue(i);
      }
    });
  })), onCancel ? /*#__PURE__*/React.createElement(Clickable, {
    className: styles$3.cancel,
    onClick: onCancel
  }, "Cancel") : null);
}

function _togglesToStr(toggles) {
  return toggles.map(function (x) {
    return x ? "1" : "0";
  }).join("");
}

function LockScreen(_ref) {
  var background = _ref.background,
      unlockMethod = _ref.unlockMethod,
      code = _ref.code,
      showDate = _ref.showDate;
  var phoneState = usePhoneState();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showKeyboard = _useState4[0],
      setShowKeyboard = _useState4[1];

  var unlocked = value === code || phoneState.storyState.phoneUnlocked;

  function unlockHandler() {
    phoneState.unlockPhone();
  }

  function toggleKeyboard(show) {
    if (show) {
      setValue("");
    }

    setShowKeyboard(show);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("LockScreen", {
      unlocked: unlocked
    }),
    style: {
      backgroundImage: "url(".concat(background, ")")
    }
  }, /*#__PURE__*/React.createElement(GestureDetector, {
    className: classnames("LockScreen-default", {
      visible: !showKeyboard
    }),
    onSwipe: function onSwipe() {
      return toggleKeyboard(true);
    }
  }, showDate ? /*#__PURE__*/React.createElement(LockScreenDate, null) : null, /*#__PURE__*/React.createElement("div", {
    className: "LockScreen-default-cta"
  }, "Swipe to unlock")), /*#__PURE__*/React.createElement("div", {
    className: classnames("LockScreen-keyboard-wrapper", {
      visible: showKeyboard
    })
  }, /*#__PURE__*/React.createElement(Locker$1, {
    unlockMethod: unlockMethod || "code",
    code: code,
    onUnlock: unlockHandler,
    onCancel: function onCancel() {
      return toggleKeyboard(false);
    }
  })));
}

var LockScreen$1 = observer(LockScreen);

function Locker$1(_ref2) {
  var unlockMethod = _ref2.unlockMethod,
      code = _ref2.code,
      onUnlock = _ref2.onUnlock,
      onCancel = _ref2.onCancel;

  switch (unlockMethod) {
    case "code":
      return /*#__PURE__*/React.createElement(PinKeyboard, {
        title: "Enter Passcode",
        password: code,
        darkMode: true,
        onUnlock: onUnlock,
        onCancel: onCancel
      });

    case "dotPattern":
      return /*#__PURE__*/React.createElement(DotPatternKeyboard, {
        title: "Enter Pattern",
        pattern: code,
        darkMode: true,
        onUnlock: onUnlock,
        onCancel: onCancel
      });

    default:
      return null;
  }
}

function LockScreenDate() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "LockScreen-default-time"
  }, dayjs().format("hh:mm A")), /*#__PURE__*/React.createElement("div", {
    className: "LockScreen-default-date"
  }, dayjs().format("dddd[, ]MMMM D")));
}

var styles$2 = {"videoCall":"VideoCall-module_videoCall__3PbGd","incoming":"VideoCall-module_incoming__1nqDt","incoming__name":"VideoCall-module_incoming__name__2hpzQ","incoming__subtitle":"VideoCall-module_incoming__subtitle__1RrtG","incoming__buttons":"VideoCall-module_incoming__buttons__23YhG","incoming__button":"VideoCall-module_incoming__button__3I6Gs","answer":"VideoCall-module_answer__1-IIA","decline":"VideoCall-module_decline__31Cth","incoming__button__icon":"VideoCall-module_incoming__button__icon__2SYm5","endButton":"VideoCall-module_endButton__3QnL1","endButton__icon":"VideoCall-module_endButton__icon__3QcxV","videoWrapper":"VideoCall-module_videoWrapper__2ajcN","video__player":"VideoCall-module_video__player__px2I3","video__loading":"VideoCall-module_video__loading__UXo3c"};

var RING_MAX_TIME_SEC = 60;
var VideoCall = observer(function VideoCall() {
  var phoneState = usePhoneState();
  var videoCall = phoneState.storyState.videoCall;

  if (!videoCall) {
    return null;
  }

  var name = videoCall.name,
      videoUrl = videoCall.videoUrl,
      declineEvent = videoCall.declineEvent,
      endEvent = videoCall.endEvent;

  function finishHandler(declined) {
    phoneState.clearVideoCall();
    var event = declined ? declineEvent : endEvent;
    event && phoneState.fireEvent(event);
  }

  return /*#__PURE__*/React.createElement(VideoCallView, {
    name: name,
    videoUrl: videoUrl,
    videoCall: videoCall,
    onFinish: finishHandler
  });
});

function VideoCallView(_ref) {
  var name = _ref.name,
      videoUrl = _ref.videoUrl,
      onFinish = _ref.onFinish;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  function finishHandler(declined) {
    onFinish && onFinish(declined);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.videoCall
  }, status === "active" ? /*#__PURE__*/React.createElement(ActiveVideoCall, {
    videoUrl: videoUrl,
    onEnded: function onEnded() {
      return finishHandler(false);
    }
  }) : /*#__PURE__*/React.createElement(IncomingCall, {
    name: name,
    onAnswer: function onAnswer() {
      return setStatus("active");
    },
    onDecline: function onDecline() {
      return finishHandler(true);
    }
  }));
}

function IncomingCall(_ref2) {
  var name = _ref2.name,
      onAnswer = _ref2.onAnswer,
      onDecline = _ref2.onDecline;
  useEffect(function () {
    var ringtone = new Howl({
      src: [videoCallRingtone],
      autoplay: true,
      loop: true,
      volume: 0.5
    });
    var timeout = setTimeout(function () {
      onDecline && onDecline();
    }, RING_MAX_TIME_SEC * 1000);
    return function () {
      ringtone.stop();
      clearTimeout(timeout);
    };
  }, [onDecline]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.incoming
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.incoming__name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles$2.incoming__subtitle
  }, "Incoming video call"), /*#__PURE__*/React.createElement("div", {
    className: styles$2.incoming__buttons
  }, /*#__PURE__*/React.createElement(IncomingButton, {
    type: "answer",
    onClick: onAnswer
  }), /*#__PURE__*/React.createElement(IncomingButton, {
    type: "decline",
    onClick: onDecline
  })));
}

function IncomingButton(_ref3) {
  var type = _ref3.type,
      onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$2.incoming__button, styles$2[type]),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: classnames(styles$2.incoming__button__icon, "icon-phone")
  }));
}

function ActiveVideoCall(_ref4) {
  var videoUrl = _ref4.videoUrl,
      onEnded = _ref4.onEnded;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      started = _useState4[0],
      setStarted = _useState4[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Video, {
    videoUrl: videoUrl,
    onEnded: onEnded,
    onStarted: function onStarted() {
      return setStarted(true);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$2.endButton,
    onClick: onEnded
  }, /*#__PURE__*/React.createElement("i", {
    className: classnames(styles$2.endButton__icon, "icon-phone")
  })), started ? null : /*#__PURE__*/React.createElement("div", {
    className: styles$2.video__loading
  }, "Connecting..."));
}

function Video(_ref5) {
  var videoUrl = _ref5.videoUrl,
      onStarted = _ref5.onStarted,
      onEnded = _ref5.onEnded;

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray(_useMeasure, 2),
      screenRef = _useMeasure2[0],
      _useMeasure2$ = _useMeasure2[1],
      width = _useMeasure2$.width,
      height = _useMeasure2$.height;

  var haveMeasure = !!(width && height);
  var videoAspectRatio = 9 / 16;
  var videoWidth, videoHeight;

  if (haveMeasure) {
    var screenAR = width / height;

    if (screenAR > videoAspectRatio) {
      videoWidth = width;
      videoHeight = width * (1 / videoAspectRatio);
    } else {
      videoHeight = height;
      videoWidth = height * videoAspectRatio;
    }
  }

  if (typeof videoUrl === "string") {
    videoUrl = {
      file: videoUrl
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.videoWrapper,
    ref: screenRef
  }, haveMeasure ? /*#__PURE__*/React.createElement(VideoPlayer, {
    hlsUrl: videoUrl.hls,
    dashUrl: videoUrl.dash,
    fileUrl: videoUrl.file,
    width: videoWidth,
    height: videoHeight,
    className: styles$2.video__player,
    playsInline: true,
    autoPlay: true,
    preload: "auto",
    noPoster: true,
    onEnded: onEnded,
    onCanPlay: onStarted
  }) : null);
} // TODO: @faintlines/video-player


function VideoPlayer() {
  return null;
}

var styles$1 = {"notifications":"PhoneNotifications-module_notifications__3x_LN","notification":"PhoneNotifications-module_notification__3kgkY","notification__header":"PhoneNotifications-module_notification__header__3INXh","notification__icon":"PhoneNotifications-module_notification__icon__21k8G","notification__app":"PhoneNotifications-module_notification__app__1S-ci","notification__time":"PhoneNotifications-module_notification__time__2CYK8","notification__text":"PhoneNotifications-module_notification__text__2GnUY"};

var baseGetTag$1 = _baseGetTag,
    isArray$2 = isArray_1,
    isObjectLike$2 = isObjectLike_1;
/** `Object#toString` result references. */

var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */

function isString(value) {
  return typeof value == 'string' || !isArray$2(value) && isObjectLike$2(value) && baseGetTag$1(value) == stringTag;
}

var isString_1 = isString;

var baseGetTag = _baseGetTag,
    isObjectLike$1 = isObjectLike_1;
/** `Object#toString` result references. */

var dateTag = '[object Date]';
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */

function baseIsDate$1(value) {
  return isObjectLike$1(value) && baseGetTag(value) == dateTag;
}

var _baseIsDate = baseIsDate$1;

var baseIsDate = _baseIsDate,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsDate = nodeUtil && nodeUtil.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */

var isDate = nodeIsDate ? baseUnary$1(nodeIsDate) : baseIsDate;
var isDate_1 = isDate;

var TIME_FORMAT = "hh:mm A";
function formatTime(time) {
  if (isString_1(time) || isDate_1(time)) {
    time = dayjs(time);
  }

  return time.format(TIME_FORMAT);
}

var baseForOwn = _baseForOwn,
    castFunction = _castFunction;
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */

function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

var forOwn_1 = forOwn;

function PhoneNotifications(_ref) {
  var rootUrl = _ref.rootUrl;
  var phoneState = usePhoneState();
  var storyState = phoneState.storyState,
      isPhoneLocked = phoneState.isPhoneLocked;

  if (!storyState || isPhoneLocked) {
    return null;
  }

  var notifs = _prepareNotifications(storyState.notifications);

  return /*#__PURE__*/React.createElement("div", {
    className: styles$1.notifications
  }, notifs.map(function (notif, i) {
    return /*#__PURE__*/React.createElement(PhoneNotification, _extends$2({
      key: i,
      rootUrl: rootUrl
    }, notif));
  }));
}

var PhoneNotifications$1 = observer(PhoneNotifications);

function PhoneNotification(_ref2) {
  var rootUrl = _ref2.rootUrl,
      id = _ref2.id,
      text = _ref2.text,
      app = _ref2.app,
      date = _ref2.date;
  var phoneState = usePhoneState();
  return /*#__PURE__*/React.createElement(Link, {
    to: urljoin(rootUrl, app.name),
    onClick: function onClick() {
      return phoneState.clearNotification(id);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.notification
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.notification__header
  }, /*#__PURE__*/React.createElement("img", {
    src: getAppIconUrl(app),
    className: styles$1.notification__icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$1.notification__app
  }, app.title), /*#__PURE__*/React.createElement("span", {
    className: styles$1.notification__time
  }, formatTime(date))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.notification__text
  }, text)));
}

function _prepareNotifications(notifications) {
  var notifs = [];
  forOwn_1(notifications || {}, function (notif, notifId) {
    notifs.push(_objectSpread2({
      id: notifId
    }, notif));
  });
  return notifs;
}

function Alert() {
  var UiState = useUiState();
  var alert = UiState.alert;

  if (!alert) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "Alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Alert-content",
    onClick: function onClick(evt) {
      return evt.stopPropagation();
    }
  }, alert.title ? /*#__PURE__*/React.createElement("div", {
    className: "Alert-title"
  }, alert.title) : null, /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "Alert-text",
    markdown: alert.text
  }), /*#__PURE__*/React.createElement("div", {
    className: "Alert-buttons"
  }, alert.buttons.map(function (btn, i) {
    return /*#__PURE__*/React.createElement("a", {
      key: i,
      className: "Alert-button",
      href: btn.href,
      onClick: function onClick() {
        return btn.event();
      }
    }, btn.text);
  }))));
}

var Alert$1 = observer(Alert);

var styles = {"locker":"AppLocker-module_locker__2fASL","calculator":"AppLocker-module_calculator__1oxmk","calculator__value":"AppLocker-module_calculator__value__1pmBi","calculator__value__inner":"AppLocker-module_calculator__value__inner__2B_ny","calculator__keyboard":"AppLocker-module_calculator__keyboard__23-Fs","calculator__key":"AppLocker-module_calculator__key__27DgX","password":"AppLocker-module_password__1hJYo","password__title":"AppLocker-module_password__title__3mOWm","password__hint":"AppLocker-module_password__hint__2EhJk","password__textbox":"AppLocker-module_password__textbox__3dLui","shake":"AppLocker-module_shake__1HUwX","password__textbox_form":"AppLocker-module_password__textbox_form__QeinA","password__submit":"AppLocker-module_password__submit__3ydZv","usernamePassword__logo":"AppLocker-module_usernamePassword__logo__GRGuH"};

var baseClone = _baseClone;
/** Used to compose bitmasks for cloning. */

var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */

function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

var clone_1 = clone;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */

function baseRandom$1(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

var _baseRandom = baseRandom$1;

var baseRandom = _baseRandom;
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */

function shuffleSelf$2(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;
  size = size === undefined ? length : size;

  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];
    array[rand] = array[index];
    array[index] = value;
  }

  array.length = size;
  return array;
}

var _shuffleSelf = shuffleSelf$2;

var copyArray = _copyArray,
    shuffleSelf$1 = _shuffleSelf;
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */

function arrayShuffle$1(array) {
  return shuffleSelf$1(copyArray(array));
}

var _arrayShuffle = arrayShuffle$1;

var arrayMap$1 = _arrayMap;
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */

function baseValues$1(object, props) {
  return arrayMap$1(props, function (key) {
    return object[key];
  });
}

var _baseValues = baseValues$1;

var baseValues = _baseValues,
    keys = keys_1;
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */

function values$1(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

var values_1 = values$1;

var shuffleSelf = _shuffleSelf,
    values = values_1;
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */

function baseShuffle$1(collection) {
  return shuffleSelf(values(collection));
}

var _baseShuffle = baseShuffle$1;

var arrayShuffle = _arrayShuffle,
    baseShuffle = _baseShuffle,
    isArray$1 = isArray_1;
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */

function shuffle(collection) {
  var func = isArray$1(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

var shuffle_1 = shuffle;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }

  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }

  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    arrayMap = _arrayMap,
    baseUnary = _baseUnary,
    cacheHas = _cacheHas;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */

function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }

  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }

  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }

  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);
    value = comparator || value !== 0 ? value : 0;

    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;

      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }

      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }

  return result;
}

var _baseDifference = baseDifference$1;

var isArrayLike$1 = isArrayLike_1,
    isObjectLike = isObjectLike_1;
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject$1(value) {
  return isObjectLike(value) && isArrayLike$1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$1;

var baseDifference = _baseDifference,
    baseRest = _baseRest,
    isArrayLikeObject = isArrayLikeObject_1;
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */

var without = baseRest(function (array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
var without_1 = without;

function TilePuzzle(_ref) {
  var width = _ref.width,
      height = _ref.height,
      rows = _ref.rows,
      cols = _ref.cols,
      hole = _ref.hole,
      image = _ref.image,
      onSolved = _ref.onSolved;

  var _useState = useState(shuffleNumbers(range_1(0, rows * cols), hole, rows, cols)),
      _useState2 = _slicedToArray(_useState, 2),
      numbers = _useState2[0],
      setNumbers = _useState2[1];

  var handleClick = function handleClick(tileIndex) {
    var holeIndex = numbers.indexOf(hole);

    if (canSwap(tileIndex, holeIndex, rows, cols)) {
      var newNumbers = swap(numbers, tileIndex, holeIndex);
      setNumbers(newNumbers);

      if (isSolved(newNumbers) && onSolved) {
        onSolved();
      }
    }
  };

  var pieceWidth = Math.round(width / cols);
  var pieceHeight = Math.round(height / rows);

  var style = _objectSpread2(_objectSpread2({}, tilesStyle), {}, {
    width: width,
    height: height
  });

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    style: style
  }, numbers.map(function (number, index) {
    return /*#__PURE__*/React.createElement(Tile, {
      hole: hole,
      rows: rows,
      cols: cols,
      index: index,
      number: number,
      key: number,
      width: pieceWidth,
      height: pieceHeight,
      image: image,
      onClick: handleClick
    });
  })));
}
TilePuzzle.defaultProps = {
  width: 300,
  height: 300,
  rows: 3,
  cols: 3,
  hole: 8
};

var Tile = function Tile(_ref2) {
  var hole = _ref2.hole,
      number = _ref2.number,
      index = _ref2.index,
      rows = _ref2.rows,
      cols = _ref2.cols,
      width = _ref2.width,
      height = _ref2.height,
      image = _ref2.image,
      _onClick = _ref2.onClick;
  var matrixPos = getMatrixPosition(index, rows, cols);
  var visualPos = getVisualPosition(matrixPos, width, height);

  var style = _objectSpread2(_objectSpread2(_objectSpread2({}, tileStyle), number === hole ? holeStyle : {}), {}, {
    width: width,
    height: height,
    backgroundImage: image ? "url(".concat(image, ")") : null,
    backgroundRepeat: "no-repeat",
    backgroundSize: "".concat(width * cols, "px ").concat(height * rows, "px"),
    backgroundPosition: "".concat(number % cols / (cols - 1) * 100, "% ").concat(Math.floor(number / rows) / (rows - 1) * 100, "%")
  });

  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      transform: "translate3d(".concat(visualPos.x, "px, ").concat(visualPos.y, "px, 0)")
    }),
    onClick: function onClick() {
      return _onClick(index);
    }
  });
};

var tilesStyle = {
  listStyle: "none",
  margin: "0 auto",
  padding: 5,
  position: "relative"
};
var tileStyle = {
  backgroundColor: "grey",
  boxSizing: "border-box",
  display: "block",
  padding: 6,
  position: "absolute"
};
var holeStyle = {
  opacity: 0
}; // Checks if the puzzle is solved.
//
// Examples:
//   isSolved([6, 4, 5, 0, 1, 2, 3, 7, 8]) // => false
//   isSolved([0, 1, 2, 3, 4, 5, 6, 7, 8]) // => true

function isSolved(numbers) {
  for (var i = 0; i < numbers.length; i += 1) {
    if (numbers[i] !== i) {
      return false;
    }
  }

  return true;
} // Get the row/col pair from a linear index.


function getMatrixPosition(index, rows, cols) {
  return {
    row: Math.floor(index / cols),
    col: index % cols
  };
}

function getVisualPosition(_ref3, width, height) {
  var row = _ref3.row,
      col = _ref3.col;
  return {
    x: col * width,
    y: row * height
  };
}

function canSwap(src, dest, rows, cols) {
  var _getMatrixPosition = getMatrixPosition(src, rows, cols),
      srcRow = _getMatrixPosition.row,
      srcCol = _getMatrixPosition.col;

  var _getMatrixPosition2 = getMatrixPosition(dest, rows, cols),
      destRow = _getMatrixPosition2.row,
      destCol = _getMatrixPosition2.col;

  return Math.abs(srcRow - destRow) + Math.abs(srcCol - destCol) === 1;
}

function swap(numbers, src, dest) {
  var newNumbers = clone_1(numbers);
  var _ref4 = [newNumbers[dest], newNumbers[src]];
  newNumbers[src] = _ref4[0];
  newNumbers[dest] = _ref4[1];
  return newNumbers;
}

function shuffleNumbers(numbers, hole, rows, cols) {
  var shuffled = null;

  do {
    shuffled = shuffle_1(without_1(numbers, hole)).concat(hole);
  } while (isSolved(shuffled) || !isSolvable(shuffled, rows, cols));

  return shuffled;
}

function isSolvable(numbers, rows, cols) {
  var product = 1;

  for (var i = 1, l = rows * cols - 1; i <= l; i += 1) {
    for (var j = i + 1, m = l + 1; j <= m; j += 1) {
      product *= (numbers[i - 1] - numbers[j - 1]) / (i - j);
    }
  }

  return Math.round(product) === 1;
}

var _excluded$1 = ["lockType"],
    _excluded2 = ["appTitle", "appName", "appIcon", "password", "onUnlock"];
var eval2 = eval; // eslint-disable-line no-eval

function AppLocker(_ref) {
  var appName = _ref.appName,
      appTitle = _ref.appTitle,
      appIcon = _ref.appIcon,
      lockType = _ref.lockType,
      password = _ref.password,
      passwordHint = _ref.passwordHint,
      lockerProps = _ref.lockerProps,
      unlockEvent = _ref.unlockEvent,
      unlockEventDelay = _ref.unlockEventDelay;
  var phoneState = usePhoneState();
  if (!password) return null;

  function onUnlock() {
    phoneState.unlockApp(appName);

    if (unlockEvent) {
      phoneState.fireEvent(unlockEvent, {
        delayMs: unlockEventDelay
      });
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.locker, {
      unlocked: phoneState.storyState.unlockedApps[appName]
    }),
    onClick: function onClick(evt) {
      return evt.stopPropagation();
    },
    onTouchStart: function onTouchStart(evt) {
      return evt.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(Locker, _extends$2({
    lockType: lockType || "code",
    appName: appName,
    appTitle: appTitle,
    appIcon: appIcon,
    passwordHint: passwordHint,
    password: password,
    onUnlock: onUnlock
  }, lockerProps)));
}

var AppLocker$1 = observer(AppLocker);

function Locker(_ref2) {
  var lockType = _ref2.lockType,
      props = _objectWithoutProperties$1(_ref2, _excluded$1);

  switch (lockType) {
    case "pin":
    case "code":
      return /*#__PURE__*/React.createElement(PinLocker, props);

    case "calculator":
      return /*#__PURE__*/React.createElement(CalculatorLocker, props);

    case "password":
      return /*#__PURE__*/React.createElement(PasswordLocker, props);

    case "dotPattern":
      return /*#__PURE__*/React.createElement(DotPatternLocker, props);

    case "userPassword":
      return /*#__PURE__*/React.createElement(UsernamePasswordLocker, props);

    case "emailPassword":
      return /*#__PURE__*/React.createElement(UsernamePasswordLocker, _extends$2({
        usernameText: "Email",
        usernameType: "email"
      }, props));

    case "tilePuzzle":
      return /*#__PURE__*/React.createElement(TilePuzzleLocker, props);

    default:
      return null;
  }
}

function PinLocker(_ref3) {
  var appTitle = _ref3.appTitle,
      passwordHint = _ref3.passwordHint,
      password = _ref3.password,
      onUnlock = _ref3.onUnlock;
  return /*#__PURE__*/React.createElement(PinKeyboard, {
    title: appTitle === "" ? "This App is Password Protected" : "App ".concat(appTitle, " is Password Protected"),
    hint: passwordHint,
    password: password,
    onUnlock: onUnlock
  });
}

function DotPatternLocker(_ref4) {
  var appTitle = _ref4.appTitle,
      passwordHint = _ref4.passwordHint,
      password = _ref4.password,
      onUnlock = _ref4.onUnlock;
  return /*#__PURE__*/React.createElement(DotPatternKeyboard, {
    title: appTitle === "" ? "This App is Protected" : "App ".concat(appTitle, " is Protected"),
    hint: passwordHint,
    pattern: password,
    onUnlock: onUnlock
  });
}

function CalculatorLocker(_ref5) {
  var password = _ref5.password,
      onUnlock = _ref5.onUnlock;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  function op(newValue) {
    setValue(newValue);

    if (newValue === password) {
      onUnlock();
    }
  }

  function calculate() {
    var expression = value.replace(/×/g, "*").replace(/÷/g, "/").replace(/(^|[^\d])0+(\d+)/g, "$1$2");

    try {
      var newValue = eval2(expression);

      if (Number.isFinite(newValue)) {
        setValue(newValue.toString());
      } else {
        setValue("");
      }
    } catch (e) {// console.log(expression);
      // console.log(e);
      // TODO: reflect error
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.calculator
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.calculator__value
  }, /*#__PURE__*/React.createElement("textarea", {
    type: "text",
    className: classnames(styles.calculator__value__inner, "data-hj-allow"),
    value: value,
    readOnly: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.calculator__keyboard
  }, /*#__PURE__*/React.createElement(CalcKey, {
    label: "C",
    evt: function evt() {
      return op("");
    },
    cls: "c"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "(",
    evt: function evt() {
      return op(value + "(");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: ")",
    evt: function evt() {
      return op(value + ")");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "\xF7",
    evt: function evt() {
      return op(value + "÷");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "7",
    evt: function evt() {
      return op(value + "7");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "8",
    evt: function evt() {
      return op(value + "8");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "9",
    evt: function evt() {
      return op(value + "9");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "\xD7",
    evt: function evt() {
      return op(value + "×");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "4",
    evt: function evt() {
      return op(value + "4");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "5",
    evt: function evt() {
      return op(value + "5");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "6",
    evt: function evt() {
      return op(value + "6");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "-",
    evt: function evt() {
      return op(value + "-");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "1",
    evt: function evt() {
      return op(value + "1");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "2",
    evt: function evt() {
      return op(value + "2");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "3",
    evt: function evt() {
      return op(value + "3");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "+",
    evt: function evt() {
      return op(value + "+");
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "\u232B",
    evt: function evt() {
      return op(value.slice(0, -1));
    },
    cls: "op"
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "0",
    evt: function evt() {
      return op(value + "0");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: ".",
    evt: function evt() {
      return op(value + ".");
    }
  }), /*#__PURE__*/React.createElement(CalcKey, {
    label: "=",
    evt: function evt() {
      return calculate();
    },
    cls: "eq"
  })));
}

function CalcKey(_ref6) {
  var label = _ref6.label,
      evt = _ref6.evt,
      cls = _ref6.cls;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.calculator__key, cls),
    onClick: evt
  }, label);
}

function PasswordLocker(_ref7) {
  var appTitle = _ref7.appTitle,
      passwordHint = _ref7.passwordHint,
      password = _ref7.password,
      onUnlock = _ref7.onUnlock;

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      animated = _useState6[0],
      setAnimated = _useState6[1];

  function onSubmit() {
    if (value.toLowerCase() === password.toLowerCase()) {
      onUnlock();
    } else {
      vibrateShort();
      setAnimated(true);
      setTimeout(function () {
        setAnimated(false);
      }, 300);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.password
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.password__title
  }, "App ".concat(appTitle, " is Password Protected")), passwordHint ? /*#__PURE__*/React.createElement("div", {
    className: styles.password__hint
  }, "Hint: ".concat(passwordHint)) : null, /*#__PURE__*/React.createElement(PasswordInput, {
    className: classnames(styles.password__textbox, {
      animated: animated
    }),
    formClassName: styles.password__textbox_form,
    value: value,
    onChange: function onChange(evt) {
      return setValue(evt.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.password__submit,
    onClick: onSubmit
  }, "Unlock"));
}

function UsernamePasswordLocker(_ref8) {
  var appTitle = _ref8.appTitle,
      appName = _ref8.appName,
      appIcon = _ref8.appIcon,
      password = _ref8.password,
      onUnlock = _ref8.onUnlock,
      props = _objectWithoutProperties$1(_ref8, _excluded2);

  var _password$split = password.split("|"),
      _password$split2 = _slicedToArray(_password$split, 2),
      username = _password$split2[0],
      pass = _password$split2[1];

  return /*#__PURE__*/React.createElement(LoginScreen$1, _extends$2({
    username: username,
    className: styles.usernamePassword,
    password: pass,
    onLogin: onUnlock,
    backgroundColor: "#e2e2e2",
    appName: appName
  }, props), /*#__PURE__*/React.createElement("img", {
    src: appIcon,
    alt: appTitle,
    className: styles.usernamePassword__logo
  }));
}

function TilePuzzleLocker(_ref9) {
  var appTitle = _ref9.appTitle,
      width = _ref9.width,
      height = _ref9.height,
      rows = _ref9.rows,
      cols = _ref9.cols,
      hole = _ref9.hole,
      image = _ref9.image,
      onUnlock = _ref9.onUnlock;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.password
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.password__title
  }, "To continue to ".concat(appTitle, ", prove you are a human by solving the puzzle")), /*#__PURE__*/React.createElement(TilePuzzle, {
    width: width,
    height: height,
    rows: rows,
    cols: cols,
    hole: hole,
    image: image,
    onSolved: onUnlock
  }));
}

var baseKeys = _baseKeys,
    getTag = _getTag,
    isArguments = isArguments_1,
    isArray = isArray_1,
    isArrayLike = isArrayLike_1,
    isBuffer = isBuffer$4.exports,
    isPrototype = _isPrototype,
    isTypedArray = isTypedArray_1;
/** `Object#toString` result references. */

var mapTag = '[object Map]',
    setTag = '[object Set]';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */

function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }

  var tag = getTag(value);

  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }

  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }

  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }

  return true;
}

var isEmpty_1 = isEmpty;

var NewsAppState = /*#__PURE__*/function () {
  function NewsAppState(_ref) {
    var _this = this;

    var existingState = _ref.existingState,
        app = _ref.app,
        mainState = _ref.mainState;

    _classCallCheck$1(this, NewsAppState);

    _defineProperty$1(this, "visibleArticles", {});

    _defineProperty$1(this, "unreadArticles", {});

    _defineProperty$1(this, "anyArticleRead", false);

    this._app = app;
    this._mainState = mainState;
    this._soundNewsIn = new Howl({
      src: [newsIn],
      volume: 0.5
    });
    makeAutoObservable(this);

    if (NewsAppState.hasProgress(existingState)) {
      set(this, existingState);
    } else {
      app.data.items.forEach(function (item) {
        if (item.visible && !item.read) {
          _this.unreadArticles[item.id] = true;
        }
      });
    }
  }

  _createClass$1(NewsAppState, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "asJson",
    get: //// Computed
    function get() {
      return {
        visibleArticles: toJS(this.visibleArticles),
        unreadArticles: toJS(this.unreadArticles),
        anyArticleRead: toJS(this.anyArticleRead)
      };
    }
  }, {
    key: "notificationCounter",
    get: function get() {
      return keys_1(this.unreadArticles).length;
    } //// Actions

  }, {
    key: "showArticle",
    value: function showArticle(_ref2) {
      var articleId = _ref2.articleId;

      if (!this.visibleArticles[articleId]) {
        this.visibleArticles[articleId] = true;
        this.unreadArticles[articleId] = true;

        this._soundNewsIn.play();

        this._pushNewArticleNotification(articleId);
      }
    }
  }, {
    key: "markArticleAsRead",
    value: function markArticleAsRead(articleId) {
      if (this.unreadArticles[articleId]) {
        delete this.unreadArticles[articleId];
        this.anyArticleRead = true;
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.visibleArticles = {};
    } //// Private functions

  }, {
    key: "_pushNewArticleNotification",
    value: function _pushNewArticleNotification(articleId) {
      if (this.isAppActive) {
        return;
      }

      var article = find_1(this._app.data.items, function (x) {
        return x.id === articleId;
      });

      if (!article) {
        // should not get here
        return;
      }

      this._mainState.pushNotification(this._app, articleId, {
        text: article.title
      });
    }
  }], [{
    key: "hasProgress",
    value: function hasProgress(state) {
      return state && (state.anyArticleRead || !isEmpty_1(state.visibleArticles));
    }
  }]);

  return NewsAppState;
}();

var SmartHomeAppState = /*#__PURE__*/function () {
  function SmartHomeAppState(_ref) {
    var existingState = _ref.existingState,
        app = _ref.app,
        mainState = _ref.mainState;

    _classCallCheck$1(this, SmartHomeAppState);

    _defineProperty$1(this, "unlocked", false);

    _defineProperty$1(this, "keypadVisible", false);

    _defineProperty$1(this, "deviceState", {});

    _defineProperty$1(this, "deviceProps", {});

    _defineProperty$1(this, "notifications", {});

    makeAutoObservable(this);
    this._mainState = mainState;
    this._app = app;

    if (SmartHomeAppState.hasProgress(existingState)) {
      set(this, existingState);
    }
  }

  _createClass$1(SmartHomeAppState, [{
    key: "asJson",
    get: // Computed
    function get() {
      return {
        deviceState: toJS(this.deviceState),
        deviceProps: toJS(this.deviceProps),
        notifications: toJS(this.notifications),
        unlocked: toJS(this.unlocked)
      };
    }
  }, {
    key: "notificationCounter",
    get: function get() {
      return keys_1(this.notifications).length;
    }
  }, {
    key: "locked",
    get: function get() {
      return this._app.data.locked && !this.unlocked;
    } // Actions

  }, {
    key: "unlock",
    value: function unlock() {
      this.unlocked = true;
      this.toggleKeypad(false);
    }
  }, {
    key: "toggleKeypad",
    value: function toggleKeypad(toggle) {
      this.keypadVisible = toggle;
    }
  }, {
    key: "setDeviceState",
    value: function setDeviceState(deviceId, state) {
      this.deviceState[deviceId] = state;
    }
  }, {
    key: "overrideDeviceProps",
    value: function overrideDeviceProps(_ref2) {
      var deviceId = _ref2.deviceId,
          newProps = _ref2.newProps;
      this.deviceProps[deviceId] = _objectSpread2(_objectSpread2({}, this.deviceProps[deviceId]), newProps);
    }
  }, {
    key: "deviceNotification",
    value: function deviceNotification(_ref3) {
      var deviceId = _ref3.deviceId,
          longText = _ref3.longText,
          shortText = _ref3.shortText;
      // if (this.isAppActive) {
      // 	return;
      // }
      this.notifications[deviceId] = shortText;

      this._mainState.pushNotification(this._app, deviceId, {
        text: longText
      }); // TODO: notification sound

    }
  }, {
    key: "clearDeviceNotification",
    value: function clearDeviceNotification(deviceId) {
      delete this.notifications[deviceId];
    }
  }], [{
    key: "hasProgress",
    value: function hasProgress(state) {
      return state && (state.unlocked || !isEmpty_1(state.deviceState) || !isEmpty_1(state.deviceProps) || !isEmpty_1(state.notifications));
    }
  }]);

  return SmartHomeAppState;
}();

var EmailAppState = /*#__PURE__*/function () {
  function EmailAppState(_ref) {
    _ref.storyId;
        var existingState = _ref.existingState;
        _ref.app;

    _classCallCheck$1(this, EmailAppState);

    _defineProperty$1(this, "downloadedAttachments", {});

    _defineProperty$1(this, "unlockedAttachments", {});

    makeAutoObservable(this);

    if (EmailAppState.hasProgress(existingState)) {
      set(this, existingState);
    }
  }

  _createClass$1(EmailAppState, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "asJson",
    get: //// Computed
    function get() {
      return {
        downloadedAttachments: toJS(this.downloadedAttachments),
        unlockedAttachments: toJS(this.unlockedAttachments)
      };
    } //// Actions

  }, {
    key: "downloadAttachment",
    value: function downloadAttachment(attachmentId) {
      this.downloadedAttachments[attachmentId] = true;
    }
  }, {
    key: "unlockAttachment",
    value: function unlockAttachment(attachmentId) {
      this.unlockedAttachments[attachmentId] = true;
    }
  }], [{
    key: "hasProgress",
    value: function hasProgress(state) {
      return state && (!isEmpty_1(state.downloadedAttachments) || !isEmpty_1(state.unlockedAttachments));
    }
  }]);

  return EmailAppState;
}();

var PhoneCallsAppState = /*#__PURE__*/function () {
  function PhoneCallsAppState(_ref) {
    _ref.storyId;
        var existingState = _ref.existingState,
        app = _ref.app;

    _classCallCheck$1(this, PhoneCallsAppState);

    _defineProperty$1(this, "currentScreen", "history");

    _defineProperty$1(this, "dialerNumber", "");

    makeAutoObservable(this);

    if (existingState) {
      set(this, existingState);
    } else {
      var _app$data;

      this.currentScreen = (app === null || app === void 0 ? void 0 : (_app$data = app.data) === null || _app$data === void 0 ? void 0 : _app$data.startScreen) || "history";
    }
  }

  _createClass$1(PhoneCallsAppState, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "asJson",
    get: //// Computed
    function get() {
      return {
        currentScreen: toJS(this.currentScreen),
        dialerNumber: toJS(this.dialerNumber)
      };
    } //// Actions

  }, {
    key: "setCurrentScreen",
    value: function setCurrentScreen(currentScreen) {
      this.currentScreen = currentScreen;
    }
  }, {
    key: "setDialerNumber",
    value: function setDialerNumber(number) {
      this.dialerNumber = number;
    }
  }], [{
    key: "hasProgress",
    value: function hasProgress(state) {
      return false;
    }
  }]);

  return PhoneCallsAppState;
}();

var assignValue = _assignValue,
    castPath$1 = _castPath,
    isIndex = _isIndex,
    isObject = isObject_1,
    toKey = _toKey;
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */

function baseSet$1(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }

  path = castPath$1(path, object);
  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;

      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }

    assignValue(nested, key, newValue);
    nested = nested[key];
  }

  return object;
}

var _baseSet = baseSet$1;

var baseGet = _baseGet,
    baseSet = _baseSet,
    castPath = _castPath;
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */

function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }

  return result;
}

var _basePickBy = basePickBy$1;

var basePickBy = _basePickBy,
    hasIn = hasIn_1;
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */

function basePick$1(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

var _basePick = basePick$1;

var baseFlatten = _baseFlatten;
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */

function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

var flatten = flatten_1,
    overRest = _overRest,
    setToString = _setToString;
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */

function flatRest$1(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$1;

var basePick = _basePick,
    flatRest = _flatRest;
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */

var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick_1 = pick;

var baseIsEqual = _baseIsEqual;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */

function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var _excluded = ["appName", "eventName"];
var BATTERY_DECREASE_INTERVAL_MS = 30 * 1000;
var DEQUEUE_EVENTS_INTERVAL_MS = 1000;
var PERSIST_KEYS = ["firedEvents", "queuedEvents", "phoneUnlocked", "phoneOnline", "unlockedApps", "appStates", "batteryLevel", "notifications"];
var DEFAULT_PHONE_STATE = {
  queuedEvents: [],
  firedEvents: [],
  batteryLevel: null,
  phoneUnlocked: false,
  phoneOnline: false,
  unlockedApps: {},
  appStates: {},
  videoCall: null,
  notifications: {},
  // a place for storing arbitrary data that will be deleted when exiting the story or
  // reloading the page. Set values using setSessionStorage.
  sessionStorage: {}
};
var APP_STORES = {
  news: NewsAppState,
  home: SmartHomeAppState,
  email: EmailAppState,
  phone: PhoneCallsAppState
};

var PhoneState = /*#__PURE__*/function () {
  function PhoneState(story, config, uiState) {
    var _this = this;

    _classCallCheck$1(this, PhoneState);

    _defineProperty$1(this, "story", null);

    _defineProperty$1(this, "storyState", null);

    this._config = config || {};
    this._storyPersistenceKey = this._config.persistenceKeyPrefix ? "".concat(this._config.persistenceKeyPrefix, "__").concat(story.id) : null;

    this._loadPersistentState();

    makeAutoObservable(this, {
      _config: false,
      _storyPersistenceKey: false,
      _loadPersistentState: false,
      _initPersistentStateAutorun: false
    });
    this._uiState = uiState;
    this._appStores = {};
    this._appStoresAutoruns = [];
    this._eventTimeouts = [];

    this._init(story);

    this._initPersistentStateAutorun();

    this._tickers = [setInterval(function () {
      return _this._decreaseBatteryLevel();
    }, BATTERY_DECREASE_INTERVAL_MS), setInterval(function () {
      return _this._dequeueEvents();
    }, DEQUEUE_EVENTS_INTERVAL_MS)];
  }

  _createClass$1(PhoneState, [{
    key: "getAppStore",
    value: function getAppStore(appName) {
      if (!this.storyState) {
        return null;
      }

      return this._appStores[appName] || null;
    } // Computed

  }, {
    key: "isPhoneLocked",
    get: function get() {
      return this.story && this.storyState && this.story.settings.lockScreen && !this.storyState.phoneUnlocked;
    }
  }, {
    key: "isPhoneOnline",
    get: function get() {
      return this.story && this.story.settings.online || this.storyState && this.storyState.phoneOnline;
    }
  }, {
    key: "_init",
    value: function _init(story) {
      var _this2 = this;

      var existingState = this._loadPersistentState();

      this.storyState = _objectSpread2(_objectSpread2({}, cloneDeep_1(DEFAULT_PHONE_STATE)), {}, {
        existingState: existingState
      });

      if (typeof this.storyState.batteryLevel !== "number") {
        this.storyState.batteryLevel = story.starting_battery_level || 100;
      }

      Object.assign(this.storyState, pick_1(DEFAULT_PHONE_STATE, ["sessionStorage"]));

      this._disposeAppStores();

      this._clearEventTimeouts();

      story.apps.forEach(function (app) {
        var AppStoreClass = APP_STORES[app.name];

        if (AppStoreClass) {
          var existingAppState = toJS(_this2.storyState.appStates[app.name]);
          var appStore = new AppStoreClass({
            storyId: story.id,
            existingState: existingAppState,
            app: app,
            mainState: _this2
          });
          _this2._appStores[app.name] = appStore;

          _this2._appStoresAutoruns.push(autorun(function () {
            return _this2._updateAppState(app.name, appStore.asJson);
          }));
        }
      });

      this._uiState.hideAlert();

      this._nextStorySettings = {}; // this should be called last

      this.story = story;

      if (story.loadEvent) {
        this.fireEvent(story.loadEvent, {
          delayMs: story.loadEventDelay
        });
      }
    }
  }, {
    key: "_updateAppState",
    value: function _updateAppState(appName, newState) {
      var currentState = toJS(this.storyState.appStates[appName]);

      if (!isEqual_1(currentState, newState)) {
        this.storyState.appStates[appName] = newState;
      }
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(eventName, options) {
      var _this3 = this;

      var _ref = options || {},
          delayMs = _ref.delayMs;

      if (!this.story || !this.story.events) {
        return;
      }

      if (delayMs) {
        this.storyState.queuedEvents.push({
          eventName: eventName,
          options: _objectSpread2(_objectSpread2({}, options), {}, {
            delayMs: 0
          }),
          time: Date.now() + delayMs
        });
        return;
      }

      var event = this.story.events[eventName];

      if (!event || this.storyState.firedEvents.includes(eventName)) {
        return;
      }

      if (event.playMusic) {
        this.playMusicTrack(event.playMusic);
      }

      if (event.incomingVideoCall) {
        this.triggerIncomingVideoCall(event.incomingVideoCall);
      }

      (event.appEvents || []).forEach(function (_ref2) {
        var appName = _ref2.appName,
            appEventName = _ref2.eventName,
            eventProps = _objectWithoutProperties$1(_ref2, _excluded);

        var appStore = _this3._appStores[appName];

        if (!appStore || !appStore[appEventName]) {
          return;
        }

        appStore[appEventName].call(appStore, eventProps);
      });
      this.storyState.firedEvents.push(eventName);
    }
  }, {
    key: "_dequeueEvents",
    value: function _dequeueEvents() {
      var _this4 = this;

      if (!this.storyState || !this.storyState.queuedEvents) {
        return;
      }

      var now = Date.now();
      this.storyState.queuedEvents.forEach(function (_ref3) {
        var eventName = _ref3.eventName,
            options = _ref3.options,
            time = _ref3.time;

        if (time <= now && !_this4.storyState.firedEvents.includes(eventName)) {
          _this4.fireEvent(eventName, options);
        }
      });
    }
  }, {
    key: "triggerIncomingVideoCall",
    value: function triggerIncomingVideoCall(_ref4) {
      var videoUrl = _ref4.videoUrl,
          name = _ref4.name,
          declineEvent = _ref4.declineEvent,
          endEvent = _ref4.endEvent;

      if (this.storyState) {
        this.storyState.videoCall = {
          videoUrl: videoUrl,
          name: name,
          declineEvent: declineEvent,
          endEvent: endEvent
        };
      }
    }
  }, {
    key: "clearVideoCall",
    value: function clearVideoCall() {
      if (this.storyState) {
        this.storyState.videoCall = null;
      }
    }
  }, {
    key: "unlockPhone",
    value: function unlockPhone() {
      this.storyState.phoneUnlocked = true;
    }
  }, {
    key: "togglePhoneOnline",
    value: function togglePhoneOnline(isOnline) {
      this.storyState.phoneOnline = isOnline;
    }
  }, {
    key: "unlockApp",
    value: function unlockApp(appName) {
      this.storyState.unlockedApps[appName] = true;
    }
  }, {
    key: "_decreaseBatteryLevel",
    value: function _decreaseBatteryLevel() {
      if (this.story && this.storyState) {
        // TODO: get decrease rate from story
        var newLevel = Math.max(this.storyState.batteryLevel - 1, 10);

        if (newLevel !== this.storyState.batteryLevel) {
          this.storyState.batteryLevel = newLevel;
        }
      }
    }
  }, {
    key: "setSessionStorage",
    value: function setSessionStorage(key, value) {
      if (this.storyState) {
        this.storyState.sessionStorage[key] = value;
      }
    }
  }, {
    key: "pushNotification",
    value: function pushNotification(app, notificationId, _ref5) {
      var text = _ref5.text;

      if (!this.storyState) {
        return;
      }

      var id = "".concat(app.name, "_").concat(notificationId);
      this.storyState.notifications[id] = {
        id: id,
        date: new Date(),
        app: pick_1(app, ["title", "type", "name", "iconUrl"]),
        text: limitString(text, 80)
      };
    }
  }, {
    key: "clearNotification",
    value: function clearNotification(fullNotificationId) {
      if (this.storyState) {
        delete this.storyState.notifications[fullNotificationId];
      }
    }
  }, {
    key: "_disposeAppStores",
    value: function _disposeAppStores() {
      values_1(this._appStores).forEach(function (appStore) {
        if (appStore.dispose) {
          appStore.dispose();
        }
      });
      this._appStores = {};

      this._appStoresAutoruns.forEach(function (disposer) {
        return disposer();
      });

      this._appStoresAutoruns = [];
    }
  }, {
    key: "_clearEventTimeouts",
    value: function _clearEventTimeouts() {
      this._eventTimeouts.forEach(clearTimeout);

      this._eventTimeouts = [];
    } // private funcs (not actions)

  }, {
    key: "_loadPersistentState",
    value: function _loadPersistentState() {
      if (!this._storyPersistenceKey) {
        return null;
      }

      return store.get(this._storyPersistenceKey);
    }
  }, {
    key: "_initPersistentStateAutorun",
    value: function _initPersistentStateAutorun() {
      var _this5 = this;

      if (!this._storyPersistenceKey) {
        return;
      }

      autorun(function () {
        var persistedState = {};
        PERSIST_KEYS.forEach(function (key) {
          persistedState[key] = toJS(_this5.storyState[key]);
        });
        store.set(_this5._storyPersistenceKey, persistedState);
      });
    }
  }]);

  return PhoneState;
}();

var UiState = /*#__PURE__*/function () {
  function UiState() {
    var _this = this;

    _classCallCheck$1(this, UiState);

    _defineProperty$1(this, "alert", null);

    makeAutoObservable(this);
    window.addEventListener("openurlinbrowserfailed", function (evt) {
      return _this.handleOpenUrlInBrowserFailedEvent(evt.detail.url);
    });
  }

  _createClass$1(UiState, [{
    key: "showAlert",
    value: function showAlert(text, title, options) {
      var _this2 = this;

      var _ref = options || {},
          onClose = _ref.onClose,
          yesText = _ref.yesText;

      this.alert = {
        title: title,
        text: text,
        buttons: [{
          text: yesText || "OK",
          event: function event() {
            _this2.hideAlert();

            onClose && onClose();
          }
        }]
      };
    }
  }, {
    key: "confirm",
    value: function confirm(_ref2) {
      var _this3 = this;

      var text = _ref2.text,
          title = _ref2.title,
          yesText = _ref2.yesText,
          onYes = _ref2.onYes,
          yesHref = _ref2.yesHref,
          noText = _ref2.noText,
          onNo = _ref2.onNo;
      this.alert = {
        title: title,
        text: text,
        buttons: [{
          text: yesText || "Yes",
          href: yesHref,
          event: function event() {
            _this3.hideAlert();

            onYes && onYes();
          }
        }, {
          text: noText || "No",
          event: function event() {
            _this3.hideAlert();

            onNo && onNo();
          }
        }]
      };
    }
  }, {
    key: "hideAlert",
    value: function hideAlert() {
      this.alert = null;
    }
  }]);

  return UiState;
}();

function PhoneSimulator(_ref) {
  var story = _ref.story,
      config = _ref.config,
      onExit = _ref.onExit;
  var uiState = new UiState();
  var phoneState = new PhoneState(story, config, uiState);
  return /*#__PURE__*/React.createElement(PhoneStateContext.Provider, {
    value: phoneState
  }, /*#__PURE__*/React.createElement(UiStateContext.Provider, {
    value: uiState
  }, /*#__PURE__*/React.createElement(MemoryRouter, null, /*#__PURE__*/React.createElement(PhoneSimulatorInner, {
    story: story,
    onExit: onExit
  }))));
}

function PhoneSimulatorInner(_ref2) {
  var story = _ref2.story,
      onExit = _ref2.onExit;
  var phoneState = usePhoneState();
  var rootUrl = "/";
  var rootPath = "/";
  var settings = story.settings,
      apps = story.apps;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$e.PhoneSimulator
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$e["PhoneSimulator-content"]
  }, /*#__PURE__*/React.createElement(PhoneBrokenScreen, {
    type: settings.brokenScreen
  }), /*#__PURE__*/React.createElement(PhoneHeader, null), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: rootPath
  }, /*#__PURE__*/React.createElement(HomeScreen, {
    backgroundImage: settings.home.background,
    appColumns: settings.home.columns,
    appIconSize: settings.home.iconSize,
    apps: apps,
    rootUrl: rootUrl
  }), settings.lockScreen ? /*#__PURE__*/React.createElement(LockScreen$1, settings.lockScreen) : null), apps.map(function (app) {
    var AppComponent = APPS[app.type || app.name];
    var appPath = urljoin(rootPath, app.name);
    var appUrl = urljoin(rootUrl, app.name);
    return /*#__PURE__*/React.createElement(Route, {
      key: app.name,
      path: appPath
    }, /*#__PURE__*/React.createElement(AppStoreProvider, {
      store: phoneState.getAppStore(app.name)
    }, /*#__PURE__*/React.createElement(AppComponent, _extends$2({
      appPath: appPath,
      appUrl: appUrl,
      rootUrl: rootUrl,
      password: app.password
    }, app.data)), /*#__PURE__*/React.createElement(AppLocker$1, {
      appName: app.name,
      appTitle: app.title,
      appIcon: getAppIconUrl(app),
      lockType: app.passwordLockType,
      password: app.password,
      passwordHint: app.passwordHint,
      lockerProps: app.locker,
      unlockEvent: app.unlockEvent,
      unlockEventDelay: app.unlockEventDelay
    })));
  })), /*#__PURE__*/React.createElement(PhoneFooter$1, {
    rootUrl: rootUrl,
    story: story,
    onExit: onExit
  }), /*#__PURE__*/React.createElement(PhoneNotifications$1, {
    rootUrl: rootUrl
  }), /*#__PURE__*/React.createElement(VideoCall, null), /*#__PURE__*/React.createElement(Alert$1, null)));
}

export { PhoneSimulator };
//# sourceMappingURL=index.js.map
